/* hi-markt · Küchenplaner — Stufe 1 der Umsetzung: Datenschicht und Geometrie.

   Diese Datei rechnet, sie zeichnet nicht. Sie beantwortet genau zwei Fragen:
   (1) Welche Variante und welcher Preis gehören zu einem Modell in der gewählten Farbe?
   (2) Wo genau steht ein Schrank an der Wand, wie tief ist er, und was bleibt frei?

   Warum getrennt: die Zeichnungen (Grundriss, Frontansicht, 3D), das Regelwerk und der
   Warenkorb bauen alle auf denselben Zahlen auf. Stimmt hier ein Zentimeter nicht, ist er in
   sieben Schichten darüber nicht mehr zu finden. Alles hier ist deshalb eine reine Funktion
   über (zustand, daten) — ohne DOM, ohne Zustand im Modul — und damit ohne Browser prüfbar.

   Alle Längen in cm, Höhen ab Fertigfußboden. Der Nullpunkt einer Wandposition ist
   IHR p0 — nicht die linke Bildkante. Auf Wand A fällt beides zusammen, auf Wand C
   einer U-Küche nicht: dort liegt p0 am offenen Ende.

   Verbindliche Quelle ist die Design-Referenz `Kuechenplaner.dc.html`. Wo README und
   Referenz sich widersprechen, ist unten an Ort und Stelle vermerkt, welche gilt und warum.
*/
(function (w) {
  'use strict';

  /* ---------- kleine Helfer ---------- */

  var r0 = function (n) { return Math.round(n); };

  /* Überschneiden sich zwei Strecken? Berührung an der Kante zählt NICHT als Überschneidung —
     zwei Schränke dürfen aneinanderstoßen. Wird für Höhenbänder genauso gebraucht wie für
     Breiten, deshalb steht es hier und nicht in der Kollisionsprüfung. */
  var ueber = function (a1, a2, b1, b2) { return a1 < b2 && b1 < a2; };

  /* Preis in der Schreibweise DES SHOPS. Die Section reicht `shop.money_format` herein
     (gemessen am 2026-08-19: `€{{amount_with_comma_separator}}`, also `€1.234,56`), damit im
     Planer keine Zahl anders aussieht als auf jeder Produktkarte und im Warenkorb.

     ABWEICHUNG vom Handoff, auf Ansage des Betreibers: dort steht `1.234,56 €` mit dem Zeichen
     HINTER dem Betrag. Der Shop setzt es davor, ohne Leerzeichen. Der Shop gewinnt — diese
     Seite soll sich von der übrigen Storefront nicht unterscheiden. */
  var MONEY = '€{{amount_with_comma_separator}}';
  function setMoneyFormat(fmt) { if (fmt) MONEY = String(fmt); }

  function gruppiere(ganz, sep) {
    return String(ganz).replace(/\B(?=(\d{3})+(?!\d))/g, sep);
  }

  /* Shopify kennt fünf Platzhalter. Welcher im Format steht, entscheidet Trennzeichen UND
     ob überhaupt Nachkommastellen erscheinen — beides wird hier abgelesen, nicht geraten. */
  function eur(n) {
    var v = Math.round((+n || 0) * 100) / 100;
    return MONEY.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      var komma = name.indexOf('comma_separator') > -1;
      var apo = name.indexOf('apostrophe_separator') > -1;
      var ohneDez = name.indexOf('no_decimals') > -1;
      var tausend = komma ? '.' : (apo ? "'" : ',');
      var dez = komma ? ',' : '.';
      if (ohneDez) return gruppiere(Math.round(v), tausend);
      var st = v.toFixed(2).split('.');
      return gruppiere(st[0], tausend) + dez + st[1];
    });
  }

  var istEck = function (m) { return /^eck/.test((m && m.funktion) || ''); };

  /* ---------- Umgebung: die vier Beruehrungen mit der Aussenwelt ----------

     Der Kern rechnet. Er holt nichts, er merkt sich nichts. Genau vier Stellen brauchten
     bisher den Browser: der Katalog kam per `fetch`, die Planung ging in den
     `localStorage`. Beides liegt jetzt hinter diesem Objekt.

     Vorbelegt ist der BROWSER, Zeichen fuer Zeichen wie vorher — im Shop aendert sich
     dadurch nichts. Der Worker setzt eine eigene Umgebung: Katalog serverseitig, keine
     Persistenz. Die Rechenlogik darunter bleibt unberuehrt, und genau deshalb bleibt der
     Goldmaster gueltig. */
  var UMGEBUNG = {
    /* `serie` nur fuer die Fehlermeldung — der Kunde soll erfahren, WELCHER Katalog fehlt. */
    holen: function (url, serie) {
      return fetch(url, { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) throw new Error('Katalog ' + serie + ' antwortete ' + r.status);
        return r.json();
      });
    },
    lesen: function (schluessel) { return localStorage.getItem(schluessel); },
    schreiben: function (schluessel, wert) { localStorage.setItem(schluessel, wert); },
    loeschen: function (schluessel) { localStorage.removeItem(schluessel); }
  };

  /* Nur ersetzen, was wirklich mitgegeben wird — eine halbe Umgebung soll nicht
     stillschweigend drei Funktionen loeschen. */
  function umgebungSetzen(u) {
    if (!u) return UMGEBUNG;
    ['holen', 'lesen', 'schreiben', 'loeschen'].forEach(function (k) {
      if (typeof u[k] === 'function') UMGEBUNG[k] = u[k];
    });
    return UMGEBUNG;
  }

  /* ---------- Datenschicht ---------- */

  /* Katalog je Serie. Die vier Dateien liegen als Theme-Asset; die Section reicht die
     `asset_url`-Adressen herein, damit hier kein Pfad hartkodiert ist. Einmal geladen bleibt
     eine Serie im Speicher: der Kunde wechselt beim Vergleichen mehrfach hin und her, und
     jede Serie ist bis zu 100 KB. */
  var cache = {};

  function laden(serie, urls) {
    if (cache[serie]) return Promise.resolve(cache[serie]);
    var url = urls && urls[serie];
    if (!url) return Promise.reject(new Error('Keine Katalogadresse für Serie ' + serie));
    return Promise.resolve(UMGEBUNG.holen(url, serie))
      .then(function (d) { cache[serie] = d; return d; });
  }

  /* Welche Shopify-Variante gehört zu Modell + Farbe + Zusatzoptionen?

     Der Katalog listet je Farbe eine oder mehrere Varianten mit einem Optionstext `opt`
     ("Standard / links"). Gewählt wird die erste, deren `opt` ALLE gewählten Zusatzoptionen
     enthält. Zwei Fälle, die es im echten Katalog wirklich gibt und die hier nicht abstürzen
     dürfen: Livaro führt `opt: null` (das Produkt IST die Farbe, es gibt nichts zu wählen),
     und Lunara hat `opt`-Texte, aber ein leeres `zusatzoptionen` — dann passt jede Variante
     und die erste gewinnt. */
  /* Welche der genannten Optionswerte fuehrt DIESES Modell in dieser Farbe ueberhaupt?
     Ein Schrank mit Schubladen hat keinen Tueranschlag. Von ihm einen zu verlangen loescht
     ihn aus dem Katalog — genau daran verschwanden 22 der 32 weissen Glanzia-Modelle. */
  function optWerte(m, farbe, werte) {
    var l = (m && m.farben && m.farben[farbe]) || [];
    return (werte || []).filter(function (w) {
      return l.some(function (v) { return String(v.opt || '').indexOf(w) > -1; });
    });
  }

  /* Welche Optionsgruppe gehoert an den EINZELNEN Schrank und welche an die ganze Kueche?
     Das entscheidet die Sache, nicht die Datenform. Der Tueranschlag wechselt innerhalb einer
     Kueche staendig — links neben dem Herd, rechts neben der Spuele. Die Ausfuehrung
     (Griff oder Push-to-Open) ist dagegen eine Entscheidung fuer die ganze Zeile: gemischt
     saehe die Front zufaellig aus, und sie steuert ausserdem, ob ueberhaupt Griffe gezeichnet
     werden. Deshalb steht hier eine benannte Liste und keine Heuristik. */
  var PRO_SCHRANK = { 'Türanschlag': 1 };

  /* Die Optionsgruppen, in denen dieses Modell wirklich eine WAHL hat (zwei oder mehr Werte)
     UND die je Schrank entschieden werden. Alles andere waere eine Scheinwahl. */
  /* Ein Regal hat keine Front — erkannt am Frontplan, der nur aus Nischen besteht. Dieselbe
     Bedingung wie in der Zeichnung und in 3D; eine zweite Kennung waere eine zweite Wahrheit. */
  function istRegal(m) {
    var f = m && m.front;
    return !!(f && f.length && f.every(function (t) { return t[0] === 'nische'; }));
  }

  /* Wie die Wahlgruppe an DIESEM Schrank heisst. Der Schluessel bleibt, was er ist — die
     Variantenaufloesung sucht damit im Variantentitel des Shops —, geaendert wird nur, was der
     Kunde LIEST. Dieselbe Trennung wie beim Beleg, wo ebenfalls nur die Anzeige uebersetzt wird.

     Der Anlass: Glanzia D25PZ ist ein offenes Regal und wurde trotzdem nach dem "Türanschlag"
     gefragt — nach dem Anschlag einer Tuer, die es nicht hat. Der Shop fuehrt dort wirklich
     zwei Artikel (KU-US131 und KU-US132); was sie unterscheidet, ist die Seite, zu der das Regal
     abgeschraegt ist, nicht ein Scharnier. */
  function gruppenName(m, gruppe) {
    return (gruppe === 'Türanschlag' && istRegal(m)) ? 'Ausrichtung' : gruppe;
  }

  function optGruppen(daten, m, farbe) {
    var zo = (daten && daten.zusatzoptionen) || {};
    return Object.keys(zo).filter(function (g) { return PRO_SCHRANK[g]; }).map(function (g) {
      return { gruppe: g, werte: optWerte(m, farbe, zo[g]) };
    }).filter(function (x) { return x.werte.length > 1; });
  }

  /* Die Gruppen, die in Schritt 3 fuer die ganze Kueche gewaehlt werden. */
  function optGlobal(daten) {
    var zo = (daten && daten.zusatzoptionen) || {};
    return Object.keys(zo).filter(function (g) { return !PRO_SCHRANK[g]; });
  }

  /* Welche kuechenweiten Ausfuehrungen aus einer bisherigen Wahl in DIESEM Katalog weiter
     gelten. Die Regel hat zwei Haelften, und beide sind noetig:

     BEHALTEN, was es hier gibt. Vorher stand in der Oberflaeche ein bedingungsloses
     `z.zusatz = {}` und danach die ERSTE Option — also "Griff aus Metall". Das lief nicht nur
     beim Serienwechsel: eine gespeicherte Planung holt ihren Katalog ueber denselben Weg. Der
     Kunde hatte "Push-to-Open" gewaehlt und fand es beim naechsten Seitenaufruf durch "Griff
     aus Metall" ersetzt, ohne etwas getan zu haben. Dieselbe Falle wie beim Zubehoer.

     ERSETZEN, was es hier NICHT gibt. Eine Ausfuehrung der alten Serie kann nicht stehen
     bleiben: `variante()` sucht sie im Variantentitel des Shops und faende nichts — der Kunde
     bekaeme still die andere Ausfuehrung geliefert.

     Gruppen, die je Schrank gewaehlt werden, bleiben aussen vor: eine kuechenweite Vorgabe
     fuer den Tueranschlag waere eine Behauptung ueber jeden einzelnen Schrank. */
  function zusatzUebernehmen(alt, daten) {
    var zo = (daten && daten.zusatzoptionen) || {}, raus = {};
    optGlobal(daten).forEach(function (k) {
      var moeglich = zo[k] || [], war = alt ? alt[k] : null;
      raus[k] = moeglich.indexOf(war) > -1 ? war : moeglich[0];
    });
    return raus;
  }

  /* Die Wahl am einzelnen Schrank schlaegt die Vorgabe aus Schritt 3 — aber nur in IHRER
     Gruppe. Ein „Links" darf die Ausfuehrung nicht mit ueberschreiben. */
  function zusatzMit(daten, zusatz, wahl) {
    var out = {}, k;
    for (k in (zusatz || {})) {
      if (Object.prototype.hasOwnProperty.call(zusatz, k)) out[k] = zusatz[k];
    }
    if (!wahl) return out;
    var zo = (daten && daten.zusatzoptionen) || {};
    Object.keys(zo).forEach(function (g) {
      if ((zo[g] || []).indexOf(wahl) > -1) out[g] = wahl;
    });
    return out;
  }

  function variante(m, farbe, zusatz) {
    var l = (m && m.farben && m.farben[farbe]) || [];
    if (!l.length) return null;
    /* Gefordert wird nur, was dieses Modell auch anbietet. */
    var noetig = Object.keys(zusatz || {}).map(function (g) { return zusatz[g]; })
      .filter(function (w) { return w && optWerte(m, farbe, [w]).length; });
    for (var i = 0; i < l.length; i++) {
      if (!l[i].opt) return l[i];
      var passt = true;
      for (var k = 0; k < noetig.length; k++) {
        if (String(l[i].opt).indexOf(noetig[k]) === -1) { passt = false; break; }
      }
      if (passt) return l[i];
    }
    return l[0];
  }

  /* ---------- Geometrie: die Serienmaße ---------- */

  var GEO_FALLBACK = {
    korpus_hoehe: 82, korpus_tiefe: 52, arbeitsplatte_dicke: 4,
    hochschrank_hoehe: 213, haengeschrank_hoehe: 72, haenge_unterkante: 141
  };

  function geo(daten) { return (daten && daten.geometrie) || GEO_FALLBACK; }

  /* Die Arbeitsplatte wird immer 60 cm tief zugeschnitten — unabhängig von der Korpustiefe der
     Serie (gemessen: 47 cm bei Glanzia und Velora, 52 cm bei Livaro und Lunara). So schließt
     sie über jeder Schrankreihe und über jedem Gerät in einer Flucht ab, und der Überstand
     vorn nimmt die Fugen auf.

     WIDERSPRUCH, hier entschieden: README nennt unter "Geometriemodell" die Formel
     `korpus_tiefe + 13`. Die ergäbe für Livaro und Lunara 65 statt 60 und damit eine
     Reihenflucht von 64,5. Dagegen stehen zwei stärkere Quellen: die Referenz selbst
     (`platteTiefe() { return 60; }`, mit dem Kommentar "egal ob der Katalog 47, 52 oder 57 cm
     nennt") und der Handoff-Auftrag, der "Reihenflucht 59,5" als feste Zahl vorgibt. Die
     Formel beschreibt einen Sonderfall (47 + 13), keine Regel. Also: fest 60. */
  function platteTiefe() { return 60; }

  /* Flucht: alle Korpusse der Bodenreihe stehen 0,5 cm hinter der Plattenkante. */
  function flucht() { return platteTiefe() - 0.5; }

  /* Arbeitshöhe IST serienabhängig — anders als die Plattentiefe. Gemessen: 86 cm bei
     Glanzia, Lunara und Velora, aber 91 cm bei Livaro (Korpus 87). Wer hier 86 festschreibt,
     hängt bei Livaro die Oberschränke 5 cm zu tief. */
  /* PLATTENSTAERKE (Betreiber 2026-09-30): die gewaehlte Arbeitsplatte ist die eine Quelle — Katalog `dicke` in mm (13, 28, 38),
     hier in cm. Ohne gewaehlte Platte die Seriengeometrie (4 cm). Die 3D-Ansicht rechnet mit derselben Funktion.
     Mit Plan (z) ist die Arbeitshoehe die Oberkante der gewaehlten Platte — so rechnen Anzeige, Zeichnung und Pruefung. Ohne z die
     Seriengeometrie: so rechnet bewusst die PLATZIERUNG (Anheben des Dunstschranks, Startkueche unter Fenstern). Jede Katalogplatte
     ist hoechstens 4 cm dick, die Platzierung bleibt damit die strengere Seite und haengt nicht an der Plattenwahl — ein Wechsel der
     Platte verschiebt keinen Schrank. */
  function plattenDicke(z, daten) {
    var p = z ? platteVon(z, daten) : null, dmm = p ? +p.dicke : 0;
    return dmm > 0 ? dmm / 10 : geo(daten).arbeitsplatte_dicke;
  }
  function arbeitsHoehe(daten, z) { var g = geo(daten); return g.korpus_hoehe + (z ? plattenDicke(z, daten) : g.arbeitsplatte_dicke); }

  /* Nischenhöhe = Luft zwischen Arbeitsplatte und Unterkante der Hängeschränke. */
  function nischenHoehe(daten, z) { return geo(daten).haenge_unterkante - arbeitsHoehe(daten, z); }

  /* Reihe im Plan. Der Katalog kennt vier Werte, der Plan nur drei: ein Hochschrank ("voll")
     steht in derselben Bodenreihe wie ein Unterschrank und konkurriert mit ihm um dieselben
     Zentimeter Wand. */
  function zeile(m) { return m.reihe === 'oben' ? 'oben' : (m.reihe === 'aufsatz' ? 'aufsatz' : 'boden'); }

  /* ---------- Geometrie: die Wände ---------- */

  /* ================= Raumgeometrie =================================================

     Bis hierher war die Raumform ein WORT (`z.form`), und wo die Waende stehen, hat sich
     jeder Verbraucher selbst ausgedacht — vier Mal, auf vier verschiedene Arten. Ab hier
     gibt es genau ein Modell des Raums; alles andere liest daraus.

     KOORDINATEN. Einheit Zentimeter. x nach rechts, y nach UNTEN (wie auf dem Bildschirm).
     Ursprung ist die Bezugsecke des Raums. Dieselben Zahlen gelten fuer 2D und 3D:
     Plan-x -> 3D-x, Plan-y -> 3D-z, Hoehe -> 3D-y. Die Raumhoehe kommt in der
     Grundrissgeometrie NICHT vor; sie gehoert allein zur Frontansicht und zu 3D.

     GESPEICHERT je Wand ist nur, was sich nicht ausrechnen laesst:
         { id, label, p0, p1, planbar }
     Laenge, Richtung, Normale und Nachbarschaft sind ABGELEITET. Sie stehen nirgends,
     koennen also auch nicht aus dem Takt geraten.

     WICKELUNG. Die Vorlagen legen p0 -> p1 so, dass der Raum LINKS der Laufrichtung liegt
     (bei y-abwaerts heisst das: die Kette ist im Uhrzeigersinn auf dem Bildschirm, die
     vorzeichenbehaftete Flaeche positiv). Nur unter dieser Bedingung ist die Innennormale
     die um +90 Grad gedrehte Tangente. Die Drehung steht als MATRIX im Code und nicht als
     Prosa — „plus 90 Grad" hat bei y-abwaerts zwei vertretbare Lesarten, und die falsche
     spiegelt lautlos jeden Schrank. Gegengeprueft wird sie in `.hm-geometrie-check.js` mit
     einem Punkt-im-Polygon-Test, nicht mit einem Blick aufs Bild.

     ZWEI TOLERANZEN, mit getrennten Aufgaben und getrennten Groessenordnungen:

       EPS_KOINZIDENZ (1e-6 cm) ist eine LESE-Toleranz gegen Fliesskommastaub. Gemessen:
       eine 305-cm-Wand, um 90 Grad gedreht, endet bei x = 1,87e-14 statt 0, und die Kette
       305/281/307 schliesst mit 5,7e-14 cm Rest in y. Null waere also zu streng. 1e-6 laesst
       acht Groessenordnungen Luft nach unten und liegt fuenf unter der kleinsten Laenge,
       die dieses Modell ueberhaupt kennt.

       EPS_FANG (0,5 cm) ist eine SCHREIB-Toleranz und wirkt nur in der Vorlage: liegen zwei
       Endpunkte naeher beieinander, bekommen sie BITGLEICHE Werte. Danach vergleicht jedes
       Lesen exakt, und kein Wert steht mehr in der Naehe einer Schwelle.

       Warum nicht eine Toleranz fuer beides: 0,5 cm ist in dieser Datei bereits eine
       MODELLIERTE Laenge — `flucht()` ist `platteTiefe() - 0.5`, `grundPfad` verzweigt auf
       `eL.x <= x + 0.5`, `items` stapelt auf `it.off <= 0.5`. Wer „derselbe Punkt" auf
       dieselbe Groessenordnung legt wie „der Korpus steht 5 mm hinter der Plattenkante",
       kann beides nicht mehr unterscheiden.
  */
  var EPS_KOINZIDENZ = 1e-6;
  var EPS_FANG = 0.5;
  /* Ein Standard-Eckschrank ist fuer 90 Grad gebaut. Zwei Grad Abweichung sind an einem
     90-cm-Schenkel rund 3 cm Fehlstellung — das laesst sich noch ausgleichen. Fuenf Grad
     waeren knapp 8 cm und damit eine Fuge, die man sieht. */
  var ECK_TOLERANZ_GRAD = 2;

  function pt(x, y) { return { x: x, y: y }; }
  function gleichPunkt(a, b) {
    var dx = a.x - b.x, dy = a.y - b.y;
    return dx * dx + dy * dy < EPS_KOINZIDENZ * EPS_KOINZIDENZ;
  }

  function wandLaenge(w) {
    var dx = w.p1.x - w.p0.x, dy = w.p1.y - w.p0.y;
    return Math.sqrt(dx * dx + dy * dy);
  }
  function wandTangente(w) {
    var l = wandLaenge(w);
    if (l < EPS_KOINZIDENZ) return pt(1, 0);
    return pt((w.p1.x - w.p0.x) / l, (w.p1.y - w.p0.y) / l);
  }
  /* Die Innennormale. Die Drehung steht hier als Matrix, damit sie nicht misszuverstehen
     ist: (x, y) -> (-y, x). Bei y-abwaerts und im Uhrzeigersinn gewickelter Kette zeigt
     das in den Raum. */
  function wandNormaleInnen(w) {
    var t = wandTangente(w);
    return pt(-t.y, t.x);
  }
  /* Ein Punkt auf der Wand, gemessen in Zentimetern ab p0 — die eine Umrechnung, aus der
     spaeter Schraenke, Fenster, Anschluesse und die Arbeitsplatte ihre Lage bekommen. */
  function wandPunkt(w, abStart, tiefe) {
    var t = wandTangente(w), n = wandNormaleInnen(w), d = tiefe || 0;
    return pt(w.p0.x + t.x * abStart + n.x * d, w.p0.y + t.y * abStart + n.y * d);
  }

  /* Dieselbe Umrechnung fuer die Zeichenebene, als Funktion statt als Punkt: u laeuft
     laengs der Wand ab p0, v in die Tiefe entlang der Innennormalen. Sie ersetzt die
     frueher fest verdrahtete Tabelle karten{} in planZeichnung, die fuer jede Wand eine
     eigene Formel trug — und fuer Wand C eine spiegelverkehrte. Ab hier gilt in JEDER
     Form dasselbe: u = 0 ist p0, ohne Ausnahme und ohne Sonderfall. */
  function wandProjektion(w) {
    var t = wandTangente(w), n = wandNormaleInnen(w);
    return function (u, v) {
      return [w.p0.x + t.x * u + n.x * v, w.p0.y + t.y * u + n.y * v];
    };
  }
  /* Das umschliessende Rechteck zweier Wandpunkte. Achsparallele Waende ergeben damit
     exakt dasselbe <rect> wie die alte Handrechnung; schraege Waende wuerden hier ein
     Polygon brauchen — solange keine Vorlage schraege Waende erzeugt, waere das Code
     ohne Fall. */
  function projRechteck(map, u0, v0, u1, v1) {
    var a = map(u0, v0), b = map(u1, v1);
    return { x: zahl(Math.min(a[0], b[0])), y: zahl(Math.min(a[1], b[1])),
             w: zahl(Math.abs(b[0] - a[0])), h: zahl(Math.abs(b[1] - a[1])) };
  }

  /* Eine Zeichnungskoordinate, gereinigt. Die Projektion rechnet ueber Tangente und
     Normale und damit ueber eine Division; dieselbe Strecke, anders geklammert, ergibt
     dann 915.5999999999999 statt 915.6. Sichtbar ist das nichts — im Dateitext aber
     ein Unterschied, und ein Netz, das Textgleichheit prueft, meldet Staub als Fehler.
     Sechs Nachkommastellen sind ein Mikrometer bei Angaben in Zentimetern: fein genug,
     dass nie eine echte Zahl daran haengenbleibt. */
  function zahl(v) { return Math.round(v * 1e6) / 1e6; }

  /* Das umschliessende Rechteck des Raumes — Waende UND freistehende Bloecke, denn eine
     Insel steht im Raum und gehoert zu seiner Ausdehnung. Die Kamera brauchte das: sie
     rechnete ihren Abstand aus `A` allein, und eine tiefe U-Kueche oder eine Insel weit
     vor der Reihe lag dann ausserhalb des Bildes.

     Ein Block zaehlt mit seiner Tiefe, nicht nur mit seiner Linie: seine zwei Punkte
     liegen auf der Vorderkante, der Korpus steht dahinter. */
  function raumBounds(raum, tiefe) {
    var t = tiefe > 0 ? tiefe : GEO_FALLBACK.korpus_tiefe;
    var xs = [], ys = [];
    (raum.waende || []).forEach(function (w) {
      xs.push(w.p0.x, w.p1.x); ys.push(w.p0.y, w.p1.y);
    });
    (raum.bloecke || []).forEach(function (b) {
      var n = wandNormaleInnen(b);
      xs.push(b.p0.x, b.p1.x, b.p0.x + n.x * t, b.p1.x + n.x * t);
      ys.push(b.p0.y, b.p1.y, b.p0.y + n.y * t, b.p1.y + n.y * t);
    });
    if (!xs.length) { xs = [0]; ys = [0]; }
    var minX = Math.min.apply(null, xs), maxX = Math.max.apply(null, xs);
    var minY = Math.min.apply(null, ys), maxY = Math.max.apply(null, ys);
    return { minX: minX, maxX: maxX, minY: minY, maxY: maxY,
             breite: maxX - minX, tiefe: maxY - minY,
             mitte: { x: (minX + maxX) / 2, y: (minY + maxY) / 2 } };
  }

  /* Die Wand, wie die dreidimensionale Ansicht sie braucht. Sie rechnet damit nichts mehr
     selbst nach: Ursprung, Drehung und Laenge kommen aus derselben Geometrie wie Grundriss
     und Frontansicht.

     DIE ABBILDUNG zwischen den beiden Ansichten steht hier und nirgends sonst:

         Raum x  ->  Welt x
         Raum y  ->  Welt z
         Hoehe   ->  Welt y

     Daraus folgt die Drehung. Eine Wandgruppe legt ihre lokale x-Achse auf die Tangente
     und ihre lokale z-Achse auf die Innennormale; in three.js bildet eine Drehung um die
     Hochachse lokal (1,0,0) auf welt (cos, ., -sin) ab. Gesucht ist also der Winkel mit
     cos = t.x und -sin = t.y, und das ist atan2(-t.y, t.x). Die lokale z-Achse landet
     damit von selbst auf (-t.y, t.x) — genau der Innennormalen. Ein Schrank, der lokal
     nach +z steht, ragt deshalb IMMER in den Raum, nie hinter die Wand.

     Gilt fuer Waende und fuer freistehende Bloecke gleichermassen; ein Block hat dieselben
     zwei Punkte und braucht keine Sonderbehandlung. */
  function wandTransform3D(w) {
    var t = wandTangente(w), n = wandNormaleInnen(w);
    return {
      ursprung: { x: w.p0.x, y: 0, z: w.p0.y },
      gierung: Math.atan2(-t.y, t.x),
      laenge: wandLaenge(w),
      tangente: t,
      innen: n
    };
  }

  /* Ein wandlokaler Punkt als Weltpunkt — dieselbe Rechnung wie wandProjektion, nur in der
     Abbildung oben. Wer eine Lage in 3D braucht, fragt hier und rechnet nicht selbst. */
  function weltPunkt3D(w, abStart, tiefe, hoehe) {
    var p = wandPunkt(w, abStart, tiefe || 0);
    return { x: p.x, y: hoehe || 0, z: p.y };
  }

  /* Nachbarschaft wird GERECHNET, nicht aus der Reihenfolge im Array gelesen. Genau das
     war der Kern des alten Fehlers: drei Waende hiessen dort automatisch zwei Ecken. */
  function wandNachbarn(raum, id) {
    var w = raum.waende.filter(function (x) { return x.id === id; })[0];
    var out = { amAnfang: null, amEnde: null };
    if (!w) return out;
    raum.waende.forEach(function (a) {
      if (a.id === w.id) return;
      if (gleichPunkt(w.p0, a.p0) || gleichPunkt(w.p0, a.p1)) out.amAnfang = a.id;
      if (gleichPunkt(w.p1, a.p0) || gleichPunkt(w.p1, a.p1)) out.amEnde = a.id;
    });
    return out;
  }

  /* Der Innenwinkel zweier Waende an ihrem gemeinsamen Punkt, in Grad. Gemessen zwischen
     den beiden Tangenten, die VOM gemeinsamen Punkt WEG zeigen — nur so ist 90 auch 90
     und nicht je nach Laufrichtung 270. */
  function eckWinkel(a, b, punkt) {
    var ra = gleichPunkt(a.p0, punkt) ? wandTangente(a)
           : pt(-wandTangente(a).x, -wandTangente(a).y);
    var rb = gleichPunkt(b.p0, punkt) ? wandTangente(b)
           : pt(-wandTangente(b).x, -wandTangente(b).y);
    var cos = Math.max(-1, Math.min(1, ra.x * rb.x + ra.y * rb.y));
    return Math.acos(cos) * 180 / Math.PI;
  }

  /* A. Zwei Waende treffen sich. Rein geometrisch, ohne Urteil darueber, ob dort ein
     Schrank hinpasst. */
  function geometrischeEcken(raum) {
    /* Einmal je Raum gerechnet: items(), eckBelegung und der Wandversatz fragen bei jeder Ecke danach, und der Raum
       aendert sich nach raumGeometrie nicht mehr. Die Merkstelle ist nicht aufzaehlbar — JSON und Object.keys sehen sie
       nicht. Rueckgabe ist dieselbe Liste; niemand veraendert sie. */
    if (raum && raum.__ecken) return raum.__ecken;
    var out = [], i, j;
    for (i = 0; i < raum.waende.length; i++) {
      for (j = i + 1; j < raum.waende.length; j++) {
        var a = raum.waende[i], b = raum.waende[j], p = null;
        if (gleichPunkt(a.p0, b.p0) || gleichPunkt(a.p0, b.p1)) p = a.p0;
        else if (gleichPunkt(a.p1, b.p0) || gleichPunkt(a.p1, b.p1)) p = a.p1;
        if (!p) continue;
        var ta = wandTangente(a), tb = wandTangente(b);
        /* Parallel heisst: kein Knick. Das Kreuzprodukt zweier Einheitsvektoren IST der
           Sinus des Winkels — bei 0,5 Grad rund 0,0087. Kollineare Stuecke sind eine
           Teilwand, keine Ecke. */
        if (Math.abs(ta.x * tb.y - ta.y * tb.x) < 0.0087) continue;
        var winkel = eckWinkel(a, b, p);
        /* Eine Ecke ist mehr als ein Punkt. Sie sagt auch, WELCHES Ende jeder Wand daran
           haengt — und genau diese Angabe hat bisher gefehlt. Ohne sie musste jeder
           Verbraucher sie neu erraten, und geraten wurde ueber die Array-Reihenfolge:
           "die naechste Wand in der Liste". In der Kette C -> A -> B kommt das Paar A/C
           in der Liste A,B,C nie vor — die Ecke war unsichtbar, waehrend B/C als Ecke
           galt, obwohl die beiden sich nicht beruehren. */
        var enden = {};
        enden[a.id] = gleichPunkt(a.p0, p) ? 'anfang' : 'ende';
        enden[b.id] = gleichPunkt(b.p0, p) ? 'anfang' : 'ende';
        var rechtwinklig = Math.abs(winkel - 90) <= ECK_TOLERANZ_GRAD;
        var beidePlanbar = a.planbar !== false && b.planbar !== false;
        out.push({ id: [a.id, b.id].sort().join('~'), a: a.id, b: b.id, enden: enden,
                   punkt: p, winkel: winkel, rechtwinklig: rechtwinklig,
                   planbar: beidePlanbar, tauglich: rechtwinklig && beidePlanbar });
      }
    }
    if (raum && Object.isExtensible(raum)) {
      try { Object.defineProperty(raum, '__ecken', { value: out, enumerable: false, configurable: true }); } catch (e) { /* ohne Merkstelle */ }
    }
    return out;
  }

  /* B. Eine Ecke, in die ein Eckschrank wirklich passt: nahe 90 Grad UND beide Waende
     werden geplant. Der zweite Teil ist der ganze Unterschied zwischen U-Form und
     Parallelkueche — dort ist die Verbindungswand vorhanden, aber nicht bestueckt, und
     genau deshalb entstehen dort null Eckschrank-Ecken. Keine Formabfrage noetig. */
  function schrankEcken(raum) {
    if (raum && raum.__schrankEcken) return raum.__schrankEcken;
    var out = geometrischeEcken(raum).filter(function (e) { return e.tauglich; });
    if (raum && Object.isExtensible(raum)) {
      try { Object.defineProperty(raum, '__schrankEcken', { value: out, enumerable: false, configurable: true }); } catch (e) { /* ohne Merkstelle */ }
    }
    return out;
  }

  /* Die eine Frage, die jeder Verbraucher stellen darf — und die einzige, die er stellen
     soll: liegt an DIESEM Ende DIESER Wand eine Ecke, in die ein Eckschrank passt?
     Kein Array-Index, kein Wandbuchstabe, keine Raumform. */
  function schrankEckeAn(raum, wandId, ende) {
    var t = schrankEcken(raum), i;
    for (i = 0; i < t.length; i++) { if (t[i].enden[wandId] === ende) return t[i]; }
    return null;
  }
  function wandAus(raum, id) {
    return raum.waende.filter(function (w) { return w.id === id; })[0] || null;
  }
  /* Wie nah an einem Wandende ein Korpus stehen muss, um noch "in der Ecke" zu heissen.
     Ein Zentimeter: enger waere Messrauschen, weiter waere schon eine Fuge. */
  var EPS_ECKE = 1;

  /* Welcher Eintrag einer Reihe steht in welcher Ecke? Diese Zuordnung ist die EINE
     Regel, aus der die Reservierung auf der Nachbarwand, die Lage in items() und das L
     der Zeichnung gemeinsam lesen. Sie kommt ohne items() aus — sonst riefe items() ueber
     die Reservierung wieder items() der Nachbarwand auf, und die der eigenen zurueck.

     Ein Eckschrank ist an eine ECKE gebunden, nicht an eine Zahl. Wer ihn gezogen hat,
     entscheidet ueber die Stelle; wer ihn nur gesetzt hat, bekommt die naechste freie
     Ecke — Anfang vor Ende, weil das die bisherige Reihenfolge war. */
  function eckPlaetze(s, daten, raum, wandId, zl) {
    var out = { anfang: null, ende: null, je: {} };
    var arr = (s.plan && s.plan[wandId + '|' + zl]) || [];
    var w = wandAus(raum, wandId);
    if (!w || !daten || !arr.length) return out;
    var hatA = !!schrankEckeAn(raum, wandId, 'anfang');
    var hatE = !!schrankEckeAn(raum, wandId, 'ende');
    arr.forEach(function (mi, i) {
      var m = daten.modelle[mi];
      if (!m || !istEck(m)) return;
      /* Die GESPEICHERTE Stelle zaehlt fuer einen Eckschrank nicht mehr.

         Bis 2026-09-09 galt: wer ihn gezogen hat, entscheidet ueber die Stelle — lag er
         weiter als EPS_ECKE von einem Wandende weg, war er kein Eckschrank mehr in einer
         Ecke, und die Pruefung sperrte den Warenkorb mit "steht hier aber in keiner Ecke".
         Der Betreiber hat das als falsch bezeichnet, und er hat recht: ein Eckschrank IST
         die Ecke. Ihn woanders hinzustellen ist kein Zustand, den man erlauben und dann
         beanstanden sollte — er darf gar nicht erst entstehen.

         Er nimmt jetzt immer die naechste freie Ecke, Anfang vor Ende. Gibt es keine — eine
         gerade Kueche hat keine —, bleibt er ohne `eckseite`, und die Pruefung sagt weiterhin,
         dass er hier nicht hingehoert. Das ist der eine Fall, in dem die Meldung stimmt: dann
         hilft nur tauschen. Die Oberflaeche laesst ihn ausserdem nicht mehr ziehen. */
      if (hatA && out.anfang == null) { out.anfang = i; out.je[i] = 'anfang'; }
      else if (hatE && out.ende == null) { out.ende = i; out.je[i] = 'ende'; }
    });
    return out;
  }

  /* Was ein Eckschrank auf der NACHBARWAND wegnimmt. Auf seiner eigenen Wand belegt er
     sein Nennmass, um die Ecke seine Nenntiefe — zwei Zahlen, nicht eine. Bei den heutigen
     Eckschraenken sind sie gleich (90/90); ein unsymmetrischer Eckschrank rechnet hier
     ohne Aenderung richtig, weil beide Masse aus dem Modell kommen und nicht aus einer
     Annahme. */
  /* ---------- Reihen naeher an der Wand oder weiter weg (Wandversatz) ----------

     Betreiber 2026-09-28: „لاتنسى ان عرض سطح العمل ٦٠سم ومن الممكن ترك الخزائن غير ملتصقة بالحائط" und „هذا الحل يجب ان
     يكون مع جميع ال form لان العميل لن يقص سطح العمل بالعرض". Die Korpusse stehen nicht an der Wand: ihre Front liegt auf
     der Flucht (59,5 cm), dahinter bleiben bei 47 cm Korpus 12,5 cm frei, bei 52 cm 7,5 cm. Die Platte bleibt 60 cm tief
     an der Wand liegen — sie wird nie in der Tiefe geschnitten.

     Eine Wand zwischen ZWEI Ecken (die Hauptwand der U-Kueche) geht mit Schraenken in 5-cm-Schritten oft nicht auf: bei
     312 cm bleiben zwischen den Eckschraenken 132 cm, die Schraenke messen 130 oder 135. Bisher stand der Rest als Luecke
     zwischen zwei Schraenken, eine Passblende fuehrt der Shop nicht. Jetzt:
       - UNTEN rueckt die Bodenreihe einer Nachbarwand samt ihrem Eckschrank so weit naeher an IHRE Wand, wie die Reihe
         dieser Wand ueber das Mass hinausgeht: 135 in 132 → die Seitenreihen zusammen 3 cm naeher an ihre Waende; die Platte
         bleibt an der Wand und steht dort vorn 0,5 + 3 cm ueber. Hoechstens so weit, wie hinter dem tiefsten Stueck der
         Seitenreihe Platz ist (versatzGrenze).
       - OBEN haengt der Eck-Haengeschrank der Nachbarwand so weit von IHRER Wand weg, wie oben neben ihm frei bliebe
         (hoechstens 2,5 cm). Er ist an der Wand zwischen den Ecken befestigt; die uebrigen Haengeschraenke der Nachbarwand
         bleiben an ihrer Wand (Betreiber 2026-09-28: „كيف سيعلقها العميل اذا ابعدتها عن الحائط؟").
     Der Wert wird NICHT gespeichert, sondern aus dem Plan abgeleitet (versatzKarte): aendert der Kunde einen Schrank,
     stimmt er sofort wieder — und Browser, Kasse und 3D rechnen dieselbe Zahl. Positiv = naeher an die Wand. */
  /* Bodenreihe: hoechstens so viel naeher an die Wand — die Platte steht dann 5 cm vor den Fronten ueber. */
  var VERSATZ_MAX = 4.5;
  /* Haengereihe: hoechstens so weit von der Wand weg. */
  var ABSTAND_MAX = 2.5;
  /* Wie tief ein Einbaugeraet hinter seiner Front mindestens braucht (Geschirrspueler, Backofen unter dem Kochfeld). */
  var GERAET_TIEFE = 57;
  var GERAET_FUNKTION = { geschirrspuelerfront: 1, herdumbau: 1, geraete_unterschrank: 1 };
  /* Wie weit die BODENREIHE dieser Wand naeher an ihre Wand darf: so viel, wie hinter ihrem tiefsten Stueck frei ist —
     ein Hochschrank (58 cm) laesst 1 cm, ein Geschirrspueler (Geraet 57 cm) 2 cm, der Eckschrank so viel, wie sein Raster
     (90) ueber den Korpus (79/84/86) hinausgeht. Ein halber Zentimeter bleibt als Montageluft. Aus den Modellen der
     Reihe, ohne items() — die Rechnung laeuft bei jeder Ecke mit. Ohne Bodenreihe: nichts. */
  function versatzGrenze(s, daten, wand) {
    if (!daten) return 0;
    var arr = ((s && s.plan) || {})[wand + '|boden'] || [];
    var fl = flucht(), frei = VERSATZ_MAX + 0.5, n = 0;
    /* In der Startkueche haelt ein Hochschrank den Platz des EIGENEN Kuehlschranks, bis er zur Nische wird
       (kuehlWahl 'platzhalter'): er steht nachher nicht in der Reihe und zaehlt hier nicht. */
    var platzhalter = s && s.kuehlWahl === 'platzhalter';
    arr.forEach(function (mi) {
      var m = daten.modelle[mi];
      if (!m) return;
      if (platzhalter && (m.funktion === 'kuehlumbau' || m.funktion === 'hochschrank')) return;
      n++;
      var tief = istEck(m) ? fl - (nennMass(m) - m.b)
        : (GERAET_FUNKTION[m.funktion] ? Math.max(+m.t || 0, GERAET_TIEFE) : (+m.t || 0));
      frei = Math.min(frei, fl - tief);
    });
    if (!n) return 0;
    return Math.max(0, Math.min(VERSATZ_MAX, Math.floor((frei - 0.5) * 2) / 2));
  }
  /* Die andere Wand an einer Ecke dieser Wand (oder null). */
  function eckNachbarWand(raum, wand, ende) {
    var e = schrankEckeAn(raum, wand, ende);
    return e ? (e.a === wand ? e.b : e.a) : null;
  }
  /* Die abgeleiteten Versaetze: { 'B|boden': 2, 'C|boden': 1, 'C|oben': -2 }. Gerechnet ueber die Waende mit Ecken an
     BEIDEN Enden, aus ihren Reihen ohne Versatz (`ohneVersatz`, sonst rechnete items() hier sich selbst):
       - unten: wie weit die Schraenke (und Nischen) zwischen den Ecken zusammen ueber das Mass gehen. Erst die
         Nachbarwand am Ende der Reihe — dann ruecken die Schraenke nicht —, den Rest die am Anfang.
       - oben: an jedem Ende, was zwischen Eck-Haengeschrank und dem ersten Haengeschrank frei ist, wenn es hoechstens
         ABSTAND_MAX ist.
     Gemerkt werden die letzten Ergebnisse: items() fragt bei jeder Ecke danach. */
  var versatzMerk = [];
  function versatzKarte(s, daten, raum) {
    var karte = {};
    if (!s || !daten || s.ohneVersatz) return karte;
    raum = raum || raumGeometrie(s);
    var zu = [];
    raum.waende.forEach(function (w) {
      if (w.planbar === false) return;
      var n0 = eckNachbarWand(raum, w.id, 'anfang'), n1 = eckNachbarWand(raum, w.id, 'ende');
      if (n0 && n1) zu.push({ id: w.id, n0: n0, n1: n1, len: wandLaenge(w) });
    });
    if (!zu.length) return karte;
    var plan = s.plan || {}, xpos = s.xpos || {};
    var liste = function (a) { return a ? a.join(',') : ''; };
    var sig = zu.map(function (g) {
      return [g.id, g.len, g.n0, g.n1, liste(plan[g.id + '|boden']), liste(plan[g.id + '|oben']), liste(xpos[g.id + '|boden']),
        liste(xpos[g.id + '|oben']), liste(plan[g.n0 + '|boden']), liste(plan[g.n0 + '|oben']), liste(plan[g.n1 + '|boden']),
        liste(plan[g.n1 + '|oben'])].join(';');
    }).join('/') + '#' + (s.merkmale || []).filter(function (m) { return zu.some(function (g) { return g.id === m.wand; }); })
      .map(function (m) { return [m.typ, m.wand, m.x, m.breite].join(','); }).join(';');
    for (var mi = 0; mi < versatzMerk.length; mi++) {
      if (versatzMerk[mi].sig === sig && versatzMerk[mi].daten === daten) return versatzMerk[mi].karte;
    }
    var s0 = {};
    for (var k in s) { if (Object.prototype.hasOwnProperty.call(s, k)) s0[k] = s[k]; }
    s0.ohneVersatz = true;
    var setze = function (key, v) { if (Math.abs(v) > 0.01 && karte[key] == null) karte[key] = zahl(v); };
    zu.forEach(function (g) {
      var wl = g.len;
      /* Unten */
      var eb = eckBelegung(s0, daten, g.id, 'boden'), its = items(s0, daten, g.id, 'boden');
      var eigen = function (its2, ende) { return its2.filter(function (it) { return it.eckseite === ende; })[0]; };
      var rA = eb.anfang ? eb.anfang.cm : (eigen(its, 'anfang') ? eigen(its, 'anfang').b : null);
      var rE = eb.ende ? eb.ende.cm : (eigen(its, 'ende') ? eigen(its, 'ende').b : null);
      var rest = its.filter(function (it) { return !it.eckseite; });
      /* Die Nischen (eigener Geschirrspueler, Kuehlschrank) gehoeren zur Reihe wie ein Schrank derselben Breite: sie
         entstehen aus einem, an seiner Stelle — mit der Summe gerechnet, bleibt der Versatz dabei derselbe, und die
         Nische passt weiter zwischen ihre Nachbarn. */
      var summe = rest.reduce(function (a, it) { return a + it.b; }, 0);
      aktiveMerkmale(s0).forEach(function (m) {
        if (m.wand === g.id && MT[m.typ] && MT[m.typ].stellplatz) summe += elementIntervallAufWand(m).laenge;
      });
      if (rA != null && rE != null && summe > 0) {
        var ueber = summe - (wl - rA - rE), gE = versatzGrenze(s0, daten, g.n1), gA = versatzGrenze(s0, daten, g.n0);
        /* Nur ganz oder gar nicht: geht die Reihe weiter ueber das Mass, als beide Nachbarreihen ruecken koennen, bleibt
           alles an seinem Platz — die Pruefung nennt dann den ganzen Ueberstand, nicht einen halb weggerechneten. */
        if (ueber > 0.05 && ueber <= gE + gA + 0.01) {
          var vE = Math.min(ueber, gE);
          setze(g.n1 + '|boden', vE);
          setze(g.n0 + '|boden', ueber - vE);
        }
      }
      /* Oben */
      var ebO = eckBelegung(s0, daten, g.id, 'oben'), ob = items(s0, daten, g.id, 'oben');
      var oA = ebO.anfang ? ebO.anfang.cm : (eigen(ob, 'anfang') ? eigen(ob, 'anfang').b : null);
      var oE = ebO.ende ? ebO.ende.cm : (eigen(ob, 'ende') ? eigen(ob, 'ende').b : null);
      var restO = ob.filter(function (it) { return !it.eckseite; });
      if (restO.length) {
        var lA = Math.min.apply(null, restO.map(function (it) { return it.x; })) - oA;
        var lE = (wl - oE) - Math.max.apply(null, restO.map(function (it) { return it.x + it.b; }));
        if (oA != null && lA > 0.05 && lA <= ABSTAND_MAX + 0.01) setze(g.n0 + '|oben', -lA);
        if (oE != null && lE > 0.05 && lE <= ABSTAND_MAX + 0.01) setze(g.n1 + '|oben', -lE);
      }
    });
    versatzMerk.unshift({ sig: sig, daten: daten, karte: karte });
    if (versatzMerk.length > 8) versatzMerk.length = 8;
    return karte;
  }
  /* Wie weit die Reihe `zl` der Wand `wand` naeher an ihrer Wand steht (cm; negativ = weiter weg). Die Aufsaetze
     stehen auf den Hochschraenken der Bodenreihe und ruecken mit ihr. */
  function wandVersatz(s, daten, wand, zl, raum) {
    var v = versatzKarte(s, daten, raum)[wand + '|' + (zl === 'aufsatz' ? 'boden' : (zl || 'boden'))];
    return v || 0;
  }

  function eckBelegung(s, daten, wand, zl) {
    var out = { anfang: null, ende: null };
    if (!daten) return out;
    var raum = raumGeometrie(s), vk = null;
    ['anfang', 'ende'].forEach(function (ende) {
      var ecke = schrankEckeAn(raum, wand, ende);
      if (!ecke) return;
      var andere = ecke.a === wand ? ecke.b : ecke.a;
      var dortEnde = ecke.enden[andere];
      var pl = eckPlaetze(s, daten, raum, andere, zl);
      var i = pl[dortEnde];
      if (i == null) return;
      var m = daten.modelle[((s.plan || {})[andere + '|' + zl] || [])[i]];
      if (!m) return;
      /* Rueckt die Reihe des Eckschranks naeher an IHRE Wand, wird die Ecke auf dieser Wand um so viel schmaler. */
      vk = vk || versatzKarte(s, daten, raum);
      out[ende] = { cm: nennTiefe(m) - (vk[andere + '|' + (zl === 'aufsatz' ? 'boden' : zl)] || 0), code: m.code, wand: (wandAus(raum, andere) || {}).label,
                    h: m.h, ecke: ecke.id,
                    quelle: { wand: andere, zeile: zl, i: i } };
    });
    return out;
  }

  /* Wo der Raum offen ist: dort, wo die Wandkette nicht schliesst. Eine offene Seite ist
     KEINE Wand mit planbar:false — sie ist die Abwesenheit einer Wand. */
  function offeneSeiten(raum) {
    var frei = [];
    raum.waende.forEach(function (w) {
      var n = wandNachbarn(raum, w.id);
      if (!n.amAnfang) frei.push({ wand: w.id, ende: 'anfang', punkt: w.p0 });
      if (!n.amEnde) frei.push({ wand: w.id, ende: 'ende', punkt: w.p1 });
    });
    return frei;
  }

  /* ---- Vorlagen: aus den Massen des Kunden werden Waende ----------------------------
     Hier und NUR hier steht, welche Form welche Waende erzeugt. Danach fragt niemand mehr
     nach der Form — alles Weitere liest Geometrie. Eine fuenfte Form ist eine fuenfte
     Vorlage, keine fuenfte Verzweigung im Rechenkern.

     Beim Bauen werden Endpunkte, die naeher als EPS_FANG beieinander liegen, auf
     BITGLEICHE Werte gezogen. Deshalb genuegt spaeter ueberall der exakte Vergleich. */
  function fang(waende) {
    var i, j, k;
    for (i = 0; i < waende.length; i++) {
      for (j = i + 1; j < waende.length; j++) {
        var paare = [['p0', 'p0'], ['p0', 'p1'], ['p1', 'p0'], ['p1', 'p1']];
        for (k = 0; k < paare.length; k++) {
          var a = waende[i][paare[k][0]], b = waende[j][paare[k][1]];
          var dx = a.x - b.x, dy = a.y - b.y;
          if (dx * dx + dy * dy < EPS_FANG * EPS_FANG && !(dx === 0 && dy === 0)) {
            waende[j][paare[k][1]] = pt(a.x, a.y);
          }
        }
      }
    }
    return waende;
  }

  var VORLAGEN = {
    /* Einzeilig: eine Wand, der Raum liegt darunter (y > 0). Keine Ecke, keine Nachbarn. */
    gerade: function (s, tiefe) {
      /* Auch die einzelne Zeile darf eine Insel bekommen. Sie hat keine Seitenzeilen, die
         freie Strecke ist also dieselbe wie in der Inselkueche — der Unterschied zwischen
         beiden Formen ist damit nur noch, ob die Insel von Anfang an da IST. */
      return { waende: [{ id: 'A', label: 'Wand A', p0: pt(0, 0), p1: pt(+s.A, 0), planbar: true }],
               bloecke: inselDazu(s, tiefe, false, false, 0) };
    },
    /* L: A oben, B an einer der beiden Schmalseiten. Die Ecke liegt bei (A, 0) oder (0, 0).

       WELCHE SEITE, entscheidet der Kunde. Eine Kueche ist an ihren Raum gebunden: Fenster,
       Tuer und Anschluesse liegen, wo sie liegen, und eine L-Form, die nur nach rechts geht,
       passt in die Haelfte aller Raeume nicht. Gespiegelt wird nur die STRECKE von Wand B;
       sie behaelt ihren Buchstaben, ihre Laenge und ihre Rolle.

       Die gespiegelte Wand ist wie Wand C der U-Kueche gebaut: sie beginnt am OFFENEN Ende
       und laeuft auf die Ecke mit A zu. Das ist keine Kosmetik — die Richtung bestimmt die
       Innennormale, und damit, wohin die Schraenke schauen.

       Sonst aendert sich nichts, und das ist der eigentliche Punkt: Ecken werden aus
       gemeinsamen Endpunkten und dem Winkel erkannt, nicht aus Wandbuchstaben oder der
       Reihenfolge im Array. Reservierung, Platzierung, Zeichnung und 3D folgen deshalb von
       allein. */
    l: function (s, tiefe) {
      var A = +s.A, B = +s.B;
      var wandB = s.bLinks
        ? { id: 'B', label: 'Wand B', p0: pt(0, B), p1: pt(0, 0),  planbar: true }
        : { id: 'B', label: 'Wand B', p0: pt(A, 0), p1: pt(A, B),  planbar: true };
      return { waende: [
        { id: 'A', label: 'Wand A', p0: pt(0, 0), p1: pt(A, 0), planbar: true },
        wandB
      ], bloecke: inselDazu(s, tiefe, !!s.bLinks, !s.bLinks, +s.B) };
    },
    /* U: die Kette laeuft C -> A -> B, nicht A -> B -> C. Wand C beginnt am OFFENEN Ende
       und laeuft auf die Ecke mit A zu — die Richtung, die 3D (wandGruppe setzt C auf
       (0,0,C) und dreht um +90 Grad) und eckL() schon immer verwendet haben. Der
       Grundriss zog seit Phase 3 nach; vorher zeichnete er sie spiegelverkehrt. */
    u: function (s, tiefe) {
      return { waende: [
        { id: 'A', label: 'Wand A', p0: pt(0, 0),     p1: pt(+s.A, 0),     planbar: true },
        { id: 'B', label: 'Wand B', p0: pt(+s.A, 0),  p1: pt(+s.A, +s.B),  planbar: true },
        { id: 'C', label: 'Wand C', p0: pt(0, +s.C),  p1: pt(0, 0),        planbar: true }
      ], bloecke: inselDazu(s, tiefe, true, true, Math.max(+s.B, +s.C)) };
    },
    /* Zweizeilig: zwei gegenueberliegende Zeilen, dazwischen die Verbindungswand B, die
       vorhanden ist, aber NICHT bestueckt wird. Die beiden Zeilen duerfen verschieden lang
       sein — A und C werden beide an B angesetzt, und die kuerzere endet einfach frueher.
       Nichts hier zwingt den Raum in ein Rechteck. */
    zweizeilig: function (s) {
      var A = +s.A, B = +s.B, C = +s.C;
      return { waende: [
        { id: 'A', label: 'Wand A', p0: pt(0, 0),      p1: pt(A, 0),      planbar: true },
        { id: 'B', label: 'Wand B', p0: pt(A, 0),      p1: pt(A, B),      planbar: false },
        { id: 'C', label: 'Wand C', p0: pt(A, B),      p1: pt(A - C, B),  planbar: true }
      ], bloecke: [] };
    },
    /* Insel: eine Wand plus ein freistehender Block. Der Block ist KEINE Wand — er hat
       keine Nachbarn und nimmt an keiner Eckrechnung teil. */
    insel: function (s, tiefe) {
      /* Faellt der Aufrufer aus, gilt DIESELBE Zahl wie ueberall sonst. Vorher standen hier
         47 und in GEO_FALLBACK 52 — zwei Rueckfaelle fuer dieselbe Groesse, und damit genau
         die zwei Modelle nebeneinander, gegen die diese Umstellung gebaut ist. */
      var A = +s.A, t = tiefe > 0 ? tiefe : GEO_FALLBACK.korpus_tiefe;
      /* DIESELBE Grenze wie in L und U. Bisher hatte die Inselkueche als einzige gar keine:
         gemessen standen 900 cm Insel in einem 500 cm breiten Raum, weil `x0` nur nach
         unten geklemmt wurde und die Laenge ungeprueft blieb. Der Rand von 10 cm je Seite
         ist derselbe wie zuvor — er steht jetzt in `inselFrei` statt hier. */
      /* Die Inselkueche HAT ihre Insel — `insel` ist hier immer wahr, sonst waere sie
         keine. Sonst gilt dieselbe Regel wie in L und U, inklusive Rueckseite. */
      var mit = {}, k;
      for (k in s) if (Object.prototype.hasOwnProperty.call(s, k)) mit[k] = s[k];
      mit.insel = true;
      /* DIE INSELKUECHE IST EINE GRUNDFORM PLUS INSEL, KEINE EIGENE GEOMETRIE.

         Ohne Angabe bleibt es bei der Zeile — genau dem, was diese Vorlage immer war. Mit
         Angabe rechnet die betreffende Vorlage, und zwar SIE und nicht eine Kopie davon:
         eine zweite Rechnung fuer dieselbe Form waere ein zweites Modell, das auseinander
         laufen kann. Die Insel kommt in beiden Faellen aus inselDazu, weil `mit.insel`
         gesetzt ist. */
      if (s.inselBasis === 'l' || s.inselBasis === 'u') return VORLAGEN[s.inselBasis](mit, t);
      return {
        waende: [{ id: 'A', label: 'Wand A', p0: pt(0, 0), p1: pt(A, 0), planbar: true }],
        bloecke: inselDazu(mit, t, false, false, 0)
      };
    }
  };

  /* Die Tiefe kommt von aussen, weil sie eine SERIENEIGENSCHAFT ist und keine
     Geometrie: Velora misst 47 cm, andere Serien messen mehr. Die Insel steht einen
     Gang von 100 cm vor der Bodenreihe an Wand A — ihre Lage im Raum haengt damit an
     der Tiefe dieser Reihe. Stuende die Zahl fest in der Vorlage, haetten Modell und
     Zeichnung fuer jede andere Serie verschiedene Inseln, und genau diese zwei Modelle
     nebeneinander hat Phase 2 beseitigt. */
  var GANG = 100;

  /* WIE TIEF DER RAUM BEI DIESEN MASSEN HOECHSTENS IST — ueber ALLE Kuechenformen.

     Der gezeichnete Boden soll sich beim Formwechsel nicht aendern, sondern nur, wenn der
     Kunde seine Maße aendert. Dafuer darf er nicht aus der GEWAEHLTEN Form kommen, sondern
     aus dem, was diese Maße ueberhaupt beschreiben koennen: gerechnet wird jede Vorlage
     einmal durch, und die tiefste gewinnt.

     Ueber die Vorlagen gerechnet, nicht ueber `Math.max(B, C)`: die Zahlen bedeuten nicht
     in jeder Form dasselbe. In der U-Kueche sind B und C beides Tiefen, in der
     Parallelkueche ist C die Laenge der zweiten ZEILE. Die Vorlagen kennen den Unterschied,
     die Zahlen kennen ihn nicht.

     DER PREIS, ausdruecklich: wo eine Form flacher ist als die tiefste, wird Boden
     gezeichnet, den sie selbst nicht hat — bei der geraden Kueche fast immer, bei der
     Parallelkueche ein Streifen jenseits von Wand C. Es kommt dabei keine Maßkette und
     keine Wand dazu; es ist Flaeche, keine Aussage. Der Betreiber hat das am 2026-09-06
     ausdruecklich so entschieden, nachdem der Wechsel zwischen den Formen das Bild jedes
     Mal springen liess. */
  /* Die Tiefe DIESER Form — fuer den Druck (Planungs-PDF, `planEcht`). Am Bildschirm bleibt der Boden so tief
     wie die tiefste Form, damit das Rechteck beim Formwechsel stillsteht; auf Papier liesse ein Boden, der unter
     der Wand gegenueber weitergeht (Zweizeilig) oder weit vor einer Zeile liegt, den Raum groesser erscheinen,
     als er ist. */
  function raumTiefeFuer(s, tiefe) {
    var t = tiefe > 0 ? tiefe : GEO_FALLBACK.korpus_tiefe;
    if (!VORLAGEN[s.form]) return raumTiefeMax(s, tiefe);
    var r = raumGeometrie(s, t), tief = 0;
    r.waende.forEach(function (w) { tief = Math.max(tief, w.p0.y, w.p1.y); });
    (r.bloecke || []).forEach(function (b) { tief = Math.max(tief, b.p0.y + t + 20, b.p1.y + t + 20); });
    return Math.max(tief, t + 60);
  }
  function raumTiefeMax(s, tiefe) {
    var t = tiefe > 0 ? tiefe : GEO_FALLBACK.korpus_tiefe;
    var tief = 0;
    Object.keys(VORLAGEN).forEach(function (f) {
      var r = VORLAGEN[f](s, t);
      r.waende.forEach(function (w) { tief = Math.max(tief, w.p0.y, w.p1.y); });
      (r.bloecke || []).forEach(function (b) {
        tief = Math.max(tief, b.p0.y + t + 20, b.p1.y + t + 20);
      });
    });
    return Math.max(tief, t + 60);
  }

  /* Die kuerzeste Insel, die noch eine ist. Der Katalog fuehrt Schraenke ab 20 cm; unter
     60 cm waere der Block schmaler als der Schrank, der darauf soll. */
  var INSEL_MIN = 60;

  /* EINE INSEL IN DER L- ODER U-KUECHE.

     Sie steht wie in der Inselkueche einen Gang vor der Zeile an Wand A — muss dort aber
     zusaetzlich an den SEITENZEILEN vorbei. In der U-Kueche stehen links und rechts
     Schraenke; eine mittig gesetzte Insel, die nur A kennt, klemmte den Gang an beiden
     Enden zu. Die freie Strecke ist deshalb um Tiefe plus Gang je besetzter Seite kuerzer,
     und die Insel wird auf DIESE Strecke zentriert, nicht auf die Wand.

     Passt sie nicht, entsteht sie NICHT. Ein Block, der halb in der Nachbarzeile steht,
     waere eine stille Falschaussage: der Kunde saehe ihn im Bild, koennte ihn bestuecken
     und bekaeme eine Kueche, die so nicht aufstellbar ist.

     Die Inselkueche selbst benutzt diese Regel ausdruecklich NICHT — ihre Vorlage bleibt
     unveraendert. Dort gibt es keine Seitenzeilen, und jede Aenderung an ihrer Lage waere
     eine Aenderung an bestehenden Planungen. */
  /* WIE LANG EINE INSEL HIER HOECHSTENS SEIN KANN — die eine Quelle fuer die Geometrie UND
     fuer die Obergrenze des Eingabefeldes.

     Ohne sie stand im Feld `max="900"`, eine Zahl ohne Bezug zum Raum. Gemessen: in einer
     U-Kueche mit Wand A = 500 betraegt die freie Strecke 196 cm — getippte 900 wurden
     stillschweigend zu 196, und selbst 200 wurden zu 196, waehrend das Feld weiter 200
     zeigte. In der Inselkueche war es umgekehrt: dort wurde gar nicht geklemmt, und 900 cm
     Insel standen in einem 500 cm breiten Raum.

     `links`/`rechts` sagen, an welcher Seite eine Zeile steht; ohne Zeile bleibt der
     schmale Rand von 10 cm, mit Zeile Tiefe plus Gang. */
  /* DIE INSEL IST IN SCHRITT 1 EIN WUNSCH, KEIN MOEBELSTUECK.

     Ihre Tiefe war bisher die Korpustiefe der Serie und ihr Abstand die Konstante GANG. In
     Schritt 1 gibt es aber noch KEINE Serie — der Kunde beschreibt hier den Platz, den die
     Insel einnehmen soll, nicht die Schraenke, aus denen sie spaeter gebaut wird. Ob die
     gewaehlte Serie diesen Wunsch bauen kann, entscheidet sich spaeter und darf ihn hier
     nicht im Voraus beschneiden.

     Fehlen die Felder — gespeicherte Plaene, Aufrufe aus Netzen —, gelten weiter die alten
     Groessen. Die Rechnung ist dieselbe, nur ihre Herkunft ist eine andere. */
  function inselTiefe(s, tiefe) {
    var t = tiefe > 0 ? tiefe : GEO_FALLBACK.korpus_tiefe;
    return +s.IT > 0 ? +s.IT : t;
  }
  function inselGang(s) { return +s.IG > 0 ? +s.IG : GANG; }

  function inselFrei(s, tiefe, links, rechts) {
    /* SEITLICH ZAEHLT DIE STANDARDTIEFE, NICHT DIE DER SERIE (Betreiber 2026-09-29: „عند اعادة تغيير المقاسات تخرب الجزيرة").
       Kasse, Plan und Schrankplaetze rechnen die Insel ohne Serie (52), 3D, Grundriss und Beleg mit ihr (Velora 47). Kuerzten
       die Seitenzeilen die Insel (U 400 mit Insel 160: frei 96 bzw. 106 cm), stand sie in der Zeichnung 10 cm laenger und
       5 cm verschoben — die Vorderreihe 5 cm links, die gespiegelte Rueckreihe 5 cm rechts ihrer Plaetze: die Doppelinsel
       zerfiel in zwei versetzte Haelften. Wie `passt` in inselDazu: EINE Laenge fuer alle; `tiefe` wirkt nur noch auf die
       Lage vor Wand A. */
    var t = GEO_FALLBACK.korpus_tiefe;
    /* Seitlich misst derselbe Abstand: eine Zeile ist eine Zeile, egal an welcher Wand. */
    var g = inselGang(s);
    var xVon = links ? t + g : 10;
    var xBis = (+s.A) - (rechts ? t + g : 10);
    return { von: xVon, bis: xBis, frei: xBis - xVon };
  }

  /* DIE DOPPELTE INSEL — eine Insel, die von BEIDEN Seiten bestueckt wird.

     Sie ist keine zweite Insel und keine tiefere: es ist dieselbe Strecke, zweimal, mit
     entgegengesetzter Richtung. Die Richtung einer Strecke bestimmt ihre Innennormale, und
     die Normale bestimmt, wohin die Schraenke schauen — `I` schaut nach vorne, `IH` mit
     vertauschten Endpunkten nach hinten. Damit braucht weder die Platzierung noch die
     Zeichnung noch 3D eine einzige Sonderregel: fuer sie sind es zwei Bloecke wie jeder
     andere.

     Die beiden liegen exakt aufeinander und sind genau antiparallel. `geometrischeEcken`
     ueberspringt Paare, deren Tangenten parallel sind — es entsteht also keine Scheinecke
     zwischen Vorder- und Rueckseite.

     WEITER WEG VON DER WAND. Die Rueckseite waechst in Richtung Wand A: die Strecke liegt
     bei y0, die Rueckreihe belegt y0-t bis y0. Bliebe y0 bei `t + GANG`, schrumpfte der
     Gang zwischen Wandzeile und Rueckseite auf GANG minus t — bei 100 und 52 also auf
     48 cm. Die doppelte Insel steht deshalb eine Schranktiefe weiter im Raum.

     UND SIE BRAUCHT TIEFE. Vor ihr muss auch noch ein Gang bleiben. Wo der Raum eine
     gemessene Tiefe hat (L, U, zweizeilig), wird das geprueft; die Inselkueche hat keine —
     dort waechst der Raum mit der Insel. */
  function inselDazu(s, tiefe, links, rechts, raumTiefe) {
    if (!s.insel) return [];
    var r = inselFrei(s, tiefe, links, rechts), IL = +s.IL;
    if (!(IL > 0) || r.frei < INSEL_MIN) return [];
    var t = tiefe > 0 ? tiefe : GEO_FALLBACK.korpus_tiefe;
    var laenge = Math.min(IL, r.frei);
    var doppelt = !!s.inselDoppelt;
    var it = inselTiefe(s, tiefe), g = inselGang(s);
    /* DIE RUECKSEITE IST EINE ZWEITE SCHRANKREIHE (Betreiber 2026-09-27: „Doppelinsel
       wirklich bauen"). Am 2026-09-06 war sie schon einmal so gebaut (f0d40c1) und vier
       Stunden spaeter zu einem blossen Merkmal geworden — mit dem Versprechen, die zweite
       Reihe komme „spaeter in der Bestueckung". Sie kam nie: der Schalter zeichnete einen
       Strich und nahm die Barhocker weg, eine Schrankreihe entstand nicht, und der Kunde
       bezahlte eine einseitige Insel, waehrend er eine doppelte gewaehlt hatte.

       Also wieder zwei Bloecke an DERSELBEN Linie, antiparallel: `I` schaut in den Raum,
       `IH` (vertauschte Endpunkte) zur Wandzeile. Fuer Platzierung, Pruefung, Preis, Kasse,
       Zeichnung und 3D sind es zwei Reihen wie jede andere; `geometrischeEcken` ueberspringt
       parallele Paare, eine Scheinecke entsteht nicht.

       DER GANG BLEIBT, WAS DER KUNDE EINGEGEBEN HAT: die Rueckreihe waechst zur Wand hin, die
       Linie steht deshalb eine Schranktiefe weiter im Raum — der Abstand von der Wandzeile
       zu den Fronten der Rueckreihe ist weiter `g`.

       PASST SIE NICHT in die gemessene Raumtiefe (L, U), bleibt es bei der einfachen Insel —
       nicht bei gar keiner: ein Schalter, der die ganze Insel verschwinden liesse, waere
       schlimmer als einer, der nichts tut. `doppeltPasst` sagt es der Bedienung. */
    /* Die Entscheidung „passt die Rueckreihe?" haengt NICHT an der Serientiefe: 3D rechnet mit
       der Korpustiefe der Serie (47), Kasse, Plan und Zeichnung ohne sie (52). Mit `t`
       entschieden stuenden bei 241–255 cm Raumtiefe in 3D zwei Reihen, im Plan eine. */
    var tp = GEO_FALLBACK.korpus_tiefe, braucht = 3 * tp + g;
    var passt = !doppelt || !(raumTiefe > 0) || braucht <= raumTiefe;
    var zwei = doppelt && passt;
    var y0 = zwei ? 2 * t + g : t + g;
    var x0 = r.von + (r.frei - laenge) / 2, x1 = r.von + (r.frei + laenge) / 2;
    /* Die Tiefe reist AM BLOCK mit. Sonst muesste jede Stelle, die ihn zeichnet oder misst,
       sie neu herleiten — und zwei Herleitungen derselben Groesse laufen auseinander. Bei
       der einfachen Insel ist es der Kasten, den der Kunde vorsieht; bei der doppelten traegt
       jede Reihe ihre Schranktiefe, zusammen 2t. */
    var vorne = { id: 'I', label: zwei ? 'Insel vorne' : 'Insel',
                  p0: pt(x0, y0), p1: pt(x1, y0), planbar: true, tiefe: zwei ? t : it };
    vorne.doppelseitig = zwei;
    vorne.doppeltPasst = passt;
    /* Wie tief der Raum fuer zwei Reihen sein muss — die Bedienung nennt die Zahl. */
    vorne.doppeltBraucht = r0(braucht);
    if (!zwei) return [vorne];
    var hinten = { id: 'IH', label: 'Insel hinten',
                   p0: pt(x1, y0), p1: pt(x0, y0), planbar: true, tiefe: t };
    hinten.doppelseitig = true;
    hinten.doppeltPasst = true;
    return [vorne, hinten];
  }

  function raumGeometrie(s, tiefe) {
    var vorlage = VORLAGEN[s.form] || VORLAGEN.gerade;
    var r = vorlage(s, tiefe);
    return { form: s.form, waende: fang(r.waende), bloecke: r.bloecke };
  }

  /* Die alte Schnittstelle, jetzt als duenne Huelle ueber `raumGeometrie`. Es gibt damit
     genau ein Modell und nicht zwei nebeneinander.

     Zwei Dinge sind hier Absicht und keine Nachlaessigkeit:

     1. Die REIHENFOLGE bleibt die alte (A, B, C, I) — nicht die Reihenfolge der Kette.
        Seit Phase 5 haengt daran keine RECHNUNG mehr: die Eckrechnung liest die
        Topologie, und wandIndex ist entfallen. Geblieben ist die ANZEIGE — die
        Wandleiste in Schritt 4 zeigt dem Kunden A, B, C in dieser Folge, und eine
        Kettenreihenfolge (C, A, B in der U-Kueche) waere dort nur verwirrend.

     2. Die INSEL bleibt in der Liste, obwohl sie im Modell ein freistehender Block ist.
        `positionen()` laeuft ueber `waende()`; nimmt man die Insel heraus, verschwinden
        Inselschraenke aus Preis, Warenkorb, Stueckliste und Beleg. Gemessen an einem Plan
        mit drei Schraenken: aus 3 Schraenken zu 300 EUR wurden 1 Schrank zu 100 EUR, ohne
        dass eine einzige der 164 Zusicherungen ansprang. Die Trennung im Modell ist
        richtig; sie darf nur nicht durch diese Huelle durchschlagen. */
  function waende(s) {
    var g = raumGeometrie(s);
    var out = g.waende.map(function (w) {
      return { id: w.id, label: w.label, len: wandLaenge(w) };
    });
    g.bloecke.forEach(function (b) {
      out.push({ id: b.id, label: b.label, len: wandLaenge(b) });
    });
    out.sort(function (a, b) { return ORD.indexOf(a.id) - ORD.indexOf(b.id); });
    return out;
  }
  /* 'IH' ist die RUECKSEITE einer doppelten Insel — dieselbe Strecke, andere Richtung. */
  var ORD = ['A', 'B', 'C', 'I', 'IH'];

  function wandObj(s, id) {
    var ws = waende(s), ziel = id || s.wand, i;
    for (i = 0; i < ws.length; i++) { if (ws[i].id === ziel) return ws[i]; }
    return ws[0];
  }

  /* wandIndex ist mit Phase 5 entfallen. Sie beantwortete "die wievielte Wand ist das?" —
     eine Frage, die nur stellt, wer Nachbarschaft aus der Reihenfolge ableitet. Genau
     daraus entstanden die Phantom-Ecke B/C und die uebersehene Ecke A/C. Wer heute einen
     Nachbarn braucht, fragt wandNachbarn(); wer eine Ecke braucht, schrankEckeAn(). */

  /* ---------- Geometrie: Nennmaß und Ecke ---------- */

  /* Eckschränke: der Korpus misst 79–86 cm, das Rastermaß der Serie ist aber die Zahl im Code
     (D90N = 90). Nur mit dem Rastermaß gehen 90 + 60 + 60 glatt auf eine 210-cm-Wand auf,
     deshalb zählt der Planer die Ecke auf beiden Seiten mit ihrem Nennmaß.
     Die Zifferngruppe ist ziffern-terminiert, damit aus "KU-S60L" keine 60 wird, wo 90 steht. */
  function nennMass(m) {
    if (!istEck(m)) return m.b;
    var z = String(m.code || '').match(/(?:^|[^0-9])(\d{2,3})(?!\d)/);
    var n = z ? +z[1] : 0;
    return n >= m.b ? n : m.b;
  }

  /* Tiefe in der Ecke: quadratische Eckschränke (Korpustiefe ~ Korpusbreite) beanspruchen auf
     der Nachbarwand dasselbe Nennmaß; ein flacher Eckschrank mit Blende bleibt bei seiner Tiefe. */
  function nennTiefe(m) {
    if (!istEck(m)) return m.t;
    var n = nennMass(m);
    return (m.t || 0) >= m.b - 12 ? n : m.t;
  }

  /* FUSSABDRUCK ist das Nennmaß (90 × 90 — so viel Wand ist auf beiden Seiten weg), die
     SCHENKELDICKE aber die Reihenflucht (59,5). Beides gleichzusetzen ließ das L zu einem
     vollen Klotz zusammenfallen: die Kerbe hatte Größe null. */
  function schenkel(b) { return Math.min(flucht(), b - 1); }

  /* Stellfläche: hinter einer Gerätefront (1,8 cm Blende) steht die Maschine in voller
     Reihentiefe. Der Grundriss zeigt den Platzbedarf, nicht die Plattenstärke — sonst
     "schwebt" eine Geschirrspülerfront ohne Maschine dahinter an der Wand. */
  function stellTiefe(it, tiefe, zl) {
    var tt = it.t || tiefe;
    if (zl === 'boden') {
      var fl = flucht();
      return Math.max(fl, tt > fl ? tt : 0) || fl;
    }
    return tt > tiefe * 0.5 ? tt : tiefe;
  }

  /* Ein Eckschrank ist gebaut wie ein L: ein Schenkel an dieser Wand, einer um die Ecke.
     Wohin der zweite zeigt, sagt die TOPOLOGIE — nicht mehr eine Tabelle aus Buchstaben
     und Raumformen. Die alte Fassung entschied `wid === 'C'` heisst "Ecke am fernen
     Ende"; bei der zweizeiligen Kueche liegt die einzige Beruehrung von C aber am Anfang,
     und weil die Verbindungswand nicht bestueckt wird, ist es ueberhaupt keine
     Schrank-Ecke. Steht ein Eckschrank nicht in einer tauglichen Ecke, gibt es kein L —
     dann ist er dort schlicht falsch, und die Pruefung sagt das.
     Rueckgabe: null (kein L) oder {x} = Kante des zurueckspringenden Schenkels, die
     naeher an p0 liegt. */
  function eckL(s, wid, it, tiefe) {
    var m = it.m;
    if (!istEck(m)) return null;
    /* Mit dem NENNmass verglichen, nicht mit it.b: rueckt die Nachbarreihe an ihre Wand (wandVersatz), ist der
       Eckschrank auf dieser Wand ein paar Zentimeter schmaler — und bleibt doch ein L. */
    var nm = nennMass(m);
    if (Math.abs((it.t || tiefe) - nm) > 1 || nm <= tiefe + 4) return null;
    var raum = raumGeometrie(s), w = wandAus(raum, wid);
    if (!w) return null;
    var len = wandLaenge(w);
    if (schrankEckeAn(raum, wid, 'anfang') && it.x <= EPS_ECKE) return { x: it.x };
    if (schrankEckeAn(raum, wid, 'ende') && it.x + it.b >= len - EPS_ECKE) {
      return { x: it.x + it.b - tiefe };
    }
    return null;
  }

  /* Grundriss-Fußabdruck: Rechteck, beim Eckschrank aber dasselbe L wie in 3D.
     map(u, v) übersetzt Wandkoordinaten (u längs der Wand, v Tiefe) in Zeichenkoordinaten. */
  /* `daten` (optional): mit dem Wandversatz — die Reihe steht um vo naeher an ihrer Wand, der zweite Schenkel eines
     Eckschranks ist um den Versatz der Nachbarwand duenner (seine Front liegt in deren Frontebene). */
  function grundPfad(s, wid, it, tiefe, map, daten) {
    var eL = eckL(s, wid, it, tiefe), tt = stellTiefe(it, tiefe, 'boden'), x = it.x, b = it.b;
    var vo = daten ? wandVersatz(s, daten, wid, 'boden') : 0;
    var d = schenkel(b), pts;
    if (!eL) pts = [[x, 0], [x + b, 0], [x + b, tt - vo], [x, tt - vo]];
    else {
      var R = (nennTiefe(it.m) || b) - vo, dn = d - Math.max(0, nennMass(it.m) - b), dv = d - vo;
      if (eL.x <= x + 0.5) pts = [[x, 0], [x + b, 0], [x + b, dv], [x + dn, dv], [x + dn, R], [x, R]];
      else pts = [[x, 0], [x + b, 0], [x + b, R], [x + b - dn, R], [x + b - dn, dv], [x, dv]];
    }
    return 'M' + pts.map(function (p) { var q = map(p[0], p[1]); return zahl(q[0]) + ' ' + zahl(q[1]); }).join(' L ') + ' Z';
  }

  /* Was von der Nachbarwand her in DIESE Wand hineinragt. Frueher standen hier drei
     eigene Rechnungen ueber ws[i+1] und ws[i-1] — die Array-Reihenfolge als Ersatz fuer
     Nachbarschaft. Jetzt sind es drei Sichten auf EINE Quelle: eckBelegung, und die liest
     die Topologie. */
  function eckNachbar(s, daten, wand, zl) { return eckBelegung(s, daten, wand, zl).ende; }
  function eckVorher(s, daten, wand, zl) { return eckBelegung(s, daten, wand, zl).anfang; }
  function eckOffset(s, daten, wand, zl) {
    var a = eckBelegung(s, daten, wand, zl).anfang;
    return a ? a.cm : 0;
  }

  /* Nutzbare Länge: Wandmaß minus dem, was die Ecken beider Nachbarn hier einnehmen.
     BEIDE zählen — vorher fehlte die zweite, und Wand B meldete "360 frei", obwohl
     90 cm längst verbraucht waren. */
  /* Nicht EINE Zahl, sondern ein Intervall. Eine Wand kann von BEIDEN Enden her belegt
     sein, und eine einzelne Restlaenge sagt nicht, wo diese Reste liegen: 270 freie
     Zentimeter auf einer 360er Wand koennen bei 0 oder bei 90 beginnen. Genau diese
     Verwechslung machte den Unterschied zwischen "die Ecke ist am Anfang" und "die Ecke
     ist am Ende" unsichtbar — und beide Faelle kommen in einer U-Kueche an derselben
     Wand vor. */
  function nutzIntervall(s, daten, wand, zl) {
    var z = zl || 'boden', b = eckBelegung(s, daten, wand, z), len = wandObj(s, wand).len;
    var start = b.anfang ? b.anfang.cm : 0;
    var ende = len - (b.ende ? b.ende.cm : 0);
    return { start: start, ende: ende, len: Math.max(0, ende - start) };
  }
  function nutzLaenge(s, daten, wand, zl) { return nutzIntervall(s, daten, wand, zl).len; }

  /* ---------- Geometrie: die Schränke an einer Wand ---------- */

  /* Jeder Schrank hat seine eigene Stelle an der Wand — wie ein Fenster. Solange der Kunde ihn
     nicht selbst verschoben hat, setzt er sich lückenlos an den vorigen an (xpos = null); nach
     dem Ziehen steht die Stelle in xpos und bleibt dort, auch wenn Nachbarn wandern. */
  /* Ein Dunstschrank haengt ueber der Kochstelle, und dort ist der Abstand zur Arbeitsplatte
     vorgeschrieben: 55 cm ueber Elektro, 65 ueber Gas.

     Gemessen: bei Glanzia und Velora ist die Standardnische 54 cm — einer zu wenig. Das ist
     kein Planungsfehler des Kunden, sondern eine Folge der Flucht: die Oberschraenke schliessen
     oben mit den Hochschraenken ab (140 + 72 = 212 = Hochschrankhoehe), und aus derselben Flucht
     folgt die Unterkante 140. Bei Lunara ergibt dieselbe Rechnung 141 -> 55, bei Livaro 147 -> 56.
     Der fehlende Zentimeter gehoert also keiner Seite: die Flucht ist richtig, die Vorschrift auch.

     Vorher sperrte das den Warenkorb bei JEDER Glanzia- und Velora-Planung mit Dunstschrank ueber
     Elektro — die Meldung verlangte vom Kunden genau das, was der Planer selbst ausrechnen kann.
     Jetzt haengt dieser eine Schrank so hoch, dass der Abstand stimmt; in einer echten Kueche
     wird die Haubenzeile genauso gesetzt.

     Es ist ein MINDESTmass, kein fester Wert: wer den Schrank weiter hochzieht, behaelt seine
     Hoehe. Die Bedingung ist dieselbe wie in der Pruefung — Herd oder Gas auf DIESER Wand, ohne
     waagrechte Feinpruefung — sonst koennte die Meldung fuer einen Schrank feuern, den das
     Anheben nie erreicht. */
  function dunstMindestOff(s, daten, wand) {
    if (!daten) return 0;
    var mk = (s.merkmale || []).filter(function (x) {
      return x.wand === wand && (x.typ === 'herd' || x.typ === 'gas');
    });
    if (!mk.length) return 0;
    var gas = mk.some(function (x) { return x.typ === 'gas'; });
    var soll = gas ? HAUBE.abstandGas : HAUBE.abstandElektro;
    /* Bewusst ohne Plattenwahl (Seriengeometrie, siehe plattenDicke): das Anheben platziert einen Schrank; die Pruefung misst
       den Abstand mit der gewaehlten Platte nach — mit einer duenneren Platte ist er nur groesser. */
    return Math.max(0, soll - nischenHoehe(daten));
  }

  /* Die Regel dazu steht in items(). Hier nur die Entscheidung, damit die Startkueche die
     Haengereihe an dieselbe Seite lehnen kann wie die Bodenreihe. */
  function reiheEnden(raum, wand, iv, pl, wlen) {
    var nbar = raum.bloecke.some(function (bl) { return bl.id === wand; }) ? { amAnfang: null, amEnde: null }
      : wandNachbarn(raum, wand);
    return { zuAnfang: pl.anfang != null || iv.start > EPS_ECKE || !!nbar.amAnfang,
             zuEnde: pl.ende != null || iv.ende < wlen - EPS_ECKE || !!nbar.amEnde };
  }
  function lehntRechts(raum, wand, iv, pl, wlen) {
    var e = reiheEnden(raum, wand, iv, pl, wlen);
    return !e.zuAnfang && e.zuEnde;
  }
  function endenVon(s, daten, wand, zl) {
    var raum = raumGeometrie(s);
    return reiheEnden(raum, wand, nutzIntervall(s, daten, wand, zl), eckPlaetze(s, daten, raum, wand, zl),
      wandObj(s, wand).len);
  }
  function reiheVonRechts(s, daten, wand, zl) {
    if (!daten) return false;
    var e = endenVon(s, daten, wand, zl);
    return !e.zuAnfang && e.zuEnde;
  }

  function items(s, daten, wand, zl) {
    var arr = (s.plan && s.plan[wand + '|' + zl]) || [], out = [];
    if (!daten) return out;
    var key = wand + '|' + zl;
    var offs = (s.hoff || {})[key] || [];
    var xs = (s.xpos || {})[key] || [];
    var wl = (s.wahl || {})[key] || [];
    /* Ein Eckschrank steht in einer ECKE, nicht an einer Zahl. Frueher begann jede Reihe
       stumpf bei 0; auf Wand A und B ist 0 zufaellig eine Ecke, auf Wand C einer U-Kueche
       ist es das offene Ende. Ein frisch gesetzter Eckschrank stand dort also, wo gar
       keine Ecke ist — und die Zeichnung zeigte trotzdem ein L. */
    var raum = raumGeometrie(s);
    var iv = nutzIntervall(s, daten, wand, zl);
    var pl = eckPlaetze(s, daten, raum, wand, zl);
    var wlen = wandObj(s, wand).len;
    var flow = iv.start;
    /* Nur die obere Reihe kennt Dunstschraenke; fuer alle anderen ist das Mindestmass 0. */
    var dunstMin = zl === 'oben' ? dunstMindestOff(s, daten, wand) : 0;

    /* ERSTER DURCHGANG: was steht FEST? Ein gezogener Schrank und ein Eckschrank haben ihre
       Stelle, bevor irgendetwas fliesst. */
    var fest = [];
    /* Der Eckschrank ist auf dieser Wand um den Versatz der NACHBARWAND schmaler (oder breiter): seine Front um die Ecke
       steht in ihrer Frontebene, und die rueckt mit ihrer Reihe (siehe wandVersatz). */
    var vk = versatzKarte(s, daten, raum), vz = zl === 'aufsatz' ? 'boden' : zl;
    var eckBreite = function (m, seite) {
      var b0 = nennMass(m);
      if (!seite) return b0;
      var n = eckNachbarWand(raum, wand, seite);
      return n ? b0 - (vk[n + '|' + vz] || 0) : b0;
    };
    arr.forEach(function (mi, i) {
      var m = daten.modelle[mi];
      if (!m) return;
      var b = eckBreite(m, pl.je[i] || null), seite = pl.je[i] || null;
      if (seite === 'anfang') fest.push({ a: 0, b: b });
      else if (seite === 'ende') fest.push({ a: wlen - b, b: wlen });
      else if (xs[i] != null) fest.push({ a: xs[i], b: xs[i] + b });
    });
    /* Ein STELLPLATZ (eigener Geschirrspueler ohne Front) steht fuer den Fluss so fest wie ein
       gezogener Schrank: die Bodenreihe fliesst um ihn herum. Vorher lief sie hinein, und die
       Pruefung meldete „durch … belegt" (Planer-App 2026-09-26: Front → Stellplatz an derselben
       Stelle, ohne dass ein Nachbar rueckt). Ein gueltiger Plan aendert sich dadurch nicht — in
       ihm steht nichts auf dem Stellplatz. */
    /* Der raumhohe Stellplatz (eigener Kuehlschrank) sperrt auch die Haengereihe und die Aufsaetze. */
    if (zl === 'boden' || zl === 'oben' || zl === 'aufsatz') {
      (s.merkmale || []).forEach(function (m) {
        if (m.wand !== wand || !MT[m.typ] || !MT[m.typ].stellplatz) return;
        if (zl !== 'boden' && !MT[m.typ].hoch) return;
        var e = elementIntervallAufWand(m);
        if (e.laenge > 0) fest.push({ a: e.start, b: e.ende });
      });
    }
    /* Die erste Stelle ab `von`, an der `br` Zentimeter frei sind. Ohne das bekam ein neu
       gesetzter Schrank stumpf die naechste Flussstelle — und die lag hinter einem GEZOGENEN
       Schrank, der den Fluss nicht aufhaelt. Zwei Korpusse standen dann uebereinander, mit
       zwei Loeschkreuzen an derselben Stelle. Gemeldet mit Bild.

       Gesucht wird von links: die Luecke vor dem ersten Hindernis, sonst hinter jedem. Passt
       nirgends etwas, bleibt die letzte Stelle — dann greift die Pruefung, und die Sperre in
       `setzen` haette den Schrank ohnehin nicht mehr angenommen. */
    var freieStelle = function (von, br) {
      var kanten = fest.slice().sort(function (p, q) { return p.a - q.a; });
      var x = von, k;
      for (k = 0; k < kanten.length; k++) {
        if (kanten[k].b <= x) continue;
        if (kanten[k].a - x >= br - 0.01) return x;
        x = Math.max(x, kanten[k].b);
      }
      return x;
    };

    /* AN WELCHES ENDE LEHNT SICH DIE REIHE?

       Bis 2026-09-25 floss jede Reihe vom Wandanfang aus. Steht die Ecke aber am ENDE (Wand A
       der L-Kueche, Wand C der U-Kueche), blieb jeder Rest zwischen dem letzten Schrank und dem
       Eckschrank haengen — mitten in der Kueche und oft schmaler als jeder Schrank der Serie
       (Velora: nichts unter 30 cm). Dasselbe nach jedem Tausch gegen einen schmaleren Schrank.
       Der Betreiber: „viele Luecken, in die ich keinen Schrank setzen kann".

       Jetzt lehnt sich die Reihe an ihr GESCHLOSSENES Ende: ist der Anfang offen und das Ende
       zu (eigener Eckschrank, Ecke der Nachbarwand oder eine anstossende Wand), fliesst sie
       von rechts; der Rest liegt dann am offenen Ende, wo die Kueche einfach aufhoert. Sonst
       bleibt es beim Fluss von links. Die Reihenfolge bleibt die des Plans: links nach rechts. */
    var vonRechts = lehntRechts(raum, wand, iv, pl, wlen);
    /* Spiegelbild von freieStelle: die letzte Stelle bis `bis`, an der `br` frei sind. */
    var freieStelleRueck = function (bis, br) {
      var kanten = fest.slice().sort(function (p, q) { return q.b - p.b; });
      var x = bis, k;
      for (k = 0; k < kanten.length; k++) {
        if (kanten[k].a >= x) continue;
        if (x - kanten[k].b >= br - 0.01) return x - br;
        x = Math.min(x, kanten[k].a);
      }
      return x - br;
    };
    var xVon = {};
    if (vonRechts) {
      var flowR = iv.ende;
      for (var ir = arr.length - 1; ir >= 0; ir--) {
        var mr = daten.modelle[arr[ir]];
        if (!mr || pl.je[ir] || xs[ir] != null) continue;
        var br0 = nennMass(mr);
        xVon[ir] = freieStelleRueck(flowR, br0);
        flowR = xVon[ir];
        fest.push({ a: xVon[ir], b: xVon[ir] + br0 });
      }
    }

    arr.forEach(function (mi, i) {
      var m = daten.modelle[mi];
      if (!m) return;
      var seite = pl.je[i] || null;
      var b = eckBreite(m, seite);
      /* Die ECKE schlaegt die gespeicherte Zahl. Ohne diesen Zusatz wurde ein Eckschrank zwar
         einer Ecke ZUGEORDNET, aber weiterhin an seiner alten Stelle gezeichnet — und die
         Pruefung meldete dann folgerichtig "beginnt bei 20 cm und ragt in die Ecke". Aus einem
         falschen Fehler waeren zwei geworden. Ein Eckschrank ist auch keine freie Position: er
         laesst sich nicht ziehen. */
      var frei = xs[i] != null && !seite;
      var x;
      if (frei) { x = xs[i]; }
      else if (seite === 'anfang') { x = 0; flow = Math.max(flow, x + b); }
      else if (seite === 'ende') { x = wlen - b; }
      else if (vonRechts) { x = xVon[i]; }
      else { x = freieStelle(flow, b); flow = x + b; fest.push({ a: x, b: x + b }); }
      out.push({
        i: i, mi: mi, m: m, x: x, b: b, t: nennTiefe(m),
        off: Math.max(offs[i] == null ? 0 : offs[i],
                       m.funktion === 'haengeschrank_dunst' ? dunstMin : 0), frei: frei,
        eckseite: seite,
        wahl: wl[i] == null ? null : wl[i]
      });
    });

    /* Wer auf wem steht, ergibt sich aus der Geometrie statt aus einem Kennzeichen: ein Schrank
       ruht auf dem, der unter ihm liegt und ihn waagrecht trägt.

       Gesucht wird ueber die REIHEN HINWEG, und das ist der Punkt. Vorher sah diese Stelle nur
       die eigene Reihe — ein Haengeschrank konnte damit NIE von einem Hochschrank getragen
       werden, obwohl genau das der Normalfall ist. Gemessen an Velora und Glanzia: der
       Kuehlumbauschrank D60ZL steht 0 bis 212 cm, und ein um 72 cm angehobener Haengeschrank
       hat seine Unterkante bei 140 + 72 = 212 — punktgenau buendig, beide 60 cm breit. Der
       Planer behauptete trotzdem, er werde nicht getragen.

       Verglichen wird deshalb in ABSOLUTEN Hoehen, jede Reihe mit ihrer eigenen Unterkante.
       Die Suchrichtung ist kreisfrei: der Boden traegt sich nicht selbst, `oben` schaut auf
       `oben` und `boden`, `aufsatz` zusaetzlich auf `oben` — nie umgekehrt. */
    var gg = geo(daten);
    var GBASIS = { boden: 0, oben: gg.haenge_unterkante, aufsatz: gg.hochschrank_hoehe };
    var DARUNTER = { boden: [], oben: ['oben', 'boden'], aufsatz: ['aufsatz', 'oben', 'boden'] };
    var fremde = {};
    if (zl !== 'boden') {
      (DARUNTER[zl] || []).forEach(function (zl2) {
        if (zl2 !== zl) fremde[zl2] = items(s, daten, wand, zl2);
      });
    }
    out.forEach(function (it) {
      if (zl === 'boden' || it.off <= 0.5) { it.traeger = null; it.gestapelt = false; return; }
      var meinUnten = GBASIS[zl] + it.off;
      var kand = [];
      (DARUNTER[zl] || []).forEach(function (zl2) {
        var liste = (zl2 === zl) ? out : (fremde[zl2] || []);
        liste.forEach(function (o) {
          if (zl2 === zl && o === it) return;
          var oben2 = GBASIS[zl2] + (o.off || 0) + o.m.h;
          if (oben2 <= meinUnten + 0.6 && it.x >= o.x - 2 && it.x + it.b <= o.x + o.b + 2) {
            kand.push({ o: o, oben: oben2 });
          }
        });
      });
      kand.sort(function (a, b2) { return b2.oben - a.oben; });
      var unten = kand[0];
      it.traeger = unten ? unten.o : null;
      it.gestapelt = !!unten && Math.abs(unten.oben - meinUnten) < 1.5;
    });
    return out;
  }

  /* Wie weit reicht die Reihe nach rechts? Nicht die Summe der Breiten — nach dem Ziehen
     können Lücken entstehen, und die zählen mit. */
  function belegt(s, daten, wand, zl) {
    return items(s, daten, wand, zl).reduce(function (mx, it) {
      return Math.max(mx, it.x + it.b);
    }, 0);
  }

  /* Die BELEGTE Laenge einer Reihe — nicht ihre aeusserste Kante. `belegt` oben ist die Kante
     und bleibt es: fuer die Breite der Zeichnung ist sie genau richtig. Als Laenge gelesen log
     sie, sobald die Reihe nicht lueckenlos am Anfang beginnt. Ein Eckschrank am Wandende
     (Wand A der L-Kueche, Wand C der U-Kueche) machte die Kante sofort zum Wandende —
     "240 von 240 cm belegt · genau voll" mit einem einzigen 90er —, und auf einer Wand, deren
     Anfang die Ecke der Nachbarwand belegt, zaehlte dieser Versatz als belegt. Gezaehlt wird
     deshalb die Vereinigung der Schrankstrecken: was sich ueberlagert einmal, was frei ist gar
     nicht. */
  function belegtLaenge(s, daten, wand, zl) {
    var st = items(s, daten, wand, zl).map(function (it) { return [it.x, it.x + it.b]; })
      .sort(function (p, q) { return p[0] - q[0]; });
    var summe = 0, a = null, e = null;
    st.forEach(function (k) {
      if (a === null) { a = k[0]; e = k[1]; }
      else if (k[0] <= e) { e = Math.max(e, k[1]); }
      else { summe += e - a; a = k[0]; e = k[1]; }
    });
    if (a !== null) summe += e - a;
    return summe;
  }

  /* ---------- Bilanz ---------- */

  /* EINE Definition für die ganze Zeile:
        eigene Schränke + Ecke der Nachbarwand + frei = Wandlänge
     Ohne den Eckanteil stand "belegt 270" neben "genau voll", und die Zeile widersprach sich
     selbst. `belegt` sind nur die eigenen Schränke: bei leerer Reihe 0 — sonst stand dort
     einmal "belegt −90". */
  function bilanz(s, daten, wand) {
    /* Belegt ist die LAENGE der eigenen Schraenke (belegtLaenge), nicht "Kante minus Versatz":
       das stimmte nur fuer eine Reihe, die lueckenlos am Anfang beginnt. */
    var off = eckOffset(s, daten, wand, 'boden');
    var bel = belegtLaenge(s, daten, wand, 'boden');
    /* Ohne Deckelung gerechnet: `nutzLaenge` klemmt auf 0, und genau das machte die Zeile
       unwahr. Wand 60 cm, Nachbarecke braucht 90 -> belegt 0 + Ecke 90 + frei 0 = 90 auf einer
       60-cm-Wand, gemeldet als "genau voll". Die Ecke passt nicht, die Wand ist leer, und der
       Kunde las, es sei alles in Ordnung. `nutzLaenge` bleibt geklemmt — Platzierungen brauchen
       das —, die BILANZ sagt die Wahrheit. */
    var eN = eckNachbar(s, daten, wand, 'boden');
    var eck = (eN ? eN.cm : 0) + off;
    var ob = belegtLaenge(s, daten, wand, 'oben');
    var wo = wandObj(s, wand);
    var wg = wandAus(raumGeometrie(s), wand);
    var nichtPlanbar = !!wg && wg.planbar === false;
    var frei = wo.len - bel - eck;
    return {
      id: wand, label: wo.label, len: r0(wo.len),
      belegt: bel, ecke: eck, frei: frei, oben: ob,
      belegtText: r0(bel) + (eck ? ' + Ecke ' + r0(eck) : ''),
      obenText: ob > 0 ? ' · oben ' + r0(ob) + ' cm' : '',
      rest: nichtPlanbar ? 'Durchgang' : (frei < 0 ? r0(-frei) + ' cm zu lang'
            : (frei === 0 ? 'genau voll' : r0(frei) + ' cm frei')),
      planbar: !nichtPlanbar,
      zuLang: frei < 0 && !nichtPlanbar, genauVoll: frei === 0 && !nichtPlanbar
    };
  }




  /* ================= Sichern und Wiederherstellen =================

     Der Speicher haelt FINGERABDRUECKE, weder Indizes noch blosse Codes.

     Die Referenz speichert `plan: { "A|boden": [3, 7, 7] }` — Positionen in `daten.modelle` —
     und uebernimmt sie beim Laden ungeprueft. Fuer diesen Shop ist das nicht tragbar: die vier
     Katalogdateien werden aus Shopify generiert (build_catalog.py). Eine Neugenerierung mit
     einem neuen Produkt aendert die Reihenfolge, und die gespeicherte Planung des Kunden waere
     danach still eine ANDERE Kueche — gleiche Zahlen, andere Schraenke, ohne jede Meldung.

     Ein Fingerabdruck ueberlebt die Neugenerierung. Was der neue Katalog nicht mehr kennt,
     faellt beim Laden weg und wird GEZAEHLT — daraus muss Stufe 4 eine Meldung machen. */

  var SPEICHER = 'hmk-planer-v2';

  /* Die Fassung des GESPEICHERTEN Formats. Sie steht ausdruecklich im Datensatz und nicht
     nur im Schluesselnamen: der Schluessel hiess schon 'v2', als sich das Format zum
     zweiten Mal aenderte, und ein Name, der nachgezogen werden muss, wird irgendwann
     vergessen.

       1  die erste Fassung (Schluessel hmk-planer-v1), Plan als Modellindizes
       2  Plan als Fingerabdruecke, Merkmale, Zubehoer
       3  wie 2, aber: `zweizeilig` ist eine gueltige Raumform, und die Eckschraenke
          liegen in ihrer Ecke statt an der Stelle 0 ihrer Reihe

     Was Fassung 3 NICHT tut: Felder umbenennen oder wegwerfen. Ein Datensatz aus 2 laesst
     sich vollstaendig lesen; er bekommt nur seine Fassungsnummer. */
  var SCHEMA = 3;

  /* Der Schluessel eines Modells im Speicher.

     Erst hielt der Speicher INDIZES — das war falsch, weil die vier Katalogdateien aus Shopify
     generiert werden und ein neues Produkt die Reihenfolge verschiebt.

     Dann hielt er CODES — auch das war falsch, und zwar messbar: `code` ist kein
     Primaerschluessel. Lunara fuehrt `W60` ZWEIMAL, einmal 72 cm hoch fuer 251,99 € und einmal
     92 cm fuer 269,99 €; Glanzia fuehrt vier Geschirrspuelerfronten doppelt. Eine Suche nach
     dem Code allein trifft eine der beiden willkuerlich — der Kunde bekaeme seinen 72er
     Haengeschrank als 92er zurueck, 20 cm hoeher und 18 € teurer, ohne jede Meldung.

     Deshalb der volle Fingerabdruck. Geprueft: `code|reihe|funktion|b|h|t` ist in allen vier
     Katalogen eindeutig, ohne eine einzige Kollision. */
  function fingerabdruck(m) {
    return [m.code, m.reihe, m.funktion, m.b, m.h, m.t].join('|');
  }

  /* Was gespeichert wird — Plan, Montagehoehen und Wandstellen IM GLEICHSCHRITT.

     Vorher fielen Eintraege ohne Modell aus der Planliste, waehrend `hoff` und `xpos` alle
     Plaetze behielten. Beim Zurueckholen erbte danach jeder folgende Schrank die Werte seines
     Vorgaengers: ein auf 200 cm gezogener Schrank kam auf 60 cm zurueck, 140 cm daneben, und
     `verloren` blieb 0 — also nicht einmal eine Meldung. */
  function planSichern(z, daten) {
    var plan = {}, hoff = {}, xpos = {}, wahl = {}, verloren = 0;
    if (!daten) return null;
    Object.keys(z.plan || {}).forEach(function (key) {
      var altH = (z.hoff || {})[key] || [], altX = (z.xpos || {})[key] || [];
      var altW = (z.wahl || {})[key] || [];
      plan[key] = []; hoff[key] = []; xpos[key] = []; wahl[key] = [];
      (z.plan[key] || []).forEach(function (mi, pos) {
        var m = daten.modelle[mi];
        if (!m) { verloren++; return; }
        var neuPos = plan[key].length;
        plan[key].push(fingerabdruck(m));
        hoff[key][neuPos] = altH[pos] == null ? null : altH[pos];
        xpos[key][neuPos] = altX[pos] == null ? null : altX[pos];
        wahl[key][neuPos] = altW[pos] == null ? null : altW[pos];
      });
    });
    return { plan: plan, hoff: hoff, xpos: xpos, wahl: wahl, verloren: verloren };
  }

  function planCodes(z, daten) {
    var r = planSichern(z, daten);
    return r ? r.plan : {};
  }

  /* Rueckweg gegen den FRISCHEN Katalog, dreistufig:
       1. voller Fingerabdruck — dasselbe Modell, unveraendert.
       2. nur der Code, aber NUR wenn er im neuen Katalog eindeutig ist. Damit ueberlebt eine
          Planung eine Preis- oder Titelaenderung, ohne je auf einen Doppelgaenger zu rutschen.
       3. sonst verloren und GEZAEHLT — eine Meldung ist besser als eine stille Veraenderung.
     `hoff` und `xpos` wandern positionstreu mit: faellt ein Eintrag weg, ruecken die uebrigen
     auf, und ihre Montagehoehe und Wandstelle muessen mitruecken. */
  function planIndizes(gespeichert, daten) {
    var plan = {}, hoff = {}, xpos = {}, wahl = {}, verloren = 0;
    if (!daten) return { plan: plan, hoff: hoff, xpos: xpos, wahl: wahl, verloren: 0 };
    /* UMZUG (2026-09-26): Glanzia fuehrte die grauen Eintuerer mit Anschlag (KU-US113/114) unter D60,
       dem Zweituerer. Seit sie bei D60-P stehen, bietet D60 in Grau keinen Anschlag mehr — ein
       gespeicherter „D60, rechts" kaeme als Zweituerer zurueck. Wird die gespeicherte Wahl am Modell
       in der gespeicherten Farbe nicht mehr angeboten, bietet sie aber genau EIN anderes Modell
       gleicher Reihe, Funktion und Breite an, zieht der Eintrag dorthin um. */
    var umzug = function (i, w) {
      var m = daten.modelle[i], f = gespeichert.farbe;
      if (!m || w == null || !f || optWerte(m, f, [w]).length) return i;
      var ziel = [];
      daten.modelle.forEach(function (x, j) {
        if (j !== i && x.reihe === m.reihe && x.funktion === m.funktion && Math.abs(x.b - m.b) < 0.5
          && optWerte(x, f, [w]).length) ziel.push(j);
      });
      return ziel.length === 1 ? ziel[0] : i;
    };

    var nachFinger = {}, codeZahl = {}, nachCode = {};
    daten.modelle.forEach(function (m, i) {
      nachFinger[fingerabdruck(m)] = i;
      var c = String(m.code).toUpperCase();
      codeZahl[c] = (codeZahl[c] || 0) + 1;
      if (nachCode[c] == null) nachCode[c] = i;
    });

    Object.keys(gespeichert.plan || {}).forEach(function (key) {
      var eintraege = gespeichert.plan[key] || [];
      var altH = (gespeichert.hoff || {})[key] || [];
      var altX = (gespeichert.xpos || {})[key] || [];
      var altW = (gespeichert.wahl || {})[key] || [];
      plan[key] = []; hoff[key] = []; xpos[key] = []; wahl[key] = [];
      eintraege.forEach(function (eintrag, pos) {
        var i = nachFinger[eintrag];
        if (i == null) {
          var c = String(eintrag).split('|')[0].toUpperCase();
          if (codeZahl[c] === 1) i = nachCode[c];
        }
        if (i == null) { verloren++; return; }
        i = umzug(i, altW[pos]);
        var neuPos = plan[key].length;
        plan[key].push(i);
        hoff[key][neuPos] = altH[pos] == null ? null : altH[pos];
        xpos[key][neuPos] = altX[pos] == null ? null : altX[pos];
        wahl[key][neuPos] = altW[pos] == null ? null : altW[pos];
      });
    });
    return { plan: plan, hoff: hoff, xpos: xpos, wahl: wahl, verloren: verloren };
  }

  /* Was gesichert wird. Alles Uebrige ist abgeleitet und wird bei jedem Zeichnen neu gerechnet:
     Positionen, Preise, Bilanz, Pruefmeldungen, SVG-Pfade. */
  /* Ohne Katalog ist der Plan NICHT leer — er ist nur nicht uebersetzbar. Ihn trotzdem als
     `{}` zu schreiben loeschte beim naechsten Seitenaufruf die ganze Planung des Kunden, noch
     bevor der Katalog geladen war. Also: was schon im Speicher steht, bleibt stehen. */
  /* EINE Beschreibung dessen, was eine Planung ausmacht. Sie geht an zwei Stellen hinaus:
     in den `localStorage` des Kunden und — seit der Draft-Order-Strecke — an `/plan`.
     Zweimal aufgeschrieben waeren es zwei Fassungen, die auseinanderlaufen, sobald jemand
     ein Feld ergaenzt. Preise, Betraege und Berechtigungen stehen bewusst NICHT darin:
     der Server rechnet sie selbst. */
  function planNutzlast(z, daten) {
    var p = planSichern(z, daten);
    var alt = p ? null : gesichert();
    return {
        schemaVersion: SCHEMA,
        /* `v` bleibt stehen, solange aeltere Fassungen der Seite im Umlauf sein koennen:
           sie lesen es, und ein fehlendes Feld liesse sie den Plan verwerfen. Gelesen wird
           es hier nicht mehr — dafuer ist schemaVersion da. */
        v: 2, serie: z.serie, farbe: z.farbe, zusatz: z.zusatz, form: z.form,
        A: z.A, B: z.B, C: z.C, IL: z.IL, IT: z.IT, IG: z.IG,
        insel: !!z.insel, inselDoppelt: !!z.inselDoppelt,
        bLinks: !!z.bLinks, inselBasis: z.inselBasis || null, hoehe: z.hoehe,
        wand: z.wand, step: z.step,
        plan: p ? p.plan : ((alt && alt.plan) || {}),
        hoff: p ? p.hoff : ((alt && alt.hoff) || z.hoff),
        xpos: p ? p.xpos : ((alt && alt.xpos) || z.xpos),
        wahl: p ? p.wahl : ((alt && alt.wahl) || z.wahl),
        merkmale: z.merkmale, mid: z.mid,
        /* Die Antworten der „Ausstattung" (Planer-App) — nur Bauwuensche, keine Ware. */
        wunsch: z.wunsch || null,
        listeModus: z.listeModus, zeigeOben: z.zeigeOben !== false, zubehoer: z.zubehoer || {},
        platte: z.platte || null,
        ansicht: z.ansicht || '2d', blick: z.blick || null
    };
  }

  function sichern(z, daten) {
    try {
      UMGEBUNG.schreiben(SPEICHER, JSON.stringify(planNutzlast(z, daten)));
      return true;
    } catch (e) { return false; }
  }

  /* Welche Fassung liegt da? Ein Datensatz ohne schemaVersion stammt aus der Zeit davor;
     `v` unterscheidet dann 1 von 2. Geraten wird nichts. */
  function schemaVon(g) {
    if (!g || typeof g !== 'object') return 0;
    if (typeof g.schemaVersion === 'number') return g.schemaVersion;
    if (g.v === 2) return 2;
    return 1;
  }

  /* Der Weg von einer alten Fassung auf die heutige. Er WIRFT NICHTS WEG: jedes Feld, das
     eine alte Fassung kennt, kommt mit. Was eine neue Fassung zusaetzlich braucht, wird
     ergaenzt — und zwar so, dass ein alter Plan danach dasselbe zeigt wie vorher.

     Eine Ausnahme gibt es, und sie ist belegt: ein ECKSCHRANK ohne ausdrueckliche Stelle
     stand in Fassung 2 an der Stelle 0 seiner Reihe. Auf Wand A und B war das zufaellig
     eine Ecke, auf Wand C einer U-Kueche das offene Ende — der Korpus stand dort, wo es
     keine Ecke gibt, und 3D zeigte ihn schon immer dort. Seit Phase 5 rastet er in seine
     wirkliche Ecke. Ein alter Plan mit Eckschrank auf Wand C sieht danach also anders aus,
     und das ist die Korrektur eines gemessenen Fehlers, keine Wanderung der Daten: die
     gespeicherte Zahl bleibt unveraendert, nur ihre Auslegung ist jetzt richtig. */
  function migriere(g) {
    if (!g) return null;
    var v = schemaVon(g);
    if (v >= SCHEMA) return g;
    var neu = {};
    for (var k in g) { if (Object.prototype.hasOwnProperty.call(g, k)) neu[k] = g[k]; }

    /* 1 -> 2: die erste Fassung hielt den Plan als Modellindizes. Sie laesst sich ohne den
       damaligen Katalog nicht sicher zurueckuebersetzen — ein Index zeigt heute auf ein
       anderes Modell. Der Plan wird deshalb NICHT geraten, sondern fallengelassen und das
       gesagt; Masse, Raumform und Anschluesse bleiben erhalten. */
    if (v <= 1) {
      neu.plan = {}; neu.hoff = {}; neu.xpos = {}; neu.wahl = {};
      neu.planVerworfen = true;
    }

    /* 2 -> 3: strukturell nichts.

       Eine UNBEKANNTE Raumform wird NICHT stillschweigend zu `gerade` gemacht. Das war
       hier zuerst so gebaut und ist falsch: aus einer Kueche, die der Kunde als etwas
       anderes gespeichert hat, wuerde beim blossen Oeffnen eine gerade Zeile — dieselben
       Masse, dieselben Anschluesse, eine andere Kueche. Wer das spaeter bemerkt, kann
       nicht mehr sagen, was urspruenglich dastand.

       Stattdessen bleibt der gespeicherte Wert stehen, wird als solcher vermerkt, und die
       Planung ist blockiert, bis der Kunde selbst eine Form waehlt. Nichts wird geloescht:
       Masse, Plan, Anschluesse und Serie bleiben unberuehrt und stehen wieder zur
       Verfuegung, sobald die Form geklaert ist. */
    if (!VORLAGEN[neu.form]) {
      neu.migrationStatus = 'unsupported_room_form';
      neu.legacyForm = g.form;
    }

    neu.schemaVersion = SCHEMA;
    return neu;
  }

  function gesichert() {
    try {
      return migriere(JSON.parse(UMGEBUNG.lesen(SPEICHER) || 'null'));
    } catch (e) { return null; }
  }

  function verwerfen() {
    /* Auch den Schluessel der Vorversion: sonst bliebe eine unerreichbare Planung fuer immer
       im Speicher des Kunden liegen. */
    try { UMGEBUNG.loeschen(SPEICHER); UMGEBUNG.loeschen('hmk-planer-v1'); return true; }
    catch (e) { return false; }
  }

  /* ================= Anschlüsse und Hindernisse (Schritt 2) =================

     Neun Typen. Das zweibuchstabige Kürzel steht im Auswahlfeld, in der Liste und in beiden
     Zeichnungen an derselben Stelle — neun gleiche Kreise waren nicht unterscheidbar.

     `tol` ist die Strecke, um die sich der Anschluss beim Einbau noch verziehen lässt; sie
     gehört zum Regelwerk, steht aber hier, weil sie eine Eigenschaft des Anschlusses ist. */
  var MT = {
    wasser:      { kurz: 'WA', label: 'Wasseranschluss',    farbe: 'var(--hm-brand)',  hoehe: 55,  tol: 30,
                   hinweis: 'Ein Spülenunterschrank muss diese Stelle überdecken. Bis 30 cm lässt sich die Zuleitung verlängern.' },
    abfluss:     { kurz: 'AB', label: 'Abfluss',            farbe: 'var(--hm-gmeta)',  hoehe: 45,  tol: 20,
                   hinweis: 'Der Abfluss braucht Gefälle und ist starrer als die Zuleitung — Toleranz 20 cm.' },
    herd:        { kurz: 'HE', label: 'Herdanschluss',      farbe: 'var(--hm-sale)',   hoehe: 20,  tol: 150,
                   hinweis: 'Herd- oder Backofenplatz muss in Reichweite liegen. Hinter einem Hochschrank darf die Dose nicht verschwinden.' },
    gas:         { kurz: 'GA', label: 'Gasanschluss',       farbe: 'var(--hm-star)',   hoehe: 40,  tol: 120,
                   hinweis: 'Der Gashahn muss zugänglich bleiben. Gaskochfelder verlangen wirksame Abluft.' },
    steckdose:   { kurz: 'ST', label: 'Steckdose',          farbe: 'var(--hm-mut)',    hoehe: 110,
                   hinweis: 'Hinter einem Hängeschrank ist die Dose nicht mehr erreichbar.' },
    fenster:     { kurz: 'FE', label: 'Fenster',            farbe: 'var(--hm-mut)',    breite: 100, hoehe: 90,  hoeheLabel: 'Brüstung',
                   hinweis: 'Brüstung unter Arbeitshöhe lässt die Unterschrankreihe nicht durch.' },
    tuer:        { kurz: 'TÜ', label: 'Tür',                farbe: 'var(--hm-ink2)',   breite: 88,  hoehe: 200, hoeheLabel: 'Höhe',
                   hinweis: 'Der Türflügel braucht die volle Breite frei, plus 5 cm Luft.' },
    heizkoerper: { kurz: 'HK', label: 'Heizkörper',         farbe: 'var(--hm-mut3)',   breite: 80,  hoehe: 60,  hoeheLabel: 'Oberkante',
                   hinweis: 'Zustellen staut die Wärme und ist in Mietwohnungen oft unzulässig.' },
    /* Unterbauhaube als Gerät, Handelsmaße 60 oder 90 × 15 × 48 cm. hoehe = Unterkante über dem
       Boden; 151 cm ergibt 65 cm Luft über einer 86 cm hohen Arbeitsplatte. */
    haube:       { kurz: 'DA', label: 'Dunstabzugshaube',   farbe: '#3C4145',          breite: 60,  hoehe: 151, hoeheLabel: 'Unterkante', geraet: true,
                   hinweis: 'Unterbauhaube 60 oder 90 cm breit, 15 cm hoch, 48 cm tief. Sie hängt unter dem Oberschrank und muss über der Kochstelle sitzen: 55 cm Abstand über Elektro, 65 cm über Gas.' },
    /* Der vorhandene Geschirrspüler ist kein Möbel: geplant wird eine LÜCKE, kein Schrank.
       Deshalb ein Merkmal und keine Katalogposition — und deshalb gestrichelt gezeichnet,
       damit niemand eine Front erwartet, die nicht geliefert wird. */
    spueler:     { kurz: 'GS', label: 'Stellplatz Geschirrspüler', farbe: '#4A5A66', breite: 60, hoehe: 82,
                   hoeheLabel: 'Nischenhöhe', geraet: true, stellplatz: true,
                   hinweis: '60-cm-Stellplatz für vorhandenen Geschirrspüler, ohne Möbelfront. Gerätemaße und Befestigungsart vor Bestellung prüfen.' },
    /* Der eigene, FREISTEHENDE Kuehlschrank (Planer-App 2026-09-26): wie der Geschirrspueler eine Luecke,
       aber raumhoch — `hoch` sperrt auch die Haengereihe, und die Arbeitsplatte endet davor wie an einem
       Hochschrank. hoehe = freie Hoehe der Nische (die Hochschrank-Linie der Serie). */
    kuehl:       { kurz: 'KS', label: 'Stellplatz Kühlschrank', farbe: '#4A5A66', breite: 60, hoehe: 200,
                   hoeheLabel: 'Nischenhöhe', geraet: true, stellplatz: true, hoch: true,
                   hinweis: '60-cm-Stellplatz für einen freistehenden Kühlschrank, ohne Schrank. Breite, Tiefe, Höhe und Türanschlag des Geräts vor Bestellung prüfen.' }
  };

  var HAUBE = { h: 15, t: 48, breiten: [60, 90], abstandElektro: 55, abstandGas: 65 };

  /* Anschlüsse, die eine Küche genau einmal hat. Steckdosen, Fenster, Türen und Heizkörper
     dürfen sich wiederholen — sie stehen ja tatsächlich mehrfach im Raum. */
  var EINMALIG = { wasser: 1, abfluss: 1, gas: 1, herd: 1, haube: 1 };

  /* Drei benannte Gruppen statt neun Knöpfen in einem Raster: Leitung, Bauwerk, Gerät.
     Aus MT abgeleitet, damit ein neuer Typ nie unbemerkt aus der Auswahl fällt. */
  var MT_GRUPPE = { wasser: 0, abfluss: 0, herd: 0, gas: 0, steckdose: 0, fenster: 1, tuer: 1, heizkoerper: 1 };
  var MT_GRUPPENNAMEN = ['Anschlüsse in der Wand', 'Bauliches', 'Gerät'];
  var MT_KURZLABEL = { wasser: 'Wasser', abfluss: 'Abfluss', herd: 'Herd/Strom', gas: 'Gas',
    steckdose: 'Steckdose', fenster: 'Fenster', tuer: 'Tür', heizkoerper: 'Heizkörper', haube: 'Haube',
    spueler: 'Stellplatz Geschirrspüler', kuehl: 'Stellplatz Kühlschrank' };

  function mtGruppen() {
    return MT_GRUPPENNAMEN.map(function (n, i) {
      return { name: n, typen: Object.keys(MT).filter(function (k) {
        return (MT_GRUPPE[k] == null ? 2 : MT_GRUPPE[k]) === i;
      }) };
    });
  }

  /* Wechselt der Kunde von U auf L, gehören Anschlüsse an Wand C zu keiner Wand mehr. Sie
     bleiben gespeichert (ein Rückwechsel soll sie nicht verlieren), werden aber nicht
     gezeichnet und nicht geprüft — stattdessen sagt ein Hinweis, dass sie ruhen. */
  function wandDa(z, id) {
    return waende(z).some(function (w) { return w.id === id; });
  }
  function aktiveMerkmale(z) {
    return (z.merkmale || []).filter(function (m) { return wandDa(z, m.wand); });
  }
  function ruhendeMerkmale(z) {
    return (z.merkmale || []).filter(function (m) { return !wandDa(z, m.wand); });
  }

  /* Welche Waende darf eine Aufgabe zur Auswahl stellen? Nicht jede Aufgabe dieselben:
     Schraenke gehoeren nur an bestueckbare Waende, Anschluesse und die Frontansicht an
     jede vorhandene. Der Durchgang einer Parallelkueche ist eine echte Wand — dort haengt
     ein Fenster, ein Heizkoerper, eine Steckdose —, aber keine Planflaeche.

     Sie im Schrankschritt anzubieten und die Platzierung dann abzulehnen ist keine
     Fuehrung, sondern eine Falle: der Kunde waehlt, klickt, und lernt erst durch eine
     Absage, dass diese Wand nicht gemeint war.

     Die Sperre in setzen() bleibt trotzdem stehen. Eine Auswahl, die etwas nicht anbietet,
     ist keine Pruefung — sie schuetzt nur den Weg, den die Oberflaeche kennt. */
  function wandAuswahl(z, zweck) {
    var g = raumGeometrie(z);
    return waende(z).filter(function (w) {
      if (zweck !== 'schrank') return true;
      var wg = wandAus(g, w.id);
      return !wg || wg.planbar !== false;
    });
  }

  /* Was auf einer Wand liegt, die es in DIESER Form nicht gibt. Geloescht wird nichts —
     ein Formwechsel ist oft ein Blick, kein Entschluss, und wer zurueckwechselt, will
     seine Maße und Anschluesse wiederfinden. Aber lautlos schlafen darf es auch nicht:
     Schraenke auf einer fehlenden Wand fallen aus Preis, Warenkorb und Stueckliste, und
     der Kunde merkt es sonst erst, wenn die Lieferung unvollstaendig ist. */
  function ruhendeDaten(z, daten) {
    var schraenke = 0, waendeIds = {};
    Object.keys(z.plan || {}).forEach(function (k) {
      var wid = k.split('|')[0], arr = z.plan[k] || [];
      if (!arr.length || wandDa(z, wid)) return;
      schraenke += arr.length;
      waendeIds[wid] = true;
    });
    var mk = ruhendeMerkmale(z);
    mk.forEach(function (m) { waendeIds[m.wand] = true; });
    return { schraenke: schraenke, merkmale: mk.length, waende: Object.keys(waendeIds).sort() };
  }

  /* Fenster, Tür und Heizkörper haben eine Breite — ihr x ist die linke Kante, also endet der
     Schiebeweg eine Breite vor dem Wandende. Punktanschlüsse dürfen bis ans Ende. */
  function mxMax(z, m) {
    var len = wandObj(z, m.wand).len;
    return Math.max(0, len - (MT[m.typ].breite ? (m.breite || 0) : 0));
  }

  /* Die Strecke, die ein Anschluss oder ein Hindernis auf SEINER Wand einnimmt — in
     Zentimetern ab p0, also in derselben Groesse wie die Stelle eines Schranks. Sie ist
     die eine Quelle fuer jede Ueberlappungsfrage: Schrank vor Heizkoerper, Schrank vor
     Tuer, Haengeschrank durchs Fenster. Vorher rechnete jede dieser Fragen ihr Intervall
     selbst aus `m.x` und `m.breite` zusammen — vier Stellen, vier Gelegenheiten, den
     Punktanschluss mit dem breiten Bauteil zu verwechseln.

     Ein Punktanschluss (Wasser, Steckdose, Herd) hat keine Breite: sein Intervall ist
     ein Punkt, und `laenge` ist 0. Genau das unterscheidet ihn vom Fenster. */
  function elementIntervallAufWand(m) {
    var c = MT[m.typ] || {};
    var b = c.breite ? (+m.breite || 0) : 0;
    var start = +m.x || 0;
    return { start: start, ende: start + b, laenge: b, punkt: !c.breite };
  }

  /* Liegt das Element noch auf seiner Wand? Gibt zurueck, WIE weit es hinausragt und an
     welchem Ende — nicht bloss ja/nein. Ohne die Seite koennte die Meldung nicht sagen,
     wohin geschoben werden muss. */
  function elementAusserhalb(z, m) {
    var iv = elementIntervallAufWand(m), len = wandObj(z, m.wand).len;
    if (iv.start < -0.5) return { seite: 'anfang', cm: -iv.start };
    if (iv.ende > len + 0.5) return { seite: 'ende', cm: iv.ende - len };
    return null;
  }

  /* Der Satz zum Ueberstand steht an EINER Stelle.

     Die Pruefung sagte ihn, und die Liste in Schritt 2 zeigte gar nichts — der Kunde legte
     dort ein Fenster an, das 152 cm ueber die Wand hinausragte, und erfuhr es erst zwei
     Schritte spaeter. Wuerde die Liste den Satz selbst zusammensetzen, gaebe es zwei
     Formulierungen derselben Regel, die auseinanderlaufen koennen. Also fragen beide hier.
     Die REGEL bleibt `elementAusserhalb` — hier wird sie nur in Worte gefasst. */
  function ueberstandText(z, m) {
    var cfg = MT[m.typ];
    if (!cfg) return null;
    var raus = elementAusserhalb(z, m);
    if (!raus) return null;
    var w = wandObj(z, m.wand);
    /* „über das Wandende hinaus" ist die Formulierung, die auch sonst im Planer steht;
       „über das Ende der Wand" war dieselbe Aussage in anderen Worten. Und „(307 cm lang)"
       liess offen, WAS 307 cm lang ist — jetzt steht die Wand davor. */
    /* Der Artikel haengt am Wort: DAS Wandende, DER Wandanfang. Beim ersten Anlauf stand
       hier ein festes „den" — „über den Wandende" war grammatisch falsch. */
    return w.label + ': ' + cfg.label + ' ragt ' + r0(raus.cm)
      + (raus.seite === 'ende' ? ' cm über das Wandende' : ' cm über den Wandanfang')
      + ' hinaus (Wand '
      + r0(w.len) + ' cm). Verschieben'
      + (cfg.breite ? ' oder schmaler machen' : '') + ' — die Stelle wurde nicht '
      + 'automatisch geändert.';
  }

  /* Ein neuer Anschluss steht in der Mitte der aktuellen Wand. */
  function merkmalNeu(z, typ, id) {
    var w = wandObj(z), c = MT[typ];
    return { id: id, typ: typ, wand: w.id, x: Math.round(w.len / 2),
             breite: c.breite || 0, hoehe: c.hoehe || 0 };
  }

  /* Hauben gibt es im Handel nur in 60 und 90 cm — die Breite rastet darauf ein.

     Was hier NICHT mehr passiert: x nachziehen. Frueher stand hier
       neu.x = Math.max(0, Math.min(mxMax(z, neu), neu.x));
     Wer ein Fenster am Wandende breiter machte, dessen Fenster RUTSCHTE — lautlos, um
     genau so viele Zentimeter, wie es sonst hinausgeragt haette. Der Kunde hatte eine
     Zahl eingegeben und bekam zwei geaenderte zurueck, ohne dass es jemand sagte.
     Jetzt bleibt die Stelle, wo sie steht, und die Pruefung nennt den Ueberstand mit
     Zentimeterzahl und Seite. Eine Zahl still zu korrigieren ist keine Hilfe, sondern
     eine unbemerkte Aenderung an den Daten des Kunden. */
  function merkmalSetzen(z, m, feld, wert) {
    var neu = {};
    for (var k in m) { if (Object.prototype.hasOwnProperty.call(m, k)) neu[k] = m[k]; }
    neu[feld] = +wert;
    if (neu.typ === 'haube' && feld === 'breite') {
      neu.breite = Math.abs(neu.breite - 60) <= Math.abs(neu.breite - 90) ? 60 : 90;
    }
    return neu;
  }

  /* ================= Stufe 3: die beiden Zeichnungen =================
     1 SVG-Einheit = 1 cm. Beide Ansichten geben { vb, inner } zurueck — den viewBox-String und
     das Markup. Wer sie einsetzt, entscheidet selbst ueber <svg>-Attribute und Ereignisse.

     Was hier NICHT gezeichnet wird: Anschluesse, Auswahl, Ziehen, Passlinien. Die brauchen
     Zustand, den es erst ab Stufe 4 gibt. Die Haken dafuer (data-sel, data-mk) folgen dort. */

  /* px -> Nutzereinheiten (cm). Ohne diese Rueckrechnung sind Beschriftungen feste cm-Werte
     und schrumpfen auf dem Telefon auf 4-7 px. Gemessen wird der CONTAINER, nie das SVG
     selbst — dessen Breite haengt von der viewBox ab, die aus dieser Messung entsteht, und
     das rastet auf einem falschen Wert ein. */
  function sk(px, vb, gemessen) {
    return Math.round(px * vb / Math.max(320, gemessen || 760) * 10) / 10;
  }

  /* Frontfarben. Der Farbname des Katalogs ist zusammengesetzt ("Beige / Dunkle Eiche"):
     vor dem Schraegstrich steht die FRONT, dahinter der Korpus. */
  var FARBHEX = {
    'weiß': '#F1F0EC', 'weiss': '#F1F0EC', 'weiß matt': '#EDECE7', 'weiß hochglanz': '#F6F6F3',
    'weiß rahmen': '#EAE8E2', 'beige': '#D9C9AC', 'grau': '#9CA2A1', 'dunkelgrau': '#5B6260',
    'grün': '#5E7360', 'grün matt': '#5E7360',
    'sonoma eiche': '#C9A57A', 'dunkle eiche': '#6B4A2E', 'artisan eiche': '#B98A5A'
  };

  var ART = {
    unterschrank: 'Unterschrank', unterschrank_schub: 'Auszugschrank', spuelen_unterschrank: 'Spülenschrank',
    geschirrspuelerfront: 'Geschirrspülerfront', herdumbau: 'Herdumbau', geraete_unterschrank: 'Backofenschrank',
    eck_unterschrank: 'Eckunterschrank', apotheker: 'Apothekerschrank', hochschrank: 'Hochschrank',
    hochschrank_geraet: 'Hochschrank Gerät', kuehlumbau: 'Kühlumbau', haengeschrank: 'Hängeschrank',
    haengeschrank_glas: 'Hängeschrank Glas', haengeschrank_dunst: 'Hängeschrank',
    eck_haengeschrank: 'Eckhängeschrank', aufsatzschrank: 'Aufsatzschrank'
  };

  /* SERIENOPTIK — was jede Serie wirklich traegt, gemessen 2026-09-24 an den Produktfotos der
     Einzelschraenke (D60, D60S3, G60/W60 je Farbe) und der Komplettkuechen im Shop:
       Glanzia  grifflos, Griffmulde an der Oberkante, Hochglanz mit Spiegelung
       Livaro   kurzer schwarzer Kantengriff oben an Tueren und Auszuegen; Haengeschraenke ohne
                sichtbaren Griff; „Weiss Rahmen" = Rahmenfront mit Messingknopf
       Velora   Korpus IMMER Artisan Eiche (auch bei grauen Fronten); „Griff aus Metall" ist eine
                lange schwarze Stange, Push-to-Open hat keinen Griff
       Lunara   kleiner schwarzer Kantengriff, unten an Tueren oben, an Haengeschraenken unten;
                Korpus weiss
     Die Farbwerte sind die Mediane der Frontflaechen in diesen Fotos, leicht aufgehellt, weil
     die Studiofotos die Front im Schatten zeigen. Dieselbe Farbe heisst in zwei Serien nicht
     dasselbe (Velora-Grau ist dunkler als Glanzia-Grau) — deshalb je Serie, mit FARBHEX als
     Rueckfall fuer alles, was hier nicht steht. */
  var OPTIK = {
    /* Grau Hochglanz nachgemessen 2026-09-27 (Betreiber: „das glaenzende Grau ist nicht echt"):
       Median der Tuerflaeche im Produktfoto Glanzia 156/156/156, Lunara 176/176/178 — die alten
       Werte (#B6B4B1, #A7A9A9) waren je nach Serie zu hell bzw. zu dunkel. Glanzia hat einen
       WEISSEN Korpus (Foto D60), wie Lunara. */
    /* NACHTRAG gleicher Tag: der Betreiber zeigte ein Kuechenfoto als „das echte Grau Hochglanz" —
       dort misst die Front im Raum 95–110 und ist kuehl (Blau ueber Rot). Das Studiofoto (156) ist
       hell ausgeleuchtet. Gewaehlt ist die Farbe, die im Raum wie sein Foto aussieht. */
    /* Spuele und Rueckwand nach den Serienfotos (2026-09-27): Glanzia, Velora, Livaro schwarzes Becken
       mit schwarzer Armatur; Lunara Edelstahl zu Weiss, schwarz zu Grau; Glanzia vor einer Rueckwand
       aus „Panda"-Marmor (weiss, breite schwarze Adern). */
    /* NACHTRAG 2026-09-28: der Betreiber zeigt die Produktfotos des D60R als „Farbe und Form von Glanzia" — Grau ist dort ein
       helles Mittelgrau (Front 157), Weiss weiss (225). Grau jetzt #96989B (live im Mittel 157); die Anhebung fuer Weiss steht
       in 3D (GLANZIA_HEBUNG). */
    /* NACHTRAG 2026-09-29: der Betreiber zeigt ein Foto der ECHTEN Glanzia-Grau-Tuer („الرمادي ليس هذا اللون الذي ارغب به —
       بل هذا مثل الذي في الصورة"): ein kuehles Mittelgrau, gemessen 97/101/100 (Gruen und Blau ueber Rot), spiegelnd wie ein
       Spiegel. Das Studiofoto des D60R (157) war hell ausgeleuchtet. #5E6366 misst im Raum 104/106/103 (unten) bzw.
       119/122/120 (oben) — Lunara Grau Hochglanz ebenso („الرمادي اللامع مثل لون غلانسيا اللامع"). */
    Glanzia: { griff: 'mulde', herdBlende: 'glatt', korpus: '#F1F1EE', spuele: 'schwarz', rueckwand: 'panda',
      farben: { 'weiß hochglanz': '#F3F3F1', 'grau hochglanz': '#5E6366' } },
    /* `eckOben: 'L'` (2026-09-29): der Eck-Haengeschrank G60N2 ist ein L mit zwei Tueren in der Innenecke (Produktfotos
       geschlossen/offen), kein Diagonalschrank wie in den anderen Serien. */
    Livaro: { griff: 'kante', griffL: 20, obenOhne: true, herdBlende: 'glatt', spuele: 'schwarz', eckOben: 'L',
      /* Gruen nachgemessen an den elf Livaro-Komplettkuechen (Verhaeltnis zur weissen Front im selben
         Raum 0,47/0,52/0,49; wir lagen bei 0,53/0,59/0,55) — 12 % dunkler. Beige und Sonoma
         stimmten schon auf 1–3 %. */
      farben: { 'beige': '#CBC3BB', 'grün': '#66716C', 'grün matt': '#66716C', 'dunkle eiche': '#6E5B49',
                'sonoma eiche': '#BC9670', 'weiß': '#F1F1EE', 'weiß rahmen': '#F1F1EE' } },
    /* Beige nachgemessen 2026-09-29 (Betreiber zeigt das Produktfoto der Kuechenzeile VELORA: „هذا لونها البيج"): die Fronten
       sind ein warmes Taupe, im Mittel 148/142/134 — #D2C7B8 lag im Raum bei 184. #A8A197 trifft es (gerechnet aus der
       Messung im Raum, linear). */
    Velora: { griff: 'stange', korpus: '#C4A27E', haengeOhne: true, spuele: 'schwarz',
      farben: { 'artisan eiche': '#C4A27E', 'beige': '#A8A197', 'grau': '#6D6E6E' } },
    /* Weiss Hochglanz WIE GLANZIA (Betreiber 2026-10-01: „يجب ان يكون لون ولمعات لونارا الابيض اللامع مثل غلانسيا الابيض اللامع"):
       dieselbe Grundfarbe; Lack, Spiegelung und Glanzlicht stellt 3D fuer jede helle Hochglanzfront gleich ein (GLANZ_HELL). */
    Lunara: { griff: 'kante', griffL: 12, korpus: '#F1F1EE', spuele: 'nachFront',
      farben: { 'dunkelgrau': '#5D5D57', 'weiß hochglanz': '#F3F3F1', 'weiß matt': '#EEEEEA', 'grau hochglanz': '#5E6366' } }
  };
  function optikSerie(z) { return (z && OPTIK[z.serie]) || null; }
  function serienFarbe(z, name) {
    var o = optikSerie(z);
    if (!o || !name) return null;
    return o.farben[name] || o.farben[name.replace(/ (matt|hochglanz)$/, '')] || null;
  }

  function frontName(z) { return String(z.farbe || '').split('/')[0].trim().toLowerCase(); }
  function frontFarbe(z) {
    var f = frontName(z);
    return serienFarbe(z, f) || FARBHEX[f] || FARBHEX[f.replace(/ (matt|hochglanz)$/, '')] || '#E3E0D8';
  }
  /* „Gruen / Dunkle Eiche" nennt Front UND Korpus. Fehlt der zweite Teil, ist der Korpus
     in derselben Farbe wie die Front. */
  /* Die Beschriftung sitzt auf einer PLAKETTE, nicht frei auf der Front.

     Vorher trug jeder Buchstabe einen dunklen Saum, damit er auf jeder Frontfarbe lesbar
     bleibt. Das funktionierte technisch und sah nach Aufkleber aus: im Belegmassstab wurde aus
     dem Saum ein Schmutzrand, und der Betreiber nennt es zu Recht unprofessionell. Auch die
     Fassung davor, die die Schriftfarbe nach der Fronthelligkeit umschaltete, loeste das nicht
     — sie machte den Saum nur weniger schlimm.

     Eine Plakette loest beides auf einmal. Die Schrift steht dann nicht mehr gegen die Front,
     sondern gegen eine Flaeche, die WIR bestimmen: der Kontrast haengt nicht mehr davon ab,
     welche Farbe der Kunde waehlt. Und sie braucht keinen Saum, also keinen Schmutzrand.

     Warum sie trotzdem nicht zustellt: sie ist durchscheinend (0.78), liegt am unteren Rand
     und ist nur so hoch wie die zwei Zeilen. Die Front bleibt darunter sichtbar. Genau so
     beschriftet die Oberflaeche schon die Anschluesse — `data-chipbg` ist dasselbe Mittel.

     Nachgerechnet: 0.78 Schwarz ueber der HELLSTEN Front der vier Serien (#F6F6F3) ergibt
     rund #454542, weisse Schrift darauf traegt 9,5:1; ueber der dunkelsten (#5E7360) sind es
     16,6:1. Beide weit ueber 4,5:1, und zwar ohne dass die Frontfarbe noch mitredet. */
  var SCHILD_GRUND = '#14110e', SCHILD_DECKUNG = 0.78, SCHILD_SCHRIFT = '#ffffff';

  function korpusFarbe(z) {
    var o = optikSerie(z);
    if (o && o.korpus) return o.korpus;
    var t = String(z.farbe || '').split('/');
    var k = (t[1] || t[0] || '').trim().toLowerCase();
    return serienFarbe(z, k) || FARBHEX[k] || FARBHEX[k.replace(/ (matt|hochglanz)$/, '')] || '#E3E0D8';
  }
  function istHolz(z) { return /eiche|artisan|holz|nuss/.test(frontName(z)); }
  function istGlanz(z) { return z.serie === 'Glanzia' || /hochglanz/.test(String(z.farbe || '').toLowerCase()); }
  /* Push-to-Open heisst: kein Griff. Wer das ignoriert, zeichnet einer grifflosen Kueche Griffe an. */
  function hatGriff(z) { return !/push/i.test((z.zusatz && z.zusatz['Ausführung']) || ''); }
  function istRahmen(z) { return /rahmen/i.test(String(z.farbe || '')); }
  function istAst(z) { return /artisan/.test(frontName(z)); }
  /* Welcher Griff: 'ohne' | 'mulde' | 'kante' | 'stange' | 'knopf'. */
  function griffStil(z) {
    if (!hatGriff(z)) return 'ohne';
    if (istRahmen(z)) return 'knopf';
    var o = optikSerie(z);
    return o ? o.griff : 'kante';
  }

  /* DIE FRONT IN TEILEN — die eine Quelle fuer 2D-Frontansicht, Beleg und 3D. Jedes Teil ist
     ein Rechteck in schranklokalen Zentimetern (x von links, y von OBEN) mit einer Art und der
     Kante, an der sein Griff sitzt (`lage`: 'oben' | 'unten'). Vorher rechnete die Zeichnung
     ihre Tueren selbst und 3D gar keine: dort war die Front eine eingefaerbte Kastenseite. */
  /* `unten` (optional): wie hoch die Fronten der Unterschraenke in DIESER Zeichnung sind (3D ohne Sockel, 2D bis zum Boden)
     — dort liegt die Fuge eines Hochschranks, wie beim echten Moebel. Ohne Angabe 38 % der Hoehe. */
  function frontTeile(z, m, b, h, unten) {
    var a = aufbau(m), F = 0.4, out = [], i;
    var haengt = m.reihe === 'oben' || m.reihe === 'aufsatz';
    var teil = function (art, x, y, bb, hh, lage) {
      out.push({ art: art, x: x, y: y, b: bb, h: hh, lage: lage || (haengt ? 'unten' : 'oben'), haengt: haengt });
    };
    /* DIE UNTERE TUER JEDES HOCHSCHRANKS ENDET AUF DER HOEHE DER UNTERSCHRAENKE (Betreiber 2026-09-28: „باب الخزانة
       السفلي للخزائن الطويلة يجب ان يكون دائما نفس ارتفاع سطح العمل في كل السيريهات"). Nur der Vorratsschrank tat das
       schon; Backofen- und Kuehlschrank-Hochschraenke teilten ihre Front nach Katalog-Anteilen bzw. 62/38 und lagen in allen
       vier Serien daneben — gemessen −12,3 bis +15,8 cm, dazu 2D und 3D verschieden (Glanzia D60P in 3D 5,6 cm unter der
       Fuge des Vorratsschranks daneben). Jetzt reicht die unterste Tuer jedes stehenden Hochschranks bis `unten`, der
       Fronthoehe der Unterschraenke in dieser Zeichnung; die Geraetenischen behalten ihr Katalogmass (Backofen 60,
       Mikrowelle 38 — vorher mitgestaucht auf 56,9), die oberste Tuer nimmt den Rest. */
    var fugeUnten = !haengt && h > 120 && unten > 20 && unten < h - 40 ? unten : 0;
    var plan = frontPlan(m);
    if (plan) {
      /* Der Griff sitzt an der Kante ZUR NISCHE — so zeigen es die Produktfotos: die Tuer ueber
         dem Backofen oeffnet nach oben, die darunter nach unten. */
      var n = plan.teile.length, rest = h - F * (n - 1), yy = 0, hs = [];
      var nischen = 0, obenTeile = 0;
      for (i = 0; i < n; i++) {
        if (String(plan.teile[i][0] || 'tuer') === 'nische') nischen += +plan.teile[i][1] || 0;
        else if (i < n - 1) obenTeile += +plan.teile[i][1] || 0;
      }
      var frei = rest - fugeUnten - nischen;
      var fest = fugeUnten && n > 1 && String(plan.teile[n - 1][0] || 'tuer') !== 'nische' && obenTeile > 0 && frei > 10;
      for (i = 0; i < n; i++) {
        var w0 = +plan.teile[i][1] || 0;
        hs.push(!fest ? rest * w0 / plan.summe
          : (i === n - 1 ? fugeUnten : (String(plan.teile[i][0] || 'tuer') === 'nische' ? w0 : frei * w0 / obenTeile)));
      }
      for (i = 0; i < n; i++) {
        var art = String(plan.teile[i][0] || 'tuer');
        var hh = hs[i];
        var vor = i > 0 && plan.teile[i - 1][0] === 'nische';
        var nach = i + 1 < plan.teile.length && plan.teile[i + 1][0] === 'nische';
        if (art === 'nische') teil('nische', 0, yy, b, hh);
        else teil('front', 0, yy, b, hh, nach ? 'unten' : (vor ? 'oben' : null));
        yy += hh + F;
      }
      return out;
    }
    if (a.art === 'tuer') {
      var bw = (b - F * (a.n - 1)) / a.n;
      for (i = 0; i < a.n; i++) teil('front', i * (bw + F), 0, bw, h);
    } else if (a.art === 'auszug') {
      var ah = (h - F * (a.n - 1)) / a.n;
      for (i = 0; i < a.n; i++) teil('front', 0, i * (ah + F), b, ah, 'oben');
    } else if (a.art === 'kombi') {
      var oh = Math.min(h * 0.3, 18);
      teil('front', 0, 0, b, oh, 'oben');
      teil('front', 0, oh + F, b, h - oh - F, 'oben');
    } else if (a.art === 'apotheker') {
      teil('front', 0, 0, b, h, 'oben');
    } else if (a.art === 'blende') {
      /* Die Geschirrspuelerfront traegt denselben Griff wie ihre Nachbarn — so steht sie in
         jeder Komplettkueche des Shops. Die Maschine dahinter gehoert nicht zur Serie. */
      teil('blende', 0, 0, b, h, 'oben');
    } else if (a.art === 'glas') {
      var gw = (b - F * (a.n - 1)) / a.n;
      for (i = 0; i < a.n; i++) teil('glas', i * (gw + F), 0, gw, h);
    } else if (a.art === 'dunst') {
      teil('front', 0, 0, b, h, 'unten');
    } else if (a.art === 'hoch') {
      var hu = fugeUnten || h * 0.38, ho = h - hu - F;
      teil('front', 0, 0, b, ho, 'unten');
      teil('front', 0, ho + F, b, hu, 'oben');
    } else if (a.art === 'ofen') {
      /* HERDUMBAU (Betreiber 2026-09-27: „der Backofen-Unterschrank ist nicht wie meiner"). Bisher
         62 % Ofen und der Rest Front — in 3D 45 cm Ofen ueber einer 27 cm hohen Schublade. Jeder
         D60ZK im Shop ist eine 60-cm-Nische fuer einen Einbaubackofen (59,5 cm) und darunter eine
         schmale Blende: bei Velora eine Schublade mit Griff, bei Livaro und Glanzia glatt (Serien-
         optik `herdBlende`). In 2D reicht die Blende wie jede Front bis zum Boden. */
      var gh = Math.max(0, Math.min(60, h - 10));
      var glatt = (optikSerie(z) || {}).herdBlende === 'glatt';
      teil('ofen', 0, 0, b, gh);
      teil('front', 0, gh + F, b, h - gh - F, glatt ? 'ohne' : 'oben');
    } else {
      /* Hohe Korpusse bekommen eine Teilungsfuge, sonst steht eine 213 cm hohe Tuer als eine
         einzige Flaeche da. Die obere Tuer greift man unten, die untere oben. Stehend (Kuehlumbau) liegt die Fuge
         auf der Hoehe der Unterschraenke (siehe oben), sonst bei 62 %. */
      var t = h > 120 ? (fugeUnten ? h - fugeUnten - F : h * 0.62) : h;
      teil('front', 0, 0, b, t, t < h ? 'unten' : null);
      if (t < h) teil('front', 0, t + F, b, h - t - F, 'oben');
    }
    return out;
  }

  /* Wo auf einem Teil der Griff sitzt: Mitte (x, y) und Laenge l, schranklokal. */
  function griffe(z, p) {
    var s = griffStil(z), o = optikSerie(z) || {};
    if (s === 'ohne' || p.art === 'nische' || p.art === 'ofen' || p.lage === 'ohne') return [];
    /* Livaro-Haengeschraenke zeigen auf keinem Foto einen Griff — nur der Rahmen-Knopf. */
    if (s === 'kante' && p.lage === 'unten' && o.obenOhne) return [];
    /* Velora: Haengeschraenke ohne Griff (Betreiber 2026-09-27, Produktfoto G60) — die Stange nur
       an Unter- und Hochschraenken. */
    if (o.haengeOhne && p.haengt) return [];
    var cx = p.x + p.b / 2, unten = p.lage === 'unten';
    if (s === 'mulde') return [{ art: s, x: cx, y: unten ? p.y + p.h - 0.8 : p.y + 0.8, l: p.b }];
    /* Rahmenfront (Livaro „Weiss Rahmen"): ein kleiner WAAGRECHTER Messinggriff, ~9 cm, oben mittig —
       so in der Komplettkueche (2026-09-27); vorher ein runder Knopf. Name bleibt 'knopf'. */
    if (s === 'knopf') return [{ art: s, x: cx, y: unten ? p.y + p.h - 3.5 : p.y + 3.5, l: Math.min(9, p.b * 0.3) }];
    if (s === 'stange') {
      var dy = Math.min(6, p.h * 0.25);
      return [{ art: s, x: cx, y: unten ? p.y + p.h - dy : p.y + dy, l: Math.min(p.b * 0.6, 34) }];
    }
    return [{ art: 'kante', x: cx, y: unten ? p.y + p.h - 0.7 : p.y + 0.7, l: Math.min(p.b * 0.4, o.griffL || 16) }];
  }

  function ton(hex, d) {
    var h = String(hex || '#cccccc').replace('#', '');
    var n = parseInt(h, 16); if (isNaN(n)) n = 0xcccccc;
    var c = [(n >> 16) & 255, (n >> 8) & 255, n & 255].map(function (v) {
      return Math.max(0, Math.min(255, Math.round(v + d)));
    });
    return '#' + ((1 << 24) + (c[0] << 16) + (c[1] << 8) + c[2]).toString(16).slice(1);
  }

  /* WO SITZT DIE GESCHIRRSPUELERFRONT? (2026-09-27, Betreiber: „ان تكون الغسالة موجودة وليس فارغ بداخلها")
     Vollintegriert (71,3 cm): oben buendig, darunter der Geraetesockel — so in jeder Komplettkueche. Teilintegriert
     (halbhohe Blende, 57 cm): die Blende haengt UNTEN an der Tuer, darueber bleibt die Bedienleiste des Geraets sichtbar.
     Bis hierher sass auch sie oben, und unten klaffte 25 cm dunkle Leere. Rueckgabe in cm ueber dem Boden:
     { unten, h, sockel, leiste: null | [von, bis] } — dieselbe Lage fuer Frontansicht, 3D und PDF. */
  var GS_VOLL_H = 71.3;
  function gsLage(m, g) {
    var kh = g.korpus_hoehe, h = +m.h || GS_VOLL_H;
    if (h >= 65) { var l = Math.max(0, kh - h); return { unten: l, h: h, sockel: l, leiste: null }; }
    var s0 = Math.max(0, kh - GS_VOLL_H);
    return { unten: s0, h: h, sockel: s0, leiste: s0 + h < kh - 0.5 ? [s0 + h, kh] : null };
  }

  /* Wie ist die Front gebaut? Aus Funktion und Code, nie aus einem Produktfoto: die
     Dreiviertel-Studioaufnahmen des Herstellers verzerren, sobald man sie auf Schrankbreite
     zieht. Die Auszugszahl steht im Code (D40S3 = 3) und ist ziffern-terminiert, damit
     KU-S60L nicht als 6 Auszuege gilt. */
  function aufbau(m) {
    var fn = m.funktion || '', code = String(m.code || '').toUpperCase();
    if (istEck(m)) return { art: 'tuer', n: 1 };
    if (fn === 'geschirrspuelerfront') return { art: 'blende' };
    if (fn === 'apotheker') return { art: 'apotheker' };
    /* 60 cm hat EINE Tuer, nicht zwei. Nachgesehen an den Produktfotos aller vier Serien —
       Velora G60, Glanzia G60K, Livaro G60, Lunara N60 — ueberall eine einzige Tuer. Die
       Schwelle liegt also UEBER 60, nicht bei 60; erst 80 cm bekommt zwei Fluegel. */
    if (fn === 'haengeschrank_glas') return { art: 'glas', n: m.b > 60 ? 2 : 1 };
    if (fn === 'haengeschrank_dunst') return { art: 'dunst' };
    if (fn === 'herdumbau') return { art: 'ofen' };
    if (fn === 'kuehlumbau' || fn === 'hochschrank_geraet' || fn === 'geraete_unterschrank') return { art: 'geraet' };
    var s = code.match(/S(\d)(?!\d)/);
    if (s) { var n = +s[1]; return n === 1 ? { art: 'kombi' } : { art: 'auszug', n: Math.min(4, n) }; }
    if (fn === 'unterschrank_schub') return { art: 'auszug', n: 3 };
    /* HOCHSCHRAENKE HABEN ZWEI TUEREN (Betreiber 2026-09-28: „D60R ببابين وليست باب واحد"): auf den Produktfotos aller
       Serien — Velora und Glanzia D60R/D40SP, Livaro D60RWN/D40SPWN/D60T — eine lange Tuer oben und eine untere auf der
       Hoehe der Unterschraenke. Bisher galt fuer sie die Faustregel der Unterschraenke: eine einzige 2 m hohe Tuer. */
    if (fn === 'hochschrank') return { art: 'hoch' };
    /* Wo der Katalog die Tueren nennt, gilt er (Glanzia D60 hat ZWEI, D60 P/L eine — Produktfotos,
       Betreiber 2026-09-26); sonst die Faustregel. */
    if (m.tueren) return { art: 'tuer', n: m.tueren };
    return { art: 'tuer', n: m.b > 60 ? 2 : 1 };
  }

  /* Maserung in ECHTEN Zentimetern (userSpaceOnUse): ein Streifenmuster von 1,6 cm las sich wie
     Kord, nicht wie Eiche. Jetzt 14 cm breite Kacheln mit sieben leicht geschwungenen Fasern in
     wechselnder Staerke, dazu fuer Artisan Eiche die Aeste, die jedes Velora-Foto zeigt.
     Hochglanz bekommt zu dem diagonalen Licht zwei senkrechte Spiegelbahnen — so sehen die
     Glanzia- und Lunara-Fronten auf den Fotos aus. */
  var FASERN = [[0.8, 0.5, 0.55, -26], [2.3, -0.6, 0.35, 16], [3.9, 0.4, 0.8, -32],
                [6.1, -0.3, 0.4, 12], [8.0, 0.7, 0.7, -22], [10.2, -0.5, 0.3, 18], [12.4, 0.3, 0.6, -28]];
  /* Jede Zeichnung bekommt EIGENE Kennungen fuer Verlaeufe und Muster. Auf der Seite stehen mehrere
     Frontansichten gleichzeitig (eine je Schritt, die der anderen Schritte verborgen); `url(#hmkHolz)`
     traf die ERSTE im Dokument, und die lag in einem verborgenen Schritt — Chrome zeichnet ein Muster
     aus einem nicht dargestellten SVG nicht. Maserung und Glanz fehlten deshalb auf dem Bildschirm
     (gemessen 2026-09-24), im Beleg dagegen nicht. */
  var defsNr = 0, defsZ = '';
  function defs(z) {
    defsNr++;
    defsZ = '-' + defsNr;
    var d = frontFarbe(z);
    var fasern = FASERN.map(function (f) {
      var x = f[0], w = f[1];
      return '<path d="M' + x + ' 0 C' + (x + w) + ' 35 ' + (x - w) + ' 70 ' + (x + w * 0.5) + ' 105 S'
        + (x - w * 0.4) + ' 140 ' + x + ' 140" fill="none" stroke="' + ton(d, f[3]) + '" stroke-width="'
        + f[2] + '" opacity=".55"/>';
    }).join('');
    return '<defs>'
      + '<linearGradient id="hmkMatt' + defsZ + '" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#fff" stop-opacity=".16"/><stop offset=".45" stop-color="#fff" stop-opacity="0"/><stop offset="1" stop-color="#000" stop-opacity=".08"/></linearGradient>'
      + '<linearGradient id="hmkGlanz' + defsZ + '" x1="0" y1="0" x2=".8" y2="1"><stop offset="0" stop-color="#fff" stop-opacity=".62"/><stop offset=".22" stop-color="#fff" stop-opacity=".08"/><stop offset=".7" stop-color="#fff" stop-opacity="0"/><stop offset="1" stop-color="#000" stop-opacity=".06"/></linearGradient>'
      + '<linearGradient id="hmkSpiegel' + defsZ + '" x1="0" y1="0" x2="1" y2="0"><stop offset=".14" stop-color="#fff" stop-opacity="0"/><stop offset=".22" stop-color="#fff" stop-opacity=".46"/><stop offset=".29" stop-color="#fff" stop-opacity="0"/><stop offset=".6" stop-color="#fff" stop-opacity="0"/><stop offset=".65" stop-color="#fff" stop-opacity=".24"/><stop offset=".7" stop-color="#fff" stop-opacity="0"/></linearGradient>'
      + '<pattern id="hmkHolz' + defsZ + '" width="14" height="140" patternUnits="userSpaceOnUse">' + fasern + '</pattern>'
      + '<pattern id="hmkAst' + defsZ + '" width="47" height="118" patternUnits="userSpaceOnUse">'
      + '<ellipse cx="12" cy="30" rx="1.8" ry="3.4" fill="' + ton(d, -60) + '" opacity=".6"/>'
      + '<ellipse cx="12" cy="30" rx="3.4" ry="6.4" fill="none" stroke="' + ton(d, -34) + '" stroke-width=".45" opacity=".55"/>'
      + '<ellipse cx="33" cy="84" rx="1.3" ry="2.4" fill="' + ton(d, -55) + '" opacity=".55"/>'
      + '<ellipse cx="33" cy="84" rx="2.6" ry="5" fill="none" stroke="' + ton(d, -30) + '" stroke-width=".4" opacity=".5"/></pattern>'
      + '<pattern id="hmkEck' + defsZ + '" width="6" height="6" patternUnits="userSpaceOnUse" patternTransform="rotate(45)"><rect width="6" height="6" fill="var(--hm-img)"/><line x1="0" y1="0" x2="0" y2="6" stroke="var(--hm-line3)" stroke-width="1.6"/></pattern>'
      + '</defs>';
  }

  function flaeche(z, x, y, b, h, farbe) {
    if (b <= 0 || h <= 0) return '';
    var r = function (a, bb, c, d, fill) {
      return '<rect x="' + a + '" y="' + bb + '" width="' + c + '" height="' + d + '" rx="0.3" fill="' + fill + '"/>';
    };
    var glanz = istGlanz(z);
    return r(x, y, b, h, farbe)
      + (istHolz(z) ? r(x, y, b, h, 'url(#hmkHolz' + defsZ + ')') : '')
      + (istAst(z) ? r(x, y, b, h, 'url(#hmkAst' + defsZ + ')') : '')
      + r(x, y, b, h, 'url(#' + (glanz ? 'hmkGlanz' : 'hmkMatt') + defsZ + ')')
      + (glanz ? r(x, y, b, h, 'url(#hmkSpiegel' + defsZ + ')') : '')
      + '<rect x="' + x + '" y="' + y + '" width="' + b + '" height="' + h + '" rx="0.3" fill="none" stroke="rgba(0,0,0,.20)" stroke-width="0.15"/>';
  }
  /* Die Rahmenfront (Livaro „Weiss Rahmen"): ein eingelassenes Feld mit Schattenkante oben
     links und Lichtkante unten rechts — so faellt das Licht auf den Produktfotos. */
  function rahmenfeld(x, y, b, h) {
    var r = Math.min(5.5, b * 0.14, h * 0.2);
    if (b - 2 * r < 4 || h - 2 * r < 4) return '';
    return '<rect x="' + (x + r) + '" y="' + (y + r) + '" width="' + (b - 2 * r) + '" height="' + (h - 2 * r)
      + '" fill="none" stroke="rgba(0,0,0,.2)" stroke-width="0.35"/>'
      + '<rect x="' + (x + r + 0.4) + '" y="' + (y + r + 0.4) + '" width="' + (b - 2 * r - 0.8) + '" height="'
      + (h - 2 * r - 0.8) + '" fill="none" stroke="rgba(255,255,255,.75)" stroke-width="0.3"/>';
  }
  /* Ein Griff, gezeichnet an seiner Mitte. Jeder traegt `data-griff`, damit Pruefungen ihn
     finden, ohne auf einen Farbwert zu zielen. */
  var GRIFF_SCHWARZ = '#1E1F21', GRIFF_MESSING = '#B8955A';
  function griffSvg(g) {
    if (g.art === 'knopf') {
      return '<rect data-griff="knopf" x="' + (g.x - g.l / 2) + '" y="' + (g.y - 0.55) + '" width="' + g.l
        + '" height="1.1" rx="0.55" fill="' + GRIFF_MESSING + '"/>'
        + '<rect x="' + (g.x - g.l / 2 + 0.4) + '" y="' + (g.y - 0.45) + '" width="' + (g.l - 0.8) + '" height="0.3" rx="0.15" fill="rgba(255,255,255,.45)"/>';
    }
    if (g.art === 'mulde') {
      return '<rect data-griff="mulde" x="' + (g.x - g.l / 2) + '" y="' + (g.y - 0.8) + '" width="' + g.l
        + '" height="1.6" fill="rgba(0,0,0,.26)"/>'
        + '<rect x="' + (g.x - g.l / 2) + '" y="' + (g.y + 0.8) + '" width="' + g.l + '" height="0.25" fill="rgba(255,255,255,.4)"/>';
    }
    var hh = g.art === 'stange' ? 1.3 : 1.2;
    return '<rect data-griff="' + g.art + '" x="' + (g.x - g.l / 2) + '" y="' + (g.y - hh / 2) + '" width="' + g.l
      + '" height="' + hh + '" rx="' + (g.art === 'stange' ? 0.65 : 0.25) + '" fill="' + GRIFF_SCHWARZ + '"/>'
      + '<rect x="' + (g.x - g.l / 2 + 0.3) + '" y="' + (g.y - hh / 2 + 0.15) + '" width="' + Math.max(0, g.l - 0.6)
      + '" height="0.28" rx="0.14" fill="rgba(255,255,255,.22)"/>';
  }

  /* Eine Schrankfront, synthetisch gezeichnet. T ist die Schriftrueckrechnung der Ansicht. */
  /* Eine offene Nische ist KEINE Front: der Kunde sieht hier in den Korpus hinein. Also
     Korpusfarbe statt Frontfarbe, ein Schatten an der Oberkante (die Nische liegt zurueck)
     und vor allem KEIN Griff — an einer Oeffnung gibt es nichts zu greifen. */
  function nische(z, x, y, b, h) {
    if (b <= 0 || h <= 0) return '';
    var k = korpusFarbe(z), ix = x + 1.4, iy = y + 1.4, ib = Math.max(0, b - 2.8), ih = Math.max(0, h - 2.8);
    /* Die Nische muss auf den ersten Blick als OEFFNUNG lesbar sein, auch bei einer weissen
       Serie und auch klein gedruckt. Der erste Versuch mit -8 war zu zart: neben einer weissen
       Tuer sah die Oeffnung aus wie eine zweite Tuer. Deshalb ein klar zurueckgesetzter Innen-
       raum, ein Schatten oben (die Decke der Nische) und je einer an den Seitenwaenden. */
    var schatten = function (sx, sy, sb, sh, deck) {
      return '<rect x="' + sx + '" y="' + sy + '" width="' + sb + '" height="' + sh + '" fill="rgba(0,0,0,' + deck + ')"/>';
    };
    return '<rect x="' + x + '" y="' + y + '" width="' + b + '" height="' + h + '" rx="0.3" fill="' + ton(k, -14) + '"/>'
      + '<rect x="' + ix + '" y="' + iy + '" width="' + ib + '" height="' + ih + '" rx="0.2" fill="' + ton(k, -30) + '"/>'
      + schatten(ix, iy, ib, Math.min(3.2, ih * 0.34), '.20')
      + schatten(ix, iy, Math.min(2.2, ib * 0.1), ih, '.11')
      + schatten(ix + ib - Math.min(2.2, ib * 0.1), iy, Math.min(2.2, ib * 0.1), ih, '.11')
      + '<rect x="' + ix + '" y="' + iy + '" width="' + ib + '" height="' + ih + '" rx="0.2" fill="none" stroke="rgba(0,0,0,.30)" stroke-width="0.2"/>'
      + '<rect x="' + x + '" y="' + y + '" width="' + b + '" height="' + h + '" rx="0.3" fill="none" stroke="rgba(0,0,0,.30)" stroke-width="0.18"/>';
  }

  /* Die Aufteilung der Front kommt aus dem KATALOG, nicht aus dem Code. Gemessen an den
     Produktfotos aller elf Geraeteschraenke: derselbe `funktion`-Wert traegt verschiedene
     Fronten. Velora D60PM und Lunara KU-S60PM haben ZWEI offene Nischen (Mikrowelle ueber
     Backofen), Glanzia D60P, Lunara KU-S60P und Livaro D60PWN nur EINE, und Lunara KU-DP60
     eine Nische ueber einem Auszug — alle vier Formen unter `hochschrank_geraet` bzw.
     `geraete_unterschrank`. Aus der Funktion ist das nicht abzuleiten, aus dem Code auch
     nicht. Also steht es je Modell und je Serie in den Katalogdateien.

     Die Zahlen sind Hoehen in cm von oben nach unten; gezeichnet wird anteilig, damit eine
     Rundung im Katalog die Zeichnung nicht verschiebt. Fehlt das Feld, bleibt alles wie
     bisher — kein Modell aendert sein Bild, nur weil es diese Funktion hier gibt. */
  function frontPlan(m) {
    var f = m && m.front, summe = 0, i;
    if (!f || !f.length) return null;
    for (i = 0; i < f.length; i++) summe += (+f[i][1] || 0);
    return summe > 0 ? { teile: f, summe: summe } : null;
  }

  function front(z, m, x, y, b, h, T, unten) {
    var d = frontFarbe(z), o = '', rahmen = istRahmen(z);
    var fT = T || function (px) { return px * 0.42; };
    frontTeile(z, m, b, h, unten).forEach(function (p) {
      var px = x + p.x, py = y + p.y;
      if (p.art === 'nische') { o += nische(z, px, py, p.b, p.h); return; }
      if (p.art === 'ofen') {
        o += '<rect x="' + (px + 0.8) + '" y="' + py + '" width="' + (p.b - 1.6) + '" height="' + p.h + '" rx="0.4" fill="#23282b"/>';
        o += '<rect x="' + (px + 2.4) + '" y="' + (py + p.h * 0.32) + '" width="' + (p.b - 4.8) + '" height="' + (p.h * 0.5) + '" rx="0.3" fill="#39434a"/>';
        o += '<rect x="' + (px + 2.4) + '" y="' + (py + 1.6) + '" width="' + (p.b - 4.8) + '" height="1.2" rx="0.6" fill="#8d979c"/>';
        return;
      }
      o += flaeche(z, px, py, p.b, p.h, d);
      if (p.art === 'glas') {
        o += '<rect x="' + (px + 2) + '" y="' + (py + 2) + '" width="' + (p.b - 4) + '" height="' + (p.h - 4) + '" fill="rgba(214,232,236,.55)" stroke="rgba(0,0,0,.18)" stroke-width="0.15"/>';
      } else if (rahmen) {
        o += rahmenfeld(px, py, p.b, p.h);
      }
      if (p.art === 'blende') {
        o += '<text x="' + (px + p.b / 2) + '" y="' + (py + p.h / 2 + fT(4)) + '" font-size="' + fT(11) + '" text-anchor="middle" fill="rgba(0,0,0,.42)">GS</text>';
      }
      griffe(z, p).forEach(function (g) {
        o += griffSvg({ art: g.art, x: x + g.x, y: y + g.y, l: g.l });
      });
    });
    return o;
  }

  /* Die gezeichnete Fensteroeffnung: so hoch wie das Fenster breit ist, aber nie hoeher als
     der Platz zwischen Bruestung und Decke und nie niedriger als 30 cm. `hoehe` ist die
     Bruestung, also die UNTERkante. */
  function fensterOeffnung(m, raumHoehe) {
    var fh = Math.max(30, Math.min(m.breite * 0.95, raumHoehe - m.hoehe - 22));
    return { unten: m.hoehe, oben: m.hoehe + fh, h: fh };
  }

  /* ---------- Frontansicht ---------- */

  /* `ohneBedienung` schaltet die Loeschknoepfe ab. Der Planungsbeleg benutzt DIESELBE
     Zeichenfunktion wie die Oberflaeche — und druckte damit die roten X mit, mit denen man
     am Bildschirm einen Schrank entfernt. Auf einem Kundendokument ist das ein Knopf, den
     niemand druecken kann, und er sieht aus wie ein Fehlerzeichen am Schrank. */
  function frontZeichnung(z, daten, gemessenPx, ohneBedienung) {
    var g = geo(daten), w = wandObj(z), A = w.len, RH = +z.hoehe;
    var reihen = ['boden', 'oben', 'aufsatz'];
    var maxBel = reihen.reduce(function (m, zl) { return Math.max(m, belegt(z, daten, w.id, zl)); }, 0);
    /* Auch ein zu weit geschobenes Fenster bleibt sichtbar — sonst verschwindet der Fehler,
       den die Pruefung nennt, hinter dem Rand der Zeichnung. */
    var mkEnde = aktiveMerkmale(z).filter(function (m) { return m.wand === w.id; })
      .reduce(function (mx, m) { return Math.max(mx, m.x + (MT[m.typ].breite ? (m.breite || 0) : 0)); }, 0);
    /* Eine Reihe, die sich an ihr Ende lehnt (siehe items), laeuft bei Ueberlaenge LINKS ueber
       den Wandanfang hinaus. Auch das muss im Bild stehen, nicht hinter dem Rand verschwinden. */
    var minBel = reihen.reduce(function (m, zl) {
      return items(z, daten, w.id, zl).reduce(function (m2, it) { return Math.min(m2, it.x); }, m);
    }, 0);
    var vbL = Math.min(0, minBel) - 6;
    var vbW = Math.max(A, maxBel, mkEnde) + 14 - Math.min(0, minBel);
    var T = function (px) { return sk(px, vbW, gemessenPx); };
    var o = [defs(z)];


    o.push('<rect x="0" y="0" width="' + A + '" height="' + RH + '" fill="var(--hm-panel)" stroke="var(--hm-tile)" stroke-width="0.3"/>');

    /* Beschriftung kippt nach rechtsbuendig, sobald das Element am Wandende steht — sonst
       laeuft der Text ueber den Rand der Zeichnung hinaus und wird abgeschnitten. */
    var cap = function (mx, breite, y, fill, txt) {
      var rechts = mx + breite > A * 0.6;
      return '<text x="' + (rechts ? mx + breite - 2 : mx + 2) + '" y="' + y + '" font-size="' + T(12)
        + '" text-anchor="' + (rechts ? 'end' : 'start') + '" fill="' + fill + '">' + txt + '</text>';
    };
    /* Ueber dem Fenster mittig und nur so lang, wie das Fenster breit ist (Stufe 2, 2026-09-27): links
       angeschlagen lief „Fenster 100 · Brüstungshöhe 100" ueber das Fenster hinaus, und der Haengeschrank
       daneben verdeckte den Anfang („…nster 100"). Die erste Fassung, die passt; sonst die kuerzeste. */
    var capMitte = function (mx, breite, y, fill, texte) {
      var txt = texte.filter(function (t) { return t.length * T(12) * 0.56 <= breite + T(6); })[0] || texte[texte.length - 1];
      return '<text x="' + (mx + breite / 2) + '" y="' + y + '" font-size="' + T(12)
        + '" text-anchor="middle" fill="' + fill + '">' + txt + '</text>';
    };

    /* Ein X in der Ecke jedes Elements. Geloescht werden soll dort, wo das Element steht —
       nicht nur ueber eine Liste in der Seitenspalte. Der Knopf traegt eine unsichtbare,
       deutlich groessere Trefferflaeche: ein Kreuz von 16 px ist mit dem Finger sonst nicht
       zu treffen, und daneben zu tippen hiesse ziehen. */
    /* Die X-Knoepfe werden GESAMMELT und ganz zuletzt gezeichnet. Innerhalb ihrer Gruppe
       lagen sie unter den Beschriftungen der Nachbarn — ein halb verdeckter Loeschknopf ist
       schlimmer als gar keiner. Zuletzt gezeichnet liegen sie ueber allem, und sie stehen
       ausserdem ausserhalb der ziehbaren Gruppen. */
    var wegs = [];
    /* Die Trefferflaeche ist 44 px, nicht 34. Gemessen am fertigen Knopf auf 390 px waren
       es 34x34 — unter dem Fingermass, und danebentippen heisst ziehen. Der SICHTBARE
       Kreis bleibt bei T(8): groesser gezeichnet verdeckte er die Schrankkante. Es waechst
       allein das durchsichtige Rechteck darunter.
       Das Rechteck haengt an px/py, nicht an der Schrankkante — die Stelle des Schranks
       aendert sich dadurch nicht. */
    var wegKnopf = function (px, py, ziel, name) {
      if (ohneBedienung) return '';
      /* 22,5 statt 22: `sk()` rundet auf eine Nachkommastelle in Nutzereinheiten, und
         zurueckgerechnet fehlten dadurch bis zu 0,15 px — 43,9 statt 44. Der halbe
         Zentimeter Zugabe faengt die Rundung ab, gemessen ueber vier Massstaebe. */
      var r = T(8), h = T(22.5), d = r * 0.42;
      wegs.push('<g data-weg="' + ziel + '" role="button" style="cursor:pointer"'
        + ' aria-label="' + (name || 'Element') + ' entfernen">'
        + '<rect x="' + (px - h) + '" y="' + (py - h) + '" width="' + (h * 2) + '" height="' + (h * 2) + '" fill="transparent"/>'
        + '<circle cx="' + px + '" cy="' + py + '" r="' + r + '" fill="var(--hm-panel)" stroke="var(--hm-sale)" stroke-width="' + T(1.2) + '"/>'
        + '<path d="M' + (px - d) + ' ' + (py - d) + ' L' + (px + d) + ' ' + (py + d)
        + ' M' + (px + d) + ' ' + (py - d) + ' L' + (px - d) + ' ' + (py + d) + '" fill="none"'
        + ' stroke="var(--hm-sale)" stroke-width="' + T(1.7) + '" stroke-linecap="round"/></g>');
      return '';
    };

    /* Bauliches liegt HINTER den Schraenken: Fenster, Tuer, Heizkoerper sind Teil der Wand. */
    var mkAktiv = aktiveMerkmale(z).filter(function (m) { return m.wand === w.id; });
    var WAND_TEILE = ['fenster', 'tuer', 'heizkoerper', 'spueler', 'kuehl'];
    mkAktiv.filter(function (m) { return WAND_TEILE.indexOf(m.typ) > -1; })
      .forEach(function (m) {
        var c = MT[m.typ], i;
        o.push('<g data-mk="' + m.id + '" style="cursor:ew-resize">');
        if (m.typ === 'spueler') {
          /* Nischenmass, nicht Moebelmass: gestrichelt, damit niemand eine Front erwartet.
             Die Beschriftung sitzt UEBER der Arbeitsplatte — auf Nischenhoehe verschwand sie
             unter dem gestrichelten Plattenband. */
          var sh = Math.min(m.hoehe, g.korpus_hoehe);
          o.push('<rect x="' + m.x + '" y="' + (RH - sh) + '" width="' + m.breite + '" height="' + sh
            + '" fill="var(--hm-img)" stroke="' + c.farbe + '" stroke-width="0.6" stroke-dasharray="4 2.5"/>');
          o.push('<text x="' + (m.x + m.breite / 2) + '" y="' + (RH - sh / 2 + T(4)) + '" font-size="' + T(11)
            + '" text-anchor="middle" font-weight="700" fill="' + c.farbe + '">GS</text>');
          o.push(cap(m.x, m.breite, RH - arbeitsHoehe(daten, z) - T(7), 'var(--hm-ink2)',
            'Stellplatz Geschirrspüler ' + r0(m.breite) + ' cm'));
        } else if (m.typ === 'kuehl') {
          /* Der eigene Kuehlschrank: raumhohe Nische, gestrichelt, darin das Geraet in Umrissen
             (Kuehl- und Gefrierteil) — sichtbar als Platz, nicht als Moebel. */
          var kh = Math.min(+m.hoehe || c.hoehe, RH), kg = Math.min(185, kh - 4), kx = m.x + 3, kw = m.breite - 6;
          o.push('<rect x="' + m.x + '" y="' + (RH - kh) + '" width="' + m.breite + '" height="' + kh
            + '" fill="var(--hm-img)" stroke="' + c.farbe + '" stroke-width="0.6" stroke-dasharray="4 2.5"/>');
          o.push('<rect x="' + kx + '" y="' + (RH - kg) + '" width="' + kw + '" height="' + kg + '" rx="2" fill="none" stroke="'
            + c.farbe + '" stroke-width="0.45" opacity=".75"/>');
          o.push('<line x1="' + kx + '" y1="' + (RH - kg * 0.34) + '" x2="' + (kx + kw) + '" y2="' + (RH - kg * 0.34)
            + '" stroke="' + c.farbe + '" stroke-width="0.45" opacity=".75"/>');
          o.push('<text x="' + (m.x + m.breite / 2) + '" y="' + (RH - kg * 0.62 + T(4)) + '" font-size="' + T(11)
            + '" text-anchor="middle" font-weight="700" fill="' + c.farbe + '">KS</text>');
          o.push(cap(m.x, m.breite, RH - kh - T(7), 'var(--hm-ink2)', 'Stellplatz Kühlschrank ' + r0(m.breite) + ' cm'));
        } else if (m.typ === 'fenster') {
          var f = fensterOeffnung(m, RH);
          o.push('<rect x="' + m.x + '" y="' + (RH - f.oben) + '" width="' + m.breite + '" height="' + f.h
            + '" fill="var(--hm-bg)" stroke="' + c.farbe + '" stroke-width="0.6"/>');
          o.push('<line x1="' + (m.x + m.breite / 2) + '" y1="' + (RH - f.oben) + '" x2="' + (m.x + m.breite / 2)
            + '" y2="' + (RH - f.unten) + '" stroke="' + c.farbe + '" stroke-width="0.5"/>');
          o.push(capMitte(m.x, m.breite, RH - f.oben - T(6), 'var(--hm-ink2)',
            ['Fenster ' + r0(m.breite) + ' · Brüstungshöhe ' + r0(m.hoehe), 'Fenster ' + r0(m.breite) + ' · Brüstung ' + r0(m.hoehe),
              'Fenster ' + r0(m.breite), 'Fenster']));
        } else if (m.typ === 'tuer') {
          o.push('<rect x="' + m.x + '" y="' + (RH - m.hoehe) + '" width="' + m.breite + '" height="' + m.hoehe
            + '" fill="var(--hm-img)" stroke="' + c.farbe + '" stroke-width="0.6"/>');
          o.push('<path d="M' + m.x + ' ' + RH + ' A ' + m.breite + ' ' + m.breite + ' 0 0 1 '
            + (m.x + m.breite) + ' ' + (RH - m.breite) + '" fill="none" stroke="' + c.farbe
            + '" stroke-width="0.4" stroke-dasharray="3 2"/>');
          o.push(cap(m.x, m.breite, RH - m.hoehe - T(6), 'var(--hm-ink2)', 'Tür ' + r0(m.breite) + ' cm'));
        } else {
          o.push('<rect x="' + m.x + '" y="' + (RH - m.hoehe) + '" width="' + m.breite + '" height="' + (m.hoehe - 12)
            + '" fill="var(--hm-img)" stroke="' + c.farbe + '" stroke-width="0.6"/>');
          for (i = 3; i < m.breite - 2; i += 5) {
            o.push('<line x1="' + (m.x + i) + '" y1="' + (RH - m.hoehe + 2) + '" x2="' + (m.x + i)
              + '" y2="' + (RH - 14) + '" stroke="' + c.farbe + '" stroke-width="0.4" opacity=".7"/>');
          }
          o.push(cap(m.x, m.breite, RH - m.hoehe - T(6), 'var(--hm-mut)', 'Heizkörper ' + r0(m.breite) + ' cm'));
        }
        /* Die Oberkante ist bei jedem Wandteil eine andere: Fenster oben an der Oeffnung,
           Tuer und Heizkoerper an ihrer Hoehe, der Stellplatz an der Nische. */
        var ok = m.typ === 'fenster' ? RH - fensterOeffnung(m, RH).oben
               : (m.typ === 'spueler' ? RH - Math.min(m.hoehe, g.korpus_hoehe) : RH - m.hoehe);
        o.push(wegKnopf(m.x + m.breite - T(11), ok + T(11), 'mk:' + m.id, MT_KURZLABEL[m.typ] || m.typ));
        o.push('</g>');
      });

    /* Arbeitsplatte nur ueber der belegten Strecke — sie gehoert nicht zur Serie und nicht
       zur Summe, deshalb erscheint sie gestrichelt. */
    var bo = items(z, daten, w.id, 'boden');
    var lauf = bo.filter(function (x) { return x.m.reihe !== 'voll'; });
    if (lauf.length) {
      /* Die Strecke reicht vom KLEINSTEN x bis zur GROESSTEN Aussenkante — nicht vom ersten bis
         zum letzten Element. items() liefert in Setzreihenfolge, ein Eckschrank springt aber in
         seine Ecke, egal wann er gesetzt wurde. In der L-Kueche stand der Eckschrank am
         Wandende zuerst in der Liste: Breite -150, die Platte wurde gar nicht gezeichnet. */
      var x0 = Infinity, x1 = -Infinity;
      lauf.forEach(function (x) { x0 = Math.min(x0, x.x); x1 = Math.max(x1, x.x + x.b); });
      o.push('<rect x="' + x0 + '" y="' + (RH - arbeitsHoehe(daten, z)) + '" width="' + (x1 - x0)
        + '" height="' + plattenDicke(z, daten) + '" fill="var(--hm-img)" stroke="var(--hm-mut3)" stroke-width="0.25" stroke-dasharray="2 1.4"/>');
    }

    /* Unterkante der Reihe ueber Fussboden. */
    var bandU = function (zl) {
      return zl === 'oben' ? g.haenge_unterkante : (zl === 'aufsatz' ? g.hochschrank_hoehe : 0);
    };

    reihen.forEach(function (zl) {
      items(z, daten, w.id, zl).forEach(function (it) {
        /* Die Geschirrspuelerfront ist niedriger als der Korpus (71,3 statt 82/87 cm): sie haengt an
           der Maschine, OBEN buendig mit den Nachbarn — so steht sie in jeder Komplettkueche im Shop.
           Unten auf dem Boden gezeichnet klaffte darueber eine Luecke bis zur Arbeitsplatte. */
        var gsL = zl === 'boden' && it.m.funktion === 'geschirrspuelerfront' ? gsLage(it.m, g) : null;
        var gsLuecke = gsL ? gsL.sockel : 0;
        var y = zl === 'boden' ? RH - it.m.h - gsLuecke : RH - (bandU(zl) + it.off + it.m.h);
        /* Der Code IM Schrank. Ohne ihn stand dort eine Reihe gleicher beiger Kaesten:
           welcher davon die Spuele ist und welcher 45 statt 60 cm breit, war nicht zu
           sehen — nachgemessen trug kein einziger Schrank in der Frontansicht Text.
           Unten gesetzt, damit er dem Loeschknopf oben rechts nicht ins Gehege kommt.
           Ob er ueberhaupt hineinpasst, MISST die Oberflaeche nach dem Zeichnen
           (`beschriftungMessen`) — geschaetzte Zeichenbreiten lagen hier schon einmal
           daneben. Die Stelle und die Groesse des Schranks bleiben unberuehrt. */
        /* Der GEWAEHLTE Schrank war in der Zeichnung nicht zu erkennen: angetippt erschien
           die Ausfuehrungsleiste darunter und der Loeschknopf wurde nutzbar, der Schrank
           selbst sah aus wie jeder andere. Ein Rahmen sagt, worauf sich die Leiste bezieht.
           Nur Darstellung — Stelle, Groesse und Reihenfolge bleiben, wie sie sind. */
        var gewaehlt = z.sel === (w.id + '|' + zl + '|' + it.i);
        /* Haengeschraenke tragen ihren Griff an der UNTERkante — genau dort lag die Plakette und
           deckte ihn zu. Dort steht sie deshalb um die Griffzone hoeher. */
        var hebe = zl === 'boden' ? 0 : Math.min(3.5, it.m.h * 0.08);
        o.push('<g data-sel="' + w.id + '|' + zl + '|' + it.i + '">'
          + front(z, it.m, it.x, y, it.b, it.m.h, T, daten ? geo(daten).korpus_hoehe : null)
          + (gsLuecke ? '<rect x="' + it.x + '" y="' + (y + it.m.h) + '" width="' + it.b + '" height="' + gsLuecke
              + '" fill="rgba(0,0,0,.32)" pointer-events="none"/>' : '')
          /* Teilintegriert: ueber der Blende die Bedienleiste des Geraets — Edelstahl mit Anzeige, nicht leer. */
          + (gsL && gsL.leiste ? '<rect x="' + (it.x + 0.3) + '" y="' + (RH - gsL.leiste[1]) + '" width="' + (it.b - 0.6) + '" height="'
              + (gsL.leiste[1] - gsL.leiste[0] - 0.3) + '" fill="#C9CDD0" stroke="rgba(0,0,0,.25)" stroke-width="0.15" pointer-events="none"/>'
              + '<rect x="' + (it.x + it.b / 2 - 6) + '" y="' + (RH - (gsL.leiste[0] + gsL.leiste[1]) / 2 - 1.6) + '" width="12" height="3.2" rx="0.6"'
              + ' fill="#15181A" pointer-events="none"/>' : '')
          /* Die Kante ZWISCHEN zwei Schraenken war kaum zu sehen: `flaeche()` umrandet jede
             Front mit 0,15 Einheiten in 20 % Schwarz, und zwei davon nebeneinander ergeben im
             Belegmassstab einen Hauch. Der Kunde muss aber erkennen, wo ein Schrank aufhoert
             und der naechste anfaengt — er bestellt sie einzeln. Deshalb umreisst jetzt jeder
             KORPUS sich selbst, deutlich staerker und in Pixelmass statt in Zentimetern: so
             ist die Linie auf dem Papier so kraeftig wie am Bildschirm, egal wie gross die
             Zeichnung gerade skaliert. */
          + '<rect x="' + it.x + '" y="' + y + '" width="' + it.b + '" height="' + it.m.h
          + '" fill="none" stroke="rgba(0,0,0,.45)" stroke-width="' + T(1.1) + '" pointer-events="none"/>'
          /* Der Rahmen war markengruen auf gruener Front: gemessen 1,85:1, also unter der
             Schwelle von 3:1 fuer Bedienelemente — die Ausfuehrungsleiste wirkte auf ein
             Ziel, das man nicht sah. Eine einzelne Farbe kann das nicht loesen, weil die
             Front dem Kunden gehoert; ein Ring aus zwei Toenen schon: gegen JEDE Fuellung
             traegt mindestens einer der beiden ueber 3:1, meist beide. Die Bedeutung bleibt
             dieselbe — hier ist gewaehlt, mehr sagt der Rahmen nicht. */
          + (gewaehlt ? '<rect x="' + it.x + '" y="' + y + '" width="' + it.b + '" height="' + it.m.h
              + '" fill="none" stroke="var(--hm-ink)" stroke-width="' + T(3.4)
              + '" pointer-events="none"/>'
              + '<rect x="' + (it.x + T(1.7)) + '" y="' + (y + T(1.7)) + '" width="' + (it.b - T(3.4))
              + '" height="' + (it.m.h - T(3.4)) + '" fill="none" stroke="var(--hm-panel)"'
              + ' stroke-width="' + T(1.6) + '" pointer-events="none"/>' : '')
          /* Der Code stand in Schriftgrad 9 und mit Deckkraft 0,72 auf der Frontfarbe. Gemessen
             auf „Gruen / Dunkle Eiche": 5,9 px gross und 2,09:1 Kontrast — auf einer dunklen
             Front war er nicht zu lesen, und WELCHE Front der Kunde waehlt, entscheidet er.
             Eine feste Schriftfarbe kann es deshalb nicht geben.

             Stattdessen traegt die Schrift ihren eigenen Grund mit: heller Kern, dunkler Saum,
             `paint-order` legt den Saum UNTER den Kern. Damit liest sie sich auf jeder Front,
             ohne dass eine Plakette den Schrank zustellt — dieselbe Loesung, mit der Karten
             ihre Ortsnamen ueber beliebige Flaechen setzen. Sekundaer bleibt sie ueber die
             Groesse, nicht mehr ueber die Blaesse.

             Die Einblendlogik fuer schmale Schraenke bleibt unberuehrt: `chipsMessen()` misst
             weiter die gezeichnete Breite und blendet aus, was nicht hineinpasst. */
          /* Der NAME ueber dem Code — der Betreiber will ihn auf der Zeichnung sehen, nicht nur
             im Beleg. Er traegt dieselbe Kennung `data-code`, damit `chipsMessen()` ihn nach
             derselben Regel ausblendet, wenn der Schrank zu schmal dafuer ist. */
          /* Die Plakette. Sie traegt `data-platz` wie die Schrift darauf, damit die Oberflaeche
             sie nach derselben Regel ausblendet: verschwinden beide Zeilen, verschwindet auch
             der Grund — ein leeres Schild waere nur noch Fleck. Die Hoehe ist gedeckelt, damit
             sie einen flachen Schrank nicht zur Haelfte zustellt. */
          + (function () {
              var sh = Math.min(T(24), it.m.h * 0.5);
              return '<rect data-schild="1" data-platz="' + r0(it.b) + '" x="' + (it.x + T(1.2))
                + '" y="' + (y + it.m.h - sh - T(2) - hebe) + '" width="' + Math.max(0, it.b - T(2.4))
                + '" height="' + sh + '" rx="' + T(1.5) + '" fill="' + SCHILD_GRUND
                + '" opacity="' + SCHILD_DECKUNG + '" pointer-events="none"/>'
                + '<rect data-schildlinie="1" x="' + (it.x + T(1.2)) + '" y="' + (y + it.m.h - sh - T(2) - hebe)
                + '" width="' + Math.max(0, it.b - T(2.4)) + '" height="' + T(0.5)
                + '" fill="rgba(255,255,255,.16)" pointer-events="none"/>';
            }())
          /* Kein Saum mehr: die Schrift steht auf der Plakette und braucht keinen. Der Name
             tritt ueber die Deckkraft zurueck, nicht ueber eine zweite Farbe. */
          + '<text data-name="1" data-platz="' + r0(it.b) + '" x="' + (it.x + it.b / 2)
          + '" y="' + (y + it.m.h - T(19) - hebe) + '" font-size="' + T(8)
          + '" letter-spacing="' + T(0.5) + '" text-anchor="middle" fill="' + SCHILD_SCHRIFT
          + '" fill-opacity="0.82" opacity="1">'
          /* Der Kern hat keine Escape-Funktion; heute traegt keiner der 153 Namen ein
             Sonderzeichen, aber ein kuenftiger Import koennte eines mitbringen und die
             Zeichnung zerreissen. Die drei kritischen Zeichen werden deshalb hier ersetzt. */
          + String(modellName(it.m)).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
          + '</text>'
          + '<text data-code="1" data-platz="' + r0(it.b) + '" x="' + (it.x + it.b / 2)
          + '" y="' + (y + it.m.h - T(7) - hebe) + '" font-size="' + T(11)
          + '" font-weight="700" letter-spacing="' + T(0.3) + '" text-anchor="middle" fill="'
          + SCHILD_SCHRIFT + '" opacity="1">' + it.m.code + '</text>'
          + wegKnopf(it.x + it.b - T(11), y + T(11), 'sel:' + w.id + '|' + zl + '|' + it.i,
              modellName(it.m) + ' ' + it.m.code)
          + '</g>');
      });
    });

    /* Der Eckschrank der Nachbarwand steht mit seinem zweiten Schenkel in DIESER Wand — als
       schraffierter Block, damit der Kunde sieht, warum dort nichts mehr hin kann. Gilt in
       beide Richtungen: die Ecke der Nachbarwand am Ende, die der Vorwand am Anfang. */
    reihen.forEach(function (zl) {
      var u = bandU(zl);
      var band = function (bx, cm, code, wandLabel, h) {
        o.push('<g><rect x="' + bx + '" y="' + (RH - u - h) + '" width="' + cm + '" height="' + h
          + '" fill="url(#hmkEck' + defsZ + ')" stroke="var(--hm-line3)" stroke-width="0.4"/>'
          + '<text x="' + (bx + cm / 2) + '" y="' + (RH - u - h / 2) + '" font-size="' + T(10.5)
          + '" text-anchor="middle" fill="var(--hm-mut)">' + code + ' · ' + wandLabel + '</text></g>');
      };
      var eNb = eckNachbar(z, daten, w.id, zl);
      if (eNb) band(A - eNb.cm, eNb.cm, eNb.code, eNb.wand, eNb.h);
      var eVo = eckVorher(z, daten, w.id, zl);
      if (eVo) band(0, eVo.cm, eVo.code, eVo.wand, eVo.h);
    });

    /* Punktanschluesse liegen VOR den Schraenken: der Kunde muss sehen, was hinter dem
       Schrank verschwindet. Plakette mit Kuerzel statt anonymem Punkt, Klartext daneben.
       Der Klartext steht in einem gefuellten Feld mit weisser Schrift — auf einer dunklen
       Front waere farbige Schrift unlesbar, und die Frontfarbe waehlt der Kunde. */
    mkAktiv.filter(function (m) { return WAND_TEILE.indexOf(m.typ) === -1; })
      .forEach(function (m) {
        var c = MT[m.typ], y = RH - (m.hoehe || 50);
        var bw = T(21), bh = T(15), rechts = m.x > A * 0.62, i;
        /* Die Feldbreite wird nicht geschaetzt, sondern nach dem Zeichnen GEMESSEN. Die alte
           Faustformel (6,4 px je Zeichen) lag bei langen Beschriftungen daneben: die Schrift
           lief links unter die Plakette und rechts aus dem Bild. Hier steht nur, was das Feld
           braucht — Platz, Polsterung und die Seite, auf der es zuerst versucht wird; die
           Masse setzt `chipsMessen()` in derselben Schrift, in der auch gezeichnet wird. */
        var txtChip = function (txt) {
          var hh = T(15), pad = T(6.5), gap = bw / 2 + T(3);
          return '<g data-chip="1" data-cx="' + m.x + '" data-gap="' + gap + '" data-pad="' + pad
            + '" data-seite="' + (rechts ? 'links' : 'rechts') + '">'
            + '<rect data-chipbg="1" x="' + (m.x + gap) + '" y="' + (y - hh / 2) + '" width="0" height="' + hh
            + '" fill="' + c.farbe + '"/>'
            + '<text data-chiptext="1" x="' + (m.x + gap + pad) + '" y="' + (y + hh * 0.31) + '" font-size="' + T(11.5)
            + '" font-weight="600" fill="var(--hm-panel)">' + txt + '</text></g>';
        };
        if (m.typ === 'haube') {
          /* Geraetekoerper in echten Massen. hoehe ist die UNTERkante. */
          var hw = m.breite || 60, hy = RH - m.hoehe - HAUBE.h, hx = m.x;
          o.push('<g data-mk="' + m.id + '" style="cursor:move">'
            + '<rect x="' + hx + '" y="' + hy + '" width="' + hw + '" height="' + HAUBE.h + '" fill="#5A6165" stroke="#1D2124" stroke-width="0.3"/>'
            + '<rect x="' + hx + '" y="' + hy + '" width="' + hw + '" height="' + (HAUBE.h * 0.42) + '" fill="#15181A"/>');
          var kn = hw >= 80 ? 3 : 2, kw = (hw - 2.4) / kn;
          for (i = 0; i < kn; i++) {
            o.push('<rect x="' + (hx + 1.2 + i * kw) + '" y="' + (hy + HAUBE.h * 0.5) + '" width="' + (kw - 1.2)
              + '" height="' + (HAUBE.h * 0.4) + '" fill="#A9AFB3" stroke="#31363a" stroke-width="0.2"/>');
          }
          o.push('<rect x="' + (hx + hw / 2 - bw / 2) + '" y="' + (hy - bh - T(3)) + '" width="' + bw + '" height="' + bh + '" fill="' + c.farbe + '"/>'
            + '<text x="' + (hx + hw / 2) + '" y="' + (hy - bh * 0.62 - T(3)) + '" font-size="' + T(10.5)
            + '" font-weight="800" text-anchor="middle" fill="var(--hm-panel)">' + c.kurz + '</text>'
            + '<text x="' + (hx + hw / 2) + '" y="' + (RH - m.hoehe + T(11)) + '" font-size="' + T(10.5)
            + '" text-anchor="middle" fill="var(--hm-mut)">' + hw + '×' + HAUBE.h + '×' + HAUBE.t + ' · UK ' + r0(m.hoehe) + '</text>'
            + wegKnopf(hx + hw - T(11), hy + T(11), 'mk:' + m.id, MT_KURZLABEL[m.typ] || m.typ) + '</g>');
          return;
        }
        o.push('<g data-mk="' + m.id + '" style="cursor:ew-resize">'
          + '<line x1="' + m.x + '" y1="' + y + '" x2="' + m.x + '" y2="' + RH + '" stroke="' + c.farbe
          + '" stroke-width="0.3" stroke-dasharray="2 2" opacity=".5"/>'
          + '<rect x="' + (m.x - bw / 2) + '" y="' + (y - bh / 2) + '" width="' + bw + '" height="' + bh + '" fill="' + c.farbe + '"/>'
          + '<text x="' + m.x + '" y="' + (y + bh * 0.31) + '" font-size="' + T(10.5)
          + '" font-weight="800" text-anchor="middle" fill="var(--hm-panel)">' + c.kurz + '</text>'
          + txtChip(c.label + ' · ' + r0(m.x) + ' cm')
          /* Das X sitzt auf der Seite, auf der KEIN Textfeld steht, und auf derselben Hoehe
             wie die Plakette. Ueber ihr landete es auf der Beschriftung des Anschlusses
             darueber — bei drei Anschluessen an derselben Stelle sind das drei Kollisionen. */
          + wegKnopf(rechts ? m.x + bw / 2 + T(11) : m.x - bw / 2 - T(11), y, 'mk:' + m.id,
              MT_KURZLABEL[m.typ] || m.typ) + '</g>');
      });

    /* Ueberlauf sichtbar machen: was ueber die Wand hinausragt, traegt Terracotta — im Shop
       ist Gruen der aktive Zustand, Terracotta das Signal. */
    if (maxBel > A) {
      o.push('<rect x="' + A + '" y="0" width="' + (maxBel - A) + '" height="' + RH + '" fill="var(--hm-sale)" fill-opacity=".12"/>');
      o.push('<line x1="' + A + '" y1="-4" x2="' + A + '" y2="' + (RH + 4) + '" stroke="var(--hm-sale)" stroke-width="' + T(2) + '"/>');
      o.push('<text x="' + (A + T(6)) + '" y="' + T(16) + '" font-size="' + T(13) + '" font-weight="800" fill="var(--hm-saleh)">' + r0(maxBel - A) + ' cm zu lang</text>');
    }
    if (minBel < -0.5) {
      o.push('<rect x="' + minBel + '" y="0" width="' + (-minBel) + '" height="' + RH + '" fill="var(--hm-sale)" fill-opacity=".12"/>');
      o.push('<line x1="0" y1="-4" x2="0" y2="' + (RH + 4) + '" stroke="var(--hm-sale)" stroke-width="' + T(2) + '"/>');
      o.push('<text x="' + (-T(6)) + '" y="' + T(16) + '" font-size="' + T(13) + '" font-weight="800" text-anchor="end" fill="var(--hm-saleh)">' + r0(-minBel) + ' cm zu lang</text>');
    }

    /* Boden und Massline */
    o.push('<line x1="0" y1="' + RH + '" x2="' + A + '" y2="' + RH + '" stroke="var(--hm-ink)" stroke-width="' + T(2) + '"/>');
    var ry = RH + T(9), ty = RH + T(9) + T(13);
    o.push('<line x1="0" y1="' + ry + '" x2="' + A + '" y2="' + ry + '" stroke="var(--hm-line3)" stroke-width="0.3"/>');
    o.push('<text x="0" y="' + ty + '" font-size="' + T(12.5) + '" fill="var(--hm-mut)">0</text>');
    o.push('<text x="' + (A / 2) + '" y="' + ty + '" font-size="' + T(12.5) + '" text-anchor="middle" font-weight="700" fill="var(--hm-ink)">' + w.label + '</text>');
    o.push('<text x="' + A + '" y="' + ty + '" font-size="' + T(12.5) + '" text-anchor="end" fill="var(--hm-mut)">' + r0(A) + ' cm</text>');

    o.push(wegs.join(''));

    return { inner: o.join(''), vb: vbL + ' ' + (-T(20)) + ' ' + vbW + ' ' + (RH + T(20) + T(26)) };
  }

  /* ---------- Grundriss ---------- */

  /* `kompakt`: die Zeichnung fuer ein Telefon.

     Gemessen auf 390 px: der Grundriss reservierte je Seite 363,6 Einheiten fuer eine
     520 Einheiten breite Kueche — 58 % der Zeichnung waren Rand. Der Grund ist keine
     Nachlaessigkeit, sondern Arithmetik: Massketten und Schrift werden in PIXELN bemessen
     und ueber `T()` in Einheiten umgerechnet. Auf einer kleinen Flaeche ist der Massstab
     klein, also wird derselbe Pixelrand zu sehr vielen Einheiten. Kleiner setzen kann man
     die Schrift nicht — sie soll lesbar bleiben.

     Also faellt auf dem Telefon weg, was doppelt ist: die beiden SENKRECHTEN Massketten.
     Ihre Zahlen stehen dort ohnehin darunter in der Zusammenfassung, jede bei ihrem Namen,
     und in ihrem Eingabefeld. Die Namen der senkrechten Waende ruecken dafuer NACH INNEN —
     in Schritt 1 ist der Raum leer, dort ist Platz. Die waagrechte Kette bleibt: sie kostet
     Hoehe, und Hoehe hat ein Telefon.

     Am Schreibtisch aendert sich dadurch nichts; der Schalter kommt nur von dort, wo er
     gebraucht wird. */
  function planZeichnung(z, daten, planK, kompakt) {
    var g = geo(daten), t = g.korpus_tiefe;
    var A = +z.A, B = +z.B, C = +z.C, IL = +z.IL, f = z.form;
    /* EINE Quelle fuer die Lage jeder Wand; die Zeichnung rechnet nichts mehr selbst nach.
       Genauer, als der Satz vorher behauptete: 3D LIEST diese Quelle nicht, es rechnet die
       Wand- und Insellage weiterhin selbst (hm-konfigurator-3d.js, wandGruppe). Beide
       kommen heute zum selben Ergebnis — geprueft — aber sie sind noch nicht dieselbe
       Rechnung. Das zusammenzulegen gehoert in die 3D-Phase. */
    var raum = raumGeometrie(z, t);
    var insel = raum.bloecke[0] || null;
    /* WOHIN eine Wand aus dem Raum zeigt. Marke und Masskette haengen daran und nicht am
       Buchstaben: bisher kamen nur drei Richtungen vor — A zeigt nach oben aus dem Raum,
       B nach rechts, C nach links —, und ihre Marken standen deshalb alle auf einer Linie
       ueber dem Bild. Die zweizeilige Kueche bringt die vierte: eine Wand, deren
       Aussenseite nach UNTEN zeigt. Fuer sie waere eine Marke oben am Bild schlicht
       falsch, und eine senkrechte Masskette an der linken Seite erst recht. */
    var richtung = function (w) {
      var n = wandNormaleInnen(w), ax = -n.x, ay = -n.y;
      if (ay < -0.5) return 'oben';
      if (ax > 0.5) return 'rechts';
      if (ax < -0.5) return 'links';
      return 'unten';
    };
    var inselX = insel ? insel.p0.x : 0, inselY = insel ? insel.p0.y : 0;
    /* Die Groesse der Zeichenflaeche ist noch eine Staffel ueber die Raumform und nicht
       das umschliessende Rechteck der Geometrie. Sie bleibt es in Phase 3: die Staffel
       durch die Huellkurve zu ersetzen wuerde die L- und Insel-Grundrisse sichtbar
       veraendern, und sichtbar aendern darf sich hier allein die Wand C.
       Neu ist nur die zweizeilige Kueche — die fiel bisher in den Zweig fuer die gerade
       Kueche und bekam eine Flaeche von einer Schranktiefe, obwohl ihre zweite Zeile
       Meter entfernt liegt. Ein Fall ohne Vergangenheit kann nichts brechen. */
    /* DIE ZEICHENFLAECHE HAENGT NICHT MEHR AN DER FORM.

       Sie war eine Staffel ueber den Formnamen: die gerade Kueche bekam eine Schranktiefe,
       die L-Kueche Wand B, die Inselkueche die Lage ihrer Insel. Gemessen bei denselben
       Maßen 360/240/180 waren das 112, 240 und 214 — dreimal dieselbe Wohnung, dreimal ein
       anders hohes Bild. Wer die Form durchprobierte, sah das Rechteck springen und musste
       jedes Mal neu einschaetzen, was er da vor sich hat.

       Jetzt entscheidet die GEOMETRIE, nicht der Name: wie tief der Raum ist, weiss seine
       eigene Huelle. Damit faellt die Staffel weg, und mit ihr die Gefahr, dass eine neue
       Form vergessen wird — die Parallelkueche fiel genau so einmal in den Zweig der
       geraden Kueche.

       Die Tiefe kommt aus `raumTiefeMax` — der tiefsten Form, die diese Maße beschreiben
       koennen. Damit steht das Rechteck bei jedem Formwechsel still und bewegt sich nur,
       wenn der Kunde seine Maße aendert. Die Begruendung und ihr Preis stehen dort. */
    var raumB = z.planEcht ? raumTiefeFuer(z, t) : raumTiefeMax(z, t);
    var o = [];
    /* planK ist der gemessene Massstab der letzten Zeichnung: px = Nutzereinheit x planK.
       Eine geschaetzte viewBox-Breite laege um rund 0,84 daneben, weil die Massketten die
       viewBox seitlich verbreitern. */
    var T = function (px) { return Math.round(px / Math.max(0.25, planK || 0.9) * 10) / 10; };

    /* In Schritt 1 geht es allein um den Raum. Gesetzte Schraenke werden nicht geloescht und
       nicht versteckt, aber auf eine duenne Kontur zurueckgenommen — sichtbar bleibt sie,
       damit eine zu klein gemessene Wand sofort auffaellt. */
    var nurRaum = z.step === 1;
    var fuell = function (aktiv) { return nurRaum ? 'none' : (aktiv ? 'var(--hm-tile)' : 'var(--hm-img)'); };
    var strich = function (aktiv) { return nurRaum ? 'var(--hm-line3)' : (aktiv ? 'var(--hm-ink)' : 'var(--hm-mut3)'); };

    var tiefA = items(z, daten, 'A', 'boden').reduce(function (m, it) { return Math.max(m, it.t || t); }, t);
    var wd = T(7), wf = function (id) { return z.wand === id ? 'var(--hm-brand)' : 'var(--hm-line3)'; };

    /* Haengeschraenke NICHT in den Unterschrankstreifen zeichnen — dort ueberlagern sich zwei
       Reihen auf zwei Bildschirm-Millimetern. Stattdessen ein schmales Band im freien Rand
       AUSSERHALB der Wand, an derselben Stelle: „ueber dieser Strecke haengt etwas". Hoehe und
       Tiefe liest der Kunde in der Frontansicht, dort gehoeren sie hin. Abschaltbar, weil wer
       nur unten plant, das Band nicht braucht. */
    var obenAn = z.zeigeOben !== false && !nurRaum;
    var bandD = T(9), randA = wd + (obenAn ? bandD + T(4) : 0);
    var obenBand = function (w, frei) {
      if (!obenAn) return;
      var liste = items(z, daten, w.id, 'oben');
      if (!liste.length) return;
      var akt = z.wand === w.id;
      var fill = akt ? 'var(--hm-brand)' : 'var(--hm-glite)';
      var kante = akt ? 'var(--hm-band)' : 'var(--hm-gmid)';
      var map = wandProjektion(w);
      /* Der einzige verbliebene Unterschied im Band: an einer Wand liegt es AUSSERHALB
         des Raumes (negative Tiefe), an einem frei stehenden Block jenseits der
         Korpustiefe. Das haengt daran, ob das Teil frei im Raum steht — nicht daran,
         wie es heisst. Die frueheren vier Zweige nach A/B/C/I sind damit fort. */
      var vA = frei ? t + T(4) : -(wd + bandD + T(2));
      var vB = frei ? t + T(4) + bandD : -(wd + T(2));
      liste.forEach(function (it) {
        var r = projRechteck(map, it.x, vA, it.x + it.b, vB);
        o.push('<rect x="' + r.x + '" y="' + r.y + '" width="' + r.w + '" height="' + r.h
          + '" fill="' + fill + '" stroke="' + kante + '" stroke-width="0.4"/>');
      });
    };

    /* Der Boden traegt den Leinwandton des Shops, nicht das Weiss der Karte. Weiss auf Weiss
       war unsichtbar: der Kunde sah keinen Raum, sondern eine grosse leere Flaeche und hielt
       die Zeichnung fuer kaputt. Jetzt ist die Raumflaeche eine Flaeche. */
    o.push('<rect x="0" y="0" width="' + A + '" height="' + raumB + '" fill="var(--hm-bg)" stroke="var(--hm-line2)" stroke-width="0.5"/>');
    /* Die Wandflaechen tragen ihre Kennung: ein Klick darauf fuehrt auf das zugehoerige
       Massfeld. Die Zeichnung wird damit zur Bedienung, nicht nur zur Anzeige. */
    /* Jedes Wandband entsteht aus p0/p1 und der Innennormalen: es liegt AUSSERHALB des
       Raumes (Tiefe -wd bis 0) und laeuft von -ueber0 bis Wandlaenge + ueber1.

       Der Ueberstand schliesst die Ecken: wo ein Nachbar anschliesst, ragt das Band um
       die Wanddicke hinaus, sonst endet es buendig. Die ERSTE Wand der Kette ragt
       zusaetzlich an ihren freien Enden hinaus. Das ist eine Altlast der alten
       Zeichnung — rein kosmetisch, ohne Bedeutung fuer die Planung. Sie bleibt stehen,
       weil ihre Beseitigung die geraden, L- und Insel-Grundrisse sichtbar veraenderte;
       Phase 3 darf sichtbar allein die Wand C in U-Form beruehren. */
    raum.waende.forEach(function (w, i) {
      var nb = wandNachbarn(raum, w.id), erste = i === 0;
      var r = projRechteck(wandProjektion(w),
        (nb.amAnfang || erste) ? -wd : 0, -wd,
        wandLaenge(w) + ((nb.amEnde || erste) ? wd : 0), 0);
      o.push('<rect data-wand="' + w.id + '" x="' + r.x + '" y="' + r.y + '" width="' + r.w
        + '" height="' + r.h + '" fill="' + wf(w.id) + '"/>');
      /* AUF DEM TELEFON IST DAS SICHTBARE BAND KEIN ZIEL.

         Es ist wd = 6 Einheiten dick, auf 390 px also rund sechs Bildpunkte — mit dem Finger
         nicht zu treffen. Das Band deshalb dicker zu zeichnen waere eine Luege ueber die
         Wandstaerke. Stattdessen liegt eine DURCHSICHTIGE Flaeche darueber: nach aussen T(8)
         (weiter reicht der Ausschnitt im kompakten Weg nicht, dort wird geschnitten), nach
         innen T(30) in den Raum hinein, wo in diesem Schritt nichts anderes anklickbar ist.
         Zusammen rund 44 Einheiten. Sie steht VOR Bloecken und Anschluessen in der Liste,
         die spaeter Gezeichneten bleiben also oben und behalten ihre eigenen Klicks. */
      if (kompakt) {
        var rt = projRechteck(wandProjektion(w),
          (nb.amAnfang || erste) ? -wd : 0, -wd - T(8),
          wandLaenge(w) + ((nb.amEnde || erste) ? wd : 0), T(30));
        o.push('<rect data-wand="' + w.id + '" x="' + rt.x + '" y="' + rt.y + '" width="' + rt.w
          + '" height="' + rt.h + '" fill="transparent"/>');
      }
    });
    /* WIE TIEF DIE INSEL IST, SAGT DIE GEOMETRIE — NICHT DAS RECHTECK IM BILD.

       Ein Block ist eine LINIE mit Tiefe nach innen; p0 und p1 haben dieselbe Hoehe. Die
       Tiefe aus `p1.y - p0.y` zu rechnen ergab deshalb immer 0 und fiel auf t zurueck: bei
       der einfachen Insel zufaellig richtig, bei der doppelten falsch — dort stehen ZWEI
       Blocke Ruecken an Ruecken an derselben Linie und wachsen in entgegengesetzte
       Richtungen, zusammen 2t.

       Gerechnet wird deshalb aus Stuetzlinie, Innennormale und Korpustiefe — denselben
       Groessen, aus denen auch die Zeichnung entsteht. NICHT aus den fertigen Rechtecken:
       eine Zahl, die aus dem Bild zurueckgelesen wird, macht den Zeichner zur Quelle der
       Wahrheit, und dann entscheiden Strichstaerke und Rundung mit, was der Kunde als Mass
       liest. */
    var inselOben = null, inselUnten = null;
    raum.bloecke.forEach(function (b) {
      var n = wandNormaleInnen(b);
      var y1 = b.p0.y, y2 = b.p0.y + n.y * (b.tiefe > 0 ? b.tiefe : t);
      var o1 = Math.min(y1, y2), u1 = Math.max(y1, y2);
      if (inselOben === null || o1 < inselOben) inselOben = o1;
      if (inselUnten === null || u1 > inselUnten) inselUnten = u1;
    });
    /* Der freistehende Block traegt seine Tiefe nach INNEN — er hat kein Aussen. */
    raum.bloecke.forEach(function (b) {
      var r = projRechteck(wandProjektion(b), 0, 0, wandLaenge(b), b.tiefe > 0 ? b.tiefe : t);
      o.push('<rect data-wand="' + b.id + '" x="' + r.x + '" y="' + r.y + '" width="' + r.w + '" height="' + r.h
        + '" fill="' + (z.wand === b.id ? 'var(--hm-tint)' : 'var(--hm-img)')
        + '" stroke="' + wf(b.id) + '" stroke-width="1.2"/>');
    });

    /* Anschluesse und Hindernisse. Bisher standen sie NUR in der Frontansicht — im
       Grundriss war nicht zu sehen, dass der Heizkoerper genau dort sitzt, wo die Reihe
       entlanglaeuft, oder dass die Tuer in die Ecke schlaegt. Gezeichnet wird ueber
       DIESELBE Projektion wie die Schraenke: keine eigene Karte, keine Wandbuchstaben,
       keine Formabfrage.

       WELCHE Darstellung ein Element bekommt, entscheiden seine Daten und nicht sein
       Name: ein Stellplatz ist eine Flaeche auf dem Boden, ein breites Bauteil steckt IN
       der Wand, ein Geraet haengt ueber der Reihe, und was keine Breite hat, ist ein
       Punkt. Ein sechster Anschlusstyp braucht hier keine Zeile. */
    /* Zwei Punktanschluesse duerfen an derselben Stelle liegen — Wasser und Abfluss tun das
       fast immer. Im Grundriss gibt es keine Hoehenachse, die sie trennt (in der
       Frontansicht sitzt jeder auf seiner eigenen Hoehe), also lagen ihre Kuerzel exakt
       uebereinander und man las nur das obere. Die MARKE bleibt, wo sie ist — die Lage ist
       ja richtig —, die Beschriftung des zweiten und jedes weiteren rueckt eine Zeile
       tiefer in den Raum. */
    var stapel = {};
    var mkTeile = function (nurPunkte) {
      aktiveMerkmale(z).forEach(function (m) {
        var w = wandAus(raum, m.wand);
        if (!w) return;
        var c = MT[m.typ] || {}, iv = elementIntervallAufWand(m);
        var map = wandProjektion(w), r;
        if (iv.punkt !== !!nurPunkte) return;
        if (iv.punkt) {
          var h = T(5);
          r = projRechteck(map, iv.start - h, -h, iv.start + h, h);
          o.push('<rect x="' + r.x + '" y="' + r.y + '" width="' + r.w + '" height="' + r.h
            + '" fill="' + c.farbe + '" rx="' + T(1.5) + '"/>');
          var sk2 = m.wand + '|' + Math.round(iv.start * 10);
          var reihe = stapel[sk2] || 0;
          stapel[sk2] = reihe + 1;
          var lp = map(iv.start, T(13) + reihe * T(11));
          o.push('<text x="' + zahl(lp[0]) + '" y="' + zahl(lp[1]) + '" font-size="' + T(9.5)
            + '" font-weight="800" text-anchor="middle" fill="' + c.farbe + '">' + c.kurz + '</text>');
          return;
        }
        if (c.stellplatz) {
          /* Nischenmass, kein Moebelmass — gestrichelt, damit niemand eine Front erwartet. */
          r = projRechteck(map, iv.start, 0, iv.ende, flucht());
          o.push('<rect x="' + r.x + '" y="' + r.y + '" width="' + r.w + '" height="' + r.h
            + '" fill="none" stroke="' + c.farbe + '" stroke-width="0.7" stroke-dasharray="4 2.5"/>');
        } else if (c.geraet) {
          /* Die Haube haengt ueber der Reihe, steht also nicht auf dem Boden. */
          r = projRechteck(map, iv.start, T(4), iv.ende, T(4) + T(7));
          o.push('<rect x="' + r.x + '" y="' + r.y + '" width="' + r.w + '" height="' + r.h
            + '" fill="none" stroke="' + c.farbe + '" stroke-width="0.7" stroke-dasharray="3 2"/>');
        } else {
          /* Fenster, Tuer, Heizkoerper stecken IN der Wand: sie fuellen das Wandband auf
             ihrer Strecke, und die Schraenke werden spaeter darueber gezeichnet. */
          r = projRechteck(map, iv.start, -wd, iv.ende, 0);
          o.push('<rect x="' + r.x + '" y="' + r.y + '" width="' + r.w + '" height="' + r.h
            + '" fill="' + c.farbe + '" opacity="' + (m.typ === 'fenster' ? '0.35' : '0.75') + '"/>');
        }
      });
    };
    mkTeile(false);

    raum.waende.forEach(function (w) { obenBand(w, false); });
    raum.bloecke.forEach(function (b) { obenBand(b, true); });

    /* Fussabdruecke. Hier stand die Tabelle karten{}: vier von Hand gerechnete
       Abbildungen, eine je Wandbuchstabe. Ihre Zeile fuer Wand C war spiegelverkehrt zum
       Modell, zu 3D und zu eckL() — ein Schrank bei x = 0 stand im Grundriss an der Ecke
       zu A, in 3D am offenen Ende. Es gibt sie nicht mehr. Jede Wand und jeder Block
       bekommt seine Abbildung aus der eigenen Geometrie, und damit gilt ueberall
       dasselbe: u = 0 ist p0. */
    raum.waende.concat(raum.bloecke).forEach(function (w) {
      var map = wandProjektion(w), aktiv = z.wand === w.id;
      items(z, daten, w.id, 'boden').forEach(function (it) {
        o.push('<path d="' + grundPfad(z, w.id, it, flucht(), map, daten) + '" fill="' + fuell(aktiv)
          + '" stroke="' + strich(aktiv) + '" stroke-width="0.8"/>');
      });
    });

    /* Die Punktanschluesse ganz zuletzt: sie sind klein, und unter einem Schrank waere
       ein Wasseranschluss nicht mehr zu finden — dabei ist genau seine Lage die Frage,
       die der Kunde an den Grundriss stellt. */
    mkTeile(true);

    /* Wandnamen als kurze Marke am Anfang jeder Wand — der Kunde erkennt die Wand, ohne dass
       eine Textzeile quer ueber die Schraenke laeuft. */
    var nameY = -(randA + T(9));
    var wname = function (x, y, anchor, id, txt, dreh) {
      var lage = dreh
        ? 'transform="translate(' + zahl(x) + ' ' + zahl(y) + ') rotate(' + dreh + ')"'
        : 'x="' + zahl(x) + '" y="' + zahl(y) + '"';
      return '<text ' + lage + ' font-size="' + T(11.5) + '" font-weight="800" letter-spacing="'
        + T(0.8) + '" text-anchor="' + anchor + '" fill="' + (z.wand === id ? 'var(--hm-brand)' : 'var(--hm-mut3)') + '">' + txt + '</text>';
    };
    /* WELCHE Wand beschriftet wird, sagt die Geometrie; WO die Marke steht, ist noch
       von Hand gesetzt. Die Marke sitzt heute bei allen drei Waenden auf einer Linie
       ueber dem Raum — sie zeigt also nicht, wo die Wand ANFAENGT. Fuer Wand C faellt
       das seit dieser Phase auseinander: ihr Anfang liegt unten am offenen Ende. Die
       Marke zu verschieben waere eine Aenderung an der Bedienung, keine an der
       Projektion; sie gehoert deshalb in die Entscheidung ueber die Leserichtung und
       nicht in diese Phase. */
    var hat = function (id) { return raum.waende.some(function (w) { return w.id === id; }); };
    /* Jede Marke steht an IHRER Wand, nicht auf einer gemeinsamen Zeile.

       Vorher lagen alle drei auf der Linie ueber dem Bild, und ihre waagrechte Lage folgte
       der Aussenrichtung. In der U-Form ergab das von links nach rechts WAND C, WAND A,
       WAND B: der Grundriss las sich wie eine Liste, die mit C beginnt, obwohl C die
       linke Wand ist und mit der Reihenfolge nichts zu tun hat. Zwei Marken standen
       ausserdem acht Einheiten nebeneinander und wirkten wie ein Paar.

       Jetzt bekommt eine senkrechte Wand ihre Marke auf HALBER HOEHE ihrer eigenen
       Strecke — dort, wo die Wand im Bild wirklich ist. Waagrechte Waende standen schon
       an ihrer Wand und bleiben, wo sie waren. Es aendert sich nur, WO die Schrift steht;
       Geometrie, Wandkennungen und jede Rechnung bleiben unberuehrt. */
    /* Die Marke einer nach unten zeigenden Wand haengt an IHRER Wand, nicht an der Kante
       des gezeichneten Bodens. Seit der Boden der tiefsten Form folgt, sind das zwei
       verschiedene Linien: in der Parallelkueche liegt Wand C bei 281, der Boden reicht
       bis 307 — die Marke stand 26 cm unter ihrer eigenen Wand, mitten auf der Flaeche. */
    var untenMarkeVon = function (w) { return w.p0.y + randA + T(11); };
    raum.waende.forEach(function (w) {
      var r = richtung(w), txt = String(w.label || w.id).toUpperCase();
      /* Auf halber Hoehe waere die Marke mit der Masskette zusammengestossen: massV setzt
         seine Zahl ebenfalls in die Mitte der Strecke, und "WAND C" lag dann auf "180 cm".
         Die Marke sitzt deshalb an ihrem ANFANG — dort, wo auch bei den waagrechten
         Waenden gemessen wird, und wo die Kette nichts stehen hat. Der Versatz zeigt zu
         p1, damit die Schrift in die Wand hinein laeuft und nicht ueber die Ecke hinaus. */
      var anfangY = w.p0.y + (w.p1.y > w.p0.y ? T(12) : -T(4));
      /* EINE SENKRECHTE WAND BEKOMMT IHREN NAMEN LAENGS.

         Waagrecht geschrieben lief er in die Masskette hinein: gemessen in der U-Kueche
         begann "WAND B" bei x = 372 und die Kettenlinie stand bei x = 401 — die Schrift
         kreuzte den Strich. Links dasselbe, spiegelverkehrt. Weiter nach aussen zu ruecken
         half nicht, dort steht die Zahl der Kette.

         Zwischen Wandband und Kette liegen rund 33 Einheiten frei. Laengs gedreht braucht
         der Name davon die Höhe einer Zeile — er passt hinein, ohne irgendetwas zu
         kreuzen, und liest sich wie in einem Grundriss ueblich in Richtung seiner Wand. */
      var quer = (randA + T(30)) / 2;
      /* Kompakt: der Name steht INNEN an seiner Wand statt aussen daneben. */
      var innen = kompakt ? -(wd + T(9)) : quer;
      if (r === 'oben') o.push(wname(w.p0.x, nameY, 'start', w.id, txt));
      else if (r === 'rechts') o.push(wname(w.p0.x + (kompakt ? innen : quer), anfangY, 'start', w.id, txt, 90));
      else if (r === 'links') o.push(wname(w.p0.x - (kompakt ? innen : quer), anfangY, 'end', w.id, txt, 90));
      else o.push(wname(w.p0.x, untenMarkeVon(w), 'end', w.id, txt));
    });

    /* Massketten liegen AUSSERHALB der Geometrie, damit nichts ueber den Schraenken klebt. */
    var tick = T(4), grau = 'var(--hm-mut)';
    var massH = function (x1, x2, y, txt) {
      return '<g stroke="' + grau + '" stroke-width="0.3">'
        + '<line x1="' + x1 + '" y1="' + y + '" x2="' + x2 + '" y2="' + y + '"/>'
        + '<line x1="' + x1 + '" y1="' + (y - tick) + '" x2="' + x1 + '" y2="' + (y + tick) + '"/>'
        + '<line x1="' + x2 + '" y1="' + (y - tick) + '" x2="' + x2 + '" y2="' + (y + tick) + '"/></g>'
        + '<text x="' + ((x1 + x2) / 2) + '" y="' + (y + T(14)) + '" font-size="' + T(12) + '" text-anchor="middle" fill="' + grau + '">' + txt + '</text>';
    };
    /* `nachLinks`: auf welcher Seite ihrer Linie die Zahl steht. Sie gehoert immer nach
       AUSSEN. Ohne diese Angabe stand sie immer rechts — bei der linken Kette also nach
       innen, und ihre zweite Haelfte lief in den Raum hinein: gemessen in der U-Kueche
       begann "180 cm" bei x = -34,4 und reichte bis rund +5, der Raum beginnt bei 0. Die
       Zahl lag damit auf der Wandkante. */
    var massV = function (y1, y2, x, txt, nachLinks) {
      return '<g stroke="' + grau + '" stroke-width="0.3">'
        + '<line x1="' + x + '" y1="' + y1 + '" x2="' + x + '" y2="' + y2 + '"/>'
        + '<line x1="' + (x - tick) + '" y1="' + y1 + '" x2="' + (x + tick) + '" y2="' + y1 + '"/>'
        + '<line x1="' + (x - tick) + '" y1="' + y2 + '" x2="' + (x + tick) + '" y2="' + y2 + '"/></g>'
        /* Die Verankerung wird nur geschrieben, wenn sie noetig ist: `start` IST die
           Voreinstellung, und sie ueberall hinzuschreiben aendert jede rechte Kette im
           Text, ohne im Bild irgendetwas zu bewegen. */
        + '<text x="' + (x + (nachLinks ? -T(6) : T(6))) + '" y="' + ((y1 + y2) / 2) + '" font-size="' + T(12)
        + (nachLinks ? '" text-anchor="end' : '') + '" fill="' + grau + '">' + txt + '</text>';
    };

    /* Wie weit reicht die Geometrie nach unten? Frueher stand hier `hat('C') ? C : 0` —
       das nimmt an, C sei eine SENKRECHTE Wand und ihre Laenge zugleich ihre Tiefe im
       Bild. Fuer die zweizeilige Kueche ist C waagrecht: 307 cm lang, aber keinen
       Zentimeter tief. Die Huellkurve weiss das, die Staffel nicht. */
    /* Die Kette von Wand A liegt unter dem GEZEICHNETEN BODEN, nicht unter der Geometrie
       dieser Form. Seit der Boden bei jeder Form gleich tief ist, sind das zwei
       verschiedene Linien: bei der Kuechenzeile reicht die Geometrie 52 cm weit, der Boden
       240 — die Kette "360 cm" stand deshalb MITTEN im Rechteck, waehrend sie bei der
       L-Kueche darunter lag. Dieselbe Zahl, zwei Plaetze, je nach Form. */
    var massY = raumB + T(22);
    /* Eine nach unten zeigende Wand bekommt ihre eigene waagrechte Kette, und zwar NAEHER
       am Raum als die von Wand A — sie gehoert zu der Kante, an der sie liegt. Gibt es
       keine solche Wand, rueckt nichts, und die vier bisherigen Formen zeichnen Zeichen
       fuer Zeichen dasselbe wie vorher. */
    var untere = raum.waende.filter(function (w) { return richtung(w) === 'unten'; });
    /* Frueher rueckte diese Kette aus, wenn eine untere Wand oder ein Block da war —
       beide hatten ihre eigene Kette naeher am Raum, und zwei Ketten uebereinander sind
       unlesbar. Beide liegen jetzt INNERHALB des Bodens (die untere Wand an sich selbst,
       die Insel an ihrer Tiefe), waehrend diese hier darunter liegt. Es gibt nichts mehr
       auszuweichen, und die Kette steht damit bei jeder Form auf derselben Linie. */
    /* Mit der echten Tiefe liegt eine untere Wand (Zweizeilig) an der Bodenkante — ihre Kette stuende sonst
       genau auf der von Wand A. */
    var massYA = massY + (z.planEcht && untere.length ? T(26) : 0);
    var rechts = A + wd + T(10), links = -(wd + T(10));
    raum.waende.forEach(function (w) {
      var r = richtung(w), len = wandLaenge(w);
      if (r === 'oben') {
        o.push(massH(Math.min(w.p0.x, w.p1.x), Math.max(w.p0.x, w.p1.x), massYA, r0(len) + ' cm'));
      } else if (r === 'rechts') {
        if (!kompakt) {
          o.push(massV(0, len, A + wd + T(30), r0(len) + ' cm'));
          rechts = A + wd + T(30) + T(52);
        }
      } else if (r === 'links') {
        if (!kompakt) {
          o.push(massV(0, len, -(wd + T(30)), r0(len) + ' cm', true));
          links = -(wd + T(30) + T(52));
        }
      } else {
        /* Die untere Wand misst an SICH, nicht an der Bodenkante — wie ihre Marke. */
        o.push(massH(Math.min(w.p0.x, w.p1.x), Math.max(w.p0.x, w.p1.x),
                     w.p0.y + T(22), r0(len) + ' cm'));
        links = Math.min(links, Math.min(w.p0.x, w.p1.x) - T(10));
      }
    });
    /* DIE INSEL SAGT IHRE MASSE IN EINER ZEILE, NICHT IN DREIEN.

       Erst stand nur die Laenge da; Tiefe und Gang fehlten, und der Kunde konnte nicht
       sehen, ob er vor der Insel noch eine Schublade aufbekommt. Beide als eigene senkrechte
       Ketten nachzutragen war der falsche Weg: „Tiefe 52 cm" lag QUER UEBER DEM KOERPER der
       Insel (gemessen: Schrift von 209.8 bis 341.4, die Insel von 152 bis 368), und die
       zweite Beschriftung stand an einer anderen Kante mit einer anderen Ausrichtung — drei
       Zahlen, drei Fluchten, keine Ordnung.

       Platz fuer eine Schrift NEBEN der Insel gibt es auch nicht verlaesslich: im kompakten
       Weg reicht der Ausschnitt nur 12 Einheiten ueber den Raum hinaus, und bei einer langen
       Insel bleibt links und rechts von ihr fast nichts.

       Also dorthin, wo Platz garantiert ist: Laenge und Tiefe stehen zusammen in der Kette
       UNTER der Insel — so wie Moebelmasse geschrieben werden. Der Gang behaelt seine eigene
       Kette, weil er eine Strecke im Raum ist und keine Eigenschaft des Moebels; er ist
       damit die einzige senkrechte Beschriftung und steht in einem leeren Band. */
    /* EIN ZEICHEN, KEINE GEOMETRIE.

       Beide Bloecke der doppelseitigen Insel decken denselben Kasten ab — gezeichnet ist das
       zweimal dasselbe Rechteck, der Kunde saehe also keinen Unterschied zum einseitigen
       Fall. Ein duenner Strich auf halber Tiefe zeigt ihn an. Er traegt kein `data-wand`,
       faengt keinen Klick und geht in keine Rechnung ein: er sagt „von beiden Seiten", nicht
       „hier stehen zwei Reihen". */
    /* Nur wenn die Rueckreihe wirklich steht — zu flach bleibt die Insel einseitig, ohne Naht. */
    if (insel && z.inselDoppelt && inselOben !== null && raum.bloecke.some(function (b) { return b.id === 'IH'; })) {
      o.push('<line x1="' + zahl(inselX) + '" y1="' + zahl((inselOben + inselUnten) / 2)
        + '" x2="' + zahl(inselX + IL) + '" y2="' + zahl((inselOben + inselUnten) / 2)
        + '" stroke="var(--hm-mut3)" stroke-width="1.4" stroke-dasharray="7 5"'
        + ' pointer-events="none"/>');
    }
    if (insel && inselOben !== null) {
      o.push(massH(inselX, inselX + IL, inselUnten + T(14),
                   'Insel ' + r0(IL) + ' × ' + r0(inselUnten - inselOben) + ' cm'));
      /* Der Gang endet an der NAHEN Kante der Insel, nicht an ihrer Stuetzlinie. Bei der
         doppelten Insel liegt die Linie in der Mitte des Koerpers; gemessen stand dort
         „Gang 152 cm", waehrend zwischen Zeile und Insel 100 cm frei sind. */
      /* „Abstand" statt „Gang": derselbe Name wie im Formular. Zwei Woerter fuer eine Zahl
         zwingen den Kunden, sie einander zuzuordnen. */
      if (inselOben > t) o.push(massV(t, inselOben, inselX + T(8),
                                      'Abstand ' + r0(inselOben - t) + ' cm'));
    }

    var oben = nameY - T(13);
    var unten = Math.max(massYA, untere.reduce(function (mx, w) {
      return Math.max(mx, untenMarkeVon(w));
    }, 0)) + T(20);

    /* DIE ZEICHENFLAECHE IST BEI JEDER FORM DIESELBE.

       Der BODEN bleibt ehrlich: gezeichnet wird nur der Raum, den die gewaehlte Form
       wirklich hat. Aber die FLAECHE, in der er steht, wird nicht mehr um ihn herum
       zugeschnitten. Vorher sprang sie bei jedem Formwechsel: dieselben Maße 360/240/180
       ergaben fuer die gerade Kueche einen flachen Streifen, fuer die L-Kueche ein hohes
       Rechteck, fuer die Inselkueche etwas dazwischen — und weil die Karte das Bild auf
       ihre Hoehe skaliert, wechselte mit der Flaeche auch der Massstab. Der Kunde verglich
       Formen, die er nicht vergleichen konnte.

       Aufgespannt wird sie von dem, was diese Maße im TIEFSTEN Fall beschreiben koennten,
       und von den Massketten, die eine Form haben KANN: links und rechts je eine senkrechte
       Kette, auch wenn diese Form dort keine Wand hat. Nichts davon wird gezeichnet — es
       ist reserviert. Deshalb entsteht auch keine Behauptung ueber den Raum: wo die Form
       nichts hat, bleibt Hintergrund. */
    /* Der Ausschnitt spannt sich ueber denselben Boden auf, den die Zeichnung zeigt —
       zwei getrennte Rechnungen liefen auseinander: bei 60/200/200 war der Boden 224 cm
       tief, der Ausschnitt aber nur 204, und die unteren 20 cm fielen aus dem Bild. */
    var flaecheTief = raumB;
    /* Die Ausdruecke des NICHT kompakten Weges stehen bewusst unveraendert da. Zu einem
       gemeinsamen `seite` zusammengefasst rechnete dieselbe Zahl als 557.8 statt
       557.8000000000001 — bildgleich, aber 48 Goldmaster-Faelle anders. Eine Rundungsstelle
       ist kein Grund, eine Abnahme zu bewegen. */
    var fLinks = Math.min(links, kompakt ? -(wd + T(6)) : -(wd + T(30) + T(52)));
    var fRechts = Math.max(rechts, kompakt ? A + wd + T(6) : A + wd + T(30) + T(52));
    /* Der zweite Zweig hat frueher IMMER gewonnen und 30 Einheiten Luft unter die letzte
       Schrift gelegt: unter „268 cm" standen 45 Bildpunkte Leere, ueber „WAND A" 17. Er
       stammt aus der Zeit, als massY der Geometrie der Form folgte; seit massY dem BODEN
       folgt, deckt `unten` (= raumB + 22 + 20) den Boden von selbst ab. Der Rest T(8) laesst
       die Zusicherung stehen, dass der gezeichnete Boden im Ausschnitt liegt. */
    var fUnten = Math.max(unten, flaecheTief + T(8));

    /* UND DER AUSSCHNITT STEHT FEST — Ursprung wie Groesse.

       Zwischendurch war die Zeichnung in dieser Flaeche zentriert. Das war noetig, solange
       der Boden der jeweiligen Form folgte: die gerade Kueche klebte sonst als schmaler
       Streifen oben links in einem grossen leeren Feld. Seit der Boden bei jeder Form
       derselbe ist, ist das Zentrieren nicht nur unnoetig, sondern schaedlich — es
       verschiebt das Rechteck bei jedem Formwechsel um den Betrag, den die Massketten
       dieser Form gerade brauchen. Der Kunde sah es springen, obwohl es gleich gross blieb.

       Jetzt liegt der Nullpunkt des Raumes bei jeder Form auf demselben Bildpunkt. Bewegen
       kann sich das Rechteck nur noch, wenn der Kunde seine Maße aendert — und genau das
       soll es. */
    return { inner: o.join(''),
             vb: fLinks + ' ' + oben + ' ' + (fRechts - fLinks) + ' ' + (fUnten - oben) };
  }


  /* ================= Serie und Farbe (Schritt 3) ================= */

  /* Die Zahl nennt VERSCHIEDENE Schraenke, nicht Katalogzeilen. Glanzia fuehrt denselben
     Schrank unter zwei Codes (`D30` und `D30-P`) — gezaehlte Zeilen ergaeben 52 und
     versprachen vierzehn Schraenke, die es nicht gibt. Hart hinterlegt, weil die Leiste
     steht, bevor ein einziger Katalog geladen ist; nachgezaehlt mit `codeKern`. */
  var SERIEN = [
    { name: 'Livaro',  info: '36 Schränke · 11 Farben · 87 cm Korpus' },
    { name: 'Glanzia', info: '38 Schränke · Türanschlag wählbar' },
    { name: 'Velora',  info: '34 Schränke · Push-to-Open möglich' },
    { name: 'Lunara',  info: '30 Schränke · matt und Hochglanz' }
  ];

  /* Ein Serienwechsel darf die Planung NICHT löschen. Übertragen wird in drei Stufen, genau
     wie beim Wiederherstellen aus dem Speicher:
       1. voller Fingerabdruck — dasselbe Modell gibt es in der neuen Serie unverändert.
       2. der Code, aber nur wenn er in der neuen Serie eindeutig ist. `code` ist kein
          Primärschlüssel: Lunara führt `W60` zweimal mit 72 und 92 cm Höhe.
       3. Reihe + Funktion + Breite + Höhe auf ganze Zentimeter — die Maßraster der Serien sind
          gleich, ein D60Z der einen entspricht dem D60Z der anderen.
     Was keine Entsprechung hat, fällt weg und wird GEZÄHLT.

     `hoff` und `xpos` wandern positionstreu mit. Die Referenz lässt beides aus: sie schreibt
     `hoff` unter einem Schlüssel, den nichts liest, und rührt `xpos` gar nicht an — nach einem
     Serienwechsel standen dort die Wandstellen der falschen Schränke. */
  function umbau(z, altDaten, neuDaten) {
    var plan = {}, hoff = {}, xpos = {}, wahl = {}, verloren = 0;
    if (!altDaten || !neuDaten) return { plan: z.plan || {}, hoff: z.hoff || {}, xpos: z.xpos || {}, wahl: z.wahl || {}, verloren: 0 };

    var nachFinger = {}, nachMass = {}, codeZahl = {}, nachCode = {};
    var massSchluessel = function (m) {
      return [m.reihe, m.funktion, Math.round(m.b), Math.round(m.h)].join('|');
    };
    neuDaten.modelle.forEach(function (m, i) {
      nachFinger[fingerabdruck(m)] = i;
      if (nachMass[massSchluessel(m)] == null) nachMass[massSchluessel(m)] = i;
      var c = String(m.code).toUpperCase();
      codeZahl[c] = (codeZahl[c] || 0) + 1;
      if (nachCode[c] == null) nachCode[c] = i;
    });

    Object.keys(z.plan || {}).forEach(function (key) {
      var altH = (z.hoff || {})[key] || [], altX = (z.xpos || {})[key] || [];
      var altW = (z.wahl || {})[key] || [];
      plan[key] = []; hoff[key] = []; xpos[key] = []; wahl[key] = [];
      (z.plan[key] || []).forEach(function (mi, pos) {
        var am = altDaten.modelle[mi];
        if (!am) { verloren++; return; }
        var i = nachFinger[fingerabdruck(am)];
        if (i == null) {
          var c = String(am.code).toUpperCase();
          if (codeZahl[c] === 1) i = nachCode[c];
        }
        if (i == null) i = nachMass[massSchluessel(am)];
        if (i == null) { verloren++; return; }
        var neuPos = plan[key].length;
        plan[key].push(i);
        hoff[key][neuPos] = altH[pos] == null ? null : altH[pos];
        xpos[key][neuPos] = altX[pos] == null ? null : altX[pos];
        /* Die Wahl wandert nur mit, wenn die NEUE Serie sie an diesem Modell auch fuehrt —
           sonst zeigte das Angebot einen Tueranschlag, den es dort nicht gibt. */
        var w = altW[pos] == null ? null : altW[pos];
        wahl[key][neuPos] = (w && optWerte(neuDaten.modelle[i], z.farbe, [w]).length) ? w : null;
      });
    });
    return { plan: plan, hoff: hoff, xpos: xpos, wahl: wahl, verloren: verloren };
  }

  /* Die Farbliste einer Serie mit echtem Farbpunkt. Der Punkt kommt aus dem FRONT-Teil des
     Namens — vor dem Schrägstrich steht die Front, dahinter der Korpus. */
  /* Wie viele Modelle einer Serie sind in DIESER Farbe ueberhaupt lieferbar? Der Katalog
     filtert still — steht ein Modell in der gewaehlten Farbe nicht im Shop, verschwindet es
     aus der Liste, und der Kunde sieht nur eine kurze Liste ohne Grund. Diese Zahl macht das
     Filtern sichtbar. `ohneFarbe` zaehlt getrennt, was in KEINER Farbe hinterlegt ist — das
     ist keine Kundenentscheidung, sondern eine Luecke in den Katalogdaten. */
  /* Derselbe Schrank steht im Katalog unter zwei Codes: `D30` und `D30-P`. Das Suffix ist
     ein Tueranschlag-Vermerk aus dem Feld `modellbezeichnungen`, kein zweiter Schrank.
     Gezaehlt werden muss der SCHRANK, nicht die Zeile — sonst behauptet die Deckungszahl
     eine Luecke, die es nicht gibt („38 von 52", obwohl 38 von 38 lieferbar sind).

     Der Trenner ist Pflicht: ohne ihn wuerde aus `D60ZL` (Kuehlumbau) ein `D60Z`
     (Spuelenschrank) — zwei voellig verschiedene Schraenke unter einem Namen. */
  /* DER ECHTE NAME DES SCHRANKS.

     Der Beleg zeigte bisher `ART[funktion]` — meine eigene Bezeichnung. Der Betreiber will,
     dass ueberall der Name steht, unter dem der Schrank im Shop verkauft wird: der Kunde soll
     dieselbe Wort im Laden wiederfinden. Gemessen an allen vier Katalogen ist der Shop-Name in
     39 Faellen GENAUER als meine Bezeichnung (Herdumbauschrank statt Herdumbau,
     Ofenumbauschrank und Mikrowellenumbauschrank statt „Hochschrank Geraet", Regalhaengeschrank
     statt Haengeschrank) und in 12 Faellen weniger fein (Glas, Aufsatz, Apotheker, Geraet
     fallen weg). Der Betreiber hat das so entschieden — der echte Name gewinnt.

     Der Titel ist ein Marketingsatz und wiederholt Code und Farbe, die eigene Spalten haben.
     Genommen wird deshalb nur, was VOR dem Code steht. Der Code erscheint im Titel nicht immer
     genau so wie im Katalog: Lunara schreibt „KU-N60", wo der Katalog `N60` fuehrt, und traegt
     Zusaetze wie `+F-L9-...`. Deshalb werden mehrere Schreibweisen probiert und die frueheste
     Fundstelle genommen; ein danach uebrig gebliebenes „KU-" faellt weg.

     Gemessen an 153 Modellen: kein leerer Name, Laenge 11 bis 30 Zeichen, und „CARGO" aus dem
     Livaro-Titel erreicht das Papier nicht, weil es hinter dem Code steht. Faellt die Ableitung
     doch einmal aus, gilt wieder ART — lieber meine Bezeichnung als gar keine. */
  function modellName(m) {
    if (!m) return 'Schrank';
    var t = String(m.titel || '');
    var c = codeKern(m.code);
    var kand = [c, c.split('+')[0], c.split('+')[0].replace(/^KU-/, ''), c.split('-').pop(), c.split('+').pop()];
    var i = -1;
    for (var k = 0; k < kand.length; k++) {
      if (!kand[k]) continue;
      var j = t.toUpperCase().indexOf(kand[k]);
      if (j > 0 && (i < 0 || j < i)) i = j;
    }
    if (i > 0) t = t.slice(0, i);
    t = t.replace(/^(Glanzia|Velora|Livaro|Lunara)\s+/i, '')
         .replace(/\s*KU-?$/i, '')
         .replace(/\s*\d+[,.]?\d*\s*cm\s*$/i, '')
         .replace(/[\s\u2013\u2014-]+$/, '').trim();
    return t || (ART[m.funktion] || 'Schrank');
  }

  function codeKern(code) {
    return String(code || '').toUpperCase().trim().replace(/(?:[-_ ]P\/L|[-_](?:P|L))$/, '');
  }

  function deckung(daten, farbe, zusatz, reihe) {
    var alle = (daten && daten.modelle) || [];
    var gesamt = {}, da = {}, ohne = {};
    alle.forEach(function (m) {
      if (reihe && m.reihe !== reihe) return;
      var k = codeKern(m.code);
      gesamt[k] = 1;
      var hat = Object.keys(m.farben || {}).some(function (x) { return (m.farben[x] || []).length; });
      if (!hat) { if (!ohne[k]) ohne[k] = 1; return; }
      if (variante(m, farbe, zusatz || {})) { da[k] = 1; delete ohne[k]; }
    });
    var n = Object.keys(gesamt).length, d = Object.keys(da).length;
    return { da: d, gesamt: n, ohneFarbe: Object.keys(ohne).length, fehlt: n - d };
  }

  function farbliste(daten, zusatz) {
    return ((daten && daten.farben) || []).map(function (f) {
      var d = deckung(daten, f, zusatz, null);
      /* Mit der Serie: dieselbe Farbe heisst in zwei Serien nicht dasselbe (siehe OPTIK). */
      return { name: f, hex: frontFarbe({ serie: daten && daten.serie, farbe: f }), da: d.da, gesamt: d.gesamt };
    });
  }

  /* Welche Modelle einer Reihe sind in der gewählten Farbe überhaupt lieferbar?
     Wichtig, weil es die Wirklichkeit ist: 12 der 52 Glanzia-Modelle führen gar keine Variante,
     und nur 44 % der Glanzia-Paare (Modell × Farbe) sind belegt. Ein Katalog, der sie trotzdem
     anbietet, führt in einen Warenkorb, den es nicht gibt. */
  /* Steht die Planung gerade auf einem freistehenden Block statt an einer Wand? */
  function aufBlock(z) {
    var g = raumGeometrie(z);
    return g.bloecke.some(function (b) { return b.id === z.wand; });
  }

  function katalog(z, daten, reihe, suche) {
    if (!daten) return [];
    var q = String(suche || '').toLowerCase();
    var out = [];
    daten.modelle.forEach(function (m, i) {
      if (m.reihe !== reihe) return;
      if (!variante(m, z.farbe, z.zusatz)) return;
      /* Auf einem freistehenden Block haengt nichts an der Wand — dort gibt es nur die
         Bodenreihe. Das folgt daraus, DASS es ein Block ist, nicht daraus, wie er heisst. */
      if (aufBlock(z) && m.reihe !== 'unten') return;
      if (q && (String(m.code) + ' ' + m.titel + ' ' + modellName(m) + ' ' + (ART[m.funktion] || '')).toLowerCase().indexOf(q) < 0) return;
      out.push({ i: i, m: m, v: variante(m, z.farbe, z.zusatz) });
    });
    return out;
  }


  /* ================= Schränke setzen (Schritt 4) ================= */

  var REIHEN_TABS = [
    { key: 'unten',   label: 'Unterschränke' },
    { key: 'oben',    label: 'Hängeschränke' },
    { key: 'voll',    label: 'Hochschränke' },
    { key: 'aufsatz', label: 'Aufsätze' },
    /* Zubehoer steht wie eine Reihe im Katalog: gleiche Zeile, gleicher Knopf. Es haengt nur
       an keiner Wandstelle — deshalb kein x und keine Sperrpruefung. */
    { key: 'zubehoer', label: 'Zubehör' }
  ];

  /* Gesperrte Strecken an einer Wand für EIN Bauteil in EINER Höhe.

     Der springende Punkt ist das Fenster: es sperrt nur, wenn sich die Höhenbänder wirklich
     schneiden. Ein Hängeschrank oberhalb der Öffnung ist erlaubt — wer hier bloss auf
     Überschneidung in der Breite prüft, verbietet ihn zu Unrecht. */
  /* `ohne` = {wand, zeile, i} des Schranks, fuer den geprueft wird. Seine EIGENE
     Eckreservierung auf der Nachbarwand darf ihm nicht als Hindernis vorgehalten werden —
     sonst stoesst der Eckschrank an sein eigenes Spiegelbild und laesst sich nicht ziehen. */
  function sperrZonen(z, daten, wand, zeile, m, off, ohne) {
    var g = geo(daten), RH = +z.hoehe;
    var uk = zeile === 'oben' ? g.haenge_unterkante : (zeile === 'aufsatz' ? g.hochschrank_hoehe : 0);
    var u = uk + (off || 0), o = u + m.h;
    var zonen = [];
    /* Die Ecke der Vorwand steht koerperlich in den ersten Zentimetern DIESER Wand, die Ecke
       der Nachbarwand in den letzten. Beide sind Sperren: ohne sie liesse sich ein Schrank in
       einen Eckkorpus hineinziehen, und die Reihe galte trotzdem als kurz genug. */
    var selbst = function (e) {
      return !!(ohne && e.quelle && ohne.wand === e.quelle.wand
        && ohne.zeile === e.quelle.zeile && ohne.i === e.quelle.i);
    };
    var eVo = eckVorher(z, daten, wand, zeile);
    if (eVo && !selbst(eVo)) zonen.push({ a: -400, b: eVo.cm, was: 'Eckschrank ' + eVo.code, art: 'ecke' });
    var eNa = eckNachbar(z, daten, wand, zeile);
    if (eNa && !selbst(eNa)) {
      zonen.push({ a: wandObj(z, wand).len - eNa.cm, b: 4000, was: 'Eckschrank ' + eNa.code, art: 'ecke' });
    }
    aktiveMerkmale(z).filter(function (x) { return x.wand === wand; }).forEach(function (x) {
      /* EINE Quelle fuer die Strecke; die Zonen unterscheiden sich nur noch darin, ob und
         wie viel Luft sie brauchen. */
      var iv = elementIntervallAufWand(x);
      if (x.typ === 'fenster') {
        var f = fensterOeffnung(x, RH);
        if (ueber(u, o, f.unten, f.oben)) zonen.push({ a: iv.start, b: iv.ende, was: 'Fenster', art: 'bau' });
      } else if (x.typ === 'tuer') {
        /* Der Türflügel braucht die volle Breite plus 5 cm Luft — auf beiden Seiten, und über
           die GANZE Höhe. Vorher sperrte die Tür nur bis zu ihrer Oberkante; darüber liess
           sich ein Hängeschrank setzen. Über einer Tür hängt aber nichts: der Flügel schwingt
           auf, und ein Schrank in dieser Achse ist weder montierbar noch erreichbar. */
        zonen.push({ a: iv.start - 5, b: iv.ende + 5, was: 'Tür', art: 'bau' });
      } else if (x.typ === 'heizkoerper' && zeile === 'boden') {
        if (u < x.hoehe) zonen.push({ a: iv.start, b: iv.ende, was: 'Heizkörper', art: 'bau' });
      }
    });
    /* Hochschraenke stehen in der Bodenreihe, reichen aber durch die Haengereihe. Ohne diese Zone setzte „Schrank
       hinzufuegen" einen G60 mitten in den Kuehlumbau (Grosstest 2026-09-27: 1986 Faelle ohne Fenster, Tuer und Wasser),
       und das Ziehen liess es ebenso zu. */
    if (zeile === 'oben') zonen = zonen.concat(hochZonenOben(z, daten, wand, m, off));
    return zonen.filter(function (zn) { return zn.b > 0; });
  }

  /* Die Hochschraenke einer Wand, deren Hoehenband ein Haengeschrank `m` mit Versatz `off` kreuzen wuerde. Ein um
     72 cm angehobener Haengeschrank sitzt AUF dem 212 cm hohen Hochschrank (siehe items: getragen) — das bleibt frei. */
  function hochZonenOben(z, daten, wand, m, off) {
    if (!daten || !m) return [];
    var u = geo(daten).haenge_unterkante + (off || 0), o = u + (m.h || 0);
    return items(z, daten, wand, 'boden').filter(function (h) {
      return h.m.reihe === 'voll' && ueber(u, o, h.off || 0, (h.off || 0) + h.m.h);
    }).map(function (h) { return { a: h.x, b: h.x + h.b, was: 'Hochschrank ' + h.m.code, code: h.m.code, art: 'hoch' }; });
  }

  /* Die nächste freie Stelle für ein Teil der Breite `breite`, ausgehend von `x`.
     Höchstens sechs Runden: mehr Ausweichschritte heissen, dass die Wand voll ist. */
  function freiSchieben(x, breite, zonen, wlen) {
    var wert = x;
    for (var runde = 0; runde < 6; runde++) {
      var treffer = zonen.filter(function (zn) { return ueber(wert, wert + breite, zn.a, zn.b); })[0];
      if (!treffer) return { x: wert, block: runde > 0 };
      var links = treffer.a - breite, rechts = treffer.b;
      var linksOk = links >= 0, rechtsOk = rechts + breite <= wlen;
      if (linksOk && (!rechtsOk || Math.abs(wert - links) <= Math.abs(wert - rechts))) wert = links;
      else if (rechtsOk) wert = rechts;
      else return { x: null, block: true, was: treffer.was };
    }
    return { x: wert, block: true };
  }

  /* Die freien Strecken zwischen `von` und `bis`, wenn `zonen` ({a, b}) belegt sind. */
  function freieLuecken(zonen, von, bis) {
    var kanten = zonen.map(function (zn) { return [Math.max(von, zn.a), Math.min(bis, zn.b)]; })
      .filter(function (kk) { return kk[1] > kk[0]; })
      .sort(function (p, q) { return p[0] - q[0]; });
    var out = [], x = von;
    kanten.forEach(function (kk) { if (kk[0] > x) out.push([x, kk[0]]); x = Math.max(x, kk[1]); });
    if (bis > x) out.push([x, bis]);
    return out;
  }
  /* Die Stelle in einer freien Luecke, die `x` am naechsten liegt — oder null. */
  function naechsteLuecke(x, breite, zonen, iv) {
    var best = null;
    freieLuecken(zonen, iv.start, iv.ende).forEach(function (g) {
      if (g[1] - g[0] < breite - 0.5) return;
      var p = Math.max(g[0], Math.min(x, g[1] - breite));
      if (best == null || Math.abs(p - x) < Math.abs(best - x)) best = p;
    });
    return best;
  }

  /* ---------- Rasten beim Ziehen ----------

     Ohne Rasten steht ein Hängeschrank zwei Zentimeter neben der Reihe, und niemand sieht,
     ob das Absicht war. Gerastet wird immer auf eine SICHTBARE Kante: Wandende, Nachbarkante,
     Nachbarmitte, Serienhöhe — nie auf ein rundes Zentimetermaß. */
  function raste(wunsch, kandidaten, tol) {
    var treffer = null, dist = tol == null ? 4 : tol;
    kandidaten.forEach(function (k) {
      if (!k || k.v == null) return;
      var d = Math.abs(k.v - wunsch);
      if (d <= dist) { dist = d; treffer = k; }
    });
    return treffer;
  }

  /* Rastpunkte fuer die Montagehoehe: Serienhoehe und die Kanten der Nachbarn derselben Reihe. */
  function rasteHoehe(z, daten, wand, zl, i, m) {
    var k = [{ v: 0, was: 'Serienhöhe' }];
    items(z, daten, wand, zl).forEach(function (it, j) {
      if (j === i) return;
      k.push({ v: it.off, was: 'Unterkante wie ' + it.m.code });
      k.push({ v: it.off + it.m.h - m.h, was: 'Oberkante wie ' + it.m.code });
    });
    return k;
  }

  /* Rastpunkte fuer die Stelle an der Wand: Kanten und Mitten aller Schraenke dieser Wand. */
  function rasteX(z, daten, wand, breite) {
    var k = [];
    ['boden', 'oben', 'aufsatz'].forEach(function (zl) {
      items(z, daten, wand, zl).forEach(function (it) {
        k.push({ v: it.x, was: 'Kante ' + it.m.code });
        k.push({ v: it.x + it.b - breite, was: 'Kante ' + it.m.code });
        k.push({ v: it.x + it.b / 2 - breite / 2, was: 'Mitte ' + it.m.code });
      });
    });
    return k;
  }

  /* Wie hoch darf ein Haenge- oder Aufsatzschrank wandern? Nach unten bleiben 25 cm Nische
     frei, nach oben 2 cm unter der Decke. Gerechnet wird als VERSATZ zur Serienhoehe. */
  function offGrenze(z, daten, zl, m, wunsch) {
    var g = geo(daten), RH = +z.hoehe;
    var basis = zl === 'oben' ? g.haenge_unterkante : g.hochschrank_hoehe;
    /* Aufgerundet: mit einer duennen Platte ist die Grenze gebrochen (-31,7), und Runden liesse nur 24,7 cm Nische. */
    var min = Math.ceil((arbeitsHoehe(daten, z) + 25) - basis);
    var max = (RH - 2 - m.h) - basis;
    return Math.round(Math.max(min, Math.min(max, wunsch)));
  }

  /* Versatz- und Stellenlisten liegen PARALLEL zur Schrankliste. Wer eine davon fuellt, muss
     sie auf dieselbe Laenge bringen — sonst haengt der Versatz am falschen Schrank. */
  function offListe(z, key) {
    var arr = ((z.hoff || {})[key] || []).slice();
    var n = ((z.plan || {})[key] || []).length;
    while (arr.length < n) arr.push(0);
    return arr;
  }
  function xListe(z, key) {
    var arr = ((z.xpos || {})[key] || []).slice();
    var n = ((z.plan || {})[key] || []).length;
    while (arr.length < n) arr.push(null);
    return arr;
  }
  function wahlListe(z, key) {
    var arr = ((z.wahl || {})[key] || []).slice();
    var n = ((z.plan || {})[key] || []).length;
    while (arr.length < n) arr.push(null);
    return arr;
  }

  /* Ein Eckschrank ist an seine Ecke gebunden — er kann nicht ausweichen wie ein gerader.
     Liegt dort ein Hindernis, auf DIESER oder auf der anschliessenden Wand, ist der Platz
     vergeben. Rückgabe: null oder der Grund. */
  /* `ohne` nennt den Schrank, der geprueft wird, wenn er SCHON im Plan steht ({wand, zeile, i}).
     Die Pruefung rief eckSperre fuer einen gesetzten Eck-Haengeschrank auf, ohne das zu sagen —
     und sperrZonen fand auf der Nachbarwand dessen EIGENEN Eckanspruch. Jeder G60N meldete
     "sitzt in der Ecke, in der Eckschrank G60N (Wand C) liegt" und sperrte den Warenkorb;
     gemessen in allen vier Kernstaenden seit e04120c. Ein ANDERER Schrank in derselben Ecke
     wird weiter gefunden: er ragt in die eigene Wand hinein, und diese Zone bleibt. Beim Setzen
     eines neuen Schranks gibt es ihn noch nicht — dort bleibt `ohne` leer. */
  function eckSperre(z, daten, wand, zeile, m, ohne, seite) {
    var nenn = nennMass(m), tief = nennTiefe(m);
    var raum = raumGeometrie(z);
    var treffer = function (wid, a, b) {
      var zn = sperrZonen(z, daten, wid, zeile, m, 0, ohne).filter(function (q) { return ueber(a, b, q.a, q.b); })[0];
      return zn ? { was: zn.was, wand: wandObj(z, wid).label } : null;
    };
    var len = wandObj(z, wand).len;
    /* Auf der eigenen Wand: nur die Enden pruefen, an denen wirklich eine Ecke liegt.
       Frueher wurden beide Enden blind geprueft und zusaetzlich die Nachbarn aus der
       Array-Reihenfolge geholt — auf Wand C hiess das: die Sperre einer Wand abfragen,
       die C gar nicht beruehrt. */
    var seiten = [];
    if (schrankEckeAn(raum, wand, 'anfang')) seiten.push(['anfang', 0, nenn]);
    if (schrankEckeAn(raum, wand, 'ende')) seiten.push(['ende', Math.max(0, len - nenn), len]);
    /* Steht der Schrank schon in SEINER Ecke, zaehlt nur diese. Vorher wurden beide Enden
       geprueft: in der U-Kueche meldete der G60N an der Ecke A/C einen Fehler, weil an der
       ANDEREN Ecke von Wand A der G60N von Wand B hing — zwei Schraenke, zwei Ecken, kein
       Konflikt, und der Warenkorb war trotzdem gesperrt. Beim Setzen ist die Ecke noch nicht
       vergeben; dort bleibt `seite` leer und es gilt die alte Pruefung beider Enden. */
    if (seite) seiten = seiten.filter(function (s) { return s[0] === seite; });
    var i, eigen;
    for (i = 0; i < seiten.length; i++) {
      eigen = treffer(wand, seiten[i][1], seiten[i][2]);
      if (eigen) return eigen;
    }
    /* Und um die Ecke: der zweite Schenkel steht auf der NACHBARWAND dieser Ecke, an dem
       Ende, das zu dieser Ecke gehoert. Welches das ist, sagt die Ecke selbst. */
    for (i = 0; i < seiten.length; i++) {
      var ecke = schrankEckeAn(raum, wand, seiten[i][0]);
      var andere = ecke.a === wand ? ecke.b : ecke.a;
      var al = wandObj(z, andere).len;
      var nb = ecke.enden[andere] === 'anfang'
        ? treffer(andere, 0, tief)
        : treffer(andere, Math.max(0, al - tief), al);
      if (nb) return nb;
    }
    return null;
  }

  /* Einen Schrank setzen. Gibt den NEUEN Zustand zurück statt ihn zu verändern — der Aufrufer
     entscheidet, ob er ihn übernimmt. Der Kollisionstest ist derselbe wie beim Ziehen:
     solange nur das Ziehen prüfte, entstand der Fehler beim Setzen und wurde erst danach
     gemeldet. */
  function setzen(z, daten, mi, wahl) {
    var m = daten.modelle[mi];
    if (!m) return { fehler: 'Modell nicht im Katalog.' };
    var zl = zeile(m), wand = z.wand;

    /* Eine Wand kann vorhanden und trotzdem nicht bestueckbar sein: die Verbindung
       zwischen den beiden Zeilen einer Parallelkueche ist der GANG. Sie traegt Anschluesse
       und Hindernisse, aber keine Schraenke — und genau das unterscheidet die zweizeilige
       Kueche von der U-Form. Ohne diese Sperre koennte der Kunde den Gang zustellen und
       das Modell haette zwei Wahrheiten. */
    var wandObjektG = wandAus(raumGeometrie(z), wand);
    if (wandObjektG && wandObjektG.planbar === false) {
      return { sperre: wandObjektG.label + ' ist der Durchgang zwischen den beiden Zeilen '
        + 'und wird nicht bestückt. Anschlüsse und Hindernisse lassen sich hier eintragen, '
        + 'Schränke nicht.' };
    }

    if (istEck(m)) {
      /* Ein Eckschrank ohne Ecke ist kein Sonderfall, sondern ein Widerspruch. Frueher
         liess sich einer in eine EINZEILIGE Kueche setzen — dort gibt es keine Ecke —,
         und die Zeichnung malte trotzdem ein L. Bezahlt haette der Kunde einen Korpus,
         der an dieser Wand nicht montierbar ist. */
      var raumS = raumGeometrie(z);
      if (!schrankEckeAn(raumS, wand, 'anfang') && !schrankEckeAn(raumS, wand, 'ende')) {
        return { sperre: 'Kein Platz: ' + wandObj(z, wand).label + ' hat keine Ecke, in die '
          + m.code + ' passt. Ein Eckschrank braucht zwei aneinanderstoßende Wände, die '
          + 'beide bestückt werden.' };
      }
      var sp = eckSperre(z, daten, wand, zl, m);
      if (sp) {
        return { sperre: 'Kein Platz: in dieser Ecke liegt ' + sp.was + ' (' + sp.wand
          + '). Ein Eckschrank kann nicht ausweichen — Fenster verschieben oder geraden Schrank wählen.' };
      }
    }

    var key = wand + '|' + zl;
    var plan = {}, hoff = {}, xpos = {}, wahlen = {};
    Object.keys(z.plan || {}).forEach(function (k) { plan[k] = (z.plan[k] || []).slice(); });
    Object.keys(z.hoff || {}).forEach(function (k) { hoff[k] = (z.hoff[k] || []).slice(); });
    Object.keys(z.xpos || {}).forEach(function (k) { xpos[k] = (z.xpos[k] || []).slice(); });
    Object.keys(z.wahl || {}).forEach(function (k) { wahlen[k] = (z.wahl[k] || []).slice(); });
    plan[key] = (plan[key] || []).concat([mi]);
    hoff[key] = hoff[key] || [];
    xpos[key] = xpos[key] || [];
    wahlen[key] = wahlen[key] || [];
    /* Die Wahl gehoert an DIESE Platzierung, nicht an das Modell: derselbe Schrank kann in
       derselben Kueche einmal links und einmal rechts angeschlagen sein. */
    wahlen[key][plan[key].length - 1] = wahl || null;

    var neuZ = { }; for (var k2 in z) { if (Object.prototype.hasOwnProperty.call(z, k2)) neuZ[k2] = z[k2]; }
    neuZ.plan = plan; neuZ.hoff = hoff; neuZ.xpos = xpos; neuZ.wahl = wahlen;

    var i = plan[key].length - 1;
    var it = items(neuZ, daten, wand, zl)[i];
    if (!it) return { fehler: 'Der Schrank konnte nicht eingeordnet werden.' };

    /* Nachbarn zählen nur, wenn sich die HÖHENBÄNDER schneiden. Versatzgleichheit genügt
       nicht: ein Schrank mit Versatz 36 überlappte einen mit Versatz 0 vollständig und galt
       trotzdem als frei. */
    var nachbarn = items(neuZ, daten, wand, zl).filter(function (o) {
      return o.i !== i && ueber(it.off || 0, (it.off || 0) + it.m.h, o.off || 0, (o.off || 0) + o.m.h);
    }).map(function (o) { return { a: o.x, b: o.x + o.b, was: o.m.code }; });

    var zonen = sperrZonen(neuZ, daten, wand, zl, it.m, it.off).concat(nachbarn);
    var hinweis = null;
    if (zonen.some(function (zn) { return ueber(it.x, it.x + it.b, zn.a, zn.b); })) {
      var frei = freiSchieben(it.x, it.b, zonen, wandObj(z, wand).len);
      if (frei.x == null) {
        return { sperre: 'Kein Platz: ' + m.code + ' passt weder links noch rechts an '
          + (frei.was || 'das Hindernis') + ' vorbei.' };
      }
      xpos[key][i] = frei.x;
      hinweis = m.code + ' ist am Hindernis vorbei auf ' + r0(frei.x) + ' cm gesetzt.';
    }

    /* PASST ER? Gefragt wird, WO er landet — nicht, wie weit die Reihe reicht.

       Bis 2026-09-09 haengte `setzen` jeden Schrank an, auch in eine volle Reihe: er bekam die
       naechste Stelle im Fluss, eine hinter dem Wandende, und in der Zeichnung stapelten sich die
       Korpusse. Die erste Sperre dagegen rechnete `nutzLaenge − belegt`, und `belegt` ist die
       aeusserste Kante. Stand ein Eckschrank am Wandende, war die Kante sofort das Wandende —
       "noch 0 cm frei" auf einer fast leeren Wand, und jeder weitere Schrank wurde abgelehnt
       (Audit B1, nachgestellt an Wand A der L-Kueche und Wand C der U-Kueche). Auf Waenden,
       deren Anfang die Nachbarecke belegt, fehlte genau dieser Versatz.

       Jetzt entscheidet die Geometrie selbst: der Schrank steht ganz im nutzbaren Bereich,
       ueberdeckt nichts in seinem Hoehenband, und ein Eckschrank schiebt die uebrige Reihe nicht
       ueber das Wandende. Findet der Fluss keinen Platz, es gibt aber eine Luecke, kommt ein
       gerader Schrank in die naechstgelegene. Sonst nennt die Sperre die groesste freie Luecke. */
    var iv = nutzIntervall(z, daten, wand, zl);
    var draussen = function (o, ivx) { ivx = ivx || iv; return o.x < ivx.start - 0.5 || o.x + o.b > ivx.ende + 0.5; };
    var warDraussen = {};
    items(z, daten, wand, zl).forEach(function (o) { warDraussen[o.i] = draussen(o); });
    /* Gemessen am nutzbaren Stueck MIT dem neuen Schrank: zwischen zwei Ecken ruecken die Nachbarreihen dafuer an ihre
       Waende (wandVersatz) — der Rest der Wand ist dann kein Grund, einen passenden Schrank abzulehnen. */
    var passt = function () {
      var jetzt = items(neuZ, daten, wand, zl), ivN = nutzIntervall(neuZ, daten, wand, zl);
      var n = jetzt.filter(function (o) { return o.i === i; })[0];
      if (!n || draussen(n, ivN)) return false;
      if (zonen.some(function (zn) { return ueber(n.x + 0.5, n.x + n.b - 0.5, zn.a, zn.b); })) return false;
      return !jetzt.some(function (o) { return o.i !== i && !warDraussen[o.i] && draussen(o, ivN); });
    };
    if (!passt()) {
      var ziel = istEck(m) ? null : naechsteLuecke(it.x, it.b, zonen, iv);
      if (ziel != null) {
        xpos[key][i] = ziel;
        hinweis = m.code + ' steht in der freien Lücke bei ' + r0(ziel) + ' cm.';
      }
      if (ziel == null || !passt()) {
        var bisher = items(z, daten, wand, zl).filter(function (o) {
          return ueber(it.off || 0, (it.off || 0) + m.h, o.off || 0, (o.off || 0) + o.m.h);
        }).map(function (o) { return { a: o.x, b: o.x + o.b }; });
        /* Ein Eckschrank braucht DIE ECKE, nicht irgendeine Luecke: „noch 100 cm frei, braucht
           60 cm" widersprach sich (Betreiber 2026-09-27). Genannt wird, was in der Ecke steht. */
        if (istEck(m)) {
          var n0 = items(neuZ, daten, wand, zl).filter(function (o) { return o.i === i; })[0];
          var imWeg = n0 ? items(z, daten, wand, zl).filter(function (o) {
            return ueber(n0.x + 0.5, n0.x + n0.b - 0.5, o.x, o.x + o.b)
              && ueber(it.off || 0, (it.off || 0) + m.h, o.off || 0, (o.off || 0) + o.m.h);
          }) : [];
          return { sperre: imWeg.length
            ? 'Die Ecke ist belegt: ' + imWeg.map(function (o) { return o.m.code + ' bei ' + r0(o.x) + ' cm'; }).join(', ')
              + '. Erst dort Platz machen.'
            : 'Mit ' + m.code + ' in der Ecke rückt die übrige Reihe über das Wandende. Erst einen Schrank entfernen.' };
        }
        var groesste = freieLuecken(sperrZonen(z, daten, wand, zl, m, it.off).concat(bisher), iv.start, iv.ende)
          .reduce(function (mx, g) { return Math.max(mx, g[1] - g[0]); }, 0);
        return { sperre: 'Kein Platz: auf ' + wandObj(z, wand).label + ' sind in dieser Reihe '
          + 'noch ' + r0(groesste) + ' cm frei, ' + m.code + ' braucht ' + r0(nennMass(m)) + ' cm. Erst einen '
          + 'Schrank entfernen oder die Wand verlängern.' };
      }
    }
    return { plan: plan, hoff: hoff, xpos: xpos, wahl: wahlen, sel: key + '|' + i, hinweis: hinweis };
  }

  /* Die Fehler eines Plans als Texte — dieselbe Pruefung, die der Worker beim Bezahlen rechnet. */
  function fehlerTexte(z, daten) {
    return pruefung(z, daten).filter(function (x) { return x.art === 'fehler'; })
      .map(function (x) { return x.text; });
  }

  /* ---------- Einen gesetzten Schrank tauschen ----------

     Die App zeigt am gewaehlten Schrank „Ersetzen durch": dieselbe Stelle, ein anderes Modell.
     Loeschen und neu setzen ist dafuer der falsche Weg — der neue Schrank landete am Ende der
     Reihe statt an dieser Stelle, und Wandstelle, Hoehe und Tueranschlag waeren verloren.

     Getauscht wird nur innerhalb derselben Katalogreihe (Unterschrank gegen Unterschrank) und
     Eckschrank nur gegen Eckschrank: ein Hochschrank reicht in eine andere Hoehe, ein
     Eckschrank ist an seine Ecke gebunden — beides ist kein Tausch an derselben Stelle.

     OB ER PASST, entscheidet die Pruefung, die auch beim Bezahlen laeuft: hat der neue Plan
     MEHR Fehler als der alte, wird nicht getauscht. Eine eigene zweite Rechnung fuer „passt"
     wuerde frueher oder spaeter anders urteilen als die Kasse. Mehr, nicht andere: ein Plan,
     der schon einen Mangel hat, darf trotzdem umgebaut werden.

     Gibt wie `setzen` einen NEUEN Zustand zurueck oder { sperre } / { fehler }. */
  function ersetzen(z, daten, sel, mi, wahl) {
    var t = String(sel || '').split('|');
    if (!daten || t.length < 3) return { fehler: 'Kein Schrank gewählt.' };
    var key = t[0] + '|' + t[1], i = +t[2];
    var alt = daten.modelle[((z.plan || {})[key] || [])[i]];
    var m = daten.modelle[mi];
    if (!alt) return { fehler: 'Kein Schrank gewählt.' };
    if (!m) return { fehler: 'Modell nicht im Katalog.' };
    if (istEck(alt) !== istEck(m)) {
      return { sperre: istEck(alt) ? 'Ein Eckschrank lässt sich nur gegen einen anderen Eckschrank tauschen.'
        : m.code + ' ist ein Eckschrank und gehört in eine Ecke, nicht an diese Stelle.' };
    }
    /* Getauscht wird innerhalb derselben ZEILE, nicht derselben Katalogreihe: Unter- und
       Hochschraenke stehen beide in der Bodenreihe. Bis 2026-09-26 galt die Katalogreihe, und
       der Betreiber fand „keine Moeglichkeit, auf den hohen Backofen zu wechseln oder einen
       Kuehlschrankschrank einzusetzen" — in einer vollen Startkueche gab es dafuer keinen Weg. */
    if (zeile(m) !== zeile(alt)) {
      return { sperre: m.code + ' gehört in eine andere Reihe als ' + alt.code + ' und lässt sich hier nicht eintauschen.' };
    }
    if (!variante(m, z.farbe, z.zusatz)) return { sperre: m.code + ' gibt es nicht in ' + z.farbe + '.' };

    /* Der Tueranschlag bleibt, wenn das neue Modell ihn kennt; sonst gilt dessen erster Wert. */
    var gr = optGruppen(daten, m, z.farbe)[0];
    var bisher = wahlListe(z, key)[i];
    var w = wahl != null ? wahl : bisher;
    if (!gr) w = null;
    else if (gr.werte.indexOf(w) < 0) w = gr.werte[0];

    var plan = {}, hoff = {}, xpos = {}, wahlen = {};
    Object.keys(z.plan || {}).forEach(function (k) { plan[k] = (z.plan[k] || []).slice(); });
    Object.keys(z.hoff || {}).forEach(function (k) { hoff[k] = (z.hoff[k] || []).slice(); });
    Object.keys(z.xpos || {}).forEach(function (k) { xpos[k] = (z.xpos[k] || []).slice(); });
    Object.keys(z.wahl || {}).forEach(function (k) { wahlen[k] = (z.wahl[k] || []).slice(); });
    plan[key][i] = mi;
    wahlen[key] = wahlListe(z, key);
    wahlen[key][i] = w;

    var neuZ = {}; for (var k2 in z) { if (Object.prototype.hasOwnProperty.call(z, k2)) neuZ[k2] = z[k2]; }
    neuZ.plan = plan; neuZ.hoff = hoff; neuZ.xpos = xpos; neuZ.wahl = wahlen;
    /* Ein Tausch in der Bodenreihe verschiebt sie (items lehnt sie an ihr Ende) — die festen
       Haengeschraenke ziehen nach, solange das keinen neuen Fehler bringt. */
    if (t[1] === 'boden') {
      var nz = obenNachziehen(z, neuZ, daten, t[0], null);
      if (nz && fehlerTexte(nz, daten).length <= fehlerTexte(neuZ, daten).length) {
        neuZ = nz; plan = nz.plan; xpos = nz.xpos; wahlen = nz.wahl;
      }
    }
    /* Wird aus einem Unterschrank ein Hochschrank, belegt er die Hoehe der Haengereihe: was
       dort an seiner Stelle hing, geht mit (und wird genannt). */
    var mitEntfernt = [];
    if (t[1] === 'boden' && m.reihe === 'voll' && alt.reihe !== 'voll') {
      var gH = geo(daten);
      var neuIt = items(neuZ, daten, t[0], 'boden').filter(function (it) { return it.i === i; })[0];
      var kO = t[0] + '|oben';
      var weg = neuIt ? items(neuZ, daten, t[0], 'oben').filter(function (o) {
        return ueber(o.x + 1, o.x + o.b - 1, neuIt.x, neuIt.x + neuIt.b)
          && gH.haenge_unterkante + (o.off || 0) < gH.hochschrank_hoehe - 0.5;
      }) : [];
      if (weg.length) {
        plan[kO] = (plan[kO] || []).slice(); hoff[kO] = offListe(neuZ, kO).slice();
        xpos[kO] = xListe(neuZ, kO).slice(); wahlen[kO] = wahlListe(neuZ, kO).slice();
        weg.sort(function (a, b) { return b.i - a.i; }).forEach(function (o) {
          [plan, hoff, xpos, wahlen].forEach(function (f) { f[kO].splice(o.i, 1); });
          mitEntfernt.push(o.m.code);
        });
        neuZ = {}; for (var k3 in z) { if (Object.prototype.hasOwnProperty.call(z, k3)) neuZ[k3] = z[k3]; }
        neuZ.plan = plan; neuZ.hoff = hoff; neuZ.xpos = xpos; neuZ.wahl = wahlen;
      }
    }

    /* Haengt nach dem Tausch ein Haengeschrank nicht mehr zur Haelfte ueber einem Unterschrank, der
       es vorher tat (schmaler Apothekerschrank ohne passenden Haengeschrank: Livaro D20C), geht er
       mit — dieselbe Regel wie beim Entfernen (Grosstest 2026-09-27). */
    if (t[1] === 'boden') {
      /* Getragen wie in `schwebende`: zusammengezaehlt ueber Unterschraenke, niedrige Nischen und den Eckschenkel der
         Nachbarwand. Nur einzelne Unterschraenke zu zaehlen liess einen Haengeschrank fallen, der halb ueber dem Eckschenkel
         hing (U 312 mit Wandversatz: 45 → 40 getauscht, der 60er darueber verschwand). */
      var traegt = function (q, o) { return getragenVon(unterbauVon(q, daten, t[0]), o); };
      var kO2 = t[0] + '|oben';
      var vorherO = {};
      items(z, daten, t[0], 'oben').forEach(function (o) { vorherO[o.i] = traegt(z, o); });
      var los = items(neuZ, daten, t[0], 'oben').filter(function (o) { return !istEck(o.m) && vorherO[o.i] && !traegt(neuZ, o); });
      if (los.length) {
        plan[kO2] = (plan[kO2] || []).slice(); hoff[kO2] = offListe(neuZ, kO2).slice();
        xpos[kO2] = xListe(neuZ, kO2).slice(); wahlen[kO2] = wahlListe(neuZ, kO2).slice();
        los.sort(function (a, b) { return b.i - a.i; }).forEach(function (o) {
          [plan, hoff, xpos, wahlen].forEach(function (f) { f[kO2].splice(o.i, 1); });
          mitEntfernt.push(o.m.code);
        });
        neuZ = {}; for (var k4 in z) { if (Object.prototype.hasOwnProperty.call(z, k4)) neuZ[k4] = z[k4]; }
        neuZ.plan = plan; neuZ.hoff = hoff; neuZ.xpos = xpos; neuZ.wahl = wahlen;
      }
    }

    var vorher = fehlerTexte(z, daten), nachher = fehlerTexte(neuZ, daten);
    if (t[1] === 'oben' && nachher.length <= vorher.length && schwebende(neuZ, daten, t[0]) > schwebende(z, daten, t[0])) {
      return { sperre: m.code + ' ist hier zu breit – ein Teil hinge über keinem Unterschrank.', breiter: nennMass(m) - nennMass(alt) };
    }
    if (nachher.length > vorher.length) {
      var grund = nachher.filter(function (x) { return vorher.indexOf(x) < 0; })[0] || nachher[nachher.length - 1];
      var mehr = nennMass(m) - nennMass(alt);
      return {
        sperre: mehr > 0.5
          ? 'Kein Platz: ' + m.code + ' ist ' + r0(mehr) + ' cm breiter als ' + alt.code + '. ' + grund
          : m.code + ' passt hier nicht. ' + grund,
        grund: grund, breiter: mehr > 0.5 ? mehr : 0
      };
    }
    return { plan: plan, hoff: hoff, xpos: xpos, wahl: wahlen, sel: key + '|' + i, hinweis: null,
             mitEntfernt: mitEntfernt };
  }

  /* ---------- Zwei Haengeschraenke uebereinander (2026-09-26) ----------

     Betreiber: „ich kann keine zwei kleinen Haengeschraenke uebereinander setzen". Der Kern
     konnte es laengst — Versatz (hoff), buendiges Aufliegen (items: gestapelt), Hoehenband in der
     Ueberschneidungspruefung, Decke —, aber nur die alte Seite hatte dafuer eine Hand (Ziehen in
     der Hoehe). `stapeln` setzt einen GLEICH BREITEN Haengeschrank buendig auf den gewaehlten:
     gleiche Stelle, Unterkante = Oberkante des unteren. Nur wenn das keinen neuen Fehler bringt
     (Decke, Ueberschneidung). `stapelAngebot` nennt, was dort passt. */
  function stapeln(z, daten, sel, mi, wahl) {
    var t = String(sel || '').split('|');
    if (!daten || t.length < 3 || t[1] !== 'oben') return { fehler: 'Kein Hängeschrank gewählt.' };
    var key = t[0] + '|oben', i = +t[2];
    var unten = items(z, daten, t[0], 'oben').filter(function (it) { return it.i === i; })[0];
    var m = daten.modelle[mi];
    if (!unten) return { fehler: 'Kein Hängeschrank gewählt.' };
    if (!m || zeile(m) !== 'oben' || istEck(m) || istEck(unten.m)) return { sperre: 'Darauf lässt sich nur ein gerader Hängeschrank setzen.' };
    if (Math.abs(nennMass(m) - unten.b) > 0.5) return { sperre: m.code + ' ist nicht so breit wie ' + unten.m.code + '.' };
    if (!variante(m, z.farbe, z.zusatz)) return { sperre: m.code + ' gibt es nicht in ' + z.farbe + '.' };
    var gr = optGruppen(daten, m, z.farbe)[0];
    var w = gr ? (gr.werte.indexOf(wahl) > -1 ? wahl : gr.werte[0]) : null;
    var plan = {}, hoff = {}, xpos = {}, wahlen = {};
    Object.keys(z.plan || {}).forEach(function (k) { plan[k] = (z.plan[k] || []).slice(); });
    Object.keys(z.hoff || {}).forEach(function (k) { hoff[k] = (z.hoff[k] || []).slice(); });
    Object.keys(z.xpos || {}).forEach(function (k) { xpos[k] = (z.xpos[k] || []).slice(); });
    Object.keys(z.wahl || {}).forEach(function (k) { wahlen[k] = (z.wahl[k] || []).slice(); });
    hoff[key] = offListe(z, key); xpos[key] = xListe(z, key); wahlen[key] = wahlListe(z, key);
    plan[key] = (plan[key] || []).concat([mi]);
    hoff[key].push(zahl((unten.off || 0) + unten.m.h));
    xpos[key].push(zahl(unten.x));
    wahlen[key].push(w);
    var neuZ = {}; for (var k2 in z) { if (Object.prototype.hasOwnProperty.call(z, k2)) neuZ[k2] = z[k2]; }
    neuZ.plan = plan; neuZ.hoff = hoff; neuZ.xpos = xpos; neuZ.wahl = wahlen;
    var vorher = fehlerTexte(z, daten), nachher = fehlerTexte(neuZ, daten);
    if (nachher.length > vorher.length) {
      var grund = nachher.filter(function (x) { return vorher.indexOf(x) < 0; })[0] || nachher[nachher.length - 1];
      return { sperre: m.code + ' passt nicht darauf. ' + grund, grund: grund };
    }
    return { plan: plan, hoff: hoff, xpos: xpos, wahl: wahlen, sel: key + '|' + (plan[key].length - 1) };
  }

  function stapelAngebot(z, daten, sel) {
    var t = String(sel || '').split('|');
    if (!daten || t.length < 3 || t[1] !== 'oben') return [];
    var s = {}; for (var k in z) { if (Object.prototype.hasOwnProperty.call(z, k)) s[k] = z[k]; }
    s.wand = t[0];
    /* Zuerst das Gegenstueck aus dem Entwurf (Betreiber 2026-09-27: „الخزائن التي تضاف فوق بعضها يجب ان تعرض اول شي
       لمثيلتها الموجودة في التصميم"): was in dieser Kueche schon auf demselben Unterschrank-Modell liegt, dann was
       ueberhaupt schon gestapelt ist, dann was sonst in der Haengereihe haengt — erst danach der Rest nach Hoehe/Preis. */
    var unten = items(z, daten, t[0], 'oben').filter(function (it) { return it.i === +t[2]; })[0];
    var aufGleichem = {}, gestapelt = {}, benutzt = {};
    waende(z).forEach(function (wd) {
      var reihe = items(z, daten, wd.id, 'oben');
      reihe.forEach(function (it) {
        benutzt[it.m.code] = true;
        if (!(it.off > 0.5)) return;
        gestapelt[it.m.code] = true;
        var traeger = reihe.filter(function (b) {
          return b !== it && Math.abs(b.x - it.x) < 0.6 && Math.abs((b.off || 0) + b.m.h - it.off) < 1.5;
        })[0];
        if (traeger && unten && traeger.m.code === unten.m.code) aufGleichem[it.m.code] = true;
      });
    });
    var rang = function (x) { return aufGleichem[x.m.code] ? 0 : (gestapelt[x.m.code] ? 1 : (benutzt[x.m.code] ? 2 : 3)); };
    return katalog(s, daten, 'oben', '').filter(function (x) { return !istEck(x.m); }).map(function (x) {
      var r = stapeln(z, daten, sel, x.i);
      return r.sperre || r.fehler ? null : { x: x, r: r };
    }).filter(Boolean).sort(function (a, b) {
      return rang(a.x) - rang(b.x) || a.x.m.h - b.x.m.h || a.x.v.preis - b.x.v.preis;
    });
  }

  /* ---------- Verschieben mit ← → (2026-09-27) ----------

     Bis hierher tauschte die App zwei EINTRAEGE der Planliste und liess die festen Wandstellen
     (xpos) stehen. Die Listenfolge ist aber nicht die Folge an der Wand: ein gestapelter
     Haengeschrank steht in der Liste hinten und an der Wand ueber seinem Unterbau, und
     die Startkueche setzt Haengeschraenke fest. Gemessen am Stand des Betreibers (Glanzia,
     L-Kueche): der hohe G60 rutschte unter den darauf gestapelten G60KN („ueberschneiden
     sich"), ein anderer G60 stand bei 330 cm hinter dem nutzbaren Ende („nutzbar ist diese
     Reihe nur bis 270 cm") — ohne dass die App es verhindert haette.

     Jetzt: getauscht wird mit dem Nachbarn AN DER WAND. Eine Einheit ist ein Schrank samt dem,
     was auf ihm gestapelt ist; sie wandert als Ganzes. Stehen die Schraenke der Reihe frei
     (keine feste Stelle), tauschen sie ihren Platz in der Liste und die Reihe fliesst neu wie
     bisher; sonst tauschen die beiden Einheiten ihre Stellen (der Abstand zwischen ihnen
     bleibt). In der Bodenreihe ziehen feste Haengeschraenke ueber ihrem Partner mit.
     Bringt das einen neuen Fehler, wird es abgelehnt — mit Grund. */
  /* Wie viele Haengeschraenke einer Wand haengen ueber nichts — weniger als die Haelfte ihrer Breite ueber Unterbau
     (Unterschraenke, niedrige Nischen, der Eckschenkel der Nachbarwand), zusammengezaehlt ueber alle Traeger (Stufe 2,
     2026-09-27: mit Tuer und Fenster hat die Bodenreihe Luecken, ueber die ein breiterer oder verschobener Haengeschrank
     sonst hinausragte — Grosstest mit Fenstern: 45 Faelle nach Tauschen/Verschieben). */
  function unterbauVon(q, daten, wand) {
    var bo = items(q, daten, wand, 'boden').filter(function (u) { return u.m.reihe !== 'voll'; }).map(function (u) { return [u.x, u.x + u.b]; });
    aktiveMerkmale(q).filter(function (m) { return m.wand === wand && MT[m.typ] && MT[m.typ].stellplatz && !MT[m.typ].hoch; })
      .forEach(function (m) { bo.push([m.x, m.x + m.breite]); });
    var eb = eckBelegung(q, daten, wand, 'boden'), wl = wandObj(q, wand).len;
    if (eb.anfang) bo.push([0, eb.anfang.cm]);
    if (eb.ende) bo.push([wl - eb.ende.cm, wl]);
    return bo;
  }
  function getragenVon(bo, o) {
    return bo.reduce(function (sm, u) { return sm + Math.max(0, Math.min(o.x + o.b, u[1]) - Math.max(o.x, u[0])); }, 0) >= o.b / 2 - 0.5;
  }
  function schwebende(q, daten, wand) {
    var bo = unterbauVon(q, daten, wand);
    return items(q, daten, wand, 'oben').filter(function (o) { return !istEck(o.m) && !getragenVon(bo, o); }).length;
  }

  function schieben(z, daten, sel, d) {
    var t = String(sel || '').split('|');
    if (!daten || t.length < 3 || (d !== 1 && d !== -1)) return { fehler: 'Kein Schrank gewählt.' };
    var wand = t[0], zl = t[1], key = wand + '|' + zl, i = +t[2];
    var its = items(z, daten, wand, zl);
    var ich = its.filter(function (it) { return it.i === i; })[0];
    if (!ich) return { fehler: 'Kein Schrank gewählt.' };
    /* Einheiten: Grundschraenke (ohne Hoehenversatz) und was ueber ihnen gestapelt ist. */
    var grund = its.filter(function (it) { return !(it.off > 0.5); });
    var einheit = {};
    grund.forEach(function (g) { einheit[g.i] = [g]; });
    its.filter(function (it) { return it.off > 0.5; }).forEach(function (st) {
      var best = null, bestU = 0;
      grund.forEach(function (g) {
        var u = Math.min(st.x + st.b, g.x + g.b) - Math.max(st.x, g.x);
        if (u > bestU + 0.01) { bestU = u; best = g; }
      });
      if (best) einheit[best.i].push(st); else { einheit[st.i] = [st]; grund.push(st); }
    });
    grund.sort(function (a, b) { return a.x - b.x || a.i - b.i; });
    var meineBasis = grund.filter(function (g) {
      return einheit[g.i].some(function (m) { return m.i === i; });
    })[0];
    var p = grund.indexOf(meineBasis), q = p + d;
    if (p < 0 || q < 0 || q >= grund.length) return { sperre: 'Am Ende der Reihe — weiter geht es nicht.' };
    var nb = grund[q];
    if (istEck(meineBasis.m) || istEck(nb.m)) return { sperre: 'Eckschränke bleiben in ihrer Ecke.' };

    var plan = {}, hoff = {}, xpos = {}, wahlen = {};
    Object.keys(z.plan || {}).forEach(function (k) { plan[k] = (z.plan[k] || []).slice(); });
    Object.keys(z.hoff || {}).forEach(function (k) { hoff[k] = (z.hoff[k] || []).slice(); });
    Object.keys(z.xpos || {}).forEach(function (k) { xpos[k] = (z.xpos[k] || []).slice(); });
    Object.keys(z.wahl || {}).forEach(function (k) { wahlen[k] = (z.wahl[k] || []).slice(); });
    hoff[key] = offListe(z, key).slice(); wahlen[key] = wahlListe(z, key).slice();
    var xs0 = (z.xpos || {})[key] || [];
    var frei = !xs0.some(function (x) { return x != null; })
      && einheit[meineBasis.i].length === 1 && einheit[nb.i].length === 1;
    var neuSel = key + '|' + i, map = null;
    if (frei) {
      /* Freie Reihe: Plaetze in der Liste tauschen, die Reihe fliesst neu. */
      var a = meineBasis.i, b = nb.i;
      [plan, hoff, wahlen].forEach(function (f) { var h = f[key][a]; f[key][a] = f[key][b]; f[key][b] = h; });
      xpos[key] = (xpos[key] || []).slice();
      neuSel = key + '|' + b;
      map = function (ii) { return ii === a ? b : (ii === b ? a : ii); };
    } else {
      /* Feste Stellen: die beiden Einheiten tauschen ihre Stellen, der Abstand bleibt. */
      xpos[key] = xListe(z, key).slice();
      var L = d > 0 ? meineBasis : nb, R = d > 0 ? nb : meineBasis;
      var luecke = R.x - (L.x + L.b);
      var dxR = L.x - R.x, dxL = (L.x + R.b + luecke) - L.x;
      einheit[R.i].forEach(function (m) { xpos[key][m.i] = zahl(m.x + dxR); });
      einheit[L.i].forEach(function (m) { xpos[key][m.i] = zahl(m.x + dxL); });
    }
    var neuZ = {}; for (var k2 in z) { if (Object.prototype.hasOwnProperty.call(z, k2)) neuZ[k2] = z[k2]; }
    neuZ.plan = plan; neuZ.hoff = hoff; neuZ.xpos = xpos; neuZ.wahl = wahlen;
    if (zl === 'boden') {
      var nz = obenNachziehen(z, neuZ, daten, wand, map);
      if (nz && fehlerTexte(nz, daten).length <= fehlerTexte(neuZ, daten).length) {
        neuZ = nz; plan = nz.plan; hoff = nz.hoff || hoff; xpos = nz.xpos; wahlen = nz.wahl;
      }
    }
    var vorher = fehlerTexte(z, daten), nachher = fehlerTexte(neuZ, daten);
    if (nachher.length > vorher.length) {
      var grund2 = nachher.filter(function (x) { return vorher.indexOf(x) < 0; })[0] || nachher[nachher.length - 1];
      return { sperre: 'Dort passt ' + ich.m.code + ' nicht hin. ' + grund2, grund: grund2 };
    }
    if (zl === 'oben' && schwebende(neuZ, daten, wand) > schwebende(z, daten, wand)) {
      return { sperre: 'Dort hinge ' + ich.m.code + ' über keinem Unterschrank.' };
    }
    return { plan: plan, hoff: hoff, xpos: xpos, wahl: wahlen, sel: neuSel };
  }

  /* ---------- Haengeschraenke folgen ihrem Unterbau (2026-09-26) ----------

     Die Startkueche setzt jeden Haengeschrank FEST ueber seinen Unterschrank (xpos), damit
     Kanten trotz 59,6er Geschirrspuelerfronten fluchten. Seit sich eine Reihe an ihr
     geschlossenes Ende lehnt (items), wandert die Bodenreihe beim Tauschen und Entfernen —
     die festen Haengeschraenke blieben stehen. Im Browser gesehen: L-Kueche, D60 gegen D30
     getauscht, unten 30 cm frei am offenen Anfang, darueber ein Haengeschrank ueber nichts.

     Jeder feste Haengeschrank hat einen Partner: den Unterschrank, den er zur Haelfte oder
     mehr ueberdeckt. Wandert der Partner, wandert er mit — buendig an der Seite, an die sich
     die Reihe lehnt. War er so breit wie der alte Partner und aendert der seine Breite, wird
     er gegen den gleichartigen Haengeschrank der neuen Breite getauscht (G60 ueber D60 wird
     G30 ueber D30), wenn es ihn in der Farbe gibt. Gezogene Stellen des Kunden (xpos) sind
     davon nicht zu unterscheiden und wandern ebenso mit; Eck-Haengeschraenke stehen in ihrer
     Ecke und bleiben. `iNeu(iAlt)` uebersetzt Planindizes der Bodenreihe (Entfernen
     verschiebt sie), null = der Partner ist weg — dann bleibt der Haengeschrank stehen.
     Rueckgabe: neuer Zustand (flache Kopie) oder null, wenn sich nichts bewegt. Ob er
     genommen wird, entscheidet der Aufrufer ueber die Pruefung. */
  function obenNachziehen(alt, neu, daten, wand, iNeu) {
    if (!daten) return null;
    var map = iNeu || function (i) { return i; };
    var key = wand + '|oben';
    var altB = items(alt, daten, wand, 'boden'), neuB = items(neu, daten, wand, 'boden');
    var neuNach = {};
    neuB.forEach(function (it) { neuNach[it.i] = it; });
    var rechts = reiheVonRechts(neu, daten, wand, 'boden');
    var planO = ((neu.plan || {})[key] || []).slice();
    if (!planO.length) return null;
    var xs = xListe(neu, key).slice(), wl = wahlListe(neu, key).slice();
    var s = {}; for (var k0 in neu) { if (Object.prototype.hasOwnProperty.call(neu, k0)) s[k0] = neu[k0]; }
    s.wand = wand;
    var angebot = katalog(s, daten, 'oben', '');
    var bewegt = false;
    items(alt, daten, wand, 'oben').forEach(function (o) {
      if (!o.frei || istEck(o.m)) return;
      var best = null, bestU = 0;
      altB.forEach(function (b) {
        var u = Math.min(o.x + o.b, b.x + b.b) - Math.max(o.x, b.x);
        if (u > bestU) { bestU = u; best = b; }
      });
      if (!best || bestU < o.b / 2 - 0.01) return;
      var j = map(best.i), nb = j == null ? null : neuNach[j];
      if (!nb) return;
      var breiteNeu = Math.abs(nb.b - best.b) > 0.5 && Math.abs(o.b - best.b) < 1;
      var x, mi = planO[o.i];
      if (breiteNeu) {
        /* Gleiche Art und Hoehe zuerst; sonst gleiche Art mit der naechsten Hoehe — ueber einem
           Herd haengt der flache G60K, und einen flachen 30er gibt es nicht; ist der Herd
           ohnehin weg, passt der normale G30. */
        var passend = function (fkt) {
          return angebot.filter(function (c) {
            return c.m.funktion === fkt && Math.round(nennMass(c.m)) === Math.round(nb.b) && !istEck(c.m);
          }).sort(function (p, q) { return Math.abs(p.m.h - o.m.h) - Math.abs(q.m.h - o.m.h); })[0];
        };
        /* Der Dunstschrank (Velora: nur 60/80) wird ein normaler Haengeschrank, wenn es ihn in
           der neuen Breite nicht gibt. */
        var ersatz = passend(o.m.funktion) || (o.m.funktion !== 'haengeschrank' ? passend('haengeschrank') : null);
        if (ersatz) {
          mi = ersatz.i;
          var gr = optGruppen(daten, ersatz.m, neu.farbe)[0];
          if (!gr) wl[o.i] = null; else if (gr.werte.indexOf(wl[o.i]) < 0) wl[o.i] = gr.werte[0];
          /* Von der EIGENEN alten Kante aus verschoben, nicht an die Kante des Unterschranks
             gesetzt: neben einer 59,6er Front sitzen Haengeschraenke 0,4 cm versetzt, und an der
             Unterschrankkante ueberschnitt der neue den Nachbarn (Glanzia, gemessen). */
          x = rechts ? (o.x + o.b) + ((nb.x + nb.b) - (best.x + best.b)) - nennMass(ersatz.m)
            : o.x + (nb.x - best.x);
        }
      }
      if (x == null) x = o.x + (rechts ? (nb.x + nb.b) - (best.x + best.b) : nb.x - best.x);
      /* Den Versatz aus „Fugen schliessen" (bis 5 cm) nimmt er mit — laege er damit in einem Hochschrank, der jetzt
         daneben steht, dann buendig ueber seinem Unterschrank (Grosstest 2026-09-27: G60KN 4 cm im D60PM nach dem Tausch). */
      var mNeu = daten.modelle[mi] || o.m, brNeu = nennMass(mNeu);
      var imHoch = function (xx) {
        return hochZonenOben(neu, daten, wand, mNeu, o.off).some(function (h) { return Math.min(xx + brNeu, h.b) - Math.max(xx, h.a) > 0.5; });
      };
      if (imHoch(x)) {
        var buendig = rechts ? nb.x + nb.b - brNeu : nb.x;
        if (!imHoch(buendig)) x = buendig;
      }
      if (Math.abs(x - o.x) > 0.01 || mi !== planO[o.i]) {
        planO[o.i] = mi; xs[o.i] = zahl(x); bewegt = true;
      }
    });
    if (!bewegt) return null;
    var plan = {}, xpos = {}, wahl = {};
    Object.keys(neu.plan || {}).forEach(function (k) { plan[k] = neu.plan[k]; });
    Object.keys(neu.xpos || {}).forEach(function (k) { xpos[k] = neu.xpos[k]; });
    Object.keys(neu.wahl || {}).forEach(function (k) { wahl[k] = neu.wahl[k]; });
    plan[key] = planO; xpos[key] = xs; wahl[key] = wl;
    var out = {}; for (var k1 in neu) { if (Object.prototype.hasOwnProperty.call(neu, k1)) out[k1] = neu[k1]; }
    out.plan = plan; out.xpos = xpos; out.wahl = wahl;
    return out;
  }

  /* Entfernen als Kernfunktion. Faellt ein Unterschrank weg, geht der Haengeschrank mit, der
     genau ueber ihm sass (gleiche Breite, buendig — das Paar aus der Startkueche); sonst hinge
     er ueber nichts. Die uebrigen Haengeschraenke ziehen nach (obenNachziehen), solange das
     keinen neuen Fehler erzeugt. `mitEntfernt` nennt, was mitgegangen ist — die Oberflaeche
     sagt es dem Kunden. */
  function entfernen(z, daten, sel) {
    var t = String(sel || '').split('|');
    if (!daten || t.length < 3) return { fehler: 'Kein Schrank gewählt.' };
    var key = t[0] + '|' + t[1], i = +t[2], wand = t[0];
    var arr0 = (z.plan || {})[key] || [];
    if (!(i >= 0 && i < arr0.length)) return { fehler: 'Kein Schrank gewählt.' };
    var kopie = function (q) {
      var c = {}; for (var k in q) { if (Object.prototype.hasOwnProperty.call(q, k)) c[k] = q[k]; }
      ['plan', 'hoff', 'xpos', 'wahl'].forEach(function (f) {
        var src = q[f] || {}, dst = {};
        Object.keys(src).forEach(function (k2) { dst[k2] = (src[k2] || []).slice(); });
        c[f] = dst;
      });
      return c;
    };
    var raus = function (q, k3, idx) {
      q.plan[k3] = (q.plan[k3] || []).slice();
      q.hoff[k3] = offListe(q, k3).slice(); q.xpos[k3] = xListe(q, k3).slice(); q.wahl[k3] = wahlListe(q, k3).slice();
      ['plan', 'hoff', 'xpos', 'wahl'].forEach(function (f) { q[f][k3].splice(idx, 1); });
    };
    var basis = z, mit = [];
    if (t[1] === 'boden') {
      /* WAS OBEN MITGEHT (Wurzel des wiederkehrenden Fehlers, Betreiber 2026-09-27).
         Bisher nur ein Haengeschrank GLEICHER Breite an GLEICHER Stelle, und nie ein Eck-
         Haengeschrank. Folge, nachgestellt an der U-Kueche aus der Startkueche: den Eck-
         Unterschrank DN90 entfernt -> Eck-Haengeschrank und der 30er daneben blieben, die Unter-
         schraenke rutschten in die Ecke, die Haengeschraenke konnten nicht folgen (der Eck-
         Haengeschrank stand im Weg) und blieben stehen. Ab da stand kein Haengeschrank mehr ueber
         „seinem" Unterschrank, jedes weitere Entfernen fand keinen Partner, und am Ende hingen
         Haengeschraenke ueber nichts oder allein am Wandende.
         Jetzt geht mit, was zur Haelfte oder mehr ueber dem entfernten Schrank haengt und dabei
         nicht zur Haelfte ueber einem anderen Unterschrank — auch ein Eck-Haengeschrank ueber dem
         Eck-Unterschrank. Ein Haengeschrank, der nie ueber einem Unterschrank hing, bleibt. */
      var bodenIts = items(z, daten, wand, 'boden');
      var weg = bodenIts.filter(function (it) { return it.i === i; })[0];
      var ueberlapp = function (o, u) { return Math.max(0, Math.min(o.x + o.b, u.x + u.b) - Math.max(o.x, u.x)); };
      var paar = weg ? items(z, daten, wand, 'oben').filter(function (o) {
        if (ueberlapp(o, weg) < o.b / 2 - 0.5) return false;
        return !bodenIts.some(function (u) { return u.i !== i && ueberlapp(o, u) >= o.b / 2 - 0.5; });
      }) : [];
      if (paar.length) {
        basis = kopie(z);
        paar.sort(function (a, b) { return b.i - a.i; }).forEach(function (o) { raus(basis, wand + '|oben', o.i); mit.push(o.m.code); });
      }
      /* Ein Eck-Unterschrank traegt auch die Ecke der NACHBARWAND: dort haengt oft deren Eck-
         Haengeschrank ueber seinem zweiten Schenkel. Geht er, geht auch, was dort nur ueber ihm hing. */
      if (weg && istEck(weg.m)) {
        waende(z).forEach(function (nw) {
          if (nw.id === wand) return;
          var eb = eckBelegung(z, daten, nw.id, 'boden');
          ['anfang', 'ende'].forEach(function (en) {
            var c = eb[en];
            if (!c || c.quelle.wand !== wand || c.quelle.i !== i) return;
            var zone = en === 'anfang' ? { x: 0, b: c.cm } : { x: nw.len - c.cm, b: c.cm };
            var nBoden = items(basis, daten, nw.id, 'boden');
            var nOben = items(basis, daten, nw.id, 'oben').filter(function (o) {
              return ueberlapp(o, zone) >= o.b / 2 - 0.5
                && !nBoden.some(function (u) { return ueberlapp(o, u) >= o.b / 2 - 0.5; });
            });
            if (!nOben.length) return;
            if (basis === z) basis = kopie(z);
            nOben.sort(function (p, q) { return q.i - p.i; }).forEach(function (o) {
              raus(basis, nw.id + '|oben', o.i); mit.push(o.m.code);
            });
          });
        });
      }
    }
    var neu = kopie(basis);
    raus(neu, key, i);
    /* STUFE 2 (2026-09-27): mit einem Fenster kann die Haengereihe der Bodenreihe nicht immer folgen — nachgezogen
       stuende ein Haengeschrank vor dem Fenster, und das GANZE Nachziehen fiel weg. Zurueck blieben Haengeschraenke
       ueber nichts oder ueber einem Hochschrank (Grosstest mit Fenstern: 227 Faelle). Dann einzeln, und nur fuer die,
       die jetzt ueber nichts haengen: folgen, wenn das keinen neuen Fehler bringt; sonst gehen sie mit weg und stehen
       in `mitEntfernt`. Wer noch ueber einem Unterschrank haengt, bleibt, wie er war. */
    var schwebt = function (q, w, o) {
      var bo = items(q, daten, w, 'boden').filter(function (u) { return u.m.reihe !== 'voll'; }).map(function (u) { return [u.x, u.x + u.b]; });
      aktiveMerkmale(q).filter(function (m) { return m.wand === w && MT[m.typ] && MT[m.typ].stellplatz && !MT[m.typ].hoch; })
        .forEach(function (m) { bo.push([m.x, m.x + m.breite]); });
      var eb = eckBelegung(q, daten, w, 'boden'), wl = wandObj(q, w).len;
      if (eb.anfang) bo.push([0, eb.anfang.cm]);
      if (eb.ende) bo.push([wl - eb.ende.cm, wl]);
      /* Getragen ist, was zusammen ueber Unterbau haengt — auch ueber zwei schmalen Schraenken (25 + 20 unter einem 60er). */
      var dk = bo.reduce(function (sm, u) { return sm + Math.max(0, Math.min(o.x + o.b, u[1]) - Math.max(o.x, u[0])); }, 0);
      return dk < o.b / 2 - 0.5;
    };
    var einzeln = function (q, nzq, w) {
      if (!nzq) return q;
      var keyO = w + '|oben';
      items(q, daten, w, 'oben').forEach(function (o) {
        if (istEck(o.m) || !schwebt(q, w, o)) return;
        var ziel = items(nzq, daten, w, 'oben').filter(function (x) { return x.i === o.i; })[0];
        if (!ziel || (Math.abs(ziel.x - o.x) < 0.01 && ziel.mi === o.mi)) return;
        var p = kopie(q);
        p.plan[keyO] = (p.plan[keyO] || []).slice(); p.plan[keyO][o.i] = ziel.mi;
        p.xpos[keyO] = xListe(p, keyO).slice(); p.xpos[keyO][o.i] = zahl(ziel.x);
        p.wahl[keyO] = wahlListe(p, keyO).slice(); p.wahl[keyO][o.i] = wahlListe(nzq, keyO)[o.i];
        if (fehlerTexte(p, daten).length <= fehlerTexte(q, daten).length) q = p;
      });
      items(q, daten, w, 'oben').filter(function (o) { return !istEck(o.m) && schwebt(q, w, o); })
        .sort(function (a, b) { return b.i - a.i; }).forEach(function (o) {
          var p = kopie(q);
          raus(p, keyO, o.i);
          if (fehlerTexte(p, daten).length <= fehlerTexte(q, daten).length) { q = p; mit.push(o.m.code); }
        });
      return q;
    };
    if (t[1] === 'boden') {
      var nz = obenNachziehen(basis, neu, daten, wand, function (a) { return a === i ? null : (a > i ? a - 1 : a); });
      if (nz && fehlerTexte(nz, daten).length <= fehlerTexte(neu, daten).length) neu = nz;
      else neu = einzeln(neu, nz, wand);
      /* Auch die Nachbarwaende: ist dort eine Ecke frei geworden, rueckt deren Bodenreihe nach
         (sie lehnt sich an ihr Ende), und ihre Haengeschraenke muessen mit. */
      waende(z).forEach(function (nw) {
        if (nw.id === wand) return;
        var nz2 = obenNachziehen(basis, neu, daten, nw.id, null);
        if (nz2 && fehlerTexte(nz2, daten).length <= fehlerTexte(neu, daten).length) neu = nz2;
        else neu = einzeln(neu, nz2, nw.id);
      });
      /* Seit die Pruefung den Haengeschrank im Hochschrank sieht (2026-09-27), kann Nachziehen UND Stehenbleiben einen
         Fehler bringen: stehen geblieben haengt er im Hochschrank, der unter ihn rueckt; nachgezogen stoesst er an einen
         anderen oder ragt ueber das Wandende (Grosstest mit Fenstern: 4 Faelle). Bleibt mehr Fehler als vor dem Entfernen,
         geht der Haengeschrank mit, dessen Weggang am meisten behebt — bei Gleichstand zuerst einer, der ueber keinem
         Unterschrank mehr haengt, dann der, der am wenigsten genau ueber EINEM Unterschrank sitzt (ein G30 buendig ueber
         seinem D30 bleibt, der G45 ueber halb D30, halb Ecke geht). Hoechstens vier; `mitEntfernt` nennt sie. */
      var vorher = fehlerTexte(z, daten).length;
      var bindung = function (q, w2, o) {
        return items(q, daten, w2, 'boden').filter(function (u) { return u.m.reihe !== 'voll'; }).reduce(function (mx, u) {
          return Math.max(mx, Math.max(0, Math.min(o.x + o.b, u.x + u.b) - Math.max(o.x, u.x)) / o.b);
        }, 0);
      };
      for (var runde = 0; runde < 4 && fehlerTexte(neu, daten).length > vorher; runde++) {
        var jetzt = fehlerTexte(neu, daten).length, bester = null;
        waende(neu).forEach(function (w2) {
          items(neu, daten, w2.id, 'oben').forEach(function (o) {
            if (istEck(o.m)) return;
            var p = kopie(neu);
            raus(p, w2.id + '|oben', o.i);
            var n2 = fehlerTexte(p, daten).length;
            if (n2 >= jetzt) return;
            var k = { p: p, n: n2, frei: schwebt(neu, w2.id, o), bind: bindung(neu, w2.id, o), code: o.m.code };
            if (!bester || k.n < bester.n || (k.n === bester.n && (k.frei !== bester.frei ? k.frei : k.bind < bester.bind - 0.01))) bester = k;
          });
        });
        if (!bester) break;
        neu = bester.p; mit.push(bester.code);
      }
    }
    return { plan: neu.plan, hoff: neu.hoff, xpos: neu.xpos, wahl: neu.wahl, mitEntfernt: mit };
  }

  /* ---------- Eigener Geschirrspueler (Planer-App, Betreiber 2026-09-26) ----------

     „Und wenn der Kunde schon einen Geschirrspueler hat und keine Front braucht?" Ein Geraet mit
     eigener Tuer (Unterbau- oder Standgeraet) braucht nur die Nische. Aus der Geschirrspuelerfront
     an `sel` wird deshalb ein STELLPLATZ genau ihres Intervalls: die Front faellt aus Plan und
     Summe, der Stellplatz haelt die Luecke (items() fliesst um ihn herum, kein Nachbar rueckt),
     die Platte laeuft darueber, der Sockel endet an ihm. Die Haengeschraenke darueber bleiben —
     dort steht ja weiterhin ein Geraet. Gesperrt, wenn die Pruefung danach mehr Fehler zaehlt.

     Rueckgabe: { plan, hoff, xpos, wahl, merkmale, mid, id } oder { fehler } / { sperre }. */
  function planKopie(z) {
    var c = {}, k;
    for (k in z) { if (Object.prototype.hasOwnProperty.call(z, k)) c[k] = z[k]; }
    ['plan', 'hoff', 'xpos', 'wahl'].forEach(function (f) {
      var src = z[f] || {}, dst = {};
      Object.keys(src).forEach(function (k2) { dst[k2] = (src[k2] || []).slice(); });
      c[f] = dst;
    });
    c.merkmale = (z.merkmale || []).slice();
    return c;
  }
  /* Welche Moebel zu welchem Stellplatz werden: die Geschirrspuelerfront zur niedrigen Nische, der
     Kuehlumbau (2026-09-26) zur raumhohen fuer den freistehenden Kuehlschrank. */
  var STELL_VON = { geschirrspuelerfront: 'spueler', kuehlumbau: 'kuehl' };
  /* `hochAlsKuehl`: auch ein Vorrats-Hochschrank wird zur Kuehlschrank-Nische — nur fuer die Startkueche,
     deren Platzhalter in einer Farbe ohne Kuehlumbau ein 60er Hochschrank ist. */
  function stellplatzStatt(z, daten, sel, hochAlsKuehl) {
    var t = String(sel || '').split('|');
    if (!daten || t.length < 3 || t[1] !== 'boden') return { fehler: 'Kein Geschirrspüler gewählt.' };
    var wand = t[0], key = wand + '|boden', i = +t[2];
    var m = daten.modelle[((z.plan || {})[key] || [])[i]];
    var typ = m && (STELL_VON[m.funktion] || (hochAlsKuehl && m.funktion === 'hochschrank' ? 'kuehl' : null));
    if (!typ) return { fehler: 'Kein Geschirrspüler gewählt.' };
    var it = items(z, daten, wand, 'boden').filter(function (x) { return x.i === i; })[0];
    if (!it) return { fehler: typ === 'kuehl' ? 'Kein Kühlschrank gewählt.' : 'Kein Geschirrspüler gewählt.' };
    var neu = planKopie(z);
    neu.plan[key] = neu.plan[key].slice(); neu.hoff[key] = offListe(z, key);
    neu.xpos[key] = xListe(z, key); neu.wahl[key] = wahlListe(z, key);
    ['plan', 'hoff', 'xpos', 'wahl'].forEach(function (f) { neu[f][key].splice(i, 1); });
    /* Was JENSEITS der Nische steht (vom Anfang des Flusses aus gesehen), bekommt seine Stelle fest.
       Sonst spraenge es beim naechsten Entfernen ueber die Nische auf die andere Seite, und die
       Haengeschraenke blieben ueber dem leeren Ende (Grosstest 2026-09-26, 5 Faelle). Die Seite am
       Anfang fliesst weiter wie bisher. `vonFront` sagt ausStellplatz, dass es diese Stellen wieder
       loesen darf. */
    var raum = raumGeometrie(z), iv = nutzIntervall(z, daten, wand, 'boden');
    var rechts = lehntRechts(raum, wand, iv, eckPlaetze(z, daten, raum, wand, 'boden'), wandObj(z, wand).len);
    items(z, daten, wand, 'boden').forEach(function (x) {
      if (x.i === i || x.eckseite || x.frei) return;
      if (rechts ? x.x < it.x : x.x > it.x) neu.xpos[key][x.i > i ? x.i - 1 : x.i] = zahl(x.x);
    });
    var id = Math.max(+z.mid || 1, 1 + (z.merkmale || []).reduce(function (a, x) { return Math.max(a, +x.id || 0); }, 0));
    neu.merkmale.push({ id: id, typ: typ, wand: wand, x: zahl(it.x), breite: zahl(it.b),
      hoehe: typ === 'kuehl' ? geo(daten).hochschrank_hoehe : geo(daten).korpus_hoehe, vonFront: true });
    neu.mid = id + 1;
    if (fehlerTexte(neu, daten).length > fehlerTexte(z, daten).length) {
      return { sperre: typ === 'kuehl' ? 'Hier lässt sich kein eigener Kühlschrank einplanen.'
        : 'Hier lässt sich der Geschirrspüler nicht ohne Front einplanen.' };
    }
    return { plan: neu.plan, hoff: neu.hoff, xpos: neu.xpos, wahl: neu.wahl, merkmale: neu.merkmale, mid: neu.mid, id: id };
  }

  /* Der Weg zurueck: aus dem Stellplatz `id` wird wieder ein Unterschrank — eine Geschirrspueler-
     front oder ein Schrank derselben Breite (Modell `mi`, Wahl `wahl`) — genau an seiner Stelle.
     Eingefuegt wird an der Position, die der Fluss an diese Stelle bringt; landet er anderswo
     (ein frei gesetzter Stellplatz aus dem alten Planer), haelt ihn eine feste Stelle. */
  function ausStellplatz(z, daten, id, mi, wahl) {
    var mk = (z.merkmale || []).filter(function (x) { return String(x.id) === String(id); })[0];
    var m = daten && daten.modelle[mi];
    if (!mk || !m || !MT[mk.typ] || !MT[mk.typ].stellplatz) return { fehler: 'Kein Stellplatz gewählt.' };
    if (Math.abs(nennMass(m) - mk.breite) > 0.5) return { sperre: 'Der Schrank ist anders breit als die Nische.' };
    var key = mk.wand + '|boden';
    /* Die Stelle in der PLANLISTE: gleich hinter dem letzten fliessenden Schrank links der Nische.
       Nicht „wie viele liegen links" — ein Eckschrank am Wandende steht oft vorn in der Liste
       (Velora-L: D90N ist Nummer 0 und steht bei 270). */
    var its = items(z, daten, mk.wand, 'boden').filter(function (x) { return !x.eckseite && !x.frei; });
    var links = its.filter(function (x) { return x.x < mk.x - 0.05; }).map(function (x) { return x.i; });
    var rechts = its.filter(function (x) { return x.x >= mk.x - 0.05; }).map(function (x) { return x.i; });
    /* Steht die Nische vorn und ist alles dahinter fest (stellplatzStatt hat es so gesetzt), dann vor den
       ersten Schrank rechts von ihr — nicht ans Listenende. Sonst ergab „zurueck" beim Kuehlschrank am
       Wandanfang eine andere Liste (Netz 2026-09-26: 84 Faelle). */
    var alleRechts = items(z, daten, mk.wand, 'boden').filter(function (x) { return !x.eckseite && x.x >= mk.x - 0.05; })
      .map(function (x) { return x.i; });
    var k = links.length ? Math.max.apply(null, links) + 1
      : (rechts.length ? Math.min.apply(null, rechts)
        : (alleRechts.length ? Math.min.apply(null, alleRechts) : ((z.plan || {})[key] || []).length));
    var neu = planKopie(z);
    neu.merkmale = neu.merkmale.filter(function (x) { return x !== mk; });
    neu.plan[key] = ((z.plan || {})[key] || []).slice(); neu.hoff[key] = offListe(z, key);
    neu.xpos[key] = xListe(z, key); neu.wahl[key] = wahlListe(z, key);
    neu.plan[key].splice(k, 0, mi); neu.hoff[key].splice(k, 0, 0);
    neu.xpos[key].splice(k, 0, null); neu.wahl[key].splice(k, 0, wahl == null ? null : wahl);
    var da = items(neu, daten, mk.wand, 'boden').filter(function (x) { return x.i === k; })[0];
    if (!da || Math.abs(da.x - mk.x) > 0.05) neu.xpos[key][k] = zahl(mk.x);
    /* Die festen Stellen, die stellplatzStatt gesetzt hat, werden wieder geloest — aber nur, wo der
       Fluss den Schrank ohnehin an dieselbe Stelle bringt. So ergibt „zurueck" dieselbe Kueche wie
       vorher, und nichts rueckt. */
    if (mk.vonFront) {
      neu.xpos[key].forEach(function (xp, j) {
        if (xp == null || j === k) return;
        var vorher = items(neu, daten, mk.wand, 'boden');
        var probe = planKopie(neu); probe.xpos[key] = neu.xpos[key].slice(); probe.xpos[key][j] = null;
        var nach = items(probe, daten, mk.wand, 'boden');
        var gleich = vorher.every(function (a) {
          var b = nach.filter(function (q) { return q.i === a.i; })[0];
          return b && Math.abs(b.x - a.x) < 0.05;
        });
        if (gleich) neu.xpos[key][j] = null;
      });
    }
    if (fehlerTexte(neu, daten).length > fehlerTexte(z, daten).length) {
      return { sperre: 'An dieser Stelle passt dieser Schrank nicht.' };
    }
    return { plan: neu.plan, hoff: neu.hoff, xpos: neu.xpos, wahl: neu.wahl, merkmale: neu.merkmale, mid: z.mid, i: k };
  }

  /* ---------- Wo gekocht wird (2026-09-27) ----------

     Das Kochfeld ist keine Ware, aber Kochfeld, Haube und der flache Schrank darueber muessen an
     DERSELBEN Stelle stehen. Bisher hiess das „auf dem Herdumbau" — mit einem hohen Backofen-
     schrank (Betreiber: „vergiss den hohen Backofenschrank nicht") steht der Ofen aber im
     Hochschrank, und gekocht wird auf dem Schubladenschrank daneben, wie in den Livaro-
     Komplettkuechen. Eine Quelle fuer 3D, Deko, Haube und Startkueche:
       1. jeder Herdumbau / Backofen-Unterschrank dieser Wand;
       2. gibt es in der ganzen Kueche keinen, und steht auf dieser Wand ein Backofen-Hochschrank:
          der Unterschrank daneben (Schubladen zuerst; nie Spuele, Geschirrspueler, Ecke). */
  function kochstellen(z, daten, wand) {
    if (!daten) return [];
    var herdRe = /herdumbau|geraete_unterschrank/;
    var raum = raumGeometrie(z), alle = raum.waende.concat(raum.bloecke).filter(function (w) { return w.planbar !== false; });
    var herde = items(z, daten, wand, 'boden').filter(function (it) { return herdRe.test(it.m.funktion || ''); });
    if (herde.length) return herde;
    var irgendwo = alle.some(function (w) {
      return items(z, daten, w.id, 'boden').some(function (it) { return herdRe.test(it.m.funktion || ''); });
    });
    if (irgendwo) return [];
    /* Ohne Herdumbau, mit Backofen-Hochschrank: EINE Kochstelle fuer die ganze Kueche — zuerst neben
       dem Hochschrank, sonst (der Kunde hat den Schrank daneben entfernt) auf dem naechsten
       geeigneten Unterschrank irgendeiner Wand, nie auf der Insel. Gerechnet ueber die ganze
       Kueche, damit jede Wand dieselbe Antwort bekommt (Grosstest 2026-09-27: 137 Kuechen mit
       Backofen und ohne Kochfeld). */
    var hohe = [], kand = [];
    alle.forEach(function (w) {
      var insel = raum.bloecke.some(function (b) { return b.id === w.id; });
      items(z, daten, w.id, 'boden').forEach(function (it) {
        if (it.m.funktion === 'hochschrank_geraet') hohe.push({ w: w.id, it: it });
        else if (!insel && it.m.reihe !== 'voll' && !istEck(it.m) && it.b >= 45
          && !/spuelen|geschirrspueler|apotheker/.test(it.m.funktion || '')) kand.push({ w: w.id, it: it });
      });
    });
    if (!hohe.length || !kand.length) return [];
    var abst = function (k) {
      return Math.min.apply(null, hohe.map(function (h) {
        if (h.w !== k.w) return 1e6;
        return Math.min(Math.abs(k.it.x + k.it.b - h.it.x), Math.abs(h.it.x + h.it.b - k.it.x));
      }));
    };
    var schubRang = function (k) { return /schub/.test(k.it.m.funktion || '') || /S\d/.test(k.it.m.code) ? 0 : 1; };
    kand.sort(function (a, b) {
      return abst(a) - abst(b) || schubRang(a) - schubRang(b) || ORD.indexOf(a.w) - ORD.indexOf(b.w) || a.it.x - b.it.x;
    });
    return kand[0].w === wand ? [kand[0].it] : [];
  }

  /* ---------- Planungs-Check (Planer-App 2026-09-26) ----------

     Nach dem Vergleich mit ROYAL24 („Check 4/4"): die Faustregeln der Kuechenplanung als Punkte, die der
     Kunde versteht. Kein Fehler im Sinne der Pruefung (das bleibt fehlerTexte) — ein Urteil ueber die
     Ergonomie. Nur Punkte, die fuer DIESE Kueche gelten: ohne Geschirrspueler kein Punkt dazu.
     Rueckgabe: [{ id, ok, titel, text }]. */
  function planungsCheck(z, daten) {
    if (!daten) return [];
    var raum = raumGeometrie(z), bl = {};
    (raum.bloecke || []).forEach(function (b) { bl[b.id] = 1; });
    var HEISS = /herdumbau|geraete_unterschrank|hochschrank_geraet/;
    var nischen = aktiveMerkmale(z).filter(function (m) { return MT[m.typ] && MT[m.typ].stellplatz; });
    /* Je Wand eine Reihe aus Schraenken und Nischen, nach x. `hoch` = Hochschrank oder raumhohe Nische. */
    var reihen = {}, alle = [];
    waende(z).forEach(function (w) {
      var koch = kochstellen(z, daten, w.id).map(function (it) { return it.i; });
      var r = items(z, daten, w.id, 'boden').map(function (it) {
        var f = it.m.funktion || '', k = koch.indexOf(it.i) > -1;
        return { w: w.id, x: it.x, b: it.b, hoch: it.m.reihe === 'voll', spuele: f === 'spuelen_unterschrank', koch: k,
          gs: f === 'geschirrspuelerfront', kuehl: f === 'kuehlumbau', heiss: k || HEISS.test(f), ofenHoch: f === 'hochschrank_geraet',
          eck: istEck(it.m) };
      });
      nischen.filter(function (m) { return m.wand === w.id; }).forEach(function (m) {
        var e = elementIntervallAufWand(m);
        if (e.laenge > 0) r.push({ w: w.id, x: e.start, b: e.laenge, hoch: !!MT[m.typ].hoch, gs: m.typ === 'spueler', kuehl: m.typ === 'kuehl' });
      });
      r.sort(function (a, b) { return a.x - b.x; });
      reihen[w.id] = r;
      alle = alle.concat(r);
    });
    if (!alle.length) return [];
    var out = [], cm = function (x) { return Math.round(x) + ' cm'; };
    /* Stoesst an: die 59,6er Geschirrspuelerfront laesst 4 mm Luft. */
    var dicht = function (a, b) { return a.w === b.w && (Math.abs(a.x + a.b - b.x) < 1.5 || Math.abs(b.x + b.b - a.x) < 1.5); };
    /* Freie Flaeche neben e in eine Richtung: Schraenke unter der Platte, lueckenlos, bis zu einem
       Hochschrank, einer raumhohen Nische oder dem Ende der Reihe. */
    var seite = function (e, dir) {
      var summe = 0, cur = e, grenze = 'Ende der Reihe', block = null;
      for (;;) {
        var n = reihen[e.w].filter(function (o) {
          return o !== cur && (dir < 0 ? Math.abs(o.x + o.b - cur.x) < 1.5 : Math.abs(cur.x + cur.b - o.x) < 1.5);
        })[0];
        if (!n) break;
        if (n.hoch) { grenze = 'Hochschrank'; block = n; break; }
        summe += n.b; cur = n;
      }
      /* DIE ECKE ZAEHLT MIT (Betreiber 2026-09-29: „لا اريد ان تظهر هذه الرسالة" — L mit Backofen-Hochschrank: „Links
         Hochschrank · rechts 40 cm"). Die eigene Eckschrank-Platte stand schon in der Reihe; die des Eckschranks der
         NACHBARWAND fehlte, obwohl die Platte dort ohne Unterbrechung weiterlaeuft. So meldete die Startkueche selbst in
         der Haelfte aller L-Kuechen zu wenig Abstellflaeche (172 von 352, Probe hochseite/diag-abstell.js). */
      if (!block) {
        var eb = eckBelegung(z, daten, e.w, 'boden'), iv = nutzIntervall(z, daten, e.w, 'boden');
        if (dir < 0 && eb.anfang && Math.abs(cur.x - iv.start) < 1.5) summe += eb.anfang.cm;
        if (dir > 0 && eb.ende && Math.abs(cur.x + cur.b - iv.ende) < 1.5) summe += eb.ende.cm;
      }
      return { text: summe ? cm(summe) : grenze, cm: Math.round(summe), ofenDaneben: !summe && !!block && !!block.ofenHoch };
    };
    var spuele = alle.filter(function (e) { return e.spuele; })[0];
    var koch = alle.filter(function (e) { return e.koch; })[0];
    if (spuele && koch) {
      if (spuele.w === koch.w) {
        var li = spuele.x < koch.x ? spuele : koch, re = li === spuele ? koch : spuele;
        var dazw = reihen[li.w].some(function (o) { return o.hoch && o.x >= li.x + li.b - 1 && o.x + o.b <= re.x + 1; });
        var frei0 = Math.round(Math.max(0, re.x - (li.x + li.b)));
        out.push({ id: 'spuele-koch', ok: !dazw && frei0 >= 60, titel: 'Arbeitsfläche zwischen Spüle und Kochfeld: ' + cm(frei0),
          text: dazw ? 'Dazwischen steht ein Hochschrank – die Arbeitsfläche ist unterbrochen.'
            : (frei0 >= 60 ? 'Genug Platz zum Schneiden und Vorbereiten.' : 'Zum Vorbereiten sind mindestens 60 cm gut.') });
      } else {
        out.push({ id: 'spuele-koch', ok: true, titel: 'Spüle und Kochfeld an verschiedenen Seiten',
          text: 'Kurze Wege – die Arbeitsfläche dazwischen bleibt frei.' });
      }
    }
    var gsE = alle.filter(function (e) { return e.gs; });
    if (gsE.length && spuele) {
      var neben = gsE.some(function (g) { return alle.some(function (s) { return s.spuele && dicht(g, s); }); });
      /* UEBER ECK (Betreiber 2026-09-29: „اخفيه"): Spuele und Geschirrspueler stehen je direkt an derselben Ecke — dazwischen nur
         der Eckschrank. So plant ein Kuechenstudio, wenn die Wand fuer beide zu kurz ist (kleine L-Kueche mit gewaehlter Seite,
         Wasseranschluss an der kurzen Wand); die Wege bleiben kurz. */
      var anDerEcke = function (e, ende) {
        var iv = nutzIntervall(z, daten, e.w, 'boden'), eigen = reihen[e.w].filter(function (o) { return o.eck; });
        if (ende === 'anfang') {
          var gA = iv.start;
          eigen.forEach(function (o) { if (o.x <= iv.start + 1.5) gA = Math.max(gA, o.x + o.b); });
          return Math.abs(e.x - gA) < 1.5;
        }
        var gE = iv.ende;
        eigen.forEach(function (o) { if (o.x + o.b >= iv.ende - 1.5) gE = Math.min(gE, o.x); });
        return Math.abs(e.x + e.b - gE) < 1.5;
      };
      var eckenR = geometrischeEcken(raum);
      var ueberEck = !neben && gsE.some(function (g) {
        return alle.some(function (sp) {
          return sp.spuele && sp.w !== g.w && eckenR.some(function (ec) {
            return ec.enden[sp.w] && ec.enden[g.w] && anDerEcke(sp, ec.enden[sp.w]) && anDerEcke(g, ec.enden[g.w]);
          });
        });
      });
      out.push({ id: 'gs-spuele', ok: neben || ueberEck,
        titel: neben ? 'Geschirrspüler direkt neben der Spüle' : (ueberEck ? 'Geschirrspüler über Eck neben der Spüle' : 'Geschirrspüler nicht neben der Spüle'),
        text: neben ? 'Kurze Wasser- und Abwasserwege.' : (ueberEck ? 'Kurze Wege über die Ecke.'
          : 'Wasser- und Abwasserwege werden lang – besser direkt neben die Spüle.') });
    }
    if (koch) {
      var l = seite(koch, -1), r = seite(koch, 1);
      var okA = (l.cm >= 30 && r.cm >= 30) || Math.max(l.cm, r.cm) >= 60;
      var pA = { id: 'abstell-koch', ok: okA, titel: 'Abstellfläche neben dem Kochfeld',
        text: 'Links ' + l.text + ' · rechts ' + r.text + '.' + (okA ? '' : ' Üblich sind auf beiden Seiten mindestens 30 cm.') };
      /* Steht der Backofen-Hochschrank direkt daneben, hilft der Backofen unter dem Kochfeld (Betreiber
         2026-09-26: als Knopf — der Kunde entscheidet, nichts aendert sich von selbst). */
      if (!okA && (l.ofenDaneben || r.ofenDaneben)) pA.aktion = 'ofen-unten';
      out.push(pA);
    }
    var ku = alle.filter(function (e) { return e.kuehl; });
    if (ku.length) {
      /* Neben dem Backofen-HOCHSCHRANK ist kein Hinweis (Betreiber 2026-09-29: „اخفيه" — der Kunde stellt beide auf eine Seite;
         die Seitenwaende der Hochschraenke stehen dazwischen). Kochfeld und Backofen unter dem Kochfeld zaehlen weiter. */
      var heissNeben = ku.some(function (k) { return alle.some(function (o) { return o.heiss && !o.ofenHoch && dicht(k, o); }); });
      var ofenNeben = !heissNeben && ku.some(function (k) { return alle.some(function (o) { return o.ofenHoch && dicht(k, o); }); });
      out.push({ id: 'kuehl-hitze', ok: !heissNeben, titel: 'Kühlschrank weg von Hitzequellen',
        text: heissNeben ? 'Er steht direkt neben Backofen oder Kochfeld – das kostet Energie.'
          : (ofenNeben ? 'Nicht direkt neben dem Kochfeld.' : 'Nicht direkt neben Backofen oder Kochfeld.') });
    }
    /* Gerundet: zwei Geschirrspuelerfronten zu 59,6 sind fuer den Kunden 120 cm, nicht „unter 120". */
    var frei = Math.round(alle.filter(function (e) { return !e.hoch && !e.spuele && !e.koch; }).reduce(function (a, e) { return a + e.b; }, 0));
    out.push({ id: 'frei', ok: frei >= 120, titel: 'Freie Arbeitsfläche: ' + cm(frei),
      text: frei >= 120 ? 'Ausreichend für Vorbereiten und Abstellen.' : 'Für bequemes Arbeiten sind 120 cm gut.' });
    var gang = z.form === 'zweizeilig' ? (+z.B || 0) - 2 * platteTiefe() : (bl.I ? inselGang(z) : null);
    if (gang != null) {
      out.push({ id: 'gang', ok: gang >= 100, titel: (z.form === 'zweizeilig' ? 'Durchgang zwischen den Zeilen: ' : 'Durchgang zur Insel: ') + cm(gang),
        text: gang >= 100 ? 'Bequem – auch mit offenen Türen.' : 'Bequem sind 100 cm, für zwei Personen 120 cm.' });
    }

    /* STUFE 2 (2026-09-27): was der Kunde im Raum eingetragen hat — Wasseranschluss, Fenster, Tuer. Nur fuer
       Waende mit Schraenken; ohne Eintrag kein Punkt. */
    var mkA = aktiveMerkmale(z).filter(function (m) { return reihen[m.wand] && reihen[m.wand].length; });
    var wasserM = mkA.filter(function (m) { return m.typ === 'wasser'; })[0] || mkA.filter(function (m) { return m.typ === 'abfluss'; })[0];
    if (wasserM) {
      var spW = reihen[wasserM.wand].filter(function (e) { return e.spuele; });
      var abW = spW.length ? Math.round(Math.min.apply(null, spW.map(function (e) {
        return wasserM.x < e.x ? e.x - wasserM.x : (wasserM.x > e.x + e.b ? wasserM.x - (e.x + e.b) : 0);
      }))) : null;
      var tolW = MT[wasserM.typ].tol;
      out.push({ id: 'wasser', ok: abW !== null && abW <= tolW,
        titel: abW === null ? 'Keine Spüle an der Wand mit dem Wasseranschluss' : (abW === 0 ? 'Spüle über dem Wasseranschluss' : 'Spüle ' + cm(abW) + ' neben dem Wasseranschluss'),
        text: abW === null ? 'Die Spüle gehört an die Wand, an der Wasser und Abfluss liegen.'
          : (abW === 0 ? 'Zu- und Ablauf liegen direkt hinter dem Spülenschrank.'
            : (abW <= tolW ? 'Bis ' + tolW + ' cm lässt sich die Leitung verlängern.' : 'Die Leitung muss verlegt werden – das macht ein Installateur.')) });
    }
    var fensterM = mkA.filter(function (m) { return m.typ === 'fenster'; });
    if (fensterM.length) {
      var unterF = function (e) {
        return fensterM.filter(function (f) { return f.wand === e.w && Math.min(e.x + e.b, f.x + f.breite) - Math.max(e.x, f.x) > 0.5; })[0];
      };
      var kochF = alle.filter(function (e) { return e.koch && unterF(e); })[0];
      var spF = alle.filter(function (e) {
        return e.spuele && fensterM.some(function (f) { return f.wand === e.w && e.x + e.b / 2 >= f.x && e.x + e.b / 2 <= f.x + f.breite; });
      })[0];
      var fSp = spF && fensterM.filter(function (f) { return f.wand === spF.w && spF.x + spF.b / 2 >= f.x && spF.x + spF.b / 2 <= f.x + f.breite; })[0];
      /* Unter einer niedrigen Fensterbank stoesst die Armatur an den Fensterfluegel. */
      var niedrig = fSp && +fSp.hoehe < arbeitsHoehe(daten, z) + 30;
      out.push({ id: 'fenster', ok: !kochF,
        titel: kochF ? 'Kochfeld unter dem Fenster' : (spF ? 'Spüle unter dem Fenster' : 'Kochfeld nicht unter dem Fenster'),
        text: kochF ? 'Über das Kochfeld gehört eine Dunstabzugshaube, und am Fenster schlagen sich Dampf und Fett nieder. Besser an eine Stelle ohne Fenster.'
          : (spF ? 'Tageslicht beim Spülen – vor dem Fenster hängt kein Schrank.'
            + (niedrig ? ' Bei dieser Fensterbank eine Vorfensterarmatur wählen: sie klappt zum Öffnen des Fensters weg.' : '')
            : 'Vor dem Fenster hängt kein Schrank.') });
    }
    var tuerM = aktiveMerkmale(z).filter(function (m) { return m.typ === 'tuer'; });
    if (tuerM.length) {
      /* Frei heisst: auf der eigenen Wand nichts im Fluegel (plus 5 cm) — und auf der Nachbarwand keine Reihe, die
         bis in die Ecke laeuft, wenn die Tuer naeher als eine Plattentiefe an dieser Ecke liegt. */
      var tief = platteTiefe() + 5, raumT = raumGeometrie(z), vor = null;
      tuerM.forEach(function (t) {
        var iv = elementIntervallAufWand(t);
        ['boden', 'oben', 'aufsatz'].forEach(function (zl) {
          if (!vor && items(z, daten, t.wand, zl).some(function (it) { return ueber(it.x, it.x + it.b, iv.start - 5, iv.ende + 5); })) vor = t;
        });
        geometrischeEcken(raumT).forEach(function (e) {
          if (vor || (e.a !== t.wand && e.b !== t.wand)) return;
          var n = e.a === t.wand ? e.b : e.a, tl = wandObj(z, t.wand).len, nl = wandObj(z, n).len;
          var nah = e.enden[t.wand] === 'anfang' ? iv.start - 5 < tief : iv.ende + 5 > tl - tief;
          if (!nah) return;
          var zone = e.enden[n] === 'anfang' ? [0, tief] : [nl - tief, nl];
          ['boden', 'oben'].forEach(function (zl) {
            if (!vor && items(z, daten, n, zl).some(function (it) { return ueber(it.x, it.x + it.b, zone[0], zone[1]); })) vor = t;
          });
        });
      });
      out.push({ id: 'tuer', ok: !vor, titel: vor ? 'Ein Schrank steht vor der Tür' : 'Tür geht frei auf',
        text: vor ? 'Der Türflügel braucht die volle Breite plus 5 cm – auch an der Ecke zur Nachbarwand.'
          : 'Vor der Tür steht kein Schrank – der Flügel geht frei auf.' });
    }
    return out;
  }

  /* ---------- Fenster, Tuer und Wasser an einer Wand (Stufe 2, 2026-09-27) ----------

     Was die Schrankreihe einer Wand unterbricht oder lenkt — aus den Merkmalen, die der Kunde im Raum
     eintraegt. Dieselben Regeln wie sperrZonen und die Pruefung, nur fuer die ganze Reihe auf einmal:
       boden    hier steht kein Unterschrank: die Tuer mit 5 cm Luft je Seite, ein Fenster, dessen
                Bruestung unter der Arbeitshoehe liegt (Pruefung: „passt dort nicht unter das Fenster"),
                ein Heizkoerper — und die Tuer der NACHBARWAND, wenn sie naeher als eine Plattentiefe an
                der gemeinsamen Ecke liegt: die Reihe dieser Wand stuende sonst vor ihrem Fluegel. Die
                Pruefung sieht das nicht (sie kennt Tueren nur auf ihrer eigenen Wand), das Bild schon.
       hoch     hier steht kein Hochschrank: alles aus `boden` und jedes Fenster, das in seine Hoehe reicht.
       fenster  die Fenster dieser Wand, { a, b, unter } — `unter`: die Arbeitsplatte laeuft darunter durch.
       wasser   die Stelle des Wasseranschlusses (ohne ihn: des Abflusses) oder null.
     Leer, wenn der Kunde an dieser Wand nichts davon eingetragen hat. */
  function bauZonen(s, daten, wand) {
    var out = { boden: [], hoch: [], fenster: [], wasser: null };
    /* Arbeitshoehe bewusst ohne Plattenwahl (siehe plattenDicke): die Startkueche haengt nicht an der Platte. */
    var g = geo(daten), RH = +s.hoehe || 250, arbeit = arbeitsHoehe(daten);
    var mk = aktiveMerkmale(s);
    mk.filter(function (m) { return m.wand === wand; }).forEach(function (m) {
      var iv = elementIntervallAufWand(m);
      if (m.typ === 'tuer') {
        out.boden.push({ a: iv.start - 5, b: iv.ende + 5, was: 'Tür' });
      } else if (m.typ === 'fenster') {
        var f = fensterOeffnung(m, RH), unter = +m.hoehe >= arbeit;
        out.fenster.push({ a: iv.start, b: iv.ende, unter: unter });
        if (!unter) out.boden.push({ a: iv.start, b: iv.ende, was: 'Fenster' });
        else if (ueber(0, g.hochschrank_hoehe, f.unten, f.oben)) out.hoch.push({ a: iv.start, b: iv.ende, was: 'Fenster' });
      } else if (m.typ === 'heizkoerper') {
        out.boden.push({ a: iv.start, b: iv.ende, was: 'Heizkörper' });
      }
    });
    var wa = mk.filter(function (m) { return m.wand === wand && m.typ === 'wasser'; })[0]
      || mk.filter(function (m) { return m.wand === wand && m.typ === 'abfluss'; })[0];
    if (wa) out.wasser = +wa.x;
    /* Die Tuer der Nachbarwand an der gemeinsamen Ecke. */
    var tief = platteTiefe() + 5, len = wandObj(s, wand).len;
    geometrischeEcken(raumGeometrie(s)).forEach(function (e) {
      if (e.a !== wand && e.b !== wand) return;
      var n = e.a === wand ? e.b : e.a, nLen = wandObj(s, n).len;
      var nah = mk.some(function (m) {
        if (m.wand !== n || m.typ !== 'tuer') return false;
        var iv = elementIntervallAufWand(m);
        return e.enden[n] === 'anfang' ? iv.start - 5 < tief : iv.ende + 5 > nLen - tief;
      });
      if (nah) out.boden.push(e.enden[wand] === 'anfang' ? { a: 0, b: tief, was: 'Tür' } : { a: len - tief, b: len, was: 'Tür' });
    });
    out.hoch = out.hoch.concat(out.boden);
    return out;
  }
  function bauDa(bz) { return !!bz && (bz.boden.length > 0 || bz.hoch.length > 0 || bz.fenster.length > 0 || bz.wasser != null); }

  /* ---------- Sichtbare Luecken ----------

     Betreiber 2026-09-28, Bild einer U-Kueche 310/350/310: „انظر لهذا الفراغ — اصلح المشكلة من الجذور لانها تكررت اكثر من
     مرة". Zwischen Geschirrspuelerfront und Eckschrank standen 5,4 cm frei, darueber dieselbe Luecke in der Haengereihe.
     Bis hierher galt ein Rest als unvermeidlich, sobald kein Schrank mehr hineinpasste (ecc4f68), und WO er lag, fragte
     niemand: die Hauptwand einer U-Kueche ist an BEIDEN Enden zu — dort steht er zwischen Schraenken. Gemessen ueber
     zufaellige Kuechen in 10-cm-Schritten: 13 % der U- und 14 % der U-Inselkuechen mit Luecke, alle anderen Formen ohne.

     Die EINE Definition, nach der die Startkueche waehlt und die Netze pruefen: eine Luecke ist jede freie Stelle einer
     Reihe, die nicht an einem offenen Ende liegt — zwischen zwei Schraenken, zwischen Schrank und Eckschrank der
     Nachbarwand, vor einer geschlossenen Wandseite. Am offenen Ende ist ein Rest harmlos: die Kueche ist dort kuerzer.
     Gewollt und deshalb keine Luecke: Tuer, Fenster unter der Arbeitshoehe, Heizkoerper, die Nischen fuer den eigenen
     Kuehlschrank und Geschirrspueler. Oben zaehlt nur, was ueber Unterschraenken (samt Eckschenkel der Nachbarwand) frei
     bleibt — nicht ueber dem Kochfeld (Haube), Fenstern, Hochschraenken und der Kuehlschranknische; Inseln haengen nichts.
     Rueckgabe: [{ wand, zeile: 'boden' | 'oben', von, bis, cm }]. */
  function sichtbareLuecken(s, daten) {
    var out = [];
    if (!daten) return out;
    var raum = raumGeometrie(s), block = {};
    (raum.bloecke || []).forEach(function (b) { block[b.id] = true; });
    var mk = aktiveMerkmale(s);
    /* Freie Stuecke von [von, bis] ohne die belegten Intervalle, jedes laenger als `min`. */
    var freiIn = function (belegt, von, bis, min) {
      var l = belegt.map(function (q) { return [Math.max(von, q[0]), Math.min(bis, q[1])]; })
        .filter(function (q) { return q[1] > q[0]; }).sort(function (p, q) { return p[0] - q[0]; });
      var frei = [], x = von;
      l.forEach(function (q) { if (q[0] > x + min) frei.push([x, q[0]]); x = Math.max(x, q[1]); });
      if (bis > x + min) frei.push([x, bis]);
      return frei;
    };
    wandAuswahl(s, 'schrank').forEach(function (w) {
      var id = w.id, wl = wandObj(s, id).len, its = items(s, daten, id, 'boden');
      var eb = eckBelegung(s, daten, id, 'boden');
      var nb = block[id] ? { amAnfang: null, amEnde: null } : wandNachbarn(raum, id);
      var eigenesEck = function (e) { return its.some(function (it) { return it.eckseite === e; }); };
      var zuA = !!eb.anfang || !!nb.amAnfang || eigenesEck('anfang');
      var zuE = !!eb.ende || !!nb.amEnde || eigenesEck('ende');
      var offen = function (q) { return (q[0] < 0.5 && !zuA) || (q[1] > wl - 0.5 && !zuE); };
      var bz = bauZonen(s, daten, id);
      var nischen = mk.filter(function (m) { return m.wand === id && (m.typ === 'kuehl' || m.typ === 'spueler'); })
        .map(function (m) { return [+m.x, +m.x + +m.breite]; });
      var belegt = its.map(function (it) { return [it.x, it.x + it.b]; }).concat(nischen,
        bz.boden.map(function (q) { return [q.a, q.b]; }));
      if (eb.anfang) belegt.push([0, eb.anfang.cm]);
      if (eb.ende) belegt.push([wl - eb.ende.cm, wl]);
      if (its.length || nischen.length) {
        freiIn(belegt, 0, wl, 0.5).forEach(function (q) {
          if (!offen(q)) out.push({ wand: id, zeile: 'boden', von: zahl(q[0]), bis: zahl(q[1]), cm: zahl(q[1] - q[0]) });
        });
      }
      if (block[id]) return;
      var ob = items(s, daten, id, 'oben');
      if (!ob.length) return;
      var unterbau = its.filter(function (it) { return it.m.reihe !== 'voll'; }).map(function (it) { return [it.x, it.x + it.b]; });
      if (eb.anfang) unterbau.push([0, eb.anfang.cm]);
      if (eb.ende) unterbau.push([wl - eb.ende.cm, wl]);
      var ebO = eckBelegung(s, daten, id, 'oben');
      var belegtO = ob.map(function (it) { return [it.x, it.x + it.b]; })
        .concat(its.filter(function (it) { return it.m.reihe === 'voll'; }).map(function (it) { return [it.x, it.x + it.b]; }))
        .concat(kochstellen(s, daten, id).map(function (o) { return [o.x, o.x + o.b]; }))
        .concat(mk.filter(function (m) { return m.wand === id && (m.typ === 'fenster' || m.typ === 'kuehl'); })
          .map(function (m) { return [+m.x, +m.x + +m.breite]; }))
        .concat(bz.hoch.map(function (q) { return [q.a, q.b]; }));
      if (ebO.anfang) belegtO.push([0, ebO.anfang.cm]);
      if (ebO.ende) belegtO.push([wl - ebO.ende.cm, wl]);
      freiIn(belegtO, 0, wl, 1).forEach(function (q) {
        if (offen(q)) return;
        /* Nur ueber Unterbau: wo unten nichts steht, haengt auch nichts. */
        var ueberUnten = unterbau.some(function (u) { return Math.min(u[1], q[1]) - Math.max(u[0], q[0]) > 1; });
        if (ueberUnten) out.push({ wand: id, zeile: 'oben', von: zahl(q[0]), bis: zahl(q[1]), cm: zahl(q[1] - q[0]) });
      });
    });
    return out;
  }
  function lueckenSumme(l) { return (l || []).reduce(function (a, q) { return a + q.cm; }, 0); }

  /* ---------- Die Startkueche ----------

     Wer zum ersten Mal Schraenke plant, stand vor einer leeren Wand und 18 Kuerzeln wie D60S3 —
     gemessen 2026-09-24 auf 375 px: erste Schrankkarte bei 1801 px, 49 Bedienelemente, und 20
     von 20 Kassenbesuchen waren Tests des Betreibers. Stattdessen steht eine vollstaendige Kueche
     da, die der Kunde aendert statt baut.

     Bis 2026-09-24 stand diese Rechnung in der Oberflaeche und kannte nur die Kuechenzeile. Sie
     steht jetzt HIER, damit die alte Planerseite, die App und das Netz dieselbe Kueche bekommen.

     Gesetzt wird AUSSCHLIESSLICH ueber `setzen` und nur mit Modellen, die `katalog` in der
     gewaehlten Farbe und Ausfuehrung anbietet — dieselben Wege wie beim Tippen auf „+". Meldet
     die Pruefung danach einen Fehler, wird zuerst die Haengereihe und dann alles verworfen:
     lieber eine leere Wand als ein Vorschlag, den der Server beim Bezahlen ablehnt.

     Die Formen:
       Zeile      Spuele, Geschirrspueler, Fueller, Herd, Schubladen — links nach rechts.
       L / U      in jede Ecke ein Eckschrank (auf Wand A), die Spuele auf A, Herd und Schubladen
                  auf der Wand danach — Schubladen zur Ecke hin, damit der Herd nicht in der Ecke
                  klemmt. Die dritte Wand der U-Kueche bekommt Unterschraenke.
       Zweizeilig Spuele auf A, Herd auf C.
       Insel      die Wand wie oben, die Insel Unterschraenke (Schubladen zuerst).
     Ist die zweite Wand zu kurz fuer den Herd, kommt alles auf A wie bei der Zeile.

     Rueckgabe: { wand, plan, hoff, xpos, wahl } oder null. Ob die Kueche uebernommen wird
     (nur bei leerem Plan, einmal je Planung), entscheidet der Aufrufer. */
  /* DOPPELINSEL: DIE ANDERE SEITE ZIEHT NACH (Betreiber 2026-09-28: „beim Aendern der Inselschraenke
     klappt es nicht" — getauscht wurde nur die angetippte Seite, 48 von 48 Taeuschen liessen die
     Insel ungleich zurueck, mit Absatz in der Platte und Spalt zwischen den Reihen).

     Die Reihe `nach` wird zum Spiegelbild der Reihe `von`: dieselben Breiten Ruecken an Ruecken,
     Fuge auf Fuge (x' = len − x − b). Geraeteschraenke (Spuele, Geschirrspueler, Herd-/Kuehlumbau)
     spiegeln sich NICHT als zweites Geraet: dort steht gegenueber ein schlichter Unterschrank
     derselben Breite — zwei Spuelen Ruecken an Ruecken wollte niemand.

     PAARE, KEIN SPALT (Betreiber 2026-09-26, Bild: ein Schubladenschrank stand einige Zentimeter
     neben dem Rest der Insel, mit eigenem Plattenstueck). Die Kuechenseite traegt feste Stellen
     (xpos); entfernte der Kunde dort einen Schrank, blieb ein Loch, das Spiegeln trug es auf die
     Raumseite, und ein schmalerer Schrank, der danach hineinkam, liess den Rest als Spalt stehen
     (Zufallssuche: 736 Spalte in 22 872 Kundenaktionen, alle auf der Doppelinsel, keiner einseitig).
     Ausserdem baute das Spiegeln die andere Reihe GANZ neu: eine Spuele auf der Raumseite wurde zum
     schlichten Unterschrank, sobald der Kunde irgendetwas an der Kuechenseite aenderte.

     Jetzt sucht jeder Schrank der geaenderten Reihe seinen Partner auf der anderen Seite — zuerst
     an derselben Stelle Ruecken an Ruecken, sonst der naechste gleich breite in derselben
     Reihenfolge (so wandert ein Paar beim Verschieben mit). Ist einer der beiden ein Geraet, bleibt
     der Partner, wie er ist: der Kunde hat ihn so gesetzt. Sonst wird er eine Kopie. Ohne Partner:
     Kopie, beim Geraet der schlichte Unterschrank. Wer drueben kein Gegenueber mehr hat, faellt weg
     (sein Gegenueber wurde entfernt). Danach stehen beide Reihen lueckenlos und fest: die Raumseite
     ab 0, die Kuechenseite Ruecken an Ruecken dazu, beide Listen in der Reihenfolge an der Insel.
     Zusaetzlich zurueck: `anders` (hat sich drueben ein Modell geaendert?), `weg` (die Modelle, die
     drueben mit entfernt wurden) — die Oberflaeche sagt es dem Kunden — und `neuIndex` (alter →
     neuer Listenplatz der geaenderten Reihe), damit die Auswahl des Kunden (`sel`) mitwandert. */
  var INSEL_GERAET = ['spuelen_unterschrank', 'geschirrspuelerfront', 'herdumbau', 'kuehlumbau', 'geraete_unterschrank'];
  function inselSpiegeln(z, daten, von) {
    var nach = von === 'I' ? 'IH' : 'I', kv = von + '|boden', kn = nach + '|boden';
    var raum = raumGeometrie(z);
    if (!(raum.bloecke || []).some(function (b) { return b.id === 'IH'; })) return null;
    var len = wandObj(z, von).len;
    var kopie = function (o) { var r = {}; Object.keys(o || {}).forEach(function (k) { r[k] = (o[k] || []).slice(); }); return r; };
    var plan = kopie(z.plan), hoff = kopie(z.hoff), xpos = kopie(z.xpos), wahl = kopie(z.wahl);
    var schlicht = {};
    (daten.modelle || []).forEach(function (m, i) {
      if (m.reihe !== 'unten' || m.funktion !== 'unterschrank' || istEck(m)) return;
      var b = Math.round(nennMass(m)), alt = schlicht[b];
      /* Je Breite der gewoehnlichste: ohne Varianten-Zusatz im Code, bei Gleichstand der hoechste. */
      var gut = function (x) { return /^[A-Z]+\d+$/.test(String(x.code || '').replace(/^KU-/, '')) ? 1 : 0; };
      if (alt == null || gut(m) > gut(daten.modelle[alt]) || (gut(m) === gut(daten.modelle[alt]) && m.h > daten.modelle[alt].h)) schlicht[b] = i;
    });
    var geraet = function (m) { return !!m && INSEL_GERAET.indexOf(m.funktion) > -1; };
    var breite = function (m) { return Math.round(nennMass(m)); };
    var feld = function (f, k, i) { var v = ((z[f] || {})[k] || [])[i]; return v == null ? null : v; };
    var nachX = function (a, b) { return a.x - b.x || a.i - b.i; };
    var S = items(z, daten, von, 'boden').slice().sort(nachX);
    var T = items(z, daten, nach, 'boden').slice().sort(nachX);
    var partner = [], vergeben = {};
    /* 1. Ruecken an Ruecken an derselben Stelle, gleiche Breite. */
    S.forEach(function (s, k) {
      var mitte = len - (s.x + s.b / 2);
      var t = T.filter(function (u) {
        return !vergeben[u.i] && breite(u.m) === breite(s.m) && Math.abs(u.x + u.b / 2 - mitte) < 2;
      })[0];
      partner[k] = t || null;
      if (t) vergeben[t.i] = true;
    });
    /* 2. Sonst der naechstgelegene gleich breite, die kuerzesten Wege zuerst. In derselben
          Reihenfolge zu suchen reicht nicht: beim Verschieben tauschen zwei Schraenke ihre Folge,
          und der zweite fand seinen Partner nicht mehr — die Spuele gegenueber fiel weg
          (Zufallssuche 2026-09-26, 25 Faelle, alle nach ← →). */
    var kandidaten = [];
    S.forEach(function (s, k) {
      if (partner[k]) return;
      var mitte = len - (s.x + s.b / 2);
      T.forEach(function (u) {
        if (!vergeben[u.i] && breite(u.m) === breite(s.m)) kandidaten.push({ k: k, u: u, d: Math.abs(u.x + u.b / 2 - mitte) });
      });
    });
    kandidaten.sort(function (a, b) { return a.d - b.d || a.k - b.k; }).forEach(function (c) {
      if (partner[c.k] || vergeben[c.u.i]) return;
      partner[c.k] = c.u; vergeben[c.u.i] = true;
    });
    var weg = T.filter(function (u) { return !vergeben[u.i]; }).map(function (u) { return u.m; });
    var anders = weg.length > 0;
    /* 3. Das Gegenueber jedes Schranks. */
    var paare = S.map(function (s, k) {
      var t = partner[k], sMi = z.plan[kv][s.i], p;
      if (t && (geraet(s.m) || geraet(t.m))) {
        p = { mi: z.plan[kn][t.i], off: feld('hoff', kn, t.i) || 0, wahl: feld('wahl', kn, t.i) };
      } else if (!t && geraet(s.m) && schlicht[breite(s.m)] != null) {
        p = { mi: schlicht[breite(s.m)], off: 0, wahl: null };
      } else {
        p = { mi: sMi, off: feld('hoff', kv, s.i) || 0, wahl: feld('wahl', kv, s.i) };
      }
      if (!t || p.mi !== z.plan[kn][t.i] || (p.wahl || null) !== (feld('wahl', kn, t.i) || null)) anders = true;
      /* Auf ganze Zentimeter und nie ueberlappend: die Geschirrspuelerfront misst 59,6 — jeder
         Schrank dahinter rueckte um 0,4, und gespiegelt lagen die Partner 0,4 cm uebereinander
         („stehen an derselben Stelle", gemessen 2026-09-28). Die Stelle ist so breit wie der
         breitere der beiden. */
      p.s = s;
      p.platz = Math.ceil(Math.max(s.b, daten.modelle[p.mi].b) - 1e-6);
      return p;
    });
    /* 4. Lueckenlos: die Raumseite ab 0, die Kuechenseite Ruecken an Ruecken (x' = len − x − platz). */
    var raumReihe = von === 'I' ? paare : paare.slice().reverse(), x = 0;
    raumReihe.forEach(function (p) { p.xI = x; x += p.platz; });
    var stelle = function (w, p) { return zahl(w === 'I' ? p.xI : len - p.xI - p.platz); };
    var neuIndex = {};
    plan[kv] = []; hoff[kv] = []; xpos[kv] = []; wahl[kv] = [];
    paare.forEach(function (p, k) {
      neuIndex[p.s.i] = k;
      plan[kv].push(z.plan[kv][p.s.i]); hoff[kv].push(feld('hoff', kv, p.s.i) || 0);
      xpos[kv].push(stelle(von, p)); wahl[kv].push(feld('wahl', kv, p.s.i));
    });
    plan[kn] = []; hoff[kn] = []; xpos[kn] = []; wahl[kn] = [];
    (nach === 'I' ? raumReihe : raumReihe.slice().reverse()).forEach(function (p) {
      plan[kn].push(p.mi); hoff[kn].push(p.off); xpos[kn].push(stelle(nach, p)); wahl[kn].push(p.wahl);
    });
    return { plan: plan, hoff: hoff, xpos: xpos, wahl: wahl, von: von, nach: nach, anders: anders, weg: weg, neuIndex: neuIndex };
  }

  /* DIE WUENSCHE AUS DER „AUSSTATTUNG" (Planer-App, Betreiber 2026-09-26: „einfache Fragen, damit das
     System weiss, wie es baut"). `z.wunsch` = { gs, ofen, oben } — fehlt es, baut die Startkueche
     genau wie bisher (alte Seite, Netze, gespeicherte Plaene).
       gs:   'voll' (Standard) | 'teil' (halbe Front: die Bedienblende bleibt sichtbar)
             | 'eigen' (eigenes Geraet mit Tuer: nur die Nische, K.stellplatzStatt)
             | 'keiner' (die Rolle entfaellt; die Reihe fuellen Unterschraenke)
       ofen: 'hoch' (Standard: Backofen-Hochschrank, wo Serie und Raumhoehe es erlauben) | 'unten'
       oben: 'ja' (Standard) | 'nein' (keine Haengeschraenke, keine Aufsaetze)
       kuehl: 'einbau' (Kuehlumbau-Hochschrank am offenen Ende der Spuelenwand) | 'keiner' (wie bisher)
     Was NACH dem Bau geaendert wird (Nische, Haengeschraenke weg), gilt nur, wenn die Pruefung danach
     nicht mehr Fehler zaehlt — sonst bleibt die Kueche, wie sie gebaut wurde.
     Passt der gewuenschte Kuehlschrank nicht, traegt das Ergebnis `kuehlFehlt` ('serie': die Serie
     fuehrt ihn in dieser Farbe nicht, 'hoehe': der Raum ist zu niedrig, 'platz': Spuele, Kochfeld und
     Geschirrspueler gehen vor) — die Oberflaeche sagt es dem Kunden. */
  /* DIE STARTKUECHE OHNE SICHTBARE LUECKE (2026-09-28, siehe sichtbareLuecken).

     Die gewohnte Verteilung gibt der Hauptwand Spuele und Geschirrspueler. In der U-Kueche ist diese Wand an beiden Enden
     zu, und ihr Nutzmass geht mit den Breiten dieser beiden Rollen oft nicht auf: 310 cm, zwei Ecken zu 90, bleiben 130 —
     Spuele 80 + halbe Geschirrspuelerfront 45 = 125, und 5 cm standen zwischen den Schraenken. Mit dem Kochfeld an dieser
     Wand geht es genau auf (60 + 40 + 30), und die Spuele steht an einer Seitenwand, deren offenes Ende den Rest schluckt.
     Deshalb: laesst die gewohnte Kueche eine Luecke, werden die anderen Verteilungen gebaut (welche Wand Spuele, welche
     Herd traegt), und es gewinnt der Reihe nach: keine Pruefmeldung, alle Rollen der gewohnten (Spuele, Kochstelle,
     Geschirrspueler, Kuehlschrank), die kleinere Luecke, weniger offene Punkte im Planungs-Check, die gewohnte Verteilung.
     Ein Rest, den keine Verteilung schliesst (das Nutzmass ist kein Vielfaches der Schrankbreiten), bleibt, wo er war. */
  /* Wo stehen Kuehlschrank und Hochschraenke? [{ typ, wand, x }] — typ 'kuehl' (Kuehlumbau oder Nische des eigenen
     Geraets), 'ofen' (Backofen-Hochschrank), 'hoch' (jeder andere Hochschrank); x ist die Mitte an der Wand. */
  function hochLagen(z, daten) {
    var out = [];
    waende(z).forEach(function (w) {
      items(z, daten, w.id, 'boden').forEach(function (it) {
        if (it.m.reihe !== 'voll') return;
        var f = it.m.funktion || '';
        out.push({ typ: f === 'kuehlumbau' ? 'kuehl' : (f === 'hochschrank_geraet' ? 'ofen' : 'hoch'), wand: w.id, x: it.x + it.b / 2,
          mi: ((z.plan || {})[w.id + '|boden'] || [])[it.i], i: it.i });
      });
    });
    aktiveMerkmale(z).forEach(function (m) {
      if (m.typ !== 'kuehl') return;
      var e = elementIntervallAufWand(m);
      out.push({ typ: 'kuehl', wand: m.wand, x: e.start + e.laenge / 2, stell: m.id });
    });
    return out;
  }
  /* Alle Hochschraenke mit Seite — fuer die App (Knoepfe „Links | Rechts") und den Wunsch `lage`:
     [{ typ, mi, wahl, seite, wand, i | stell }]. */
  function hochInventar(z, daten) {
    var raum = raumGeometrie(z);
    return hochLagen(z, daten).map(function (q) {
      return { typ: q.typ, mi: q.mi, wahl: q.stell ? null : wahlListe(z, q.wand + '|boden')[q.i], seite: seiteAm(raum, q.wand, q.x),
        wand: q.wand, i: q.i, stell: q.stell };
    });
  }
  /* LINKS ODER RECHTS — von der Kueche aus gesehen, wie die Raumansicht sie zeigt (Wand A hinten, links die kleinere x).
     Die Mitte ist die Mitte aller Wandenden; `ab` ist die Stelle auf der Wand. Inselbloecke haben keine Seite. */
  function seiteAm(raum, w, ab) {
    var xs = [];
    raum.waende.forEach(function (q) { xs.push(q.p0.x, q.p1.x); });
    var mitte = (Math.min.apply(null, xs) + Math.max.apply(null, xs)) / 2;
    var wo = raum.waende.filter(function (q) { return q.id === w; })[0];
    if (!wo) return null;
    var x = wo.p0.x + (wo.p1.x - wo.p0.x) * ab / (wandLaenge(wo) || 1);
    return x < mitte - 0.5 ? 'links' : (x > mitte + 0.5 ? 'rechts' : null);
  }
  /* Auf welcher Seite stehen Kuehlschrank und Backofen-Hochschrank? { kuehl, ofen }: 'links' | 'rechts' | null (keiner da). */
  function hochSeiten(z, daten) {
    var raum = raumGeometrie(z), out = { kuehl: null, ofen: null };
    hochLagen(z, daten).forEach(function (q) {
      if ((q.typ === 'kuehl' || q.typ === 'ofen') && !out[q.typ]) out[q.typ] = seiteAm(raum, q.wand, q.x);
    });
    return out;
  }
  /* Wie viele der gewuenschten Seiten stimmen nicht? */
  function lageFehler(z, daten, lage) {
    if (!lage) return 0;
    var ist = hochSeiten(z, daten), n = 0;
    ['kuehl', 'ofen'].forEach(function (t) { if (lage[t] && ist[t] !== lage[t]) n++; });
    if (lage.extra && lage.extra.length) {
      var raum = raumGeometrie(z), da = {};
      hochLagen(z, daten).forEach(function (q) { if (q.typ === 'hoch') { var k = q.mi + '|' + seiteAm(raum, q.wand, q.x); da[k] = (da[k] || 0) + 1; } });
      lage.extra.forEach(function (e) { var k = e.mi + '|' + e.seite; if (da[k]) da[k]--; else n++; });
    }
    return n;
  }
  /* Welche Rollen hat die Kueche? Spuele, Kochfeld (Herdumbau oder Backofen-Hochschrank), Geschirrspueler, Kuehlschrank —
     je 0 oder 1, Nischen eigener Geraete zaehlen mit. */
  function rollenVon(st, daten) {
    var n = { spuele: 0, koch: 0, gs: 0, kuehl: 0 };
    waende(st).forEach(function (wd) {
      items(st, daten, wd.id, 'boden').forEach(function (it) {
        var fk = it.m.funktion;
        if (fk === 'spuelen_unterschrank') n.spuele = 1;
        if (/^(herdumbau|geraete_unterschrank|hochschrank_geraet)$/.test(fk)) n.koch = 1;
        if (fk === 'geschirrspuelerfront') n.gs = 1;
        if (fk === 'kuehlumbau') n.kuehl = 1;
      });
    });
    aktiveMerkmale(st).forEach(function (m) { if (m.typ === 'spueler') n.gs = 1; if (m.typ === 'kuehl') n.kuehl = 1; });
    return n;
  }
  /* Wie viele Hochschraenke fehlen gegenueber `alt` (je Art)? */
  function hochVerloren(alt, neu) {
    var n = 0;
    ['kuehl', 'ofen', 'hoch'].forEach(function (t) {
      var a = alt.filter(function (q) { return q.typ === t; }).length, b = neu.filter(function (q) { return q.typ === t; }).length;
      if (b < a) n += a - b;
    });
    return n;
  }

  /* DER KUNDE WAEHLT DIE SEITE (Wunsch `lage: { kuehl, ofen }` = 'links' | 'rechts', Betreiber 2026-09-29: „اريد ان يختار
     العميل اين يقوم بوضعه وليس انت"). Dieselbe Suche wie immer; nach Fehlern und den Rollen der gewohnten Kueche zaehlt
     dort zuerst, dass kein Hochschrank verloren geht und jeder auf seiner gewaehlten Seite steht. Stehen beide auf
     derselben Seite, stehen sie nebeneinander (Kuehlschrank aussen). Geht es nicht, bleibt die gewohnte Kueche und traegt
     `lageFehlt`: die App sagt es dem Kunden. Ohne Wunsch Zeichen fuer Zeichen die bisherige Startkueche. */
  function startKueche(z, daten) {
    var wu = (z && z.wunsch) || {}, lage = wu.lage;
    if (!daten || !lage || (!lage.kuehl && !lage.ofen && !(lage.extra && lage.extra.length))) return startKuecheSuche(z, daten, null);
    var zStd = planKopie(z), wStd = {};
    for (var k in wu) { if (Object.prototype.hasOwnProperty.call(wu, k) && k !== 'lage') wStd[k] = wu[k]; }
    zStd.wunsch = wStd;
    var std = startKuecheSuche(zStd, daten, null);
    if (!std) return null;
    var mitErg = function (erg) {
      var st = planKopie(z);
      st.wand = erg.wand; st.plan = erg.plan; st.hoff = erg.hoff; st.xpos = erg.xpos; st.wahl = erg.wahl;
      if (erg.merkmale) { st.merkmale = erg.merkmale; st.mid = erg.mid; }
      return st;
    };
    /* Nur, was da ist: eine Seite fuer den Backofen-Hochschrank gilt nicht, wenn der Ofen unter dem Kochfeld steht. */
    var lagenStd = hochLagen(mitErg(std), daten), lg = {};
    ['kuehl', 'ofen'].forEach(function (t) { if (lage[t] && lagenStd.some(function (q) { return q.typ === t; })) lg[t] = lage[t]; });
    if (lage.extra && lage.extra.length) lg.extra = lage.extra;
    if ((!lg.kuehl && !lg.ofen && !lg.extra) || !lageFehler(mitErg(std), daten, lg)) return std;
    lage = lg;
    var zL = planKopie(z), wL = {};
    for (var k4 in wu) { if (Object.prototype.hasOwnProperty.call(wu, k4)) wL[k4] = wu[k4]; }
    wL.lage = lg; zL.wunsch = wL;
    var nichtGeht = function () {
      var g = {};
      for (var k2 in std) { if (Object.prototype.hasOwnProperty.call(std, k2)) g[k2] = std[k2]; }
      g.lageFehlt = true;
      return g;
    };
    var r = startKuecheSuche(zL, daten, { lagen: lagenStd, soll: std, lage: lage });
    if (!r) return nichtGeht();
    var st = mitErg(r), ra = rollenVon(mitErg(std), daten), rb = rollenVon(st, daten);
    var weg = Object.keys(ra).some(function (k3) { return ra[k3] && !rb[k3]; });
    return weg || hochVerloren(lagenStd, hochLagen(st, daten)) || lageFehler(st, daten, lage) ? nichtGeht() : r;
  }

  function startKuecheSuche(z, daten, seite) {
    var r = startKuecheRollen(z, daten);
    if (!r || !daten) return r;
    var mitR = function (erg) {
      var st = planKopie(z);
      st.wand = erg.wand; st.plan = erg.plan; st.hoff = erg.hoff; st.xpos = erg.xpos; st.wahl = erg.wahl;
      if (erg.merkmale) { st.merkmale = erg.merkmale; st.mid = erg.mid; }
      return st;
    };
    /* Eine Luecke unten unter 4,5 cm ist der Rest des Masses selbst: alle Schraenke messen Vielfache von 5 cm, und eine
       Wand von 312 cm laesst in jeder Verteilung 2 cm auf der Wand, die an beiden Enden zu ist. Dafuer lohnt kein Umbau
       (gemessen: in Zentimeterschritten wurde die U-Kueche sonst viermal langsamer, ohne eine Luecke weniger). Die
       Haengereihe folgt der Bodenreihe und entscheidet hier nicht. */
    var groessteUnten = sichtbareLuecken(mitR(r), daten).reduce(function (m, q) { return q.zeile === 'boden' ? Math.max(m, q.cm) : m; }, 0);
    var rollen = function (st) { return rollenVon(st, daten); };
    /* Mit gewaehlter Seite sind die Rollen der GEWOHNTEN Kueche das Soll — fuer die andere Seite faellt keine weg. */
    var soll = rollen(mitR(seite ? seite.soll : r));
    /* Mit gewaehlter Seite auch ohne Luecke weitersuchen, solange ein Hochschrank fehlt, auf der falschen Seite steht oder eine
       Rolle fehlt (der Geschirrspueler fand ueber Eck keinen Platz). */
    var fehltVon = function (st) { var n = rollen(st), f = 0; Object.keys(soll).forEach(function (k) { if (soll[k] && !n[k]) f++; }); return f; };
    var nochDa = !!seite && (hochVerloren(seite.lagen, hochLagen(mitR(r), daten)) + lageFehler(mitR(r), daten, seite.lage) + fehltVon(mitR(r))) > 0;
    if (!sichtbareLuecken(mitR(r), daten).length && !nochDa) return r;
    var raum = raumGeometrie(z);
    var gerade = raum.waende.filter(function (w) { return w.planbar !== false; }).map(function (w) { return w.id; });
    if (gerade.length < 2 || gerade.some(function (w) { return bauDa(bauZonen(z, daten, w)); })) return r;
    /* Was die Startkueche sonst nie tut und der Planungs-Check nicht sieht: das Kochfeld direkt an einer Ecke (die
       Toepfe brauchen Platz zur Seite), ein Hochschrank vor einer Ecke (er sperrt den Eckschrank). Gezaehlt wird der
       eigene Eckschrank und der Eckschenkel der Nachbarwand. Ohne das gewann bei 310/350/310 eine Verteilung mit dem
       Backofen-Hochschrank an der Ecke der Hauptwand und dem Kochfeld am Eckschrank der Seitenwand. */
    var anEcken = function (st) {
      var n = 0;
      waende(st).forEach(function (wd) {
        var id = wd.id, iv = nutzIntervall(st, daten, id, 'boden'), wl = wandObj(st, id).len;
        var its = items(st, daten, id, 'boden');
        var ecken = its.filter(function (it) { return istEck(it.m); }).map(function (it) { return [it.x, it.x + it.b]; });
        if (iv.start > 0.5) ecken.push([-1e9, iv.start]);
        if (iv.ende < wl - 0.5) ecken.push([iv.ende, 1e9]);
        /* Bis 5 cm neben der Ecke zaehlt als „an der Ecke": bei 312 cm stand der Backofen-Hochschrank 2 cm vor dem
           Eckschenkel und galt mit 1,5 cm Spiel als frei. */
        var an = function (a, b) { return ecken.some(function (e) { return Math.abs(e[1] - a) < 5 || Math.abs(e[0] - b) < 5; }); };
        kochstellen(st, daten, id).forEach(function (k) { if (an(k.x, k.x + k.b)) n++; });
        its.forEach(function (it) { if (it.m.reihe === 'voll' && an(it.x, it.x + it.b)) n++; });
      });
      return n;
    };
    /* Luecken unter 4,5 cm sind der Rest des Masses (siehe unten) — keine Verteilung ist deswegen besser. Sie entscheiden
       erst nach dem Aufbau der Kueche: bei 312 cm gewann sonst der Hochschrank an der Ecke, weil er 2 cm der Haengereihe
       verdeckte (2 statt 4 cm Luecke). */
    var wertung = function (erg, rang) {
      var st = mitR(erg), n = rollen(st), fehlt = 0, l = sichtbareLuecken(st, daten);
      Object.keys(soll).forEach(function (k) { if (soll[k] && !n[k]) fehlt++; });
      var offenCheck = planungsCheck(st, daten).filter(function (x) { return !x.ok; }).length;
      var gross = lueckenSumme(l.filter(function (q) { return q.cm >= 4.5; })), klein = lueckenSumme(l) - gross;
      var vs = seite ? [hochVerloren(seite.lagen, hochLagen(st, daten)), lageFehler(st, daten, seite.lage)] : [];
      return [fehlerTexte(st, daten).length, fehlt].concat(vs)
        .concat([Math.round(gross * 10), anEcken(st), offenCheck, Math.round(klein * 10), rang]);
    };
    var kleiner = function (a, b) {
      for (var i = 0; i < a.length; i++) { if (a[i] !== b[i]) return a[i] < b[i]; }
      return false;
    };
    var best = { r: r, sc: wertung(r, 0), vorgabe: null }, rang = 0;
    if (groessteUnten >= 4.5 || nochDa) {
      gerade.forEach(function (h) {
        [null].concat(gerade.filter(function (w) { return w !== h; })).forEach(function (zw) {
          var z2 = planKopie(z);
          z2.rollenVorgabe = { haupt: h, zweite: zw };
          var r2 = startKuecheRollen(z2, daten);
          if (!r2) return;
          var sc = wertung(r2, ++rang);
          if (kleiner(sc, best.sc)) best = { r: r2, sc: sc, vorgabe: z2.rollenVorgabe };
        });
      });
    }
    /* DER REST ZWISCHEN ZWEI ECKEN (Betreiber 2026-09-28: keine Passblende, „die Platte wird nicht in der Tiefe
       geschnitten"). Bleibt unten an einer Wand zwischen zwei Ecken eine Luecke, wird dieselbe Kueche noch einmal gebaut,
       und diese Wand darf um so viel laenger werden, wie ihre Nachbarreihen naeher an ihre Waende ruecken koennen
       (versatzGrenze, gemessen an der gebauten Kueche); gewaehlt wird die kleinste Fuellung, die aufgeht. Den Rest
       rechnet versatzKarte. Gewertet wie jede Verteilung — die mit weniger Luecke gewinnt. */
    var mitVersatz = function (b) {
      var st = mitR(b.r), rv = raumGeometrie(st), reserve = {}, da = false;
      var lu = sichtbareLuecken(st, daten);
      rv.waende.forEach(function (w) {
        var n0 = eckNachbarWand(rv, w.id, 'anfang'), n1 = eckNachbarWand(rv, w.id, 'ende');
        if (!n0 || !n1 || !lu.some(function (q) { return q.wand === w.id && q.zeile === 'boden'; })) return;
        var R = versatzGrenze(st, daten, n0) + versatzGrenze(st, daten, n1);
        if (R >= 0.5) { reserve[w.id] = R; da = true; }
      });
      if (!da) return b;
      var z3 = planKopie(z);
      if (b.vorgabe) z3.rollenVorgabe = b.vorgabe;
      z3.versatzReserve = reserve;
      var r3 = startKuecheRollen(z3, daten);
      if (!r3) return b;
      var sc3 = wertung(r3, b.sc[b.sc.length - 1]);
      return kleiner(sc3, b.sc) ? { r: r3, sc: sc3, vorgabe: b.vorgabe } : b;
    };
    return mitVersatz(best).r;
  }

  function startKuecheRollen(z, daten) {
    var wu = (z && z.wunsch) || {};
    var basis = z, eigenK = wu.kuehl === 'eigen';
    if (wu.ofen === 'unten' || wu.gs === 'teil' || wu.gs === 'keiner' || wu.kuehl === 'einbau' || eigenK) {
      basis = {};
      for (var k1 in z) { if (Object.prototype.hasOwnProperty.call(z, k1)) basis[k1] = z[k1]; }
      if (wu.ofen === 'unten') basis.ohneHochOfen = true;
      basis.gsWahl = wu.gs;
      basis.kuehlWahl = eigenK ? 'platzhalter' : wu.kuehl;
      /* Der FREISTEHENDE Kuehlschrank braucht keine Raumhoehe fuer einen Hochschrank. Sein Platzhalter darf
         deshalb auch in einem niedrigeren Raum stehen; ein Backofen-Hochschrank passt dort ohnehin nicht
         (dieselbe Hochschrank-Linie der Serie). */
      if (eigenK && daten && (+z.hoehe || 250) < geo(daten).hochschrank_hoehe + 4) {
        basis.hoehe = geo(daten).hochschrank_hoehe + 4;
        basis.ohneHochOfen = true;
      }
    }
    var r = startKuecheBasis(basis, daten);
    /* Scheitert die Kueche MIT Kuehlschrank ganz, dann ohne ihn — nie gar keine Kueche seinetwegen. */
    if (!r && basis.kuehlWahl) {
      basis.kuehlWahl = null;
      basis.hoehe = z.hoehe;
      r = startKuecheBasis(basis, daten);
      if (r) r.kuehlFehlt = 'platz';
    }
    if (!r || (wu.oben !== 'nein' && wu.gs !== 'eigen' && !eigenK)) return r;
    var st = planKopie(z);
    st.wand = r.wand; st.plan = r.plan; st.hoff = r.hoff; st.xpos = r.xpos; st.wahl = r.wahl;
    /* Bis der Platzhalter des eigenen Kuehlschranks zur Nische wird, zaehlt er beim Wandversatz nicht mit — wie beim
       Bauen (versatzGrenze). Sonst sperrte er hier die Nische des eigenen Geschirrspuelers. */
    if (eigenK && !r.kuehlFehlt) st.kuehlWahl = 'platzhalter';
    var f0 = fehlerTexte(st, daten).length;
    if (wu.oben === 'nein') {
      var ohne = planKopie(st);
      Object.keys(ohne.plan).forEach(function (k) {
        if (!/\|(oben|aufsatz)$/.test(k)) return;
        delete ohne.plan[k]; delete ohne.hoff[k]; delete ohne.xpos[k]; delete ohne.wahl[k];
      });
      if (fehlerTexte(ohne, daten).length <= f0) st = ohne;
    }
    if (wu.gs === 'eigen') {
      var bloecke = {};
      (raumGeometrie(st).bloecke || []).forEach(function (b) { bloecke[b.id] = 1; });
      var doppelt = !!bloecke.IH;
      waende(st).forEach(function (wd) {
        if (doppelt && bloecke[wd.id]) return;
        items(st, daten, wd.id, 'boden').filter(function (it) { return it.m.funktion === 'geschirrspuelerfront'; })
          .sort(function (a, b) { return b.i - a.i; })
          .forEach(function (it) {
            var n = stellplatzStatt(st, daten, wd.id + '|boden|' + it.i);
            if (n.fehler || n.sperre) return;
            st.plan = n.plan; st.hoff = n.hoff; st.xpos = n.xpos; st.wahl = n.wahl; st.merkmale = n.merkmale; st.mid = n.mid;
          });
      });
    }
    /* Eigener Kuehlschrank: der Platzhalter wird zur raumhohen Nische (K.stellplatzStatt). Bleibt er
       stehen (die Nische waere gesperrt), gibt es die Kueche ohne Kuehlschrank — nie einen Hochschrank,
       den der Kunde nicht wollte. */
    if (eigenK && !r.kuehlFehlt) {
      var bloeckeK = {};
      (raumGeometrie(st).bloecke || []).forEach(function (b) { bloeckeK[b.id] = 1; });
      var platzhalter = function (it) { return it.m.funktion === 'kuehlumbau' || it.m.funktion === 'hochschrank'; };
      waende(st).forEach(function (wd) {
        if (bloeckeK[wd.id]) return;
        items(st, daten, wd.id, 'boden').filter(platzhalter).sort(function (a, b) { return b.i - a.i; })
          .forEach(function (it) {
            var n = stellplatzStatt(st, daten, wd.id + '|boden|' + it.i, true);
            if (n.fehler || n.sperre) return;
            st.plan = n.plan; st.hoff = n.hoff; st.xpos = n.xpos; st.wahl = n.wahl; st.merkmale = n.merkmale; st.mid = n.mid;
          });
      });
      var bleibt = waende(st).some(function (wd) { return !bloeckeK[wd.id] && items(st, daten, wd.id, 'boden').some(platzhalter); });
      if (bleibt) {
        var ohneK = {};
        for (var k2 in basis) { if (Object.prototype.hasOwnProperty.call(basis, k2)) ohneK[k2] = basis[k2]; }
        ohneK.kuehlWahl = null; ohneK.hoehe = z.hoehe;
        var r3 = startKuecheBasis(ohneK, daten);
        if (!r3) return null;
        r3.kuehlFehlt = 'platz';
        return r3;
      }
    }
    var erg = { wand: r.wand, plan: st.plan, hoff: st.hoff, xpos: st.xpos, wahl: st.wahl, merkmale: st.merkmale, mid: st.mid };
    if (r.kuehlFehlt) erg.kuehlFehlt = r.kuehlFehlt;
    return erg;
  }

  function startKuecheBasis(z, daten) {
    if (!daten) return null;
    var s = {}; for (var k0 in z) { if (Object.prototype.hasOwnProperty.call(z, k0)) s[k0] = z[k0]; }
    s.plan = {}; s.hoff = {}; s.xpos = {}; s.wahl = {};
    var raum = raumGeometrie(s);
    var gerade = raum.waende.filter(function (w) { return w.planbar !== false; }).map(function (w) { return w.id; })
      .sort(function (a, b) { return ORD.indexOf(a) - ORD.indexOf(b); });
    if (!gerade.length) return null;
    var haupt = gerade.indexOf('A') > -1 ? 'A' : gerade[0];
    var insel = raum.bloecke.filter(function (b) { return b.id === 'I' || b.id === 'IH'; }).map(function (b) { return b.id; });

    s.wand = haupt;
    var alle = function (reihe) { return katalog(s, daten, reihe, ''); };
    var unten = alle('unten').filter(function (x) { return !istEck(x.m); });
    var oben = alle('oben').filter(function (x) { return !istEck(x.m); });
    var eckUnten = alle('unten').filter(function (x) { return istEck(x.m); });
    var eckOben = alle('oben').filter(function (x) { return istEck(x.m); });
    var breite = function (x) { return Math.round(nennMass(x.m)); };
    var nimm = function (liste, passt, breiten) {
      for (var k = 0; k < breiten.length; k++) {
        var t = liste.filter(function (x) { return passt(x.m) && breite(x) === breiten[k]; });
        /* Bei gleicher Breite der hoechste — die vollintegrierte Geschirrspuelerfront vor der
           teilintegrierten, der normale Haengeschrank vor dem flachen. */
        t.sort(function (a, b) { return b.m.h - a.m.h; });
        if (t.length) return t[0];
      }
      return null;
    };
    var f = function (namen) { return function (m) { return namen.indexOf(m.funktion) > -1; }; };
    var jeder = function () { return true; };
    var spuele = nimm(unten, f(['spuelen_unterschrank']), [60, 80]);
    var herd = nimm(unten, f(['herdumbau', 'geraete_unterschrank']), [60]);
    /* HOHER BACKOFENSCHRANK, wie in den Komplettkuechen des Shops: wenn die Serie ihn in dieser
       Farbe fuehrt und der Raum hoch genug ist (dieselbe Grenze wie die Pruefung: Hochschrank + 4).
       Bevorzugt der mit EINER Nische (nur Backofen); Velora fuehrt nur den mit Mikrowelle. */
    var nischen = function (m) { return (m.front || []).filter(function (t) { return t[0] === 'nische'; }).length; };
    /* `ohneHochOfen` ist kein Kundenfeld: damit prueft das Netz die Anordnung mit Herdumbau weiter. */
    var ofenHoch = !s.ohneHochOfen && (+s.hoehe || 250) >= geo(daten).hochschrank_hoehe + 4
      ? alle('voll').filter(function (x) { return x.m.funktion === 'hochschrank_geraet' && breite(x) === 60 && nischen(x.m) > 0; })
          .sort(function (p, q) { return nischen(p.m) - nischen(q.m); })[0] || null
      : null;
    /* KUEHLSCHRANK IM HOCHSCHRANK (Wunsch kuehl 'einbau', Betreiber 2026-09-26 nach dem Vergleich mit
       ROYAL24: deren Startkueche hat einen, unsere hatte in keiner Serie und Form einen). Ein Hochschrank
       wie der Backofenschrank — nur, wenn der Raum hoch genug ist (dieselbe Grenze wie die Pruefung). */
    /* 'platzhalter' (Wunsch „eigener Kuehlschrank", siehe startKueche): derselbe Platz, gleich danach zur
       Nische gemacht. Fuehrt die Farbe keinen Kuehlumbau, haelt ein 60er Vorrats-Hochschrank die Stelle. */
    var kuehl = null, kuehlFehlt = null;
    if (s.kuehlWahl === 'einbau' || s.kuehlWahl === 'platzhalter') {
      var kuehlKat = alle('voll').filter(function (x) {
        return breite(x) === 60 && (x.m.funktion === 'kuehlumbau' || (s.kuehlWahl === 'platzhalter' && x.m.funktion === 'hochschrank'));
      }).sort(function (p, q) {
        return (p.m.funktion === 'kuehlumbau' ? 0 : 1) - (q.m.funktion === 'kuehlumbau' ? 0 : 1)
          || String(p.m.code).localeCompare(String(q.m.code));
      });
      if (!kuehlKat.length) kuehlFehlt = 'serie';
      else if ((+s.hoehe || 250) < geo(daten).hochschrank_hoehe + 4) kuehlFehlt = 'hoehe';
      else kuehl = kuehlKat[0];
    }
    /* Wunsch „halbe Front" (s.gsWahl, siehe startKueche): die niedrige zuerst, sonst wie immer die hohe.
       „Kein Geschirrspueler": die Rolle faellt weg, die Reihe fuellen Unterschraenke. */
    var gsPasst = s.gsWahl === 'teil'
      ? function (m) { return m.funktion === 'geschirrspuelerfront' && m.h < 65; } : f(['geschirrspuelerfront']);
    var gsNimm = function (breiten) { return nimm(unten, gsPasst, breiten) || nimm(unten, f(['geschirrspuelerfront']), breiten); };
    var gs = s.gsWahl === 'keiner' ? null : gsNimm([60, 45]);
    /* Drei Schubladen vor einer — der S1 ist gleich hoch und stand sonst zufaellig vorn. */
    var schub = nimm(unten, function (m) {
      return /^(unterschrank_schub|unterschrank)$/.test(m.funktion) && /^D\d+S3$/.test(m.code);
    }, [60, 40, 80]) || nimm(unten, f(['unterschrank_schub']), [60, 40, 80]);
    /* Mit Anschlag-Endung (-P/-L): bei Glanzia Weiss gibt es den 30er nur als D30-P. Ohne sie
       blieb dort unten eine 30-cm-Luecke und oben eine 60er (codeKern sieht darin dasselbe
       Modell). */
    var schlicht = function (m) { return m.funktion === 'unterschrank' && /^D\d+(?:-[PL])?$/.test(m.code); };
    /* Der quadratische 90er vor dem flachen 100er (Livaro D100N ragt nur 56 cm um die Ecke). */
    var eckU = nimm(eckUnten, f(['eck_unterschrank']), [90, 100]);
    var eckO = nimm(eckOben, jeder, [60]);

    var setz = function (wand, x, xpos) {
      s.wand = wand;
      var gr = optGruppen(daten, x.m, s.farbe)[0];
      var r = setzen(s, daten, x.i, x.kundenWahl != null ? x.kundenWahl : (gr ? gr.werte[0] : null));
      if (r.sperre || r.fehler) return false;
      if (xpos != null) r.xpos[r.sel.split('|').slice(0, 2).join('|')][+r.sel.split('|')[2]] = xpos;
      s.plan = r.plan; s.hoff = r.hoff; s.xpos = r.xpos; s.wahl = r.wahl;
      return true;
    };
    var ecke = function (wand, ende) { return !!schrankEckeAn(raum, wand, ende); };

    /* 1. Die Ecken — zuerst, denn sie bestimmen, wie viel Platz den Waenden bleibt.

       Jede Wand traegt hoechstens EINEN Eckschrank: `setzen` prueft bei einem neuen beide Enden
       der Wand und sperrt den zweiten an einem schon besetzten Anfang. Und `eckPlaetze` legt
       einen Eckschrank an den Anfang, wenn dort eine Ecke ist — getragen wird eine Ecke also nur
       von einer Wand, an deren ANFANG sie liegt, oder von einer ohne Ecke am Anfang. In der
       U-Kueche heisst das: A traegt die Ecke zu C, B die Ecke zu A. Wand A zuerst. */
    if (eckU) {
      var traeger = {};
      schrankEcken(raum).forEach(function (e) {
        var kand = [e.a, e.b].sort(function (p, q) { return (p === 'A' ? 0 : 1) - (q === 'A' ? 0 : 1); })
          .filter(function (w) {
            return !traeger[w] && (e.enden[w] === 'anfang' || !ecke(w, 'anfang'));
          });
        /* Wand A zuerst; sperrt sie (in der U-Kueche reserviert der Eckschrank von B schon ihr
           anderes Ende), traegt die Nachbarwand die Ecke. */
        for (var c = 0; c < kand.length; c++) {
          if (setz(kand[c], eckU)) { traeger[kand[c]] = true; break; }
        }
      });
    }

    /* STUFE 2 (2026-09-27): Fenster, Tuer, Wasser. Nur wenn der Kunde an einer bestueckbaren Wand eines
       davon eingetragen hat, gilt das Folgende; sonst baut die Startkueche Zeichen fuer Zeichen wie vorher. */
    var bauZ = {}, bau = false;
    gerade.forEach(function (w) { bauZ[w] = bauZonen(s, daten, w); if (bauDa(bauZ[w])) bau = true; });
    /* Die freien Strecken der Bodenreihe: das nutzbare Stueck ohne die eigenen Eckschraenke und ohne das,
       was dort keinen Unterschrank erlaubt. */
    var strecken = function (wand) {
      var iv = nutzIntervall(s, daten, wand, 'boden');
      var zonen = items(s, daten, wand, 'boden').map(function (it) { return { a: it.x, b: it.x + it.b }; })
        .concat(bauZ[wand] ? bauZ[wand].boden : []);
      return freieLuecken(zonen, iv.start, iv.ende).filter(function (q) { return q[1] - q[0] > 0.5; });
    };
    /* Die laengste Strecke, auf der ein Kochfeld stehen darf: frei und unter keinem Fenster. */
    var herdRaum = function (wand) {
      var fe = (bauZ[wand] ? bauZ[wand].fenster : []).map(function (f) { return { a: f.a, b: f.b }; });
      return strecken(wand).reduce(function (mx, q) {
        return Math.max(mx, freieLuecken(fe, q[0], q[1]).reduce(function (m2, p) { return Math.max(m2, p[1] - p[0]); }, 0));
      }, 0);
    };
    /* Die Spuele gehoert ueber den Wasseranschluss; ohne ihn unter ein Fenster, unter dem die Platte
       durchlaeuft — dorthin kommt die Wand mit der Spuele. */
    if (bau) {
      var wasserW = gerade.filter(function (w) { return bauZ[w].wasser != null; })[0];
      /* Das Fenster allein zieht die Spuele nur an eine Wand, an der Spuele und Geschirrspueler nebeneinander Platz
         haben: sonst fiel an der kurzen Seitenwand (L 360/180) der Geschirrspueler weg, nur damit die Spuele unter dem
         Fenster steht. Der Wasseranschluss dagegen bestimmt die Wand — dort MUSS die Spuele hin. */
      var gsMin = unten.filter(function (x) { return x.m.funktion === 'geschirrspuelerfront'; })
        .reduce(function (mn, x) { return Math.min(mn, breite(x)); }, Infinity);
      var blockMin = (spuele ? breite(spuele) : 60) + (gs && gsMin < Infinity ? gsMin : 0);
      var fensterW = gerade.filter(function (w) {
        return bauZ[w].fenster.some(function (f) { return f.unter; })
          && strecken(w).some(function (q) { return q[1] - q[0] >= blockMin - 0.5; });
      })[0];
      if (wasserW || fensterW) haupt = wasserW || fensterW;
      /* Die Spuele braucht an ihrer Wand EINE freie Strecke, auf der sie steht — moeglichst mit dem Geschirrspueler.
         Teilt eine Tuer die Hauptwand in zu kurze Stuecke (Betreiber 2026-09-27: U 360/240/180, Tuer 139–227 an der
         Hauptwand, Livaro: die Kueche hatte GAR KEINE Spuele, und der Hinweis sprach von einem Spuelenschrank), kommt
         sie an die erste andere Wand, an der das geht. Ein Wasseranschluss bleibt bindend. */
      var spuelPlatz = function (w, min) { return strecken(w).some(function (q) { return q[1] - q[0] >= min - 0.5; }); };
      if (!wasserW && spuele && !spuelPlatz(haupt, breite(spuele))) {
        var mitGs = gerade.filter(function (w) { return w !== haupt && spuelPlatz(w, blockMin); })[0];
        var nurSp = gerade.filter(function (w) { return w !== haupt && spuelPlatz(w, breite(spuele)); })[0];
        if (mitGs || nurSp) haupt = mitGs || nurSp;
      }
    }

    /* 2. Rollen: wer bekommt Spuele, wer Herd? */
    var zweite = gerade.filter(function (w) { return w !== haupt; })[0];
    /* Mit Fenster, Tuer oder Wasser: die erste Wand, an der das Kochfeld samt 30 cm daneben auf EINER freien
       Strecke und unter keinem Fenster Platz hat — eine Tuer in der Mitte laesst sonst zwei Stuecke, in die
       es nicht passt. Gibt es keine, kommt alles an die Wand der Spuele. */
    if (bau) {
      zweite = herd ? gerade.filter(function (w) { return w !== haupt && herdRaum(w) >= breite(herd) + 30; })[0] : null;
    }
    /* Eine andere Rollenverteilung (startKueche, 2026-09-28): Spuele und Herd an andere Waende, wenn die gewohnte eine
       sichtbare Luecke laesst. Nur ohne Fenster, Tuer und Wasser — dort legen sie die Waende fest. */
    if (s.rollenVorgabe && !bau) {
      if (gerade.indexOf(s.rollenVorgabe.haupt) > -1) haupt = s.rollenVorgabe.haupt;
      zweite = gerade.indexOf(s.rollenVorgabe.zweite) > -1 && s.rollenVorgabe.zweite !== haupt ? s.rollenVorgabe.zweite : null;
    }
    var rolle = {};
    rolle[haupt] = 'alles';
    /* Die zweite Wand bekommt den Herd nur, wenn neben ihm zur Ecke hin noch ein Schrank
       passt (mindestens 30 cm) — sonst steht er in der Ecke, und dann besser alles auf A. */
    if (zweite && herd && nutzLaenge(s, daten, zweite, 'boden') - belegtLaenge(s, daten, zweite, 'boden') >= breite(herd) + 30) {
      rolle[haupt] = 'spuele'; rolle[zweite] = 'herd';
    }
    gerade.forEach(function (w) { if (!rolle[w]) rolle[w] = 'rest'; });
    insel.forEach(function (w) { rolle[w] = 'insel'; });
    /* DIE SEITE WAEHLT DER KUNDE (Wunsch `lage`, startKueche). Links und rechts wie in der Raumansicht (seiteAm). Der
       Backofen-Hochschrank steht am offenen Ende der Kochfeldwand: soll er auf die andere Seite, tauscht die Kochfeldwand die
       Rolle mit einer Wand, deren offenes Ende dort liegt (L: Spuele und Kochfeld, U: die beiden Schenkel) — nur, wenn dort
       neben dem Kochfeld wieder 30 cm bleiben. Wo eine Wand an beiden Enden offen ist, dreht wandReihe die Reihe; den
       Kuehlschrank setzen kuehlKand und kuehlRein. Mit Fenster, Tuer oder Wasser legen diese die Waende fest. */
    var lage = (s.wunsch || {}).lage || null, lageAn = !!lage && !bau && !!(lage.kuehl || lage.ofen || (lage.extra && lage.extra.length));
    var seiteEnde = function (w, e) { var wo = wandAus(raum, w); return wo ? seiteAm(raum, w, e === 'anfang' ? 0 : wandLaenge(wo)) : null; };
    var hatSeite = function (w, sd) { return ['anfang', 'ende'].some(function (e) { return !ecke(w, e) && seiteEnde(w, e) === sd; }); };
    var offen2 = function (w) { return !ecke(w, 'anfang') && !ecke(w, 'ende'); };
    if (lageAn && lage.ofen && ofenHoch && herd) {
      var herdJetzt = gerade.filter(function (w) { return rolle[w] === 'herd'; })[0];
      if (herdJetzt && !hatSeite(herdJetzt, lage.ofen)) {
        var herdZiel = gerade.filter(function (w) {
          return w !== herdJetzt && hatSeite(w, lage.ofen)
            && nutzLaenge(s, daten, w, 'boden') - belegtLaenge(s, daten, w, 'boden') >= breite(herd) + 30;
        })[0];
        if (herdZiel) { rolle[herdJetzt] = rolle[herdZiel]; rolle[herdZiel] = 'herd'; }
      }
    }
    /* Ohne Backofen-Hochschrank (Backofen unter dem Kochfeld): liegt auf der Seite des Kuehlschranks nur das offene Ende der
       Kochfeldwand, stuende er direkt neben dem Kochfeld. Dann geht das Kochfeld an eine andere Wand — zuerst eine Restwand
       (U: der andere Schenkel), sonst die der Spuele (L) —, und der Kuehlschrank steht bei der Spuele. */
    if (lageAn && lage.kuehl && !(lage.ofen && ofenHoch) && herd) {
      var hW = gerade.filter(function (w) { return rolle[w] === 'herd'; })[0];
      var kaltDort = gerade.some(function (w) { return w !== hW && hatSeite(w, lage.kuehl); });
      if (hW && hatSeite(hW, lage.kuehl) && !kaltDort) {
        var zielH = gerade.filter(function (w) {
          return w !== hW && (rolle[w] === 'rest' || rolle[w] === 'spuele')
            && nutzLaenge(s, daten, w, 'boden') - belegtLaenge(s, daten, w, 'boden') >= breite(herd) + 30;
        }).sort(function (p, q) { return (rolle[p] === 'rest' ? 0 : 1) - (rolle[q] === 'rest' ? 0 : 1); })[0];
        if (zielH) { rolle[hW] = rolle[zielH]; rolle[zielH] = 'herd'; }
      }
    }

    /* Der Herd nie direkt an der Ecke: die Toepfe brauchen Platz zur Seite, und der
       Eckschrank oeffnet nach vorn. Steht er am Eckende der Reihe, tauscht er mit dem
       Nachbarn. Die Kuechenzeile hat keine Ecke und bleibt, wie sie war. */
    var herdWeg = function (wand, reihe) {
      var j = reihe.indexOf(herd), n = reihe.length;
      if (j < 0 || n < 2) return reihe;
      var k = (j === 0 && ecke(wand, 'anfang')) ? 1 : ((j === n - 1 && ecke(wand, 'ende')) ? n - 2 : -1);
      if (k > -1) { reihe[j] = reihe[k]; reihe[k] = herd; }
      return reihe;
    };
    /* DIE LUECKE ZUM SCHLUSS SOLL SO KLEIN WIE MOEGLICH SEIN.

       Bis 2026-09-24 wurde gierig gefuellt: erst alle 60er, dann 80er, 45er, 40er, 30er. Bei 110 cm
       Rest gab das 60 + 45 und 5 cm Luecke, obwohl 80 + 30 genau passen; der Betreiber sah die
       Luecken in der Zeichnung und in 3D. Jetzt wird die Kombination gesucht, die den kleinsten
       Rest laesst — bei gleichem Rest die mit weniger Schraenken, dann die mit mehr 60ern (die
       Standardbreite, fuer die es auch den passenden Haengeschrank gibt). Gerechnet in ganzen
       Zentimetern ueber die Breiten, die die Serie in dieser Farbe WIRKLICH fuehrt. */
    /* `ersatz` (optional): weitere Schraenke, deren Breiten mitzaehlen — gesetzt wird bei gleicher
       Breite trotzdem zuerst einer aus `passt`. */
    /* `ziel` (optional, Wand zwischen zwei Ecken mit Wandversatz): die KLEINSTE Fuellung ab `ziel` — so ruecken die
       Seitenreihen nur so weit an ihre Waende, wie es noetig ist. Gibt es keine bis `rest`, gilt wie sonst die groesste. */
    var fuellen = function (liste, passt, rest, ersatz, ziel) {
      var br = [];
      var jeder = ersatz ? function (m) { return passt(m) || ersatz(m); } : passt;
      liste.forEach(function (x) { if (jeder(x.m) && br.indexOf(breite(x)) < 0) br.push(breite(x)); });
      br.sort(function (p, q) { return q - p; });
      var R = Math.max(0, Math.floor(rest));
      var best = [];                       /* best[c] = kuerzeste Liste mit Summe genau c */
      best[0] = [];
      for (var c = 1; c <= R; c++) {
        for (var k = 0; k < br.length; k++) {
          var v = br[k], vor = best[c - v];
          if (c - v < 0 || !vor) continue;
          var neu = vor.concat([v]);
          var alt = best[c];
          var sechziger = function (l) { return l.filter(function (y) { return y === 60; }).length; };
          if (!alt || neu.length < alt.length || (neu.length === alt.length && sechziger(neu) > sechziger(alt))) best[c] = neu;
        }
      }
      var c2 = R;
      if (ziel != null) {
        for (var cz = Math.max(0, Math.ceil(ziel - 1e-6)); cz <= R; cz++) { if (best[cz]) { c2 = cz; break; } }
      }
      while (c2 > 0 && !best[c2]) c2--;
      return (best[c2] || []).sort(function (p, q) { return (q === 60) - (p === 60) || q - p; })
        .map(function (v) { return nimm(liste, passt, [v]) || (ersatz ? nimm(liste, ersatz, [v]) : null); }).filter(Boolean);
    };
    /* DIE BREITEN DER FESTEN SCHRAENKE WERDEN MIT DEM FUELLER GEMEINSAM GEWAEHLT (2026-09-25).

       Vorher stand jede Rolle auf ihrer Standardbreite, und nur der Rest wurde gefuellt. Auf der
       Mittelwand der U-Kueche (260 cm, 180 davon Ecken) blieben so Spuele 60 und 20 cm Luecke,
       obwohl die 80er Spuele genau passt — bei Velora eine Luecke, in die kein Schrank der Serie
       passt. Jetzt werden die Breiten der Serie je Rolle durchprobiert. Gewertet: zuerst so viele
       PFLICHTROLLEN wie moeglich (Spuele, Herd, Geschirrspueler — keine faellt einer Luecke zum
       Opfer; gemessen bei Livaro Gruen, wo es den Geschirrspueler nur 45 breit gibt). Danach
       kommt es darauf an, WO der Rest landet (items lehnt die Reihe an ihr geschlossenes Ende):
       hat die Strecke ein offenes Ende, liegt er dort und ist harmlos — die Kueche ist einfach
       kuerzer; dann gilt, was vorher galt (Standardbreiten, von hinten gekuerzt), und eine
       andere Breite nur, wo sonst eine Pflichtrolle wegfiele. Ist die Strecke an BEIDEN Enden
       zu, waere er eine Luecke an der Wand oder zwischen Schraenken; dann zaehlt zuerst der
       kleinste Rest, und die Schubladen duerfen weichen; danach moeglichst keine Sonderschraenke
       als Fueller und wenige Schraenke — eine 80er Spuele schlaegt Spuele 60 plus Weinregal. */
    var ROLLEN = {
      spuele: { x: spuele, breiten: [60, 80], nimm: function (b) { return nimm(unten, f(['spuelen_unterschrank']), [b]); } },
      herd:   { x: herd,   breiten: [],       nimm: null },
      gs:     { x: gs,     breiten: [60, 45], nimm: function (b) { return gsNimm([b]); } },
      schub:  { x: schub,  breiten: [60, 40, 80], nimm: function (b) {
        return nimm(unten, function (m) {
          return /^(unterschrank_schub|unterschrank)$/.test(m.funktion) && /^D\d+S3$/.test(m.code);
        }, [b]) || nimm(unten, f(['unterschrank_schub']), [b]);
      } }
    };
    var optionen = function (name) {
      var R = ROLLEN[name], o = [R.x];
      R.breiten.forEach(function (b) {
        var y = R.nimm(b);
        if (y && !o.some(function (q) { return breite(q) === breite(y); })) o.push(y);
      });
      return o;
    };
    /* `abzug`: so viel der Wand ist schon vergeben (der Kuehlschrank). `letztePflicht` haelt fest, wie
       viele Pflichtrollen die gewaehlte Reihe traegt — der Kuehlschrank darf keine verdraengen. */
    var letztePflicht = 0;
    var wandReihe = function (wand, abzug) {
      var r = rolle[wand];
      var namen = (r === 'alles' ? ['spuele', 'herd', 'gs', 'schub'] : r === 'spuele' ? ['spuele', 'gs']
        : r === 'herd' ? ['herd', 'schub'] : r === 'insel' ? ['schub'] : [])
        .filter(function (n) { return !!ROLLEN[n].x; });
      /* Der eigene Eckschrank steht schon und zaehlt ab; `nutzLaenge` zieht nur die Ecke der
         NACHBARWAND ab. Ohne das verplante die gespiegelte L-Kueche 90 cm zu viel und warf
         ausgerechnet Spuele und Geschirrspueler als letzte hinaus. */
      var len = nutzLaenge(s, daten, wand, 'boden') - belegtLaenge(s, daten, wand, 'boden') - (abzug || 0);
      var summeVon = function (l) { return l.reduce(function (a, x) { return a + breite(x); }, 0); };
      var enden = endenVon(s, daten, wand, 'boden'), geschlossen = enden.zuAnfang && enden.zuEnde;
      /* WANDVERSATZ (startKueche, 2026-09-28): zwischen zwei Ecken darf die Reihe um `reserve` laenger werden — so weit
         ruecken die Seitenreihen dann an ihre Waende (siehe wandVersatz). Gewertet wird dann: genau aufgehend vor
         wenig Ueberstand vor jeder Luecke. */
      var reserve = geschlossen && s.versatzReserve ? +s.versatzReserve[wand] || 0 : 0;
      var len0 = len;
      len += reserve;
      /* Faellt eine Rolle weg, dann wie bisher von hinten. `mitReserve`: dieselben Rollen wie ohne Versatz (`nurTeil`) —
         er ist fuer den Rest da, nicht fuer eine Rolle mehr (sonst kam in der Livaro-U 293 der Geschirrspueler an die
         Hauptwand, und die ganze Kueche wurde eine andere); ihre Breiten und die Fueller duerfen ihn nutzen. */
      var waehle = function (mitReserve, nurTeil) {
        var lenX = mitReserve ? len : len0, best = null;
        for (var n = namen.length; n >= 0; n--) {
          var teil = namen.slice(0, n), kombis = [[]];
          if (nurTeil && teil.join() !== nurTeil.join()) continue;
          teil.forEach(function (nm) {
            var neu = [];
            kombis.forEach(function (k) { optionen(nm).forEach(function (o) { neu.push(k.concat([o])); }); });
            kombis = neu;
          });
          kombis.forEach(function (k) {
            var sm = summeVon(k);
            if (sm > lenX + 0.01) return;
            /* Auf einer geschlossenen Strecke ist jeder Unterschrank besser als eine Luecke — auch
               einer, den das Muster fuer „schlicht" nicht kennt (Livaro D15P), und der schmale
               Apothekerschrank (Livaro D20C), der in echten Kuechen genau dafuer steht. */
            var fl = fuellen(unten, schlicht, lenX - sm, geschlossen ? function (m) {
              return m.funktion === 'unterschrank' || m.funktion === 'apotheker';
            } : null, mitReserve ? len0 - sm : null);
            var ersatzZahl = fl.filter(function (x) { return !schlicht(x.m); }).length;
            var rest = Math.round(lenX - sm - summeVon(fl));
            if (mitReserve) {
              var ueberV = sm + summeVon(fl) - len0;
              rest = ueberV < -0.5 ? Math.round(100 - ueberV) : Math.max(0, Math.round(ueberV));
            }
            var abw = k.filter(function (x, i) { return x !== ROLLEN[teil[i]].x; }).length;
            var pflicht = teil.filter(function (nm) { return nm !== 'schub'; }).length;
            var sc = geschlossen ? [-pflicht, rest, -teil.length, ersatzZahl, k.length + fl.length, abw]
              : [-pflicht, abw, -teil.length, rest, k.length + fl.length];
            var besser = !best;
            for (var q = 0; !besser && q < sc.length; q++) {
              if (sc[q] !== best.sc[q]) { besser = sc[q] < best.sc[q]; break; }
            }
            if (besser) best = { k: k, fl: fl, teil: teil, sc: sc };
          });
        }
        return best;
      };
      var best = waehle(false, null);
      if (reserve && best) {
        /* Nur wenn der Versatz die Luecke wirklich schliesst: sonst bleibt es bei der Reihe ohne ihn. */
        var bestV = waehle(true, best.teil);
        if (bestV && best.sc[1] > 0 && bestV.sc[1] < 100) best = bestV;
      }
      if (!best || (r === 'alles' && !best.k.length)) return null;
      letztePflicht = -best.sc[0];
      var gew = {};
      best.teil.forEach(function (nm, i) { gew[nm] = best.k[i]; });
      /* Ab hier dieselben Namen wie vorher — nur jetzt die gewaehlten Breiten. */
      var spuele = gew.spuele || null, herd = gew.herd || null, gs = gew.gs || null, schub = gew.schub || null;
      var kern = best.k, fueller = best.fl;
      var hat = function (x) { return !!x && kern.indexOf(x) > -1; };
      var reihe = [];
      /* Mit hohem Backofenschrank: er ersetzt den Herdumbau (gleiche Breite, 60) und steht am Ende
         der Reihe; gekocht wird auf den Schubladen daneben (kochstellen). Nur wenn beides passt. */
      var hochOfen = ofenHoch && hat(herd) && hat(schub) && breite(herd) === breite(ofenHoch);
      /* Gewaehlte Seite auf einer Wand, die an beiden Enden offen ist: zeigt `sd` auf den Anfang und nicht auf das Ende? */
      var zumAnfang = function (sd) { return !!sd && offen2(wand) && seiteEnde(wand, 'anfang') === sd && seiteEnde(wand, 'ende') !== sd; };
      var zumEnde = function (sd) { return !!sd && offen2(wand) && seiteEnde(wand, 'ende') === sd && seiteEnde(wand, 'anfang') !== sd; };
      if (r === 'alles') {
        /* Links die Spuele mit dem Geschirrspueler daneben, rechts Herd und Schubladen — mit gewaehlter Seite gespiegelt, wenn
           der Backofen-Hochschrank (ohne ihn: der Kuehlschrank neben der Spuele) auf die andere Seite soll. */
        if (hat(spuele)) reihe.push(spuele);
        if (hat(gs)) reihe.push(gs);
        reihe = reihe.concat(fueller);
        if (hochOfen) { reihe.push(schub); reihe.push(ofenHoch); }
        else {
          if (hat(herd)) reihe.push(herd);
          if (hat(schub)) reihe.push(schub);
        }
        var drehen = lageAn && (hochOfen ? zumAnfang(lage.ofen) : zumEnde(lage.kuehl));
        return drehen ? reihe.reverse() : reihe;
      }
      if (r === 'spuele') {
        /* Die Spuele bleibt am offenen Ende, weg von der Ecke. Mit gewaehlter Seite und ohne Geschirrspueler daneben (fuer den
           Kuehlschrank) an die Ecke: er kommt dann ueber Eck an die Nachbarwand, und der Weg bleibt kurz. Steht der Kuehlschrank
           am anderen Ende einer offenen Wand, gespiegelt — die Spuele bleibt neben ihm. */
        reihe = lageAn && abzug > 0 && ROLLEN.gs.x && !gs ? fueller.concat(kern) : kern.concat(fueller);
        if (lageAn && abzug > 0 && zumEnde(lage.kuehl)) return reihe.reverse();
        return ecke(wand, 'anfang') && !ecke(wand, 'ende') ? reihe.reverse() : reihe;
      }
      if (r === 'herd') {
        if (hochOfen) {
          /* Von der Ecke her: Fueller, die Schubladen mit dem Kochfeld, der Hochschrank am offenen
             Ende — das Kochfeld nicht in der Ecke, der hohe Schrank nicht vor der Ecke. Auf einer offenen Wand (zweizeilig)
             an der gewaehlten Seite. */
          reihe = fueller.concat([schub, ofenHoch]);
          if (lageAn && lage.ofen && offen2(wand)) return zumAnfang(lage.ofen) ? reihe.reverse() : reihe;
          return ecke(wand, 'ende') && !ecke(wand, 'anfang') ? reihe.reverse() : reihe;
        }
        /* Von der Ecke her: erst die Schubladen, dann der Herd — nie der Herd in der Ecke. */
        reihe = [];
        if (hat(schub)) reihe.push(schub);
        if (hat(herd)) reihe.push(herd);
        reihe = reihe.concat(fueller);
        return ecke(wand, 'ende') && !ecke(wand, 'anfang') ? reihe.reverse() : reihe;
      }
      /* INSEL (Betreiber 2026-09-27: „الجزيرة يجب ان تكون الخزائن افتراضيا متشابهة"): alle Schraenke der Insel
         gleich. Sie begann mit einem Schubladenschrank, daneben standen Tuerschraenke (D60S3, D60, D60); jetzt
         wird jeder Fueller der Schubladenschrank derselben Breite, wo die Serie einen hat. Die Breiten bleiben —
         also auch Laenge, Rest und das Spiegelbild der Doppelinsel. */
      if (r === 'insel') {
        return kern.concat(fueller.map(function (x) { return ROLLEN.schub.nimm(breite(x)) || x; }));
      }
      return kern.concat(fueller);
    };

    /* Die Wand des Kuehlschranks: die der Spuele (bzw. die mit allem), sonst eine Restwand — nie die
       des Herdes, und nur eine mit einem Ende ohne Ecke (ein Hochschrank vor der Ecke sperrte den
       Eckschrank). In der U-Kueche ist das die dritte Wand; die mittlere hat an beiden Enden Ecken. */
    var kuehlWand = null, kuehlKand = [];
    if (kuehl) {
      var kuehlRang = function (w) { var rl = rolle[w]; return rl === 'alles' || rl === 'spuele' ? 0 : rl === 'rest' ? 1 : 9; };
      kuehlKand = gerade.filter(function (w) { return kuehlRang(w) < 9 && (!ecke(w, 'anfang') || !ecke(w, 'ende')); })
        .sort(function (p, q) { return kuehlRang(p) - kuehlRang(q); });
      /* Gewaehlte Seite: eine Wand mit offenem Ende dort — die der Spuele zuerst, dann eine Restwand, zuletzt die des
         Kochfelds (dann steht er neben dem Backofen-Hochschrank, weil der Kunde beide auf dieselbe Seite gestellt hat). */
      if (lageAn && lage.kuehl) {
        var rangL = function (w) { var rl = rolle[w]; return rl === 'alles' || rl === 'spuele' ? 0 : rl === 'rest' ? 1 : rl === 'herd' ? 2 : 9; };
        kuehlKand = gerade.filter(function (w) { return rangL(w) < 9 && hatSeite(w, lage.kuehl); })
          .sort(function (p, q) { return rangL(p) - rangL(q); });
      }
      kuehlWand = kuehlKand[0] || null;
      /* Passt er an der ersten Wand nur, wenn dort eine Pflichtrolle wegfiele, dann an die naechste, an der das nicht so
         ist (2026-09-28). Bis hierher hiess das sofort „kein Platz": U 310/200/190 mit der Spuele an der Seitenwand liess
         den Kuehlschrank weg, obwohl die dritte Wand genau 60 + 40 frei hatte — und die lueckenlose Verteilung verlor
         dadurch gegen eine mit Luecke (startKueche). Ohne Fenster, Tuer und Wasser; dort waehlt bauReihe die Wand. */
      if (!bau && kuehlKand.length > 1) {
        for (var kq = 0; kq < kuehlKand.length; kq++) {
          var kOhne = wandReihe(kuehlKand[kq]), pflichtOhne = letztePflicht;
          var kMit = kOhne !== null ? wandReihe(kuehlKand[kq], breite(kuehl)) : null;
          if (kMit !== null && letztePflicht >= pflichtOhne) { kuehlWand = kuehlKand[kq]; break; }
        }
      }
      if (!kuehlWand) kuehlFehlt = 'platz';
    }
    /* WEITERE HOCHSCHRAENKE (Betreiber 2026-09-29: „يوجد ايضا خزائن طويلة غير البراد والفرن"): Vorratsschraenke, die der
       Kunde gesetzt hat, stehen am offenen Ende ihrer Seite — aussen neben Kuehlschrank und Backofen-Hochschrank. Die Wand:
       die des Kuehlschranks bzw. des Backofens dieser Seite, sonst eine andere mit offenem Ende dort. Kostet einer eine
       Pflichtrolle, bleibt er weg (und startKueche meldet: geht nicht). */
    var extraWand = {};
    if (lageAn && lage.extra) {
      lage.extra.forEach(function (e) {
        var m = daten.modelle[e.mi];
        if (!m || m.reihe !== 'voll' || !variante(m, s.farbe, s.zusatz)) return;
        var rangE = function (w) {
          if (w === kuehlWand && lage.kuehl === e.seite) return 0;
          if (rolle[w] === 'herd' && lage.ofen === e.seite) return 1;
          return rolle[w] === 'alles' || rolle[w] === 'spuele' ? 2 : (rolle[w] === 'rest' ? 3 : 4);
        };
        var kandE = gerade.filter(function (w) { return hatSeite(w, e.seite); }).sort(function (p, q) { return rangE(p) - rangE(q); });
        if (kandE[0]) (extraWand[kandE[0]] = extraWand[kandE[0]] || []).push({ x: { i: e.mi, m: m, kundenWahl: e.wahl }, seite: e.seite });
      });
    }
    var extraBreite = function (w) { return (extraWand[w] || []).reduce(function (a, e) { return a + breite(e.x); }, 0); };
    /* Der Kuehlschrank kommt an ein Ende ohne Ecke — bevorzugt eines, dessen Nachbar keine Hitze
       abgibt (Herd, Backofen); bei Gleichstand der Anfang, wo die Spuele steht. */
    var heiss = function (x) { return !!x && (x === ofenHoch || /herdumbau|geraete_unterschrank|hochschrank_geraet/.test(x.m.funktion || '')); };
    var kuehlRein = function (wand, reihe) {
      var enden = ['anfang', 'ende'].filter(function (e) { return !ecke(wand, e); });
      var nachbar = function (e) { return e === 'anfang' ? reihe[0] : reihe[reihe.length - 1]; };
      enden.sort(function (p, q) { return (heiss(nachbar(p)) ? 1 : 0) - (heiss(nachbar(q)) ? 1 : 0); });
      /* Gewaehlte Seite geht vor — auch neben den Backofen, wenn der Kunde beide dorthin gestellt hat. */
      if (lageAn && lage.kuehl) {
        var dort = enden.filter(function (e) { return seiteEnde(wand, e) === lage.kuehl; });
        if (dort.length) enden = dort.concat(enden.filter(function (e) { return dort.indexOf(e) < 0; }));
      }
      var neu = reihe.slice();
      if (enden[0] === 'anfang') neu.unshift(kuehl); else neu.push(kuehl);
      return neu;
    };

    /* ---------- STUFE 2: die Reihe einer Wand mit Fenster, Tuer oder Wasseranschluss ----------

       ROYAL24 setzte mit Fenster das Kochfeld UNTER das Fenster, und oben blieb eine 20-cm-Luecke. Hier gilt,
       was jeder Kuechenplaner tut: die Spuele ueber den Wasseranschluss, sonst unter das Fenster, der
       Geschirrspueler daneben; das Kochfeld nie unter ein Fenster und nicht an die Ecke; Kuehlschrank und
       Backofen-Hochschrank nie vor ein Fenster, der Kuehlschrank am offenen Ende der Reihe und nicht neben der
       Hitze. Eine Tuer (ein Fenster bis unter die Arbeitshoehe, ein Heizkoerper) teilt die Reihe in Strecken;
       jede Strecke ist lueckenlos, ihr Rest liegt an ihrem Ende wie sonst am Ende der Reihe.

       Gerechnet wird wie in wandReihe — dieselben Rollen, Breiten und Fueller —, nur ueber Strecken: welche
       Gruppe (Spuele mit Geschirrspueler, Kochfeld mit Schubladen bzw. Backofen-Hochschrank, Kuehlschrank)
       in welche Strecke, die Fueller dazu, dann die beste Reihenfolge. Die Strecke am Anfang des Flusses
       (items) fliesst wie jede Reihe; jede andere bekommt feste Stellen — sonst liefe beim naechsten
       Entfernen ein Schrank ueber die Tuer.
       Rueckgabe: { reihe: [{ x, stelle }] von links nach rechts, mitKuehl } oder null wie wandReihe. */
    var bauReihe = function (wand, kuehlHier, kuehlStreng) {
      var bz = bauZ[wand], r = rolle[wand];
      var namen = (r === 'alles' ? ['spuele', 'herd', 'gs', 'schub'] : r === 'spuele' ? ['spuele', 'gs']
        : r === 'herd' ? ['herd', 'schub'] : []).filter(function (n) { return !!ROLLEN[n].x; });
      var iv = nutzIntervall(s, daten, wand, 'boden'), wl = wandObj(s, wand).len;
      var eigen = items(s, daten, wand, 'boden').map(function (it) { return { a: it.x, b: it.x + it.b }; });
      var zonen = eigen.concat(bz.boden), st = strecken(wand);
      var rechtsF = reiheVonRechts(s, daten, wand, 'boden'), enden = endenVon(s, daten, wand, 'boden');
      /* Wo items() zu fliessen beginnt: am Ende des nutzbaren Stuecks, an dem die Reihe lehnt, hinter dem
         eigenen Eckschrank. */
      var fluss = rechtsF ? iv.ende : iv.start;
      eigen.forEach(function (e) {
        if (rechtsF ? (e.a < fluss - 0.5 && e.b >= fluss - 0.5) : (e.b > fluss + 0.5 && e.a <= fluss + 0.5)) fluss = rechtsF ? e.a : e.b;
      });
      /* Endet eine Strecke an einer Tuer, einem Eckschrank oder einer Wand, ist ihr Rest eine sichtbare Luecke
         (wie auf einer an beiden Enden geschlossenen Wand); am offenen Ende der Kueche ist er harmlos. */
      var zuBei = function (p) {
        if (Math.abs(p - iv.start) < 0.5 && enden.zuAnfang) return true;
        if (Math.abs(p - iv.ende) < 0.5 && enden.zuEnde) return true;
        return zonen.some(function (q) { return Math.abs(q.a - p) < 0.5 || Math.abs(q.b - p) < 0.5; });
      };
      /* Eckschraenke dieser Wand und die Ecke der Nachbarwand: daneben kein Kochfeld, kein Hochschrank. */
      var eckSp = eigen.slice();
      if (iv.start > 0.5) eckSp.push({ a: -1e9, b: iv.start });
      if (iv.ende < wl - 0.5) eckSp.push({ a: iv.ende, b: 1e9 });
      var anEcke = function (a, b) { return eckSp.some(function (e) { return Math.abs(e.b - a) < 1.5 || Math.abs(e.a - b) < 1.5; }); };
      var ueberZ = function (a, b, zs) { return zs.some(function (q) { return Math.min(b, q.b) - Math.max(a, q.a) > 0.5; }); };
      var fUnter = bz.fenster.filter(function (f) { return f.unter; }), wx = bz.wasser;
      var eckBreite = function (p) {
        var e = eigen.filter(function (q) { return Math.abs(q.a - p) < 1.5 || Math.abs(q.b - p) < 1.5; })[0];
        return e ? e.b - e.a : 0;
      };
      var hochT = function (t) { return t.r === 'kuehl' || t.r === 'ofen'; };

      /* Eine Reihenfolge einer Strecke vermessen. Kleiner ist besser, der Reihe nach: ungueltig (Hochschrank
         vor Fenster oder Ecke, Kuehlschrank nicht am Ende), Abstand der Spuele zum Wasseranschluss, Kochfeld
         unter einem Fenster, wie weit die Spuele unter dem Fenster hervorsteht, weiche Regeln (Kochfeld an der
         Ecke, zu wenig Abstellflaeche, Spuele und Kochfeld zu nah, Kuehlschrank neben der Hitze, Backofen-
         Hochschrank nicht am Ende), Abstand zur Fenstermitte, Abweichung von der gewohnten Folge. */
      /* Mit den ECHTEN Breiten, wie items() fliesst: die 59,6er Geschirrspuelerfront rueckt alles dahinter um
         4 mm — ein Hochschrank, gerundet genau neben dem Fenster, stuende sonst 4 mm davor (Pruefung: Fehler). */
      /* `gegen`: die Strecke an das ANDERE Ende gelehnt — nur, wo die Stellen ohnehin fest sind (Wand mit Fenster,
         Strecke hinter einer Tuer). Dann liegt der Rest dort, wo er nicht stoert: in der Innenkueche 240 mit Tuer und
         Fenster rueckte so das Kochfeld aus dem Fenster, und die 22 cm Rest liegen am Tuerrahmen. */
      var messen = function (q, folge, gegen, beide) {
        var T = folge.reduce(function (a, t) { return a + nennMass(t.x.m); }, 0);
        var x = (rechtsF ? !gegen : gegen) ? q[1] - T : q[0], x0 = x;
        var pos = folge.map(function (t) { var p = { t: t, a: x, b: x + nennMass(t.x.m) }; x = p.b; return p; });
        var m = { ungueltig: 0, wasser: 0, kochFenster: 0, fensterAus: 0, weich: 0, mitte: 0, wasserMitte: 0, abw: 0, pos: pos };
        /* Der Rest am anderen Ende nur neben einer Tuer (einem Hindernis) oder am offenen Ende — nie als Luecke am Eckschrank. */
        var amHindernis = function (pt) { return bz.boden.some(function (zn) { return Math.abs(zn.a - pt) < 0.5 || Math.abs(zn.b - pt) < 0.5; }); };
        if (gegen && (q[1] - q[0]) - T > 0.5) {
          var pR = rechtsF ? q[1] : q[0];
          if (!amHindernis(pR) && zuBei(pR)) m.ungueltig++;
        }
        /* Dasselbe in der gewohnten Richtung, wo die Strecke an BEIDEN Enden zu ist und am einen eine Tuer steht
           (Betreiber-Bild 2026-09-27: „فراغ بين الخزائن" — D30 hinter der Tuer, 8 cm Spalt zum Eckschrank): der Rest gehoert
           an die Tuer, dort sieht er aus wie der Abstand zum Rahmen. Nur wo die andere Richtung erlaubt ist (beide). */
        if (!gegen && beide && (q[1] - q[0]) - T > 0.5) {
          var pR2 = x0 === q[0] ? q[1] : q[0], pO2 = pR2 === q[1] ? q[0] : q[1];
          if (!amHindernis(pR2) && zuBei(pR2) && amHindernis(pO2)) m.ungueltig++;
        }
        var spuele = null, koch = null;
        pos.forEach(function (p, i) {
          if (hochT(p.t) && bz.hoch.some(function (q2) { return Math.min(p.b, q2.b) - Math.max(p.a, q2.a) > 0.01; })) m.ungueltig++;
          if (p.t.r === 'kuehl') {
            if ((i !== 0 && i !== pos.length - 1) || anEcke(p.a, p.b)) m.ungueltig++;
            /* Nie direkt neben Herd, Kochfeld oder Backofen (1a). Ohne Fenster sorgt kuehlRein dafuer; mit Fenster stand
               er sonst neben dem Herd, wenn das freie Ende der Reihe unter dem Fenster lag (Grosstest: 5 Faelle). */
            [pos[i - 1], pos[i + 1]].forEach(function (nb) {
              if (nb && (nb.t.koch || nb.t.r === 'ofen' || nb.t.r === 'herd')) m.ungueltig++;
            });
          }
          if (p.t.r === 'ofen' && ((i !== 0 && i !== pos.length - 1) || anEcke(p.a, p.b))) m.weich++;
          if (p.t.koch) koch = p;
          if (p.t.r === 'spuele') spuele = p;
        });
        if (koch) {
          if (ueberZ(koch.a, koch.b, bz.fenster)) m.kochFenster++;
          if (anEcke(koch.a, koch.b)) m.weich++;
          /* Abstellflaeche wie im Planungs-Check: bis zu einem Hochschrank; ein Eckschrank am Rand zaehlt mit. */
          var ki = pos.indexOf(koch);
          var lauf = function (d) {
            var sum = 0, i = ki + d;
            for (; i >= 0 && i < pos.length; i += d) { if (hochT(pos[i].t)) return sum; sum += pos[i].b - pos[i].a; }
            return sum + eckBreite(d < 0 ? pos[0].a : pos[pos.length - 1].b);
          };
          var l = lauf(-1), rr = lauf(1);
          if (!((l >= 30 && rr >= 30) || Math.max(l, rr) >= 60)) m.weich++;
        }
        if (spuele && koch) {
          var li = spuele.a < koch.a ? spuele : koch, re = li === spuele ? koch : spuele;
          var dazw = pos.some(function (p) { return hochT(p.t) && p.a >= li.b - 0.5 && p.b <= re.a + 0.5; });
          if (dazw || re.a - li.b < 60 - 0.5) m.weich++;
        }
        if (spuele) {
          var c = (spuele.a + spuele.b) / 2;
          if (wx != null) {
            /* Zu- und Ablauf kommen durch die Rueckwand des Spuelenschranks: mindestens 10 cm innerhalb seiner
               Seitenwaende, nicht auf der Fuge zum Nachbarn. */
            m.wasser = Math.round(Math.max(0, spuele.a + 10 - wx, wx - (spuele.b - 10)));
            m.wasserMitte = Math.round(Math.abs(c - wx));
          } else if (fUnter.length) {
            /* Unter dem Fenster heisst: die Mitte der Spuele liegt innerhalb des Fensters. Wie genau mittig, zaehlt
               erst nach den weichen Regeln — sonst stand fuer 10 cm Mitte ein Hochschrank zwischen Spuele und Kochfeld. */
            var fb = fUnter.map(function (f) {
              return { aus: Math.max(0, f.a - c, c - f.b), mitte: Math.abs(c - (f.a + f.b) / 2) };
            }).sort(function (p1, p2) { return p1.aus - p2.aus || p1.mitte - p2.mitte; })[0];
            m.fensterAus = Math.round(fb.aus); m.mitte = Math.round(fb.mitte);
          } else if (anEcke(spuele.a, spuele.b)) m.weich++;
        }
        var rang = { spuele: 0, gs: 1, fueller: 2, herd: 3, schub: 4, ofen: 5 };
        var rs = pos.filter(function (p) { return rang[p.t.r] != null; }).map(function (p) { return rang[p.t.r]; });
        for (var i1 = 0; i1 < rs.length; i1++) for (var j1 = i1 + 1; j1 < rs.length; j1++) if (rs[i1] > rs[j1]) m.abw++;
        return m;
      };
      var kleiner = function (a, b) {
        for (var i = 0; i < a.length; i++) { if (a[i] !== b[i]) return a[i] < b[i]; }
        return false;
      };
      /* Die beste Reihenfolge einer Strecke: Gruppen in jeder Reihenfolge und Richtung, die Fueller in jeder
         Verteilung auf die Plaetze davor, dazwischen und dahinter (gleiche Schraenke zaehlen einmal). */
      var ordnen = function (q, bloecke, fueller, beide) {
        var gruppen = [];
        fueller.forEach(function (x) {
          var g0 = gruppen.filter(function (g) { return g.x === x; })[0];
          if (g0) g0.n++; else gruppen.push({ x: x, n: 1 });
        });
        var best = null, versuche = 0;
        var perm = function (rest, bis, fertig) {
          if (!rest.length) { fertig(bis); return; }
          rest.forEach(function (b, i) { perm(rest.slice(0, i).concat(rest.slice(i + 1)), bis.concat([b]), fertig); });
        };
        perm(bloecke, [], function (folgeB) {
          /* Der Kuehlschrank steht am Ende der Reihe: vorn oder hinten, und davor bzw. dahinter kein Fueller. */
          var kI = -1;
          folgeB.forEach(function (b, i) { if (b.kuehl) kI = i; });
          if (kI > 0 && kI < folgeB.length - 1) return;
          var plaetze = folgeB.length + 1;
          /* Ist der Kuehlschrank die einzige Gruppe, steht er vorn ODER hinten — nicht beides zugleich (sonst durfte kein
             Fueller mehr daneben, und eine Restwand bekam ihn nie: U-Kueche mit Fenster, 30 Faelle ohne Kuehlschrank). */
          var seiten = kI === 0 && folgeB.length === 1 ? ['vorn', 'hinten'] : [kI === 0 ? 'vorn' : (kI > -1 ? 'hinten' : '')];
          seiten.forEach(function (seite) {
          var frei = [];
          for (var p0 = 0; p0 < plaetze; p0++) frei.push(!(seite === 'vorn' && p0 === 0) && !(seite === 'hinten' && p0 === plaetze - 1));
          var richt = function (j, teile) {
            if (j === folgeB.length) {
              var slots = [];
              for (var p1 = 0; p1 < plaetze; p1++) slots.push([]);
              var verteilen = function (gi) {
                if (versuche > 3000) return;
                if (gi === gruppen.length) {
                  versuche++;
                  var folge = [];
                  for (var si = 0; si < plaetze; si++) {
                    slots[si].forEach(function (x) { folge.push({ x: x, r: 'fueller' }); });
                    if (si < folgeB.length) folge = folge.concat(teile[si]);
                  }
                  (beide ? [false, true] : [false]).forEach(function (gegen) {
                    var m = messen(q, folge, gegen, beide);
                    if (m.ungueltig) return;
                    /* Das andere Ende zaehlt wie eine weiche Regel: gewaehlt nur, wenn es Wasser, Kochfeld, Fenster oder eine
                       weiche Regel wirklich bessert — nicht fuer 2 cm naeher an der Fenstermitte (dafuer rueckte die Reihe, und
                       oben blieb neben dem Fenster eine 15-cm-Luecke). */
                    var sc = [m.wasser, m.kochFenster, m.fensterAus, m.weich + (gegen ? 1 : 0), m.mitte, m.wasserMitte, m.abw];
                    if (!best || kleiner(sc, best.sc)) best = { m: m, sc: sc };
                  });
                  return;
                }
                var g = gruppen[gi];
                /* Die n gleichen Fueller dieser Gruppe auf die freien Plaetze verteilen. */
                var auf = function (si, rest) {
                  if (si === plaetze) { if (!rest) verteilen(gi + 1); return; }
                  if (!frei[si]) { auf(si + 1, rest); return; }
                  for (var n = rest; n >= 0; n--) {
                    for (var k2 = 0; k2 < n; k2++) slots[si].push(g.x);
                    auf(si + 1, rest - n);
                    slots[si].length -= n;
                  }
                };
                auf(0, g.n);
              };
              verteilen(0);
              return;
            }
            folgeB[j].var.forEach(function (v) { richt(j + 1, teile.concat([v])); });
          };
          richt(0, []);
          });
        });
        return best;
      };

      /* Welche Gruppe in welche Strecke, die Fueller dazu — bewertet wie in wandReihe. */
      var schlichtBreiten = [];
      unten.forEach(function (x) { var w = Math.round(nennMass(x.m)); if (schlicht(x.m) && schlichtBreiten.indexOf(w) < 0) schlichtBreiten.push(w); });
      var memo = {};
      var fuell = function (rest, zu) {
        var k = Math.floor(Math.max(0, rest) + 1e-6) + (zu ? 'z' : 'o');
        if (!memo[k]) {
          memo[k] = fuellen(unten, schlicht, rest, zu ? function (m) {
            return m.funktion === 'unterschrank' || m.funktion === 'apotheker';
          } : null);
        }
        return memo[k];
      };
      var kand = [];
      (kuehlHier ? [true, false] : [false]).forEach(function (mitK) {
        for (var n = namen.length; n >= 0; n--) {
          var teil = namen.slice(0, n), kombis = [[]];
          teil.forEach(function (nm) {
            var neu = [];
            kombis.forEach(function (k) { optionen(nm).forEach(function (o) { neu.push(k.concat([o])); }); });
            kombis = neu;
          });
          kombis.forEach(function (k) {
            var gew = {};
            teil.forEach(function (nm, i) { gew[nm] = k[i]; });
            var T = function (x, rl, koch) { return { x: x, r: rl, koch: !!koch }; };
            var bl = [];
            if (gew.spuele) {
              bl.push({ var: gew.gs ? [[T(gew.spuele, 'spuele'), T(gew.gs, 'gs')], [T(gew.gs, 'gs'), T(gew.spuele, 'spuele')]]
                : [[T(gew.spuele, 'spuele')]] });
            }
            /* Das Kochfeld liegt dann auf den Schubladen — erst ab 45 cm (K.kochstellen); ein 40er gibt keine
               Kochstelle, und sie landete auf einem Schrank unter dem Fenster. */
            if (ofenHoch && gew.herd && gew.schub && breite(gew.herd) === breite(ofenHoch) && nennMass(gew.schub.m) >= 45) {
              bl.push({ var: [[T(gew.schub, 'schub', true), T(ofenHoch, 'ofen')], [T(ofenHoch, 'ofen'), T(gew.schub, 'schub', true)]] });
            } else if (gew.herd) {
              bl.push({ var: gew.schub ? [[T(gew.herd, 'herd', true), T(gew.schub, 'schub')], [T(gew.schub, 'schub'), T(gew.herd, 'herd', true)]]
                : [[T(gew.herd, 'herd', true)]] });
            }
            if (mitK) bl.push({ kuehl: true, var: [[T(kuehl, 'kuehl')]] });
            bl.forEach(function (b) { b.b = b.var[0].reduce(function (a, t) { return a + nennMass(t.x.m); }, 0); });
            var zu = st.map(function () { return []; });
            var rek = function (j) {
              if (j === bl.length) {
                var fl = [], rest = 0, restZu = 0, zuIrgend = false, ersatzZahl = 0, zahlF = 0;
                st.forEach(function (q, jj) {
                  var len = q[1] - q[0], bel = zu[jj].reduce(function (a, b) { return a + b.b; }, 0);
                  var z0 = zuBei(rechtsF ? q[0] : q[1]), f = fuell(len - bel, z0);
                  var r0 = len - bel - f.reduce(function (a, x) { return a + nennMass(x.m); }, 0);
                  fl.push(f); rest += r0;
                  if (z0) { restZu += r0; zuIrgend = true; }
                  ersatzZahl += f.filter(function (x) { return !schlicht(x.m); }).length;
                  zahlF += f.length;
                });
                var abw = k.filter(function (x, i) { return x !== ROLLEN[teil[i]].x; }).length;
                var c0 = { teil: teil, k: k, zu: zu.map(function (l) { return l.slice(); }), fl: fl, mitK: mitK,
                  pflicht: teil.filter(function (nm) { return nm !== 'schub'; }).length, zuIrgend: zuIrgend,
                  rest: Math.round(rest), restZu: Math.round(restZu), ersatzZahl: ersatzZahl, abw: abw,
                  anzahl: k.length + zahlF + (mitK ? 1 : 0) };
                kand.push(c0);
                /* Die Spuele MITTIG unter das Fenster (so plant jedes Kuechenstudio): dafuer darf EIN Fueller der Strecke
                   mit der Spuele in zwei schlichte geteilt werden (60 → 30 + 30), die dann links und rechts der Spuele
                   stehen. Ein Schrank mehr; ob es sich lohnt, entscheidet die Reihenfolge-Suche (fensterMitte). */
                if (fUnter.length && wx == null && gew.spuele) {
                  var jS = -1;
                  zu.forEach(function (l, jj) { if (l.some(function (b) { return b.var[0].some(function (t) { return t.r === 'spuele'; }); })) jS = jj; });
                  if (jS > -1) {
                    var gesehen = {};
                    fl[jS].forEach(function (x, xi) {
                      var w = Math.round(nennMass(x.m));
                      if (gesehen[w]) return;
                      gesehen[w] = true;
                      schlichtBreiten.forEach(function (a) {
                        var b2 = w - a, y1 = nimm(unten, schlicht, [a]), y2 = nimm(unten, schlicht, [b2]);
                        if (a > b2 || !y1 || !y2) return;
                        var fl2 = fl.map(function (l) { return l.slice(); });
                        fl2[jS].splice(xi, 1, y1, y2);
                        kand.push(Object.assign({}, c0, { fl: fl2, anzahl: c0.anzahl + 1, geteilt: true, eltern: c0 }));
                      });
                    });
                  }
                }
                return;
              }
              for (var q = 0; q < st.length; q++) {
                var bel = zu[q].reduce(function (a, b) { return a + b.b; }, 0);
                if (bel + bl[j].b > st[q][1] - st[q][0] + 0.01) continue;
                zu[q].push(bl[j]); rek(j + 1); zu[q].pop();
              }
            };
            rek(0);
          });
        }
      });
      var fuellSc = function (c) {
        return c.zuIrgend ? [-c.pflicht, c.restZu, -c.teil.length, c.ersatzZahl, c.anzahl, c.abw]
          : [-c.pflicht, c.abw, -c.teil.length, c.rest, c.anzahl];
      };
      /* Je Lauf (mit / ohne Kuehlschrank) die besten Fuellungen in die Reihenfolge-Suche. */
      var wahl = function (mitK) {
        var liste = kand.filter(function (c) { return c.mitK === mitK && !c.geteilt; })
          .sort(function (a, b) { return kleiner(fuellSc(a), fuellSc(b)) ? -1 : (kleiner(fuellSc(b), fuellSc(a)) ? 1 : 0); })
          .slice(0, 8);
        liste = liste.concat(kand.filter(function (c) { return c.geteilt && liste.indexOf(c.eltern) > -1; }));
        var best = null;
        liste.forEach(function (c) {
          var ords = [], ok = true, summe = [0, 0, 0, 0, 0, 0, 0];
          st.forEach(function (q, j) {
            if (!ok) return;
            /* Beide Enden nur, wo die Strecke feste Stellen bekommt (siehe unten: Fenster oder nicht am Flussanfang). */
            var festeStellen = bz.fenster.length > 0 || !(rechtsF ? Math.abs(q[1] - fluss) < 0.5 : Math.abs(q[0] - fluss) < 0.5);
            var o = ordnen(q, c.zu[j], c.fl[j], festeStellen);
            if (!o) { ok = false; return; }
            ords.push(o);
            o.sc.forEach(function (v, i) { summe[i] += v; });
          });
          if (!ok) return;
          /* Zuerst die ganze Kueche (Pflichtrollen), die Spuele am Wasser, kein Kochfeld unter dem Fenster; dann
             wie in wandReihe die Fuellung (Luecke, Rollen, Standardbreiten); erst danach, wie nah die Spuele unter
             dem Fenster steht und die weichen Regeln. Vorher stand die Fenstermitte vor den Schubladen: fuer eine
             exakt mittige Spuele fielen Schubladen und Backofen-Hochschrank weg, und der Geschirrspueler wurde 45. */
          var f = fuellSc(c);
          /* Mittig heisst: bis 20 cm neben der Fenstermitte. Erst ab dann zaehlt ein Schrank mehr (geteilter Fueller). */
          var mitteStufe = Math.floor(summe[4] / 20);
          var sc = c.zuIrgend
            ? [f[0], summe[0], summe[1], f[1], f[2], summe[2], summe[3], mitteStufe, f[3], f[4], f[5], summe[4], summe[5], summe[6]]
            : [f[0], summe[0], summe[1], f[1], f[2], summe[2], summe[3], mitteStufe, f[3], f[4], summe[4], summe[5], summe[6]];
          if (!best || kleiner(sc, best.sc)) best = { c: c, ords: ords, sc: sc };
        });
        return best;
      };
      var ohne = wahl(false), mit = kuehlHier ? wahl(true) : null;
      /* Der Kuehlschrank nur, wenn keine Pflichtrolle wegfaellt und er weder die Spuele vom Wasser noch das Kochfeld
         unter ein Fenster draengt (Zeile 360 mit Fenster und Tuer: mit ihm blieb fuer das Kochfeld nur der Platz unter
         dem Fenster). An der Wand des Kochfelds (kuehlStreng) faellt auch keine andere Rolle weg. */
      var best = mit && (!ohne || (mit.c.pflicht >= ohne.c.pflicht && mit.sc[1] <= ohne.sc[1] && mit.sc[2] <= ohne.sc[2]
        && (!kuehlStreng || mit.c.teil.length >= ohne.c.teil.length))) ? mit : ohne;
      if (!best) return r === 'alles' ? null : { reihe: [], mitKuehl: false };
      if (r === 'alles' && !best.c.k.length) return null;
      var reihe = [];
      st.forEach(function (q, j) {
        var fliesst = rechtsF ? Math.abs(q[1] - fluss) < 0.5 : Math.abs(q[0] - fluss) < 0.5;
        best.ords[j].m.pos.forEach(function (p) { reihe.push({ x: p.t.x, stelle: zahl(p.a), fliesst: fliesst }); });
      });
      return { reihe: reihe, mitKuehl: best.c.mitK };
    };

    var mitWand = function (st0, wand) {
      var c = {}; for (var k in st0) { if (Object.prototype.hasOwnProperty.call(st0, k)) c[k] = st0[k]; }
      c.wand = wand;
      return c;
    };
    var mit3 = function (st0, xpos) {
      var c = {}; for (var k in st0) { if (Object.prototype.hasOwnProperty.call(st0, k)) c[k] = st0[k]; }
      c.xpos = xpos;
      return c;
    };
    /* Wie setz, aber an einer festen Stelle, die schon VOR dem Setzen gilt: setzen prueft dann genau diese
       Stelle — nicht die, an die der Fluss den Schrank erst truege (die laege womoeglich in der Tuer). */
    var setzAn = function (wand, x, stelle) {
      if (stelle == null) return setz(wand, x);
      var key = wand + '|' + zeile(x.m), n = ((s.plan || {})[key] || []).length;
      var alt = s.xpos, xs = {};
      Object.keys(alt || {}).forEach(function (k) { xs[k] = (alt[k] || []).slice(); });
      xs[key] = xs[key] || [];
      while (xs[key].length < n) xs[key].push(null);
      xs[key][n] = stelle;
      s.xpos = xs;
      if (setz(wand, x)) return true;
      s.xpos = alt;
      return false;
    };

    /* STUFE 2: mit Fenster, Tuer oder Wasser geht der Kuehlschrank an die erste Wand der Rangfolge, an der er
       GUELTIG steht (nicht vor einem Fenster) — nicht nur an die erste. Als letzter Ausweg die Wand des Kochfelds,
       wenn dort keine Rolle wegfaellt und er nicht neben Herd oder Backofen steht (1a: „am Ende der Spülen-/
       Hauptwand, nie direkt neben Herd oder Backofen"). Sonst wandert mit einem Fenster an der Seitenwand die
       Spuele dorthin, und der Kuehlschrank fiele weg, obwohl an der Hauptwand Platz ist. */
    var kuehlZiel = null, kuehlGesetzt = false;
    if (bau && kuehl) {
      var kandB = kuehlKand.concat(gerade.filter(function (w) {
        return rolle[w] === 'herd' && (!ecke(w, 'anfang') || !ecke(w, 'ende'));
      }));
      /* Jede Kandidatenwand ueber bauReihe — auch eine ohne Fenster, Tuer und Wasser: dort gilt dann dieselbe harte Regel
         „nie neben Herd oder Backofen" (der alte Weg kuehlRein nahm im Notfall das heisse Ende; Grosstest: 5 Faelle). */
      for (var kc = 0; kc < kandB.length && !kuehlZiel; kc++) {
        var wk = kandB[kc], streng = rolle[wk] === 'herd';
        var tk = bauReihe(wk, true, streng);
        if (tk && tk.mitKuehl) kuehlZiel = wk;
      }
    }

    /* 3. Die Bodenreihen, Wand fuer Wand, in Lesereihenfolge der Wand gesetzt. */
    var reihen = {}, gsUeberEck = false;
    var waendeAlle = gerade.concat(insel);
    for (var wi = 0; wi < waendeAlle.length; wi++) {
      /* DOPPELINSEL: die Kuechenseite ist das SPIEGELBILD der Raumseite — gleiche Schraenke Ruecken
         an Ruecken, Fuge auf Fuge (Betreiber 2026-09-28: „die Inselschraenke besser gleich").
         IH laeuft in Gegenrichtung; jeder Schrank steht deshalb bei len − (x + b) seines Partners. */
      if (waendeAlle[wi] === 'IH' && reihen.I) {
        var lenIH = wandObj(s, 'IH').len;
        var partner = items(s, daten, 'I', 'boden').slice().sort(function (p, q) { return q.x - p.x; });
        reihen.IH = [];
        partner.forEach(function (it) {
          var x = reihen.I[it.i];
          if (x && setz('IH', x, zahl(lenIH - (it.x + it.b)))) reihen.IH.push(x);
        });
        continue;
      }
      /* Stufe 2: eine Wand mit Fenster, Tuer oder Wasseranschluss plant bauReihe — ebenso die Wand des
         Kochfelds, wenn der Kuehlschrank als Ausweg dorthin geht. */
      var wId = waendeAlle[wi];
      var kVersuch = kuehl && (bau ? wId === kuehlZiel : wId === kuehlWand);
      var kStreng = bau && kVersuch && rolle[wId] === 'herd';
      if (bau && (bauDa(bauZ[wId]) || kVersuch)) {
        var br = bauReihe(wId, kVersuch, kStreng);
        if (br === null) return null;
        if (br.mitKuehl) kuehlGesetzt = true;
        reihen[wId] = br.reihe.map(function (e) { return e.x; });
        /* Jeder Schrank zuerst an seiner festen Stelle: fliessend gesetzt landete ein Schrank einer Reihe, die von
           rechts fliesst, fuer einen Augenblick ganz rechts — vor dem Fenster —, und setzen schob ihn „am Hindernis
           vorbei" an eine falsche feste Stelle (L-Kueche, Fenster an der Hauptwand: Kuehlschrank mitten in der Wand).
           Danach fliesst die Strecke am Anfang des Flusses wieder, wenn der Fluss dieselben Stellen ergibt. */
        var keyW = wId + '|boden', frei = [];
        /* An einer Wand mit Fenster bleibt jeder Schrank an seiner Stelle: floesse die Reihe, rutschte beim naechsten
           Entfernen (auch des Eckschranks der Nachbarwand) ein Hochschrank vor das Fenster (Grosstest mit Fenstern:
           70 Faelle „D60P steht vor dem Fenster"). Ohne Fenster fliesst die Strecke am Flussanfang wie jede Reihe. */
        var mitFenster = bauZ[wId].fenster.length > 0;
        br.reihe.forEach(function (e) {
          if (setzAn(wId, e.x, e.stelle) && e.fliesst && !mitFenster) frei.push(((s.plan || {})[keyW] || []).length - 1);
        });
        if (frei.length) {
          var vorher = items(s, daten, wId, 'boden'), xsF = xListe(s, keyW);
          frei.forEach(function (i) { xsF[i] = null; });
          var los = {}; Object.keys(s.xpos).forEach(function (k) { los[k] = (s.xpos[k] || []).slice(); });
          los[keyW] = xsF;
          var nachher = items(mit3(s, los), daten, wId, 'boden');
          var gleich = vorher.every(function (a) {
            var b = nachher.filter(function (q) { return q.i === a.i; })[0];
            return b && Math.abs(b.x - a.x) < 0.05;
          });
          if (gleich) s.xpos = los;
        }
        continue;
      }
      var r1 = wandReihe(wId);
      if (r1 === null) return null;
      var eb = extraBreite(wId);
      if (eb) {
        var pOhneE = letztePflicht, rE = wandReihe(wId, eb);
        if (rE !== null && letztePflicht >= pOhneE) r1 = rE;
        else { extraWand[wId] = []; eb = 0; letztePflicht = pOhneE; }
      }
      var mitKuehl = false;
      if (kVersuch) {
        /* Dieselbe Reihe um den Kuehlschrank kuerzer — nur, wenn dabei keine Pflichtrolle wegfaellt. */
        var ohnePflicht = letztePflicht, r2 = wandReihe(wId, breite(kuehl) + eb);
        var istGs = function (x) { return x.m.funktion === 'geschirrspuelerfront'; };
        if (r2 !== null && letztePflicht >= ohnePflicht) { r1 = r2; mitKuehl = true; kuehlGesetzt = true; }
        /* Gewaehlte Seite: lieber der Geschirrspueler ueber Eck als kein Kuehlschrank (kleine L-Kueche: der kurze Schenkel
           traegt Spuele und Kuehlschrank, nicht auch noch ihn). Nur, wenn allein er fehlt; er tritt unten an die Stelle eines
           Unterschranks der Nachbarwand, der Ecke am naechsten — findet er keinen, dieselbe Kueche ohne diesen Ausweg. */
        else if (lageAn && !s.ohneUeberEck && r2 !== null && letztePflicht === ohnePflicht - 1 && r1.some(istGs) && !r2.some(istGs)
          && r2.some(function (x) { return x.m.funktion === 'spuelen_unterschrank'; })) {
          r1 = r2; mitKuehl = true; kuehlGesetzt = true; gsUeberEck = true;
        } else kuehlFehlt = 'platz';
      }
      r1 = herdWeg(wId, r1);
      if (mitKuehl) r1 = kuehlRein(wId, r1);
      (extraWand[wId] || []).forEach(function (e) {
        var endeE = ['anfang', 'ende'].filter(function (en) { return !ecke(wId, en) && seiteEnde(wId, en) === e.seite; })[0];
        if (endeE === 'anfang') r1.unshift(e.x); else r1.push(e.x);
      });
      reihen[wId] = r1;
      r1.forEach(function (x) { setz(wId, x); });
    }
    if (bau && kuehl && !kuehlGesetzt && !kuehlFehlt) kuehlFehlt = 'platz';
    /* GESCHIRRSPUELER UEBER ECK (Stufe 2): liegt der Wasseranschluss an einer kurzen Wand, passt neben die Spuele oft kein
       Geschirrspueler (U 360/240/180, Wasser links: 90 cm frei). Statt keinen zu planen, tritt er an der Nachbarwand an die
       Stelle des schlichten Unterschranks gleicher Breite, der der gemeinsamen Ecke am naechsten steht — wie ein Kuechen-
       studio „ueber Eck" plant. Nur, wenn die Pruefung danach nicht mehr Fehler zaehlt (ersetzen); der Planungs-Check
       sagt dann ehrlich, dass er nicht direkt neben der Spuele steht. */
    if ((bau || gsUeberEck) && gs) {
      var alleWaende = gerade.concat(insel);
      var gsDa = alleWaende.some(function (w) { return items(s, daten, w, 'boden').some(function (it) { return it.m.funktion === 'geschirrspuelerfront'; }); });
      var spW = alleWaende.filter(function (w) { return items(s, daten, w, 'boden').some(function (it) { return it.m.funktion === 'spuelen_unterschrank'; }); })[0];
      if (!gsDa && spW) {
        var kandGs = [];
        geometrischeEcken(raumGeometrie(s)).forEach(function (e) {
          if (e.a !== spW && e.b !== spW) return;
          var n = e.a === spW ? e.b : e.a;
          if (gerade.indexOf(n) < 0) return;
          var nl = wandObj(s, n).len, ende = e.enden[n];
          /* Mit gewaehlter Seite (gsUeberEck) nur der erste Schrank an der Ecke — sonst stuende der Geschirrspueler am
             anderen Ende der Wand, weit weg von der Spuele —, und dort darf auch ein Schubladenschrank ohne Kochfeld weichen. */
          var itsN = items(s, daten, n, 'boden'), kochN = kochstellen(s, daten, n);
          var abVon = function (it) { return ende === 'anfang' ? it.x : nl - (it.x + it.b); };
          var ersteAb = Math.min.apply(null, itsN.filter(function (it) { return !istEck(it.m); }).map(abVon).concat([Infinity]));
          itsN.forEach(function (it) {
            var schubFrei = gsUeberEck && /^(unterschrank_schub|unterschrank)$/.test(it.m.funktion || '') && kochN.indexOf(it) < 0
              && !kochN.some(function (k) { return k.i === it.i; });
            if (!schlicht(it.m) && !schubFrei) return;
            if (gsUeberEck && Math.abs(abVon(it) - ersteAb) > 1.5) return;
            kandGs.push({ w: n, it: it, ab: abVon(it) });
          });
        });
        kandGs.sort(function (p, q) { return p.ab - q.ab; });
        for (var kg = 0; kg < kandGs.length; kg++) {
          var ziel = gsNimm([Math.round(kandGs[kg].it.b)]);
          if (!ziel || Math.round(nennMass(ziel.m)) !== Math.round(kandGs[kg].it.b)) continue;
          var grG = optGruppen(daten, ziel.m, s.farbe)[0];
          var rG = ersetzen(mitWand(s, kandGs[kg].w), daten, kandGs[kg].w + '|boden|' + kandGs[kg].it.i, ziel.i, grG ? grG.werte[0] : null);
          if (rG && !rG.sperre && !rG.fehler) { s.plan = rG.plan; s.hoff = rG.hoff; s.xpos = rG.xpos; s.wahl = rG.wahl; break; }
        }
      }
    }
    if (gsUeberEck && !gerade.concat(insel).some(function (w) {
      return items(s, daten, w, 'boden').some(function (it) { return it.m.funktion === 'geschirrspuelerfront'; });
    })) {
      var ohneUE = {};
      for (var kUE in z) { if (Object.prototype.hasOwnProperty.call(z, kUE)) ohneUE[kUE] = z[kUE]; }
      ohneUE.ohneUeberEck = true;
      return startKuecheBasis(ohneUE, daten);
    }
    var boden = { plan: s.plan, hoff: s.hoff, xpos: s.xpos, wahl: s.wahl };
    var fehlerZahl = function () { return fehlerTexte(s, daten).length; };

    /* 4. Haengeschraenke genau ueber ihren Unterschraenken; ueber dem Herd der flache
       Dunstschrank, sonst bleibt dort die Luecke fuer die Haube. Ueber dem Eckschrank der
       Eck-Haengeschrank. Jeder einzeln geprueft: stoesst einer an ein Fenster, faellt nur er. */
    var hoch = function (m) { return m.funktion === 'haengeschrank' && m.h >= 60 && /^[GW]\d+(?:-[PL])?$/.test(m.code); };
    var flach = function (m) { return m.funktion === 'haengeschrank_dunst' || (m.funktion === 'haengeschrank' && m.h <= 40); };
    /* Jeder Schritt zaehlt die Fehler der Pruefung — seit 2026-09-27 auch den Haengeschrank im Hochschrank (Stufe 2:
       vom Fenster weggerueckt, rutschte ein Haengeschrank bis 4 cm in den Hochschrank daneben). */
    var probe = function (tun) {
      var vorher = { plan: s.plan, hoff: s.hoff, xpos: s.xpos, wahl: s.wahl }, n = fehlerZahl();
      if (!tun()) return false;
      if (fehlerZahl() > n) { s.plan = vorher.plan; s.hoff = vorher.hoff; s.xpos = vorher.xpos; s.wahl = vorher.wahl; return false; }
      return true;
    };
    /* Stufe 2: was in der Haengereihe dieser Wand gesperrt ist (Fenster, Tuer). */
    var bauObenVon = function (wand) {
      return bau ? sperrZonen(s, daten, wand, 'oben', { h: geo(daten).haengeschrank_hoehe }, 0)
        .filter(function (q) { return q.art === 'bau'; }).map(function (q) { return [q.a, q.b]; }) : [];
    };
    /* Ragt ein Haengeschrank nur bis 5 cm in ein Fenster (die 59,6er Front darunter verschiebt die Reihe
       um 4 mm), rueckt er an die Fensterkante — wie der Schritt „Fugen schliessen" unten. Nicht ueber
       `min`/`max` hinaus, sonst stiesse er an den Nachbarn. */
    var ausweichen = function (wand, at, br, min, max) {
      var neu = at;
      bauObenVon(wand).forEach(function (q) {
        var ov = Math.min(neu + br, q[1]) - Math.max(neu, q[0]);
        if (ov > 0 && ov < 5) neu = neu + br / 2 < (q[0] + q[1]) / 2 ? q[0] - br : q[1];
      });
      return neu >= min - 0.01 && neu <= max + 0.01 ? zahl(neu) : at;
    };
    /* Wie weit der Haengeschrank ueber `it` dabei hoechstens ruecken darf: die Haengeschraenke ueber den Unterschraenken
       bis zum naechsten Hochschrank in dieser Richtung ruecken mit und brauchen ihre Breite. Links (-1) die kleinste,
       rechts (+1) die groesste erlaubte Stelle; ohne Hochschrank keine Grenze (Ecke, Tuer und Wandende sieht die Pruefung). */
    var hochGrenze = function (wand, it, richtung, br) {
      var reihe = items(s, daten, wand, 'boden');
      var hs = reihe.filter(function (h) {
        return h.m.reihe === 'voll' && (richtung < 0 ? h.x + h.b <= it.x + 0.01 : h.x >= it.x + it.b - 0.01);
      }).sort(function (p, q) { return richtung < 0 ? q.x - p.x : p.x - q.x; });
      if (!hs.length) return richtung < 0 ? -Infinity : Infinity;
      var h = hs[0];
      var zwischen = reihe.filter(function (u) {
        if (u.m.reihe === 'voll' || istEck(u.m)) return false;
        return richtung < 0 ? u.x >= h.x + h.b - 0.01 && u.x + u.b <= it.x + 0.01 : u.x >= it.x + it.b - 0.01 && u.x + u.b <= h.x + 0.01;
      }).reduce(function (a, u) { return a + Math.round(u.b); }, 0);
      return richtung < 0 ? h.x + h.b + zwischen : h.x - zwischen - br;
    };
    /* DER FLACHE SCHRANK UEBER DEM KOCHFELD haengt oben buendig mit den anderen Haengeschraenken; darunter sitzt die Haube
       (3D zeichnet sie). Unten angesetzt blieb ueber ihm ein Streifen Wand von 32–36 cm frei — der Betreiber sah ihn als
       Luecke (2026-09-28, Glanzia L 295/265: „لماذا ظهر هذا الفراغ هنا"). So beschreibt ihn auch der Shop: „Oberschrank ueber
       der Dunstabzugshaube". Das Mindestmass ueber dem Kochfeld (dunstMindestOff) ist damit weit uebertroffen. */
    var hStd = (function () {
      var r = nimm(oben, function (m) { return hoch(m) && m.h <= 80; }, [60]) || nimm(oben, hoch, [60]);
      return r ? r.m.h : 0;
    })();
    var obenBuendig = function (wand, x) {
      var key = wand + '|oben', n = ((s.plan || {})[key] || []).length - 1, off = zahl(hStd - x.m.h);
      if (n < 0 || !(off >= 0.5)) return;
      probe(function () {
        var ho = {}; Object.keys(s.hoff || {}).forEach(function (k) { ho[k] = (s.hoff[k] || []).slice(); });
        ho[key] = ho[key] || [];
        ho[key][n] = off;
        s.hoff = ho;
        return true;
      });
    };
    gerade.forEach(function (wand) {
      /* Nie vor dem Ende des vorigen: Geschirrspuelerfronten sind 59,6 cm breit, ein 60er
         darueber ragte 4 mm in den naechsten, und die Pruefung verwarf die Haengereihe (Glanzia).

         Lehnt sich die Bodenreihe an ihr Ende (items), lehnt sich die Haengereihe mit: von rechts
         gesetzt, jeder buendig mit der RECHTEN Kante seines Unterschranks. Sonst wandert das
         Spiel der 59,6er Front an die Ecke, und ueber dem Eckschrank bleiben 29,6 cm, in die
         kein 30er passt (gemessen: Glanzia L 240/180). */
      var ende = 0, grenze = Infinity;
      var rechts = reiheVonRechts(s, daten, wand, 'boden');
      var reiheB = items(s, daten, wand, 'boden').slice().sort(function (a, b) { return a.x - b.x; });
      if (rechts) reiheB.reverse();
      var koch = kochstellen(s, daten, wand).map(function (it) { return it.i; });
      reiheB.forEach(function (it) {
        if (istEck(it.m)) {
          if (eckO) probe(function () { return setz(wand, eckO); });
          return;
        }
        /* Ueber einem Hochschrank haengt nichts. */
        if (it.m.reihe === 'voll') return;
        var istHerd = koch.indexOf(it.i) > -1;
        /* Lunara fuehrt W60 in 72 und 92 cm; die Standardhoehe zuerst, sonst was die Serie hat
           (Livaro-Haengeschraenke sind 100 cm hoch). */
        var x = istHerd ? nimm(oben, flach, [Math.round(it.b)])
          : (nimm(oben, function (m) { return hoch(m) && m.h <= 80; }, [Math.round(it.b)]) || nimm(oben, hoch, [Math.round(it.b)]));
        if (!x) return;
        if (rechts) {
          var stelleR = Math.min(it.x + it.b, grenze) - nennMass(x.m);
          if (bau) {
            stelleR = ausweichen(wand, stelleR, nennMass(x.m), hochGrenze(wand, it, -1, nennMass(x.m)),
              Math.min(grenze - nennMass(x.m), hochGrenze(wand, it, 1, nennMass(x.m))));
          }
          if (probe(function () { return setz(wand, x, stelleR); })) { grenze = stelleR; if (istHerd) obenBuendig(wand, x); }
          return;
        }
        var stelle = Math.max(it.x, ende);
        if (bau) stelle = ausweichen(wand, stelle, nennMass(x.m), Math.max(ende, hochGrenze(wand, it, -1, nennMass(x.m))), hochGrenze(wand, it, 1, nennMass(x.m)));
        if (probe(function () { return setz(wand, x, stelle); })) { ende = stelle + nennMass(x.m); if (istHerd) obenBuendig(wand, x); }
      });
    });
    /* Erst wenn JEDE Wand ihre Haengeschraenke ueber den Unterschraenken hat — die
       Eck-Haengeschraenke eingeschlossen —, wird aufgefuellt. In einem Durchgang Wand fuer Wand
       fuellte A in der U-Kueche ihre beiden Ecken, bevor B und C ihren Eck-Haengeschrank setzen
       konnten; zwei gerade Haengeschraenke standen dann ineinander in der Ecke. */
    gerade.forEach(function (wand) {
      /* Was danach oben noch frei ist — ueber dem Eckschrank (90 unten, 60 oben: 30 cm), ueber
         einem Unterschrank ohne gleich breiten Haengeschrank —, wird mit Haengeschraenken gefuellt,
         wie ein Kuechenplaner es taete. Frei bleibt nur, was ueber dem Herd liegt: dort gehoert
         die Haube hin, nicht ein Schrank. Jeder einzeln geprueft. */
      var bodenIt = items(s, daten, wand, 'boden');
      var rechtsF = reiheVonRechts(s, daten, wand, 'boden');
      /* Der zweite Schenkel des Eckschranks der NACHBARWAND ist hier ebenfalls Unterbau: ueber ihm
         blieb oben an jeder Ecke eine 30-cm-Luecke (Eckschrank unten 90, Eck-Haengeschrank 60),
         gemessen in 1100 von 2648 Startkuechen. Als Unterbau gezaehlt, nicht als Schrank. */
      var ebN = eckBelegung(s, daten, wand, 'boden'), wlN = wandObj(s, wand).len;
      var unterbau = bodenIt.filter(function (it) { return it.m.reihe !== 'voll'; })
        .map(function (it) { return { x: it.x, b: it.b }; });
      if (ebN.anfang) unterbau.push({ x: 0, b: ebN.anfang.cm });
      if (ebN.ende) unterbau.push({ x: wlN - ebN.ende.cm, b: ebN.ende.cm });
      var herdStrecke = kochstellen(s, daten, wand).concat(bodenIt.filter(function (it) { return it.m.reihe === 'voll'; }))
        .map(function (it) { return [it.x, it.x + it.b]; });
      var belegtOben = items(s, daten, wand, 'oben').map(function (it) { return [it.x, it.x + it.b]; });
      var iv = nutzIntervall(s, daten, wand, 'oben');
      /* Stufe 2: Fenster und Tuer teilen auch die Haengereihe. Ohne sie galt die ganze Strecke ueber dem
         Fenster als EINE Luecke; die Fueller dafuer stiessen alle an das Fenster und fielen weg, und links und
         rechts davon blieb die Luecke offen (ROYAL24: 20 cm). Jetzt wird jedes Stueck daneben fuer sich gefuellt. */
      var sperr = belegtOben.concat(herdStrecke, bauObenVon(wand)).sort(function (p, q) { return p[0] - q[0]; });
      var luecken = [], x0 = iv.start;
      sperr.forEach(function (st) { if (st[0] - x0 >= 15) luecken.push([x0, st[0]]); x0 = Math.max(x0, st[1]); });
      if (iv.ende - x0 >= 15) luecken.push([x0, iv.ende]);
      luecken.forEach(function (l) {
        /* Nur ueber Unterschraenken — ueber freiem Boden haengt kein Schrank. */
        var unter = unterbau.filter(function (it) { return it.x < l[1] - 1 && it.x + it.b > l[0] + 1; });
        if (!unter.length) return;
        var von = Math.max(l[0], Math.min.apply(null, unter.map(function (it) { return it.x; })));
        var bis = Math.min(l[1], Math.max.apply(null, unter.map(function (it) { return it.x + it.b; })));
        var passtO = function (m) { return hoch(m) && m.h <= 80; };
        if (!oben.some(function (x) { return passtO(x.m); })) passtO = hoch;
        /* Lehnt sich die Reihe an ihr Ende, fuellt auch das von rechts — sonst bleibt der Rest
           vor dem Eck-Haengeschrank stehen (Lunara L 200/180: 4,6 cm, weil es ueber der 44,6er
           Geschirrspuelerfront keinen 45er Haengeschrank gibt). */
        var liste = fuellen(oben, passtO, bis - von);
        /* Stufe 2: neben einem Fenster fehlen oft nur Millimeter — die 59,6er Geschirrspuelerfront laesst 29,6 cm, wo
           ein 30er haengen soll. Bis 1 cm rueckt die Haengereihe jenseits der Luecke dafuer zur Seite (wie „Fugen
           schliessen" unten); sonst bliebe dort eine Luecke, und genau die hat ROYAL24 (Betreiber: „keine Luecke"). */
        var summeO = function (l2) { return l2.reduce(function (a, x) { return a + nennMass(x.m); }, 0); };
        var luft = bis - von, ganz = Math.ceil(luft - 1e-6);
        if (bau && ganz - luft > 0.01 && ganz - luft <= 1) {
          var liste2 = fuellen(oben, passtO, ganz), delta = summeO(liste2) - luft;
          if (summeO(liste2) > summeO(liste) + 0.5 && delta > 0 && delta <= 1.01) {
            var keyO = wand + '|oben';
            var geruckt = probe(function () {
              var xs = {}; Object.keys(s.xpos).forEach(function (k) { xs[k] = (s.xpos[k] || []).slice(); });
              items(s, daten, wand, 'oben').forEach(function (o) {
                if (rechtsF ? o.x + o.b <= von + 0.01 : o.x >= bis - 0.01) (xs[keyO] = xs[keyO] || [])[o.i] = zahl(o.x + (rechtsF ? -delta : delta));
              });
              s.xpos = xs;
              return true;
            });
            if (geruckt) { liste = liste2; if (rechtsF) von -= delta; else bis += delta; }
          }
        }
        if (rechtsF) {
          var stelleR = bis;
          liste.forEach(function (x) {
            var at = stelleR - nennMass(x.m);
            if (probe(function () { return setz(wand, x, at); })) stelleR = at;
          });
          return;
        }
        var stelle = von;
        liste.forEach(function (x) {
          if (probe(function () { return setz(wand, x, stelle); })) stelle += nennMass(x.m);
        });
      });
    });

    /* 5. Fugen unter 5 cm in der Haengereihe schliessen — zur Seite, an die sich die Reihe
       lehnt. Sie entstehen, wo es ueber einem Unterschrank keinen gleich breiten Haengeschrank
       gibt (Lunara: kein 45er ueber der 44,6er Front): der Rest ist unvermeidlich, aber er
       gehoert ans offene Ende und nicht zwischen zwei Haengeschraenke. Ein Haengeschrank sitzt
       dafuer bis zu 5 cm neben seinem Unterschrank; das sieht niemand, eine Fuge schon. */
    gerade.forEach(function (wand) {
      var key = wand + '|oben', rechtsZ = reiheVonRechts(s, daten, wand, 'boden');
      var liste = items(s, daten, wand, 'oben').filter(function (it) { return !istEck(it.m); })
        .sort(function (a, b) { return rechtsZ ? b.x - a.x : a.x - b.x; });
      liste.forEach(function (it) {
        /* Die naechste Kante auf der Anlehnseite — ein anderer Haengeschrank oder das Ende. */
        var iv0 = nutzIntervall(s, daten, wand, 'oben');
        var kante = rechtsZ ? iv0.ende : iv0.start;
        items(s, daten, wand, 'oben').forEach(function (o) {
          if (o.i === it.i) return;
          if (rechtsZ && o.x >= it.x + it.b - 0.01) kante = Math.min(kante, o.x);
          if (!rechtsZ && o.x + o.b <= it.x + 0.01) kante = Math.max(kante, o.x + o.b);
        });
        var fuge = rechtsZ ? kante - (it.x + it.b) : it.x - kante;
        if (fuge <= 0.01 || fuge >= 5) return;
        var ziel = rechtsZ ? kante - it.b : kante;
        probe(function () {
          var xs = {}; Object.keys(s.xpos).forEach(function (k) { xs[k] = s.xpos[k].slice(); });
          (xs[key] = xs[key] || [])[it.i] = ziel;
          s.xpos = xs;
          return true;
        });
      });
    });

    /* 6. DIE HAENGEREIHE ZWISCHEN ZWEI ECKEN (2026-09-28, siehe wandVersatz). Ueber den Unterschraenken gesetzt, bleibt
       auf der Hauptwand der U-Kueche oft ein Rest, der nicht zu schliessen ist: unten ruecken die Seitenreihen an ihre
       Waende, oben stehen die Eck-Haengeschraenke fest an der Wand (U 312: oben 192 cm fuer Haengeschraenke zu 5 cm,
       und ueber dem 2 cm verschobenen Unterbau blieben links 28 cm, in die keiner passt). Dann wird die Haengereihe
       dieser Wand neu gelegt: so viele Schraenke, dass hoechstens 2 x ABSTAND_MAX fehlen, die Fugen moeglichst ueber den
       Fugen der Unterschraenke, mittig — den Rest an beiden Enden schliessen die Seitenreihen, die dafuer so weit von
       ihrer Wand weg haengen (versatzKarte). Nicht bei Kochfeld oder Hochschrank an dieser Wand: dort gehoert die Luecke
       zur Haube bzw. endet die Reihe am Hochschrank. */
    if (!bau && eckO) {
      raum.waende.forEach(function (w) {
        var wand = w.id, key = wand + '|oben';
        if (!eckNachbarWand(raum, wand, 'anfang') || !eckNachbarWand(raum, wand, 'ende')) return;
        if (!sichtbareLuecken(s, daten).some(function (q) { return q.wand === wand && q.zeile === 'oben'; })) return;
        if (kochstellen(s, daten, wand).length || items(s, daten, wand, 'boden').some(function (it) { return it.m.reihe === 'voll'; })) return;
        var s0 = {}; for (var k6 in s) { if (Object.prototype.hasOwnProperty.call(s, k6)) s0[k6] = s[k6]; }
        s0.ohneVersatz = true;
        var ebO = eckBelegung(s0, daten, wand, 'oben'), obAlt = items(s0, daten, wand, 'oben');
        var eigenO = function (ende) { return obAlt.filter(function (it) { return it.eckseite === ende; })[0]; };
        var u0 = ebO.anfang ? ebO.anfang.cm : (eigenO('anfang') ? eigenO('anfang').b : null);
        var u1 = ebO.ende ? ebO.ende.cm : (eigenO('ende') ? eigenO('ende').b : null);
        if (u0 == null || u1 == null) return;
        var wl = wandObj(s, wand).len, U = wl - u0 - u1;
        var passtO = function (m) { return hoch(m) && m.h <= 80; };
        if (!oben.some(function (x) { return passtO(x.m); })) passtO = hoch;
        var br6 = [];
        oben.forEach(function (x) { if (passtO(x.m) && br6.indexOf(breite(x)) < 0 && breite(x) >= 15) br6.push(breite(x)); });
        if (!br6.length || U < 15) return;
        /* Die Fugen der Bodenreihe (mit ihrem Versatz), an denen sich die Haengereihe ausrichtet. */
        var fugen = [];
        items(s, daten, wand, 'boden').forEach(function (it) { fugen.push(it.x, it.x + it.b); });
        var eb6 = eckBelegung(s, daten, wand, 'boden');
        if (eb6.anfang) fugen.push(eb6.anfang.cm);
        if (eb6.ende) fugen.push(wl - eb6.ende.cm);
        /* Die groesste Summe bis U, der hoechstens 2 x ABSTAND_MAX fehlen. */
        var T = -1, Ug = Math.floor(U + 1e-6);
        var geht = [true];
        for (var c6 = 1; c6 <= Ug; c6++) {
          geht[c6] = br6.some(function (b) { return c6 - b >= 0 && geht[c6 - b]; });
        }
        for (var t6 = Ug; t6 >= 0 && U - t6 <= 2 * ABSTAND_MAX + 1e-6; t6--) { if (geht[t6]) { T = t6; break; } }
        if (T < 15) return;
        var start = u0 + (U - T) / 2;
        var fugKost = function (p) {
          var x = start + p, d = Infinity;
          fugen.forEach(function (g) { d = Math.min(d, Math.abs(g - x)); });
          return Math.min(d, 15);
        };
        var f6 = [0], von6 = [];
        for (var p6 = 1; p6 <= T; p6++) {
          f6[p6] = Infinity;
          for (var q6 = 0; q6 < br6.length; q6++) {
            var vor = p6 - br6[q6];
            if (vor < 0 || !(f6[vor] < Infinity)) continue;
            /* Schmale Haengeschraenke (15, 20) nur, wo es ohne sie nicht aufgeht. */
            var kost = f6[vor] + 3 + (br6[q6] < 30 ? 12 : 0) + (p6 < T ? fugKost(p6) : 0);
            if (kost < f6[p6]) { f6[p6] = kost; von6[p6] = br6[q6]; }
          }
        }
        if (!(f6[T] < Infinity)) return;
        var folge = [], p7 = T;
        while (p7 > 0) { folge.unshift(von6[p7]); p7 -= von6[p7]; }
        var vorher = { plan: s.plan, hoff: s.hoff, xpos: s.xpos, wahl: s.wahl }, n0 = fehlerZahl();
        var luecken0 = lueckenSumme(sichtbareLuecken(s, daten));
        /* Die alten geraden Haengeschraenke dieser Wand heraus, die Eck-Haengeschraenke bleiben. */
        var neuP = planKopie(s), bleib = [];
        (s.plan[key] || []).forEach(function (mi, i) { if (istEck(daten.modelle[mi])) bleib.push(i); });
        ['plan', 'hoff', 'xpos', 'wahl'].forEach(function (f) {
          var alt = (s[f] || {})[key] || [];
          neuP[f][key] = bleib.map(function (i) { return alt[i] == null ? null : alt[i]; });
        });
        s.plan = neuP.plan; s.hoff = neuP.hoff; s.xpos = neuP.xpos; s.wahl = neuP.wahl;
        var x6 = start, ok6 = true;
        folge.forEach(function (b) {
          if (!ok6) return;
          var x = nimm(oben, passtO, [b]) || nimm(oben, hoch, [b]);
          if (!x || !setz(wand, x, zahl(x6))) ok6 = false;
          x6 += b;
        });
        if (!ok6 || fehlerZahl() > n0 || lueckenSumme(sichtbareLuecken(s, daten)) >= luecken0) {
          s.plan = vorher.plan; s.hoff = vorher.hoff; s.xpos = vorher.xpos; s.wahl = vorher.wahl;
        }
      });
    }

    var fehlerIn = function () { return fehlerZahl() > 0 || !kaufbar(s, daten); };
    if (fehlerIn()) {
      s.plan = boden.plan; s.hoff = boden.hoff; s.xpos = boden.xpos; s.wahl = boden.wahl;
      if (fehlerIn()) return null;
    }
    var erg = { wand: haupt, plan: s.plan, hoff: s.hoff, xpos: s.xpos, wahl: s.wahl };
    if (kuehlFehlt) erg.kuehlFehlt = kuehlFehlt;
    return erg;
  }

  /* Die Positionen des Angebots: gleiches Modell = eine Zeile, Menge summiert. */
  /* ---------- Zubehoer: die Sockelleiste ----------

     Sockelleisten sind kein Schrank und werden trotzdem gebraucht: sie laufen vor der ganzen
     Bodenreihe durch. Gerechnet wird die Laufmeterlaenge aus dem Plan, gesetzt wird per Knopf
     wie ein Schrank — nur ohne Wandstelle und ohne Sperrpruefung.

     Das Sockelprogramm steht im KATALOG der Serie, nicht in den Theme-Einstellungen. Grund ist
     gemessen: der Worker liest die Katalogdateien aus dem veroeffentlichten Theme, die
     Section-Einstellungen aber nie. Eine Nummer, die nur im Theme steht, erreicht die
     Bestellung deshalb NICHT — das Zubehoer wurde ausgewiesen, bepreist, gedruckt und beim
     Bestellen still weggefiltert. Eine Quelle fuer beide Seiten beendet das.

     Vom Kunden entgegengenommen wird davon nichts: `daten` ist der geprueft geladene Katalog,
     nicht der Zustand. Wer Preise oder Nummern schicken koennte, koennte sich rabattfaehige
     Positionen erfinden.

     Aufbau je Serie:  sockel: { hoehe, gruppen: [ { dekor, name, artikel: [{id,vid,preis}] } ] }
     `dekor: "*"` heisst: gilt fuer JEDE Farbe dieser Serie — so fuehrt Glanzia eine weisse
     Leiste fuer die weisse UND die graue Kueche (der Korpus ist in beiden weiss), und Velora
     eine in Artisan Eiche fuer alle drei Farben. Fehlt der Block ganz, gibt es fuer diese
     Serie kein Sockelprogramm; dann wird auch keines angeboten. */

  function teilen(x) { return String(x == null ? '' : x).split(/\s*[·;|]\s*/).map(function (t) { return t.trim(); }).filter(Boolean); }

  function sockelTabelle(daten) {
    var s = daten && daten.sockel;
    return (s && Array.isArray(s.gruppen) && s.gruppen.length) ? s : null;
  }

  /* Welche Sockelgruppe gehoert zu dieser Kueche? Die Serienfarbe nennt oft Front UND Korpus
     („Gruen / Dunkle Eiche"); gesucht wird zuerst die Front, dann der Korpus. Findet sich
     nichts, wird kein Artikel behauptet. */
  function sockelGruppe(z, daten) {
    var tab = sockelTabelle(daten);
    var roh = String(z.farbe || '');
    var front = roh.split('/')[0].trim() || roh;
    var korpus = (roh.split('/')[1] || '').trim();
    if (!tab) return { gruppe: null, front: front, dekore: [], hoehe: 0, ohneProgramm: true };
    var dekore = tab.gruppen.map(function (g) { return g.name || g.dekor; });
    var basis = { gruppe: null, front: front, dekore: dekore, hoehe: tab.hoehe, ohneProgramm: false };
    var stern = tab.gruppen.filter(function (g) { return g.dekor === '*'; })[0];
    if (stern) { basis.gruppe = stern; basis.quelle = 'serie'; return basis; }
    var norm = function (x) {
      return String(x).toLowerCase().replace(/\s*(matt|hochglanz|rahmen)\s*/g, ' ').replace(/\s+/g, ' ').trim();
    };
    var treffer = function (wunsch) {
      if (!wunsch) return null;
      return tab.gruppen.filter(function (g) { return norm(g.dekor) === norm(wunsch); })[0]
        || tab.gruppen.filter(function (g) {
             return norm(wunsch).indexOf(norm(g.dekor)) > -1 || norm(g.dekor).indexOf(norm(wunsch)) > -1;
           })[0] || null;
    };
    /* KORPUS VOR FRONT (Betreiber 2026-09-27, Livaro-Komplettkuechen): in allen elf Livaro-Fotos
       traegt der Sockel das Korpusdekor — „Beige / Dunkle Eiche" steht auf dunkler Eiche,
       „Beige / Weiss" auf Weiss, „Gruen / Sonoma Eiche" auf Sonoma. Bisher wurde zuerst die Front
       gesucht, und zu Beige kam ein beiger Sockel, den keine dieser Kuechen hat. Ohne zweiten
       Teil (einfarbig) ist Korpus = Front, das Ergebnis also dasselbe. */
    var k = treffer(korpus);
    if (k) { basis.gruppe = k; basis.quelle = 'korpus'; return basis; }
    var f = treffer(front);
    if (f) { basis.gruppe = f; basis.quelle = 'front'; return basis; }
    return basis;
  }

  /* Die vier Artikel sind immer dieselben Rollen; was sich je Serie aendert, sind Nummer,
     Preis und Hoehe. Ein Artikel OHNE Variantennummer wird gar nicht erst angeboten — genau
     daran ist frueher die Bestellung stumm geworden. */
  var SOCKEL_ROLLEN = [
    /* `\u00a0` ist ein GESCHUETZTES Leerzeichen zwischen Zahl und Einheit. Ohne es brach der
       Name in der schmalen Code-Spalte des Belegs genau dort um, und auf dem Papier stand ein
       einzelnes "m" in einer eigenen Zeile — eine Einheit ohne ihre Zahl ist keine Angabe mehr.
       Als Escape geschrieben und nicht als unsichtbares Zeichen, damit niemand es beim
       Bearbeiten spurlos entfernt. */
    { id: 'sl100', laenge: 100, name: 'Sockelleiste 1\u00a0m' },
    { id: 'sl200', laenge: 200, name: 'Sockelleiste 2\u00a0m' },
    { id: 'sab',   laenge: 0,   name: 'Sockelabschluss' },
    { id: 'sabt',  laenge: 0,   name: 'Sockelabschluss tief' }
  ];

  function zubehoerArten(z, daten) {
    var sg = sockelGruppe(z, daten);
    if (!sg.gruppe) return [];
    var hoehe = r0(sg.hoehe || 15);
    var name = sg.gruppe.name || sg.gruppe.dekor || '';
    var suffix = (z.serie ? ' – ' + z.serie : '') + (name ? ' – ' + name : '');
    var out = [];
    SOCKEL_ROLLEN.forEach(function (r) {
      var a = (sg.gruppe.artikel || []).filter(function (x) { return x.id === r.id; })[0];
      if (!a || !a.vid) return;
      out.push({
        id: r.id, laenge: r.laenge, name: r.name, code: r.name,
        art: r.name + suffix, farbe: name, farbQuelle: sg.quelle || '',
        frontFarbe: sg.front || '', lager: sg.dekore, lieferbar: true,
        hoehe: hoehe, vid: String(a.vid), preis: +a.preis, img: a.img || '', sku: a.sku || '',
        mass: r.laenge ? r.laenge + ' × ' + hoehe + ' × 1,5 cm' : 'Stück'
      });
    });
    return out;
  }

  /* Laufmeter vor der Bodenreihe — daraus der Vorschlag, wie viele Stuecke noetig sind.

     Hochschraenke zaehlen MIT. Bis 2026-09-08 stand hier das Gegenteil ("vor ihnen laeuft
     keine Sockelleiste"), und das war falsch: der Shop schreibt zu jedem Hochschrank
     "Hoehenverstellbare Beine (10-12,5 cm)" — er steht auf Fuessen wie jeder Unterschrank und
     braucht denselben Sockel. Der Fehler kostete doppelt: die Breite fehlte in der Summe, UND
     der ausgelassene Schrank zerriss die Strecke, sodass `sockelEnden` zwei Stirnseiten je
     Hochschrank erfand. Gemessen an einer zweizeiligen Kueche mit drei Hochschraenken:
     540 statt 680 cm Front und 8 statt 4 offene Enden. */
  function sockelLaufmeter(z, daten) {
    var cm = 0;
    waende(z).forEach(function (w) {
      items(z, daten, w.id, 'boden').forEach(function (it) { cm += nennMass(it.m); });
    });
    return r0(cm);
  }

  /* Abschluesse braucht jede offene Stirnseite einer Sockelstrecke. „tief" gehoert an
     Strecken, die tiefer als die Reihenflucht sind — Eck- und Geraeteschraenke. */
  /* WIE VIEL SOCKELLEISTE BRAUCHT DIESE KUECHE WIRKLICH.

     `sockelLaufmeter` gibt die Frontlaenge — was vor der Bodenreihe durchlaeuft. Das ist NICHT
     der Bedarf: an jedem offenen Ende biegt die Leiste um und deckt die Seite ab. Der Planer
     nannte bisher nur die Frontlaenge, und wer danach kaufte, hatte zu wenig. Gemessen an einer
     zweizeiligen Kueche mit 360 cm Front: vier offene Stirnseiten, also 240 cm zusaetzlich —
     zwei Drittel mehr, als die Zahl behauptete.

     Ein Seitenstueck ist 60 cm lang, unabhaengig von der Schranktiefe. Owner-Ruling
     2026-09-08: der Kunde zieht die Schraenke buendig zur Arbeitsplatte, und hinten darf der
     Sockel offen bleiben. 60 cm ist die Plattentiefe — also genau die sichtbare Kante.

     Verkauft wird das nicht als Zwang: die Leisten werden ohnehin auf Mass zugeschnitten. */
  function seitenStueck() { return platteTiefe(); }

  /* Eine Insel ist ein freistehender KOERPER, keine Zeile an einer Wand: der Sockel laeuft
     rundherum. Gezaehlt wird deshalb ihr Umfang — zweimal die belegte Laenge plus zweimal ihre
     Tiefe. Gemessen an einer 240er Insel mit 90 cm Tiefe: 660 cm statt der 360, die der Planer
     nannte; die ganze Rueckseite fehlte, und die Enden waren mit 60 statt 90 cm angesetzt.
     `sockelEnden` laesst Bloecke deshalb aus — ihre zwei Enden stecken schon im Umfang. */
  function inselUmfang(z, daten) {
    var cm = 0, bl = raumGeometrie(z).bloecke || [];
    var belegtVon = function (id) {
      var n = 0;
      items(z, daten, id, 'boden').forEach(function (it) { n += nennMass(it.m); });
      return n;
    };
    /* Die DOPPELTE Insel ist EIN Koerper aus zwei Reihen Ruecken an Ruecken: rundherum laufen
       beide Fronten, die zwei Stirnseiten ueber die GANZE Tiefe (je Reihe eine Plattentiefe,
       wie jedes Seitenstueck) und, sind die Reihen verschieden lang, der Absatz dazwischen.
       Je Reihe als eigene Insel gezaehlt, stand jede Stirnseite doppelt und jede Front ein
       zweites Mal als „Rueckseite" da — gemessen 14,88 m statt 10,88 m. */
    if (bl.some(function (b) { return b.id === 'IH'; })) {
      var a = belegtVon('I'), h = belegtVon('IH');
      if (a > 0 || h > 0) cm += a + h + Math.abs(a - h) + 2 * ((a > 0 ? seitenStueck() : 0) + (h > 0 ? seitenStueck() : 0));
      return cm;
    }
    bl.forEach(function (b) {
      var belegt = belegtVon(b.id);
      if (belegt > 0) cm += 2 * belegt + 2 * (b.tiefe || 0);
    });
    return cm;
  }

  function sockelBedarf(z, daten) {
    var e = sockelEnden(z, daten);
    /* Die Vorderseite der Insel steckt schon in sockelLaufmeter — im Umfang steckt sie ein
       zweites Mal. Einmal abziehen, sonst zaehlt sie doppelt. */
    var inselVorn = 0;
    (raumGeometrie(z).bloecke || []).forEach(function (b) {
      items(z, daten, b.id, 'boden').forEach(function (it) { inselVorn += nennMass(it.m); });
    });
    return r0(sockelLaufmeter(z, daten) - inselVorn
              + inselUmfang(z, daten)
              + (e.stirnseiten || 0) * seitenStueck());
  }

  function sockelEnden(z, daten) {
    var enden = 0, tief = 0, fl = flucht();
    /* Freistehende Bloecke haben keine offenen Stirnseiten im Sinne einer Wandzeile — ihre
       zwei Enden gehoeren zum Umfang und werden dort gezaehlt. */
    var blockIds = {};
    (raumGeometrie(z).bloecke || []).forEach(function (b) { blockIds[b.id] = 1; });
    waende(z).forEach(function (w) {
      if (blockIds[w.id]) return;
      /* Auch hier zaehlen die Hochschraenke mit — sonst reissen sie die Strecke auseinander
         und jede Luecke erfindet zwei offene Stirnseiten, die es nicht gibt. */
      var bo = items(z, daten, w.id, 'boden').slice()
        .sort(function (a, b) { return a.x - b.x; });
      if (!bo.length) return;
      /* Eine Luecke von mehr als 2 cm ist eine neue Strecke mit zwei weiteren Enden. */
      var strecken = 1, i;
      for (i = 1; i < bo.length; i++) if (bo[i].x - (bo[i - 1].x + bo[i - 1].b) > 2) strecken++;
      enden += strecken * 2;
      bo.forEach(function (it) { if (nennTiefe(it.m) > fl + 1) tief++; });
    });
    /* An einer Innenecke treffen zwei Strecken aufeinander — dort ist keine Stirnseite
       offen. WELCHE Waende eine Innenecke bilden, sagt die Topologie und nicht mehr die
       Nachbarschaft im Array: in einer U-Kueche stossen A/B und A/C aneinander, nicht
       A/B und B/C. Wer nur auf A und C plant, hatte nach der alten Zaehlung zwei offene
       Stirnseiten zu viel im Angebot. */
    var eckenR = schrankEcken(raumGeometrie(z));
    var geplanteEcke = function (id, ende) {
      return eckenR.some(function (e) {
        return (e.a === id || e.b === id) && e.enden[id] === ende
          && items(z, daten, e.a, 'boden').length && items(z, daten, e.b, 'boden').length;
      });
    };
    eckenR.forEach(function (e) {
      if (items(z, daten, e.a, 'boden').length && items(z, daten, e.b, 'boden').length) enden -= 2;
    });
    /* Ein Zeilenende am WANDENDE steht an einer Wand (Betreiber 2026-09-29, siehe sockelStrecken): keine offene Stirnseite,
       kein Seitenstueck, kein Abschluss — ausser es ist eine geplante Ecke, die oben schon abgezogen ist. */
    waende(z).forEach(function (w) {
      if (blockIds[w.id]) return;
      var bo = items(z, daten, w.id, 'boden');
      if (!bo.length) return;
      var von = Infinity, bis = -Infinity;
      bo.forEach(function (it) { von = Math.min(von, it.x); bis = Math.max(bis, it.x + it.b); });
      /* Nur, wo der Raum dort eine Wand hat (endeAnRaumwand) — sonst ist die Stirnseite offen und bekommt ihr Seitenstueck. */
      var rg = raumGeometrie(z);
      if (von <= EPS_ECKE && !geplanteEcke(w.id, 'anfang') && endeAnRaumwand(z, daten, rg, w.id, 'anfang')) enden -= 1;
      if (bis >= w.len - EPS_ECKE && !geplanteEcke(w.id, 'ende') && endeAnRaumwand(z, daten, rg, w.id, 'ende')) enden -= 1;
    });
    /* `stirnseiten` ist die ROHE Zahl der offenen Enden. `enden` und `tief` teilen dieselbe
       Zahl auf die zwei Abschluss-Artikel auf und taugen deshalb nicht zum Rechnen: stehen in
       einer Strecke drei tiefe Schraenke, aber nur zwei Enden offen, wird `enden` auf 0
       gedeckelt und `enden + tief` waere 3 statt 2. Fuer die Laenge zaehlt nur diese Zahl. */
    return { enden: Math.max(0, enden - tief), tief: tief, stirnseiten: Math.max(0, enden) };
  }

  /* ---------- Wo die Sockelleiste LIEGT (2026-09-26) ----------

     `sockelBedarf` sagt, wie viel verkauft wird; hier steht, wo die Leiste im Bild liegt —
     damit 3D sie nicht mehr Schrank fuer Schrank zeichnet. So fehlte sie unter dem zweiten
     Schenkel jedes Eckschranks, unter der Geschirrspuelerfront stand eine graue buendige Platte
     in anderer Farbe und Tiefe, offene Enden hatten kein Seitenstueck, und die Insel keine
     Rueckseite — der Betreiber: „der Sockel ist nicht unter der ganzen Kueche".

     Je Wand (und Insel) die Strecken der Bodenreihe — Hochschraenke und Geschirrspuelerfronten
     eingeschlossen, die Eckreservierung der Nachbarwand ebenfalls (dort steht der zweite
     Schenkel des Eckschranks, und seine Front ist die Frontebene DIESER Wand). Eine Luecke ueber
     2 cm trennt, wie in `sockelEnden`. Die Leiste steht SOCKEL_ZURUECK cm hinter der Front (seit 2026-09-30: 0 = buendig).
       - Ecke: die Front endet dort, wo die Frontebene der Nachbarwand verlaeuft (flucht −
         Ruecksprung) — beide Leisten treffen sich im inneren Eckpunkt.
       - Wand: bis an die Wand.
       - offen: SOCKEL_ZURUECK cm vor dem Ende, und von dort ein Seitenstueck bis zur Wand
         (bei der Insel bis zur Rueckseite, die ebenfalls eine Leiste bekommt).
       - Stellplatz (vorhandener Geschirrspueler): das Geraet hat seine eigene Blende; die
         Strecke endet dort, ohne Seitenstueck.
     Rueckgabe: [{ wand, art: 'front'|'seite'|'rueck', x0, x1, z0, z1 }] — Rechtecke am Boden in
     Wandkoordinaten (x laengs, z = Abstand von der Wand), mit der Staerke der Leiste. */
  /* DER RAUM ALS RECHTECK (aus 3D in den Kern gezogen, 2026-09-29): um alle Waende und Bloecke; fehlt ihm die Tiefe (gerade
     Kueche, nur eine Wand, L/U mit kurzen Schenkeln), dann 360 cm — ausser eine Wand des Kunden schliesst ihn vorn. `luecken`:
     die Stuecke jeder Seite ohne Wand des Kunden; 3D schliesst dort den Raum mit einer Wand. Nur achsparallel, sonst null.
     Sockel und 3D lesen DIESELBE Huelle: was die Ansicht als Wand zeigt, ist fuer die Sockelleiste eine Wand. */
  function raumHuelle(raum, t) {
    var wl = raum.waende || [], xs = [], ys = [];
    if (wl.some(function (w) { return Math.abs(w.p0.x - w.p1.x) > 0.5 && Math.abs(w.p0.y - w.p1.y) > 0.5; })) return null;
    wl.forEach(function (w) { xs.push(w.p0.x, w.p1.x); ys.push(w.p0.y, w.p1.y); });
    (raum.bloecke || []).forEach(function (b) {
      var n = wandNormaleInnen(b);
      xs.push(b.p0.x, b.p1.x, b.p0.x + n.x * t, b.p1.x + n.x * t);
      ys.push(b.p0.y, b.p1.y, b.p0.y + n.y * t, b.p1.y + n.y * t);
    });
    if (!xs.length) return null;
    var h = { minX: Math.min.apply(null, xs), maxX: Math.max.apply(null, xs), minY: Math.min.apply(null, ys), maxY: Math.max.apply(null, ys) };
    if (h.maxX - h.minX < 150) return null;
    var vornZu = wl.some(function (w) { return Math.abs(w.p0.y - w.p1.y) <= 0.5 && Math.abs(w.p0.y - h.maxY) < 1; });
    if (h.maxY - h.minY < 330 && (!vornZu || h.maxY - h.minY < 1)) h.maxY = h.minY + 360;
    var seiten = { minY: [h.minX, h.maxX], maxY: [h.minX, h.maxX], minX: [h.minY, h.maxY], maxX: [h.minY, h.maxY] };
    var belegt = { minY: [], maxY: [], minX: [], maxX: [] };
    wl.forEach(function (w) {
      if (Math.abs(w.p0.y - w.p1.y) <= 0.5) {
        var sy = Math.abs(w.p0.y - h.minY) < 1 ? 'minY' : (Math.abs(w.p0.y - h.maxY) < 1 ? 'maxY' : null);
        if (sy) belegt[sy].push([Math.min(w.p0.x, w.p1.x), Math.max(w.p0.x, w.p1.x)]);
      } else {
        var sx = Math.abs(w.p0.x - h.minX) < 1 ? 'minX' : (Math.abs(w.p0.x - h.maxX) < 1 ? 'maxX' : null);
        if (sx) belegt[sx].push([Math.min(w.p0.y, w.p1.y), Math.max(w.p0.y, w.p1.y)]);
      }
    });
    h.luecken = [];
    Object.keys(seiten).forEach(function (sd) {
      var a = seiten[sd][0], e = seiten[sd][1];
      belegt[sd].sort(function (p, q) { return p[0] - q[0]; }).forEach(function (iv) {
        if (iv[0] - a >= 5) h.luecken.push({ seite: sd, a: a, b: iv[0] });
        a = Math.max(a, iv[1]);
      });
      if (e - a >= 5) h.luecken.push({ seite: sd, a: a, b: e });
    });
    return h;
  }
  /* Steht am Ende `ende` der Wand `id` quer eine Wand des Raums (Huelle)? Die Zeile am Wandende einer Kuechenzeile stoesst an
     die Seitenwand; der freie Schenkel einer L- oder U-Kueche endet mitten im Raum, wenn der Raum tiefer ist. */
  function endeAnRaumwand(z, daten, raum, id, ende) {
    /* Mit der Korpustiefe der Serie, wie 3D (die Insel liegt je nach Tiefe anders) — die Waende sind dieselben. */
    var tK = geo(daten).korpus_tiefe, raumT = raumGeometrie(z, tK);
    var h = raumHuelle(raumT, tK), wo = wandAus(raumT, id);
    if (!h || !wo) return true;
    var pE = ende === 'anfang' ? wo.p0 : wo.p1;
    return Math.abs(wo.p0.y - wo.p1.y) <= 0.5
      ? (Math.abs(pE.x - h.minX) < 1 || Math.abs(pE.x - h.maxX) < 1)
      : (Math.abs(pE.y - h.minY) < 1 || Math.abs(pE.y - h.maxY) < 1);
  }
  /* BUENDIG MIT DER FRONT (Betreiber 2026-09-30: „الزوكيل يجب ان تكون على حواف الخزائن في الجزيرة والمطبخ لانها تعطي جمالية
     اكثر وليست داخلة للداخل"): die Leiste steht in der Frontebene, nicht mehr 5 cm dahinter — an der Zeile, an offenen Enden
     (Seitenstueck an der Korpusseite) und rund um die Insel. Nur das BILD aendert sich: verkauft wird weiter sockelBedarf
     (Laufmeter der Schraenke + Seitenstuecke in Plattentiefe), und das deckt die buendige Leiste ab.
     INSEL_BLENDE: die Rueckwand der einfachen Insel (3D: Box 1,8 cm hinter dem Korpus) — die Rueckleiste steht in ihrer Flucht. */
  var SOCKEL_ZURUECK = 0, SOCKEL_STAERKE = 1.6, INSEL_BLENDE = 1.8;
  function sockelStrecken(z, daten) {
    if (!daten) return [];
    var raum = raumGeometrie(z), out = [];
    var R = SOCKEL_ZURUECK, D = SOCKEL_STAERKE, fz = flucht() - R;
    var blockIds = {};
    (raum.bloecke || []).forEach(function (b) { blockIds[b.id] = 1; });
    var laeufe = {};
    waende(z).forEach(function (w) {
      var iv = [], stell = [];
      items(z, daten, w.id, 'boden').forEach(function (it) { iv.push([it.x, it.x + it.b]); });
      var eb = blockIds[w.id] ? { anfang: null, ende: null } : eckBelegung(z, daten, w.id, 'boden');
      if (eb.anfang) iv.push([0, eb.anfang.cm]);
      if (eb.ende) iv.push([w.len - eb.ende.cm, w.len]);
      aktiveMerkmale(z).forEach(function (m) {
        if (m.wand !== w.id || !MT[m.typ] || !MT[m.typ].stellplatz) return;
        var e = elementIntervallAufWand(m);
        if (e.laenge > 0) stell.push([e.start, e.ende]);
      });
      iv.sort(function (p, q) { return p[0] - q[0]; });
      var runs = [];
      iv.forEach(function (k) {
        var r = runs[runs.length - 1];
        if (r && k[0] - r.e <= 2) r.e = Math.max(r.e, k[1]);
        else runs.push({ a: k[0], e: k[1] });
      });
      laeufe[w.id] = { w: w, runs: runs, stell: stell, insel: !!blockIds[w.id] };
    });
    var reicht = function (id, ende) {
      var l = laeufe[id];
      if (!l || !l.runs.length) return false;
      return ende === 'anfang' ? l.runs[0].a <= EPS_ECKE : l.runs[l.runs.length - 1].e >= l.w.len - EPS_ECKE;
    };
    var eckTyp = function (id, ende) {
      if (laeufe[id].insel) return 'offen';
      var e = schrankEckeAn(raum, id, ende);
      if (e) {
        var andere = e.a === id ? e.b : e.a;
        if (reicht(andere, e.enden[andere])) return 'ecke';
      }
      /* WANDENDE = WAND (Betreiber 2026-09-29: „الزوكيل ليس كامل من الحائط للحائط" — und auf die Frage, ob ein Zeilenende am
         Wandende immer zwischen Waenden steht: „نعم"). Bisher galt ein Ende ohne geplante Nachbarwand als offen: 5 cm
         zurueck und ein Seitenstueck — waehrend der Raum dort eine Wand hat. Jetzt laeuft die Leiste bis an die Wand.
         ABER NUR, WO DER RAUM DORT EINE WAND HAT (Betreiber 2026-09-29 nachmittags, Bild „Ganze Küche": „والزوكيل الجانبي غير
         موجود"): der freie Schenkel einer L-Kueche endet mitten im Raum, und dort gehoert das Seitenstueck hin. */
      return endeAnRaumwand(z, daten, raum, id, ende) ? 'wand' : 'offen';
    };
    Object.keys(laeufe).forEach(function (id) {
      var l = laeufe[id];
      /* Wandversatz: die Leiste rueckt mit ihrer Reihe; an der Ecke endet sie an der Frontebene der Nachbarreihe. */
      var vW = l.insel ? 0 : wandVersatz(z, daten, id, 'boden', raum);
      var vN = function (ende) { var n = l.insel ? null : eckNachbarWand(raum, id, ende); return n ? wandVersatz(z, daten, n, 'boden', raum) : 0; };
      var fzW = fz - vW;
      l.runs.forEach(function (r) {
        var an = function (x) { return l.stell.some(function (s) { return Math.abs(s[0] - x) <= 2 || Math.abs(s[1] - x) <= 2; }); };
        var la = r.a <= EPS_ECKE ? eckTyp(id, 'anfang') : (an(r.a) ? 'geraet' : 'offen');
        var re = r.e >= l.w.len - EPS_ECKE ? eckTyp(id, 'ende') : (an(r.e) ? 'geraet' : 'offen');
        var x0 = la === 'ecke' ? fz - vN('anfang') : (la === 'offen' ? r.a + R : r.a);
        var x1 = re === 'ecke' ? l.w.len - (fz - vN('ende')) : (re === 'offen' ? r.e - R : r.e);
        if (x1 - x0 < 0.5) return;
        /* Doppelinsel: die Mitte ist Ruecken an Ruecken, keine Rueckseite. Mit dem Ruecksprung R und
           einer Rueckleiste je Reihe klaffte an den Stirnseiten ein Spalt, durch den die zwei Leisten
           in der Mitte zu sehen waren (Betreiber 2026-09-28). Die Seitenstuecke laufen bis zur Mitte. */
        var doppelMitte = l.insel && !!laeufe.IH;
        var hinten = l.insel && !doppelMitte ? R - INSEL_BLENDE : 0;
        out.push({ wand: id, art: 'front', x0: zahl(x0), x1: zahl(x1), z0: zahl(fzW - D), z1: zahl(fzW) });
        if (la === 'offen') out.push({ wand: id, art: 'seite', x0: zahl(x0), x1: zahl(x0 + D), z0: zahl(hinten), z1: zahl(fzW - D) });
        if (re === 'offen') out.push({ wand: id, art: 'seite', x0: zahl(x1 - D), x1: zahl(x1), z0: zahl(hinten), z1: zahl(fzW - D) });
        if (l.insel && !doppelMitte) out.push({ wand: id, art: 'rueck', x0: zahl(x0), x1: zahl(x1), z0: zahl(hinten), z1: zahl(hinten + D) });
      });
    });
    return out;
  }

  function zubehoerPos(z, daten) {
    var gew = z.zubehoer || {};
    return zubehoerArten(z, daten).filter(function (a) { return (gew[a.id] || 0) > 0; }).map(function (a) {
      var menge = gew[a.id];
      var p = {}; for (var k in a) { if (Object.prototype.hasOwnProperty.call(a, k)) p[k] = a[k]; }
      p.menge = menge;
      p.betrag = a.preis * menge;
      return p;
    });
  }

  /* Ein gespeicherter Plan kann Zubehoer-Schluessel einer frueheren Fassung enthalten. Sie
     werden nicht als Position gefuehrt und hier still entfernt, damit sie nicht ewig in der
     Summe fehlen und trotzdem im Speicher stehen. */
  function zubehoerAufraeumen(z, daten) {
    var gew = z.zubehoer || {};
    /* OHNE Katalog wird nichts geloescht. Beim Wiederherstellen liegt der Katalog noch nicht
       vor — er wird erst nachgeladen —, und eine leere Artikelliste heisst dort nicht „gibt es
       nicht", sondern „weiss ich noch nicht". Wer auf Unwissen hin loescht, nimmt dem Kunden
       sein gespeichertes Zubehoer; genau das ist beim Umbau passiert und erst auf DEV
       aufgefallen. Aufgeraeumt wird, sobald der Katalog da ist. */
    if (!daten) return gew;
    var gut = {};
    zubehoerArten(z, daten).forEach(function (a) { if (gew[a.id]) gut[a.id] = gew[a.id]; });
    return gut;
  }

  function zubehoerSumme(z, daten) {
    return zubehoerPos(z, daten).reduce(function (a, p) { return a + p.betrag; }, 0);
  }

  /* ================= Arbeitsplatten (S3, 2026-09-25) =================

     Der Katalog fuehrt je Platte 12 Varianten, eine je Laengenband (30–59 … 360–400 cm). Die
     Option „Fertigstellung Links/Rechts" hat der Betreiber am 2026-09-26 aus dem Shop genommen
     („ich will kein Links oder Rechts"). Gekauft wird das Band, geliefert der Zuschnitt auf Mass —
     deshalb faehrt die Schnittlaenge als Eigenschaft der Zeile mit, und zwei Stuecke im
     selben Band bleiben zwei Zeilen.

     Welche Stuecke eine Kueche braucht, folgt aus der Bodenreihe und aus sonst nichts:
       - Hochschraenke tragen keine Platte; sie unterbrechen die Strecke.
       - Ein Stellplatz (vorhandener Geschirrspueler) liegt UNTER der Platte; er verbindet.
       - Eine Luecke ueber 2 cm trennt — dieselbe Grenze wie beim Sockel (`sockelEnden`).
       - In einer Ecke laeuft EINE Platte durch; die andere stoesst stumpf an ihre Vorderkante,
         beginnt also bei der Plattentiefe (60) und nicht bei der Eckreservierung (90). Die
         durchlaufende ist die der Wand, auf der der Eckschrank steht — sie deckt ihn ab.
         Der zweite Schenkel des Eckschranks liegt auf der Nachbarwand zwischen 60 und 90;
         steht dort sonst nichts, wird er als eigenes kurzes Stueck gefuehrt.
       - Ueber 400 cm (laengstes Band) wird in gleich lange Stuecke geteilt; zwischen ihnen
         liegt ein Stoss.
     Die Enden eines Stuecks (offen, Wand, Ecke, Hochschrank, Stoss) rechnet der Kern weiter —
     3D zeichnet daran die Fuge am Stoss —, in Korb und Beleg stehen sie nicht mehr. */
  var PLATTE_MAX = 400, PLATTE_LUECKE = 2;

  function plattenTabelle(daten) {
    var a = daten && daten.arbeitsplatten;
    return Array.isArray(a) && a.length ? a : null;
  }

  function platteVon(z, daten) {
    var t = plattenTabelle(daten);
    if (!t || !z || !z.platte) return null;
    return t.filter(function (p) { return p.id === z.platte; })[0] || null;
  }

  /* Das kleinste Band, in das die Schnittlaenge passt. Unter 30 cm gibt es kein Band —
     dann wird aus dem kleinsten zugeschnitten. */
  function plattenVariante(platte, laenge) {
    var vs = (platte && platte.varianten || []).slice()
      .sort(function (a, b) { return a.band[1] - b.band[1]; });
    for (var i = 0; i < vs.length; i++) if (laenge <= vs[i].band[1]) return vs[i];
    return null;
  }

  /* Die Stuecke als Geometrie — ohne Produkt. Daraus lesen Preis, Warenkorb, Beleg und 3D.
     Rueckgabe je Stueck: wand, label, von, bis (Wandkoordinaten), laenge (Zuschnitt, auf
     ganze cm aufgerundet), enden {links, rechts} in offen|wand|ecke|hoch|stoss, offen[],
     insel, teil. */
  /* DIE DOPPELINSEL HAT KEINE ARBEITSPLATTE AUS DEM SHOP (Betreiber 2026-09-27).

     Jede Platte im Shop ist 60 cm tief und wird nur in der Laenge zugeschnitten. Zwei Reihen
     Ruecken an Ruecken sind aber 98 cm (47er Korpus) bzw. 108 cm (52er) tief: zwei 60er
     Platten stuenden entweder 6–11 cm ueber die Fronten, oder die Schraenke ruecken an die
     Kanten und in der Mitte bleibt ein Spalt, der an beiden Enden offen ist. Beides ist kein
     sauberes Ergebnis, und in der Tiefe schneiden koennen wir nicht. Also: die Doppelinsel
     wird ohne Platte geplant und verkauft, und der Kunde liest das (INSEL_OHNE_PLATTE). Die
     einfache Insel behaelt ihre Platte — eine Reihe, eine 60er Platte, wie an der Wand. */
  var INSEL_OHNE_PLATTE = 'Insel ohne Arbeitsplatte: Die Arbeitsplatte der Doppelinsel ist nur im Bild zu sehen und nicht im Preis enthalten.';
  function inselOhnePlatte(z) {
    return (raumGeometrie(z).bloecke || []).some(function (b) { return b.id === 'IH'; });
  }

  /* `ansicht`: auch die Doppelinsel — fuer das BILD (3D). Preis, Warenkorb, Kasse und Beleg rufen
     ohne `ansicht` und bekommen sie nicht (Betreiber 2026-09-28: „nicht in den Preis, aber im Bild"). */
  function plattenStuecke(z, daten, ansicht) {
    if (!daten) return [];
    var raum = raumGeometrie(z), T = platteTiefe(), out = [];
    var blockIds = {};
    (raum.bloecke || []).forEach(function (b) { blockIds[b.id] = 1; });

    /* Erster Durchgang: Strecken je Wand, Eckreservierung schon auf die Plattentiefe gekuerzt. */
    var strecken = {}, ohneInsel = !ansicht && inselOhnePlatte(z);
    waende(z).forEach(function (w) {
      /* Die Doppelinsel bekommt keine Platte (siehe inselOhnePlatte). */
      if (ohneInsel && blockIds[w.id]) { strecken[w.id] = { w: w, runs: [], hoch: [] }; return; }
      var iv = [], hoch = [];
      items(z, daten, w.id, 'boden').forEach(function (it) {
        (it.m.reihe === 'voll' ? hoch : iv).push([it.x, it.x + it.b]);
      });
      /* Ueber den niedrigen Stellplatz laeuft die Platte; vor dem raumhohen endet sie wie am Hochschrank. */
      aktiveMerkmale(z).forEach(function (m) {
        if (m.wand !== w.id || !MT[m.typ] || !MT[m.typ].stellplatz) return;
        var e = elementIntervallAufWand(m);
        if (e.laenge > 0) (MT[m.typ].hoch ? hoch : iv).push([e.start, e.ende]);
      });
      var eb = blockIds[w.id] ? { anfang: null, ende: null } : eckBelegung(z, daten, w.id, 'boden');
      if (eb.anfang) iv.push([0, eb.anfang.cm]);
      if (eb.ende) iv.push([w.len - eb.ende.cm, w.len]);
      iv.sort(function (p, q) { return p[0] - q[0]; });
      var runs = [];
      iv.forEach(function (k) {
        var r = runs[runs.length - 1];
        if (r && k[0] - r.e <= PLATTE_LUECKE) r.e = Math.max(r.e, k[1]);
        else runs.push({ a: k[0], e: k[1], la: null, re: null });
      });
      runs.forEach(function (r) {
        if (eb.anfang && r.a <= EPS_ECKE) { r.a = Math.max(r.a, T); r.la = 'ecke'; }
        if (eb.ende && r.e >= w.len - EPS_ECKE) { r.e = Math.min(r.e, w.len - T); r.re = 'ecke'; }
      });
      strecken[w.id] = { w: w, runs: runs.filter(function (r) { return r.e - r.a > 0.5; }), hoch: hoch };
    });

    /* Zweiter Durchgang: Ecken OHNE Eckschrank. Reichen beide Strecken bis in die Ecke, laeuft
       die Platte der ersten Wand der Ecke durch, die zweite beginnt an ihrer Vorderkante. */
    var amEnde = function (sw, ende) {
      if (!sw || !sw.runs.length) return null;
      var r = ende === 'anfang' ? sw.runs[0] : sw.runs[sw.runs.length - 1];
      if (ende === 'anfang' ? r.a <= EPS_ECKE : r.e >= sw.w.len - EPS_ECKE) return r;
      return null;
    };
    /* Die Strecke, die an diesem Ende schon auf die Plattentiefe gekuerzt wurde — sie stoesst
       an die durchlaufende Platte der Nachbarwand. */
    var gekuerzt = function (sw, ende) {
      if (!sw || !sw.runs.length) return false;
      return ende === 'anfang' ? sw.runs[0].la === 'ecke' : sw.runs[sw.runs.length - 1].re === 'ecke';
    };
    schrankEcken(raum).forEach(function (e) {
      var ea = e.enden[e.a], eb2 = e.enden[e.b], sa = strecken[e.a], sb = strecken[e.b];
      var ra = amEnde(sa, ea), rb = amEnde(sb, eb2);
      if (ra && rb) {
        if (eb2 === 'anfang') { rb.a = T; rb.la = 'ecke'; } else { rb.e = sb.w.len - T; rb.re = 'ecke'; }
        if (ea === 'anfang') ra.la = 'ecke'; else ra.re = 'ecke';
      } else if (ra || rb) {
        /* Nur eine Seite reicht bis an die Wand: sie laeuft durch. Stoesst die andere an ihre
           Vorderkante, ist es eine Ecke, sonst steht sie einfach an der Nachbarwand. */
        var r = ra || rb, en = ra ? ea : eb2;
        var typ = gekuerzt(ra ? sb : sa, ra ? eb2 : ea) ? 'ecke' : 'wand';
        if (en === 'anfang') r.la = r.la || typ; else r.re = r.re || typ;
      }
    });

    /* Dritter Durchgang: Enden benennen und in Stuecke teilen. */
    waende(z).forEach(function (w0) {
      var sw = strecken[w0.id];
      if (!sw) return;
      var insel = !!blockIds[w0.id];
      var nb = insel ? { amAnfang: null, amEnde: null } : wandNachbarn(raum, w0.id);
      var anHoch = function (x) {
        return sw.hoch.some(function (h) { return Math.abs(h[0] - x) <= PLATTE_LUECKE || Math.abs(h[1] - x) <= PLATTE_LUECKE; });
      };
      sw.runs.forEach(function (r) {
        var la = r.la, re = r.re;
        if (!la) la = anHoch(r.a) ? 'hoch' : (r.a <= EPS_ECKE && nb.amAnfang ? 'wand' : 'offen');
        if (!re) re = anHoch(r.e) ? 'hoch' : (r.e >= sw.w.len - EPS_ECKE && nb.amEnde ? 'wand' : 'offen');
        var L = r.e - r.a, n = Math.max(1, Math.ceil(L / PLATTE_MAX - 1e-9)), teil = L / n, k;
        for (k = 0; k < n; k++) {
          var von = r.a + k * teil, bis = von + teil;
          var enden = { links: k === 0 ? la : 'stoss', rechts: k === n - 1 ? re : 'stoss' };
          var offen = ['links', 'rechts'].filter(function (s) { return enden[s] === 'offen'; });
          out.push({
            wand: w0.id, label: w0.label, insel: insel,
            von: zahl(von), bis: zahl(bis), laenge: Math.ceil(teil - 1e-6),
            enden: enden, offen: offen,
            teil: n > 1 ? (k + 1) + '/' + n : ''
          });
        }
      });
    });
    return out;
  }

  /* Die Stuecke mit Produkt und Preis. Ohne gewaehlte Platte: keine Position. */
  function arbeitsplattenPos(z, daten) {
    var p = platteVon(z, daten);
    if (!p) return [];
    return plattenStuecke(z, daten).map(function (s) {
      var v = plattenVariante(p, s.laenge);
      return {
        id: p.id, name: p.name, dicke: p.dicke, img: p.img || '', farbe: p.farbe || '',
        wand: s.wand, label: s.label, insel: s.insel, von: s.von, bis: s.bis,
        laenge: s.laenge, enden: s.enden, offen: s.offen, teil: s.teil,
        band: v ? v.band : null, vid: v ? String(v.vid) : '', sku: v ? v.sku : '',
        preis: v ? +v.preis : 0, menge: 1, betrag: v ? +v.preis : 0,
        art: 'Arbeitsplatte ' + p.name + ' ' + p.dicke + ' mm',
        mass: s.laenge + ' × ' + r0(platteTiefe()) + ' cm'
      };
    });
  }

  function plattenSumme(z, daten) {
    return arbeitsplattenPos(z, daten).reduce(function (a, p) { return a + p.betrag; }, 0);
  }

  /* Eine Summe fuer alles: Schraenke plus gewaehltes Zubehoer plus Arbeitsplatte. */
  function gesamt(z, daten) { return summe(z, daten) + zubehoerSumme(z, daten) + plattenSumme(z, daten); }

  /* Nur was eine Varianten-ID hat, kann in den Warenkorb — daran haengt der Knopfbetrag. */
  function korbSumme(z, daten) {
    var mitVid = function (a, p) { return p.vid ? a + p.betrag : a; };
    return summe(z, daten) + zubehoerPos(z, daten).reduce(mitVid, 0)
      + arbeitsplattenPos(z, daten).reduce(mitVid, 0);
  }

  /* EINE Beschreibung der Summe, im Kopf und im Angebot gleich. */
  function posGesamtText(z, daten) {
    var zn = zubehoerPos(z, daten).reduce(function (a, p) { return a + p.menge; }, 0);
    var pn = arbeitsplattenPos(z, daten).length;
    var n = anzahl(z, daten);
    var t = n === 1 ? '1 Schrank' : n + ' Schränke';
    if (pn) t += ' + ' + (pn === 1 ? '1 Arbeitsplatte' : pn + ' Arbeitsplatten');
    return zn ? t + ' + ' + zn + ' Zubehör' : t;
  }

  /* Gruppiert wird nach Modell UND Wahl: zwei D60, einer links und einer rechts angeschlagen,
     sind zwei verschiedene Varianten und muessen als zwei Zeilen in den Warenkorb. Vorher
     entschied allein der Modellindex — beide waeren mit derselben Varianten-ID gefahren. */
  function positionen(z, daten) {
    if (!daten) return [];
    var map = {}, out = [];
    waende(z).forEach(function (w) {
      ['boden', 'oben', 'aufsatz'].forEach(function (zl) {
        items(z, daten, w.id, zl).forEach(function (it) {
          var v = variante(it.m, z.farbe, zusatzMit(daten, z.zusatz, it.wahl));
          if (!v) return;
          var k = it.mi + '|' + (it.wahl || '');
          if (!map[k]) {
            map[k] = { mi: it.mi, m: it.m, v: v, wahl: it.wahl || '', menge: 0 };
            out.push(map[k]);
          }
          map[k].menge++;
        });
      });
    });
    return out;
  }

  function summe(z, daten) {
    return positionen(z, daten).reduce(function (s, p) { return s + p.v.preis * p.menge; }, 0);
  }
  function anzahl(z, daten) {
    return positionen(z, daten).reduce(function (s, p) { return s + p.menge; }, 0);
  }


  /* ================= Regelwerk =================

     Zwei Stufen: `fehler` blockiert den Kauf, `hinweis` informiert. Kein Angebot ohne
     bestandene Prüfung — das ist der ganze Zweck des Planers. Die Texte sind wörtlich; sie
     sind die einzige Erklärung, die der Kunde bekommt, und eine umformulierte Regel ist eine
     andere Regel. */
  /* Was sich ohne KATALOG pruefen laesst — also alles, was nur mit dem Raum und den
     eingetragenen Anschluessen zu tun hat. Es gilt ab Schritt 1 und nicht erst, wenn eine
     Serie gewaehlt ist.

     Der Grund fuer die Trennung: ein Fenster, das ueber das Wandende hinausragt, ist ein
     Fehler des RAUMES. Ihn erst nach der Serienwahl zu zeigen hiess, den Kunden erst drei
     Schritte weiterlaufen zu lassen und ihm dann zu sagen, dass Schritt 1 nicht stimmt. */
  function raumPruefung(z) {
    var out = [];
    var F = function (t) { out.push({ art: 'fehler', text: t }); };
    var H = function (t) { out.push({ art: 'hinweis', text: t }); };

    /* Eine Raumform, die diese Fassung nicht kennt. Der gespeicherte Wert bleibt stehen —
       geaendert wird nichts, gerechnet wird nichts, gekauft wird nichts. Die Bedingung
       haengt an der HEUTIGEN Form und nicht am Vermerk aus der Wanderung: waehlt der
       Kunde eine gueltige Form, ist die Sache erledigt, ohne dass jemand ein Feld
       aufraeumen muss. */
    if (!VORLAGEN[z.form]) {
      F('Die gespeicherte Küchenform „' + (z.legacyForm || z.form) + '" kennt diese Fassung '
        + 'des Planers nicht. Ihre Maße, Anschlüsse und Schränke sind vollständig erhalten '
        + 'und wurden NICHT verändert — bitte wählen Sie oben eine Küchenform aus, dann '
        + 'geht die Planung normal weiter.');
      return out;
    }

    /* ZWEI ZEILEN (Planer-App 2026-09-26): zwischen den Zeilen muss man stehen und Tueren oeffnen koennen.
       Bis hierher nahm der Kern jeden Abstand an — auch 60 cm, in denen sich beide Zeilen ueberdecken.
       Gemessen wird von Plattenkante zu Plattenkante (Abstand der Waende minus zweimal die Platte):
       unter 60 cm geht keine Schublade und keine Geschirrspuelertuer auf (Fehler), unter 100 cm ist es
       eng (Hinweis). Die Zahlen nennt der Satz, damit der Kunde weiss, woran er drehen muss. */
    if (z.form === 'zweizeilig') {
      var gang = Math.round(+z.B - 2 * platteTiefe());
      if (gang < 60) {
        F('Zwischen den beiden Zeilen bleiben nur ' + Math.max(0, gang) + ' cm — zu wenig, um Türen und Schubladen '
          + 'zu öffnen. Der Abstand der Wände muss mindestens ' + (2 * platteTiefe() + 60) + ' cm betragen.');
      } else if (gang < 100) {
        H('Zwischen den beiden Zeilen bleiben ' + gang + ' cm. Bequem sind 100 cm, für zwei Personen 120 cm.');
      }
    }

    /* Liegt jedes Bauteil noch auf seiner Wand? */
    waende(z).forEach(function (w) {
      aktiveMerkmale(z).filter(function (m) { return m.wand === w.id; }).forEach(function (m) {
        var cfg = MT[m.typ];
        if (!cfg) return;
        var t = ueberstandText(z, m);
        if (t) F(t);
      });
    });

    /* Doppelt eingetragene Einmal-Anschluesse. */
    Object.keys(EINMALIG).forEach(function (typ) {
      var gl = (z.merkmale || []).filter(function (m) { return m.typ === typ; });
      if (gl.length > 1) {
        F(MT[typ].label + ' ist ' + gl.length + '× eingetragen ('
          + gl.map(function (m) { return wandObj(z, m.wand).label; }).join(', ')
          + '). Eine Küche hat davon genau einen — löschen Sie die überzähligen in der Liste.');
      }
    });

    /* Was auf einer Wand liegt, die es in dieser Form nicht gibt. */
    var ruht = ruhendeDaten(z, null);
    if (ruht.schraenke || ruht.merkmale) {
      /* Der Plural wurde durch Anhaengen gebaut: 'Schrank' + 'e' ergab „4 Schranke", und
         'Anschluss' + 'e/Hindernis' ergab „5 Anschlusse/Hindernis" — beides stand so auf
         dem Schirm. Deutsche Plurale bekommen hier einen Umlaut, und „Hindernis" muss
         mitgehen; das Verb folgt der Zahl. Dieselbe Formulierung wie in der Notiz in
         Schritt 1, damit dieselbe Sache nicht zweimal verschieden heisst.
         Die Regel selbst ist unberuehrt: Schwere, Anzahl und `kaufbar` bleiben, wie sie
         sind — geaendert hat sich der Wortlaut. */
      var wortform = function (n, eins, viele) { return n + ' ' + (n === 1 ? eins : viele); };
      var teile = [];
      if (ruht.schraenke) teile.push(wortform(ruht.schraenke, 'Schrank', 'Schränke'));
      if (ruht.merkmale) teile.push(wortform(ruht.merkmale, 'Anschluss oder Hindernis',
        'Anschlüsse oder Hindernisse'));
      var mehrzahl = teile.length > 1 || ruht.schraenke > 1 || ruht.merkmale > 1;
      H('In dieser Küchenform gibt es ' + ruht.waende.join(' und ') + ' nicht. '
        + teile.join(' und ') + (mehrzahl ? ' liegen' : ' liegt') + ' dort und '
        + (mehrzahl ? 'sind' : 'ist') + ' NICHT gelöscht — '
        + (mehrzahl ? 'sie zählen' : 'das zählt') + ' aber auch nicht mit. '
        + 'Zurück zur vorigen Form, und alles ist wieder da.');
    }
    return out;
  }

  function pruefung(z, daten) {
    /* Die Raumpruefung gilt immer und steht deshalb VOR der Katalogpruefung — auch wenn
       noch keine Serie gewaehlt ist. */
    var out = raumPruefung(z);
    /* Drei Stufen, und sie sind nicht dasselbe:
         fehler     — so gebaut geht es nicht. Sperrt den Warenkorb.
         hinweis    — es geht, aber der Kunde soll es wissen.
         empfehlung — es ist richtig und koennte besser sein. Sperrt NICHTS.
       Vorher gab es nur zwei, und jeder gute Rat musste sich als Hinweis ausgeben.
       Wer Rat und Mangel in denselben Topf wirft, macht beide wertlos: der Kunde
       liest ueber die Mangel hinweg, weil daneben Geschmacksfragen stehen. */
    var F = function (t) { out.push({ art: 'fehler', text: t }); };
    var H = function (t) { out.push({ art: 'hinweis', text: t }); };
    var E = function (t) { out.push({ art: 'empfehlung', text: t }); };
    if (!daten) return out;

    var g = geo(daten), arbeit = arbeitsHoehe(daten, z), RH = +z.hoehe;
    var liste = function (a) { return a.join(', '); };
    var alle = [];

    /* Die Hochschränke der Serie müssen in den Raum passen — aber nur, wenn einer GEPLANT ist
       (oder ein Aufsatz, der auf ihm steht). Bis 2026-09-24 galt die Regel für jede Planung:
       Livaro (247 cm) bei der voreingestellten Raumhöhe 250 cm sperrte den Warenkorb auch mit
       einem einzigen 20-cm-Unterschrank, gemessen auf dem Live-Laden. */
    var hochGeplant = waende(z).some(function (w) {
      return ['boden', 'aufsatz'].some(function (zl) {
        return items(z, daten, w.id, zl).some(function (it) { return it.m.reihe === 'voll' || it.m.reihe === 'aufsatz'; });
      });
    });
    if (hochGeplant && g.hochschrank_hoehe + 4 > RH) {
      F('Die Hochschränke dieser Serie sind ' + r0(g.hochschrank_hoehe) + ' cm hoch — bei '
        + r0(RH) + ' cm Raumhöhe bleibt keine Luft zum Aufstellen.');
    }

    waende(z).forEach(function (w) {
      var boden = items(z, daten, w.id, 'boden');
      var oben = items(z, daten, w.id, 'oben');
      var auf = items(z, daten, w.id, 'aufsatz');
      alle = alle.concat(boden, oben, auf);

      /* Reihenlänge. Die Ecke der Nachbarwand wird benannt — sonst sucht der Kunde die
         fehlenden Zentimeter an der falschen Stelle. */
      /* Die belegte LAENGE gegen die nutzbare Laenge — nicht die aeusserste Kante. Die Kante ist
         eine Stelle an der Wand, die nutzbare Laenge ein Mass. Auf einer Wand, deren Anfang die
         Ecke der Nachbarwand belegt, lag die Kante um genau diesen Versatz hoeher: "60 cm zu
         lang" fuer eine Reihe, die passte — gemessen an der L-Kueche mit dem Eckschrank auf A
         (Wand B, 3x D60 auf 210 cm) und an der U-Kueche mit dem Eckschrank auf C (Wand A, 4x D60
         auf 270 cm). Der Warenkorb war gesperrt, im Worker ebenso. WO eine Reihe falsch steht,
         sagt der Block darunter. */
      var bb = belegtLaenge(z, daten, w.id, 'boden'), nb = nutzLaenge(z, daten, w.id, 'boden');
      var eN = eckNachbar(z, daten, w.id, 'boden');
      var wegen = eN ? ' — der Eckschrank ' + eN.code + ' aus ' + eN.wand + ' nimmt hier ' + r0(eN.cm) + ' cm' : '';
      if (bb > nb) F(w.label + ': die untere Reihe ist ' + r0(bb - nb) + ' cm zu lang' + wegen + '.');

      /* Nicht nur "zu lang", sondern WO. Eine Wand kann von beiden Enden her belegt sein;
         eine einzelne Restlaenge sagt nicht, an welchem Ende der Schrank hinausragt. */
      var raumP = raumGeometrie(z);
      ['boden', 'oben', 'aufsatz'].forEach(function (zl) {
        var iv = nutzIntervall(z, daten, w.id, zl);
        items(z, daten, w.id, zl).forEach(function (it) {
          if (it.x < iv.start - 0.5 && iv.start <= 0.5) {
            /* Kein Eck-Anspruch am Anfang: dann ragt er ueber den Wandanfang hinaus. */
            F(w.label + ': ' + it.m.code + ' ragt ' + r0(-it.x) + ' cm über den Anfang der Wand hinaus.');
          } else if (it.x < iv.start - 0.5) {
            F(w.label + ': ' + it.m.code + ' beginnt bei ' + r0(it.x) + ' cm und ragt in die '
              + 'Ecke, die ab ' + r0(iv.start) + ' cm belegt ist.');
          } else if (it.x + it.b > iv.ende + 0.5) {
            F(w.label + ': ' + it.m.code + ' endet bei ' + r0(it.x + it.b) + ' cm; nutzbar ist '
              + 'diese Reihe nur bis ' + r0(iv.ende) + ' cm.');
          }
          if (istEck(it.m) && !it.eckseite) {
            F(w.label + ': ' + it.m.code + ' ist ein Eckschrank, steht hier aber in keiner '
              + 'Ecke. Entweder an ein Wandende ziehen, an dem zwei bestückte Wände '
              + 'zusammenstoßen, oder gegen einen geraden Schrank tauschen.');
          }
        });
      });
      var bo = belegtLaenge(z, daten, w.id, 'oben'), nu = nutzLaenge(z, daten, w.id, 'oben');
      if (bo > nu) F(w.label + ': die Hängeschränke sind ' + r0(bo - nu) + ' cm zu lang.');

      /* Ein Aufsatzschrank braucht einen Unterbau gleicher Breite. */
      auf.forEach(function (a) {
        var traeger = boden.filter(function (x) { return x.m.reihe === 'voll'; }).concat(oben);
        var ok = traeger.some(function (t) { return t.x <= a.x + 1 && t.x + t.b >= a.x + a.b - 1; });
        if (!ok) {
          F(w.label + ': der Aufsatzschrank ' + a.m.code + ' steht ohne Unterbau. Er braucht einen '
            + 'Hoch- oder Hängeschrank gleicher Breite darunter.');
        }
      });

      [['oben', g.haenge_unterkante], ['aufsatz', g.hochschrank_hoehe]].forEach(function (rz) {
        var reihe = items(z, daten, w.id, rz[0]);
        reihe.forEach(function (it) {
          var ok = rz[1] + it.off + it.m.h;
          if (ok > RH) {
            F(w.label + ': ' + it.m.code + ' reicht bis ' + r0(ok) + ' cm und stößt an die '
              + r0(RH) + ' cm hohe Decke.');
          }
          /* `traeger` heisst nur „darunter liegt etwas, das ihn waagrecht deckt" — ein
             Schrank, der 18 cm darueber schwebt, hat einen Traeger und ruht doch nicht
             auf ihm. Gemeldet wird deshalb an `gestapelt`, das die Buendigkeit verlangt.
             Sonst verstummte der Hinweis, sobald irgendetwas darunter stand. */
          if (it.off > 0.5 && !it.gestapelt) {
            /* „Ohne Schrank darunter" war falsch, sobald einer darunter STAND und nur nicht
               trug — zu schmal oder nicht buendig. Der Kunde hatte die Notiz dann befolgt und
               las trotzdem denselben Satz. Ein Hinweis, der nicht verschwindet, wenn man ihm
               folgt, erzieht dazu, ihn zu ueberlesen. */
            /* „Darunter" meint, was der Kunde sieht — nicht, was in derselben Reihe steht.
               Ein Unterschrank unter dem angehobenen Haengeschrank ist fuer ihn sehr wohl ein
               Schrank darunter; er traegt ihn nur nicht. Gesucht wird deshalb ueber ALLE drei
               Reihen dieser Wand, mit der jeweiligen Unterkante der Reihe. */
            var basis = { boden: 0, oben: g.haenge_unterkante, aufsatz: g.hochschrank_hoehe };
            var meinUnten = rz[1] + it.off;
            var drunter = null;
            ['boden', 'oben', 'aufsatz'].forEach(function (zl2) {
              if (drunter) return;
              drunter = items(z, daten, w.id, zl2).filter(function (o) {
                if (o === it) return false;
                var oben2 = basis[zl2] + (o.off || 0) + o.m.h;
                return oben2 <= meinUnten + 0.6 && ueber(it.x, it.x + it.b, o.x, o.x + o.b);
              })[0] || null;
            });
            if (drunter) {
              H(w.label + ': ' + it.m.code + ' hängt ' + r0(it.off) + ' cm über der Reihe. '
                + drunter.m.code + ' steht darunter, trägt ihn aber nicht — dafür müsste er '
                + 'mindestens so breit sein und bündig darunter stehen. Einzeln montiert ist '
                + 'das in Ordnung.');
            } else {
              H(w.label + ': ' + it.m.code + ' hängt ' + r0(it.off) + ' cm über der Reihe, ohne Schrank '
                + 'darunter. Einzeln montiert ist das in Ordnung.');
            }
          } else if (it.traeger && it.traeger.b + 2 < it.b) {
            F(w.label + ': ' + it.m.code + ' (' + r0(it.b) + ' cm) steht auf dem schmaleren '
              + it.traeger.m.code + ' (' + r0(it.traeger.b) + ' cm) — der Überhang hat keinen Halt.');
          }
          if (istEck(it.m)) {
            var sp = eckSperre(z, daten, w.id, rz[0], it.m, { wand: w.id, zeile: rz[0], i: it.i },
              it.eckseite);
            if (sp) {
              F(w.label + ': ' + it.m.code + ' sitzt in der Ecke, in der ' + sp.was + ' ('
                + sp.wand + ') liegt — der Eckschrank kann nicht ausweichen.');
            }
          }
        });
      });

      /* Überschneidungen. Oben zählt das Höhenband, unten die blosse Stelle. */
      ['oben', 'aufsatz'].forEach(function (zl) {
        var arr = items(z, daten, w.id, zl);
        arr.forEach(function (it) {
          arr.forEach(function (o2) {
            if (o2.i <= it.i) return;
            if (ueber(it.x, it.x + it.b, o2.x, o2.x + o2.b)
                && ueber(it.off, it.off + it.m.h, o2.off, o2.off + o2.m.h)) {
              F(w.label + ': ' + it.m.code + ' und ' + o2.m.code
                + ' überschneiden sich — einen davon zur Seite oder höher ziehen.');
            }
          });
        });
      });
      boden.forEach(function (it) {
        boden.forEach(function (o2) {
          if (o2.i <= it.i) return;
          if (ueber(it.x, it.x + it.b, o2.x, o2.x + o2.b)) {
            F(w.label + ': ' + it.m.code + ' und ' + o2.m.code
              + ' stehen an derselben Stelle — einen davon zur Seite ziehen.');
          }
        });
      });
      /* Haengeschrank gegen Hochschrank (2026-09-27): der Vergleich oben sah nur die Haengereihe, der Hochschrank steht
         in der Bodenreihe. Die Kasse nahm deshalb einen G60 im Kuehlumbau an. Bis 0,5 cm gelten als das Spiel der
         59,6er Geschirrspuelerfront (so in jeder Startkueche mit ihr neben einem Hochschrank). */
      oben.forEach(function (it) {
        hochZonenOben(z, daten, w.id, it.m, it.off).forEach(function (h) {
          if (Math.min(it.x + it.b, h.b) - Math.max(it.x, h.a) > 0.5) {
            F(w.label + ': ' + it.m.code + ' und ' + h.code + ' überschneiden sich — einen davon zur Seite ziehen.');
          }
        });
      });

      var treffer = function (arr, a1, a2) {
        return arr.filter(function (x) { return ueber(a1, a2, x.x, x.x + x.b); })
                  .map(function (x) { return x.m.code; });
      };

      /* EMPFEHLUNGEN. Nichts hiervon ist falsch geplant — es ist bloss besser oder
         schlechter. Deshalb eine eigene Stufe: waeren es Hinweise, staenden sie neben
         echten Maengeln und wuerden mit ihnen zusammen ueberlesen. Sie sperren nichts. */
      var mkm = aktiveMerkmale(z).filter(function (x) { return x.wand === w.id; });
      var spuelSchrank = boden.filter(function (x) { return x.m.funktion === 'spuelen_unterschrank'; });
      mkm.filter(function (x) { return x.typ === 'spueler'; }).forEach(function (x) {
        if (!spuelSchrank.length) return;
        var mitte = x.x + x.breite / 2;
        var nah = spuelSchrank.some(function (sp) {
          return Math.abs(mitte - (sp.x + sp.b / 2)) <= sp.b / 2 + x.breite / 2 + 65;
        });
        if (!nah) {
          E(w.label + ': der Geschirrspüler steht weit vom Spülenschrank entfernt. Direkt '
            + 'daneben teilt er sich Zulauf und Ablauf — sonst braucht es eine zweite '
            + 'Leitung unter der Reihe.');
        }
      });
      var kochSchrank = boden.filter(function (x) {
        return /herdumbau|geraete_unterschrank|kochfeld/.test(x.m.funktion || '');
      });
      if (kochSchrank.length && !mkm.some(function (x) { return x.typ === 'herd' || x.typ === 'gas'; })) {
        E(w.label + ': für ' + kochSchrank[0].m.code + ' ist an dieser Wand kein Herd- oder '
          + 'Gasanschluss eingetragen. Ein Kochfeld braucht Starkstrom — die Dose gehört in '
          + 'den Plan, damit der Elektriker sie sieht.');
      }

      aktiveMerkmale(z).filter(function (m) { return m.wand === w.id; }).forEach(function (m) {
        var cfg = MT[m.typ];
        /* Eine Quelle fuer "liegt das noch auf der Wand?" — und sie nennt die SEITE.
           Nichts wird dabei stillschweigend zurechtgerueckt: die Zahl des Kunden bleibt
           stehen, und hier steht, um wie viel sie nicht passt. */
        /* Die Meldung selbst steht in raumPruefung — sie braucht keinen Katalog. Hier
           wird nur noch abgebrochen, wenn das Bauteil ganz ausserhalb liegt: alles
           Weitere unten setzt voraus, dass es ueberhaupt auf der Wand ist. */
        if (m.x > w.len) return;

        if (m.typ === 'wasser' || m.typ === 'abfluss') {
          var sp = boden.filter(function (x) { return x.m.funktion === 'spuelen_unterschrank'; });
          var tr = sp.some(function (x) { return x.x - cfg.tol <= m.x && x.x + x.b + cfg.tol >= m.x; });
          var genau = sp.some(function (x) { return x.x <= m.x && x.x + x.b >= m.x; });
          if (!sp.length) {
            F(w.label + ': ' + cfg.label + ' bei ' + r0(m.x) + ' cm, aber kein Spülenunterschrank gesetzt.');
          } else if (!tr) {
            /* WARNUNG, nicht Fehler: der Satz sagt selbst, dass es geht — nur eben mit
               Installateur. Ein Hinweis, der den Kauf sperrt, widerspricht seinem
               eigenen Text. Physisch unmoeglich ist hier nichts. */
            H(w.label + ': ' + cfg.label + ' bei ' + r0(m.x) + ' cm liegt mehr als ' + cfg.tol
              + ' cm vom Spülenschrank entfernt — dafür braucht es einen Installateur.');
          } else if (!genau) {
            H(w.label + ': ' + cfg.label + ' liegt neben dem Spülenschrank. Innerhalb von '
              + cfg.tol + ' cm ist das Verziehen der Leitung üblich.');
          }
        }

        if (m.typ === 'herd' || m.typ === 'gas') {
          /* Was an einem Herdanschluss stehen darf, ist mehr als ein Herdumbauschrank.

             Ein KOCHFELD wird in die Arbeitsplatte gesetzt; darunter genuegt irgendein
             Unterschrank, kein besonderer. Ein EINBAUBACKOFEN braucht sein Gehaeuse — das ist
             der Fall, den die Funktion `herdumbau | geraete_unterschrank | hochschrank_geraet`
             abdeckt. Und ein FREISTEHENDER Herd braucht ueberhaupt keinen Schrank; er wird
             zwischen zwei gestellt.

             Bis 2026-09-09 verlangte diese Stelle ausschliesslich ein Geraetegehaeuse und
             SPERRTE sonst den Warenkorb. Das war in drei Richtungen falsch: es hielt das
             Kochfeld fuer ein Einbaugeraet, es kannte den freistehenden Herd nicht, und es
             machte aus einer Planungsfrage einen Kaufabbruch. Der Betreiber hat es gemeldet —
             der Kunde hatte eine Schrankreihe unter dem Anschluss und kam trotzdem nicht
             weiter.

             Geblieben ist ein HINWEIS fuer den einen Fall, der wirklich auffaellt: am Anschluss
             steht gar nichts, worauf oder worin ein Geraet Platz haette. Er sagt, was moeglich
             ist, statt zu verbieten. Ein Hochschrank zaehlt nicht mit — auf ihm laesst sich
             nichts einbauen; steht er ueber dem Anschluss, meldet das der Fehler darunter. */
          var traegt = boden.filter(function (x) {
            return x.m.reihe === 'unten'
              || /herdumbau|geraete_unterschrank|hochschrank_geraet/.test(x.m.funktion || '');
          });
          var nah = traegt.some(function (x) { return Math.abs((x.x + x.b / 2) - m.x) <= cfg.tol; });
          if (!nah) {
            H(w.label + ': ' + cfg.label + ' bei ' + r0(m.x) + ' cm — dort steht kein '
              + 'Unterschrank. Ein Kochfeld wird in die Arbeitsplatte über einem Unterschrank '
              + 'gesetzt, ein Einbaubackofen braucht seinen Umbauschrank; ein freistehender '
              + 'Herd kommt ohne aus.');
          }
          var hinter = boden.filter(function (x) {
            return x.m.reihe === 'voll' && x.x <= m.x && x.x + x.b >= m.x;
          });
          if (hinter.length) {
            F(w.label + ': ' + cfg.label + ' verschwindet hinter dem Hochschrank ' + hinter[0].m.code
              + ' und bleibt nicht zugänglich.');
          }
          if (m.typ === 'gas' && !oben.filter(function (x) { return x.m.funktion === 'haengeschrank_dunst'; }).length) {
            H(w.label + ': Gaskochfeld ohne Hängeschrank für die Haube. Für Gas ist wirksame '
              + 'Abluft Pflicht — Haube unter Schritt 2 setzen.');
          }
          /* Die Haube unter einem Dunstschrank muss denselben Abstand halten wie eine gesetzte. */
          oben.filter(function (x) { return x.m.funktion === 'haengeschrank_dunst'; }).forEach(function (x) {
            var uk = g.haenge_unterkante + (x.off || 0), luft = uk - arbeit;
            var soll = m.typ === 'gas' ? HAUBE.abstandGas : HAUBE.abstandElektro;
            if (luft < soll) {
              F(w.label + ': die Haube unter ' + x.m.code + ' hängt ' + mm(luft) + ' cm über der '
                + 'Arbeitsplatte. Über ' + (m.typ === 'gas' ? 'Gas' : 'Elektro') + ' sind ' + soll
                + ' cm Mindestabstand nötig — Schrank senkrecht höher ziehen.');
            }
          });
        }

        /* Der Stellplatz braucht eine echte Luecke: steht dort ein Schrank, passt das Geraet
           nicht — und zwei Geraeteplaetze (Stellplatz UND Geschirrspuelerfront) sind einer
           zu viel. */
        if (m.typ === 'spueler') {
          var drin = boden.filter(function (x) { return ueber(m.x, m.x + m.breite, x.x, x.x + x.b); })
            .map(function (x) { return x.m.code; });
          if (drin.length) {
            F(w.label + ': der Stellplatz für den Geschirrspüler bei ' + r0(m.x) + ' cm ist durch '
              + drin.join(', ') + ' belegt. Das Gerät braucht ' + r0(m.breite) + ' cm freie Nische.');
          }
          if (m.x + m.breite > w.len + 0.5) {
            F(w.label + ': der Stellplatz ragt ' + r0(m.x + m.breite - w.len) + ' cm über das Wandende hinaus.');
          }
          if (boden.some(function (x) { return x.m.funktion === 'geschirrspuelerfront'; })) {
            H(w.label + ': es ist zusätzlich eine Geschirrspülerfront geplant. Entweder Stellplatz '
              + 'ohne Front oder Front — beides zusammen ergibt zwei Geräteplätze.');
          }
        }
        /* Der eigene Kuehlschrank steht raumhoch: weder unten noch oben darf etwas in seiner Nische stehen. */
        if (m.typ === 'kuehl') {
          /* Mit 1 cm Spiel: die 59,6er Geschirrspuelerfront verschiebt die Reihe um 4 mm, und der
             Haengeschrank daneben ragte dann 0,4 cm „in die Nische" — das sieht und stoert niemand. */
          var drinK = boden.concat(oben).filter(function (x) {
            return Math.min(m.x + m.breite, x.x + x.b) - Math.max(m.x, x.x) > 1;
          }).map(function (x) { return x.m.code; });
          if (drinK.length) {
            F(w.label + ': der Stellplatz für den Kühlschrank bei ' + r0(m.x) + ' cm ist durch '
              + drinK.join(', ') + ' belegt. Das Gerät braucht ' + r0(m.breite) + ' cm freie Nische bis unter die Decke.');
          }
          if (m.x + m.breite > w.len + 0.5) {
            F(w.label + ': der Stellplatz ragt ' + r0(m.x + m.breite - w.len) + ' cm über das Wandende hinaus.');
          }
        }

        if (m.typ === 'haube') {
          var gasDa = z.merkmale.some(function (x) { return x.wand === w.id && x.typ === 'gas'; });
          var soll2 = gasDa ? HAUBE.abstandGas : HAUBE.abstandElektro;
          var luft2 = m.hoehe - arbeit;
          if (luft2 < soll2) {
            F(w.label + ': die Haube hängt ' + mm(luft2) + ' cm über der Arbeitsplatte. Über '
              + (gasDa ? 'Gas' : 'Elektro') + ' sind ' + soll2
              + ' cm Mindestabstand nötig — senkrecht höher ziehen.');
          }
          if (m.hoehe + HAUBE.h > RH) F(w.label + ': die Haube stößt an die Decke.');
          var kochen = boden.filter(function (x) {
            return /herdumbau|geraete_unterschrank/.test(x.m.funktion || '');
          });
          var mitte = m.x + (m.breite || 60) / 2;
          if (kochen.length) {
            if (!kochen.some(function (x) { return Math.abs((x.x + x.b / 2) - mitte) <= 20; })) {
              F(w.label + ': die Haube sitzt nicht über der Kochstelle ('
                + kochen.map(function (x) { return x.m.code; }).join(', ') + ').');
            } else if (kochen.some(function (x) { return x.b > (m.breite || 60) + 1; })) {
              H(w.label + ': das Kochfeld ist breiter als die Haube — eine 90-cm-Haube fängt den '
                + 'Dampf besser.');
            }
          } else {
            H(w.label + ': Haube geplant, aber noch kein Herd- oder Kochfeldschrank darunter.');
          }
          oben.forEach(function (x) {
            var uk = g.haenge_unterkante + (x.off || 0);
            if (ueber(m.x, m.x + (m.breite || 60), x.x, x.x + x.b)
                && uk < m.hoehe + HAUBE.h - 0.5 && x.m.funktion !== 'haengeschrank_dunst') {
              F(w.label + ': ' + x.m.code + ' reicht bis ' + r0(uk) + ' cm herab und lässt der '
                + 'Haube keine 15 cm — Schrank höher ziehen oder einen flachen Schrank für die '
                + 'Haube wählen.');
            }
          });
        }

        if (m.typ === 'steckdose') {
          /* Verdeckt ist die Dose nur, wenn der Schrank sie waagrecht UND SENKRECHT ueberdeckt.
             Die Hoehe fehlte hier ganz: ein Haengeschrank haengt bei Velora von 140 bis 176 cm,
             die Dose sitzt auf 110 — sie ist frei erreichbar, und trotzdem stand da, sie sei es
             nicht. Ein Hochschrank (Reihe `voll`) steht dagegen auf dem Boden und deckt sie
             wirklich zu. */
          var dh = (m.hoehe == null ? MT.steckdose.hoehe : +m.hoehe);
          var senkrecht = function (x) {
            var u = (x.m.reihe === 'voll') ? (x.off || 0) : g.haenge_unterkante + (x.off || 0);
            return dh >= u && dh <= u + x.m.h;
          };
          var verdeckt = oben.concat(boden.filter(function (x) { return x.m.reihe === 'voll'; }))
            .filter(function (x) { return x.x <= m.x && x.x + x.b >= m.x && senkrecht(x); });
          if (verdeckt.length) {
            H(w.label + ': Steckdose bei ' + r0(m.x) + ' cm auf ' + r0(dh) + ' cm Höhe liegt hinter '
              + verdeckt[0].m.code + ' und ist nicht mehr erreichbar.');
          }
        }

        /* Die Strecke des Bauteils auf der Wand — EINMAL gerechnet, hier und in
           sperrZonen aus derselben Funktion. Vorher stand `m.x, m.x + m.breite` an vier
           Stellen nebeneinander, und die Tuer rechnete ihre 5 cm Luft an einer fuenften. */
        var miv = elementIntervallAufWand(m);

        if (m.typ === 'fenster') {
          /* Ein Haengeschrank steht nur dann VOR dem Fenster, wenn sich die Hoehenbaender
             schneiden. Frueher galt jeder Haengeschrank auf dieser Strecke als Konflikt —
             auch ueber einem niedrigen, schmalen Fenster, das laengst zu Ende ist, bevor
             die Haengeschraenke anfangen. sperrZonen wusste das immer; die Pruefung nicht,
             und die beiden widersprachen sich. Jetzt fragen beide dieselbe Rechnung. */
          var hoch = oben.concat(boden.filter(function (x) { return x.m.reihe === 'voll'; }))
            .filter(function (x) {
              var zn = sperrZonen(z, daten, w.id, zeile(x.m), x.m, x.off).filter(function (q) {
                return q.art === 'bau' && q.was === 'Fenster' && ueber(x.x, x.x + x.b, q.a, q.b);
              });
              return zn.length > 0;
            });
          if (hoch.length) {
            /* `hoch` sind Stellungen, keine Namen — `liste` machte daraus den Platzhaltertext eines
               Objekts, und die Meldung nannte keinen Schrank. Sie sperrt den Kauf; der Kunde musste den
               Schrank selbst suchen. Die uebrigen Meldungen dieser Pruefung nennen den Code, diese jetzt auch. */
            F(w.label + ': ' + liste(hoch.map(function (x) { return x.m.code; })) + ' steht vor dem Fenster bei ' + r0(m.x) + ' cm.');
          }
          if (m.hoehe < arbeit) {
            var tief = treffer(boden.filter(function (x) { return x.m.reihe !== 'voll'; }),
                               miv.start, miv.ende);
            if (tief.length) {
              F(w.label + ': Brüstung ' + r0(m.hoehe) + ' cm liegt unter der Arbeitshöhe von '
                + mm(arbeit) + ' cm — ' + liste(tief) + ' passt dort nicht unter das Fenster.');
            }
          }
        }

        if (m.typ === 'tuer') {
          var c = treffer(boden.concat(oben, auf), miv.start - 5, miv.ende + 5);
          if (c.length) {
            F(w.label + ': ' + liste(c) + ' steht im Türbereich. Der Flügel braucht die volle '
              + 'Breite plus 5 cm Luft.');
          }
        }

        if (m.typ === 'heizkoerper') {
          var ch = treffer(boden, miv.start, miv.ende);
          if (ch.length) F(w.label + ': ' + liste(ch) + ' stellt den Heizkörper zu.');
          if (m.hoehe > 140) {
            var co = treffer(oben, miv.start, miv.ende);
            if (co.length) {
              H(w.label + ': der Heizkörper reicht bis ' + r0(m.hoehe) + ' cm — ' + liste(co)
                + ' sitzt darüber sehr knapp.');
            }
          }
        }
      });
    });

    if (alle.length) {
      if (!alle.some(function (x) { return x.m.funktion === 'spuelen_unterschrank'; })) {
        H('Es ist noch kein Spülenunterschrank geplant — ohne Spüle wird die Küche nicht abgenommen.');
      }
      if (!alle.some(function (x) { return /kuehlumbau/.test(x.m.funktion || ''); })) {
        H('Kein Kühlumbau in der Planung. Wenn der Kühlschrank frei stehen soll, ist das in Ordnung.');
      }
      /* Der Test auf doppelte Einmal-Anschluesse steht jetzt in raumPruefung: er braucht
         keinen Katalog, und er soll schon in Schritt 2 erscheinen. */
      if (!aktiveMerkmale(z).length) {
        H('Es sind noch keine Anschlüsse eingetragen. Ohne Wasser, Abfluss und Strom kann der '
          + 'Planer die Positionen nicht prüfen.');
      }
    }

    if (z.verloren) {
      H(z.verloren === 1
        ? 'Beim Serienwechsel hatte ein Schrank in der neuen Serie keine Entsprechung und wurde aus der Zeile genommen.'
        : 'Beim Serienwechsel hatten ' + z.verloren + ' Schränke in der neuen Serie keine Entsprechung und wurden aus der Zeile genommen.');
    }
    var ruht = ruhendeMerkmale(z);
    if (ruht.length) {
      H(ruht.length === 1
        ? 'Ein Anschluss liegt an einer Wand, die die aktuelle Form nicht hat (' + MT[ruht[0].typ].label + '). Er ruht und wird nicht geprüft.'
        : ruht.length + ' Anschlüsse liegen an Wänden, die die aktuelle Form nicht hat. Sie ruhen und werden nicht geprüft.');
    }

    /* KOCHFELD OHNE PLATZ (Grosstest 2026-09-27): steht ein Backofen-Hochschrank in der Kueche, aber
       kein Herdumbau und kein Unterschrank, der ein 60er Kochfeld tragen kann (K.kochstellen), hat die
       Kueche keine Kochstelle — der Kunde hat z. B. die Schubladen daneben gegen einen Geschirr-
       spueler getauscht. Das ist seine Entscheidung und sperrt nichts; sagen muss man es ihm. */
    var raumK = raumGeometrie(z), wK = raumK.waende.concat(raumK.bloecke);
    var hatHochOfen = wK.some(function (w) {
      return items(z, daten, w.id, 'boden').some(function (it) { return it.m.funktion === 'hochschrank_geraet'; });
    });
    if (hatHochOfen && !wK.some(function (w) { return kochstellen(z, daten, w.id).length; })) {
      H('Für das Kochfeld fehlt ein Unterschrank ab 45 cm (z. B. ein Schubladenschrank) neben dem '
        + 'Backofen-Hochschrank — so hat die Küche keine Kochstelle.');
    }

    /* Ein Konflikt wird EINMAL genannt. Dasselbe Paar aus zwei Blickrichtungen ist eine
       Meldung, nicht zwei. */
    var gesehen = {};
    return out.filter(function (x) {
      var k = x.art + '|' + x.text;
      if (gesehen[k]) return false;
      gesehen[k] = 1;
      return true;
    });
  }

  /* Kein Angebot ohne bestandene Prüfung. Hinweise blockieren nie. */
  function kaufbar(z, daten) {
    return anzahl(z, daten) > 0 && !pruefung(z, daten).some(function (m) { return m.art === 'fehler'; });
  }


  /* ================= Angebot (Schritt 5) ================= */

  /* Die Stückliste. Gleiches Modell = eine Zeile, Menge summiert — der Kunde will wissen, was
     er kauft, nicht an welcher Wand jedes Stück steht. Wo es steht, geht als Eigenschaft mit
     in den Warenkorb, damit die Bestellung dem Plan zuordenbar bleibt. */
  function stueckliste(z, daten) {
    return positionen(z, daten).map(function (p) {
      return {
        code: p.m.code,
        art: modellName(p.m) + (p.wahl ? ' · ' + p.wahl : ''),
        mass: r0(nennMass(p.m)) + '×' + r0(p.m.h) + ' cm',
        menge: p.menge,
        einzel: eur(p.v.preis),
        zeile: eur(p.v.preis * p.menge),
        img: p.v.img || '',
        sku: p.v.sku || '',
        vid: p.v.vid
      };
    });
  }

  /* Geräte stehen im Set genau einmal. Die Haube ist ein GERÄT, kein Schrank, und wird nicht
     über diese Serie geliefert — sie gehört als Position OHNE Preis ins Angebot, damit der
     Kunde sie beim Kauf nicht übersieht. */
  function geraeteListe(z) {
    var out = [];
    Object.keys(MT).forEach(function (typ) {
      if (!MT[typ].geraet) return;
      var da = aktiveMerkmale(z).filter(function (m) { return m.typ === typ; });
      if (!da.length) return;
      var m = da[0];
      out.push({
        kurz: MT[typ].kurz, name: MT[typ].label,
        mass: (m.breite || 60) + '×' + HAUBE.h + '×' + HAUBE.t + ' cm · UK ' + r0(m.hoehe)
              + ' cm · ' + wandObj(z, m.wand).label,
        menge: da.length > 1 ? da.length + '×' : '1×'
      });
    });
    return out;
  }

  /* Wo genau steht dieses Modell? Für die Warenkorb-Eigenschaften. Ein Modell kann mehrfach
     vorkommen; genannt werden alle Stellen, damit die Bestellung dem Plan folgt. */
  function stellen(z, daten, mi, wahl) {
    var out = [];
    waende(z).forEach(function (w) {
      ['boden', 'oben', 'aufsatz'].forEach(function (zl) {
        items(z, daten, w.id, zl).forEach(function (it) {
          if (it.mi !== mi) return;
          if (wahl != null && (it.wahl || '') !== wahl) return;
          out.push(w.label + ' ' + r0(it.x) + ' cm (' + zl + ')');
        });
      });
    });
    return out;
  }

  /* Die Nutzlast für /cart/add.js. Sie wird hier GEBAUT, nicht gesendet — das Senden ist eine
     Handlung des Kunden. */
  /* Zubehoer faehrt in derselben Ladung mit — aber nur, was eine Nummer aus dem Shop hat.
     Ohne Nummer bleibt die Position im Angebot sichtbar und aus dem Warenkorb draussen; genau
     das sagt auch die Fussnote unter dem Knopf. */
  /* ---------- Planungsbeleg ----------

     Der Planer rechnet, das Druckdokument zeigt nur. Statt die ganze Geometrie ein zweites Mal
     zu schreiben, wird hier EINMAL alles Fertige abgelegt — die Zeichnungen als SVG-Text, die
     Tabellen als Zeilen — und die Bedienung setzt es auf Papier. */
  function mm(x) { return String(r0(x * 10) / 10).replace('.', ','); }

  /* Die Blende, die einen vollintegrierten Geschirrspueler verkleidet. Das Geraet selbst
     gehoert nicht dazu — und genau das muss auf dem Papier stehen. */
  var FRONT_HINWEIS = 'Möbelfront für einen vollintegrierten Geschirrspüler. Das Gerät selbst '
    + 'gehört nicht zum Lieferumfang. Gerätemaße und Befestigungsart vor der Bestellung prüfen.';
  /* Die HALBHOHE Blende (57 cm, Velora/Glanzia …FZN) gehoert zu einem TEILintegrierten Geraet — dessen
     Bedienblende bleibt sichtbar. Bis 2026-09-26 stand auch dort „vollintegriert" (Betreiber: falsch);
     wer danach ein Geraet kauft, kauft das falsche. Unterschieden wird an der Hoehe, nicht am Code: die
     vollen Fronten messen in allen vier Serien 71,3 cm. */
  var FRONT_HINWEIS_TEIL = 'Halbhohe Möbelfront für einen teilintegrierten Geschirrspüler — die Bedienblende '
    + 'des Geräts bleibt sichtbar. Das Gerät selbst gehört nicht zum Lieferumfang. Gerätemaße und '
    + 'Befestigungsart vor der Bestellung prüfen.';
  function frontHinweis(m) { return m.h < 65 ? FRONT_HINWEIS_TEIL : FRONT_HINWEIS; }

  function beleg(z, daten, texte) {
    var g = geo(daten), t = texte || {};
    var ws = waende(z);
    /* Frontansicht je Wand: gezeichnet wird immer die AKTIVE Wand, also bekommt jede Wand
       eine eigene Kopie des Zustands. Am Original wird nichts veraendert. */
    var fuerWand = function (wid) {
      var k = {}; for (var q in z) { if (Object.prototype.hasOwnProperty.call(z, q)) k[q] = z[q]; }
      k.wand = wid;
      return k;
    };
    var waendeOut = ws.map(function (w) {
      var f = frontZeichnung(fuerWand(w.id), daten, 900, true);
      var b = bilanz(z, daten, w.id);
      var teile = [];
      ['boden', 'oben', 'aufsatz'].forEach(function (zl) {
        items(z, daten, w.id, zl).forEach(function (it) {
          var v = variante(it.m, z.farbe, z.zusatz);
          teile.push({
            reihe: zl === 'boden' ? 'Boden' : (zl === 'oben' ? 'Hängend' : 'Aufsatz'),
            code: it.m.code, sku: (v && v.sku) || '', art: modellName(it.m),
            /* Auf Papier gilt das ECHTE Korpusmass aus dem Katalog — daran wird geliefert und
               montiert. Das Rastermass (90 fuer D90N) steht daneben, weil der Grundriss damit
               rechnet; wer nur eine der beiden Zahlen sieht, misst falsch. */
            b: mm(it.m.b), h: mm(it.m.h), tt: mm(it.m.t),
            raster: nennMass(it.m) !== it.m.b ? r0(nennMass(it.m)) + ' × ' + r0(nennTiefe(it.m)) : '',
            x: r0(it.x), preis: v ? eur(v.preis) : '—', mass: '', notiz: ''
          });
        });
      });
      /* Der als Merkmal gesetzte Stellplatz ist ebenfalls eine Zeile — ohne Preis. */
      aktiveMerkmale(z).filter(function (m) { return m.wand === w.id && MT[m.typ].stellplatz; })
        .forEach(function (m) {
          teile.push({
            reihe: 'Boden', code: MT[m.typ].kurz, sku: '', art: m.typ === 'kuehl' ? 'vorhandener Kühlschrank' : 'vorhandener Geschirrspüler',
            mass: r0(m.breite) + ' cm Stellplatz', b: r0(m.breite), h: '', tt: '', raster: '',
            x: r0(m.x), preis: 'nicht im Lieferumfang', notiz: MT[m.typ].hinweis
          });
        });
      return {
        id: w.id, label: w.label, len: r0(w.len),
        belegt: r0(b.belegt), eck: r0(b.ecke), frei: r0(b.frei), oben: r0(b.oben),
        front: f.inner, frontVb: f.vb, teile: teile
      };
    });

    var pl = planZeichnung(z, daten, 2.2);
    var hatVoll = ws.some(function (w) {
      return items(z, daten, w.id, 'boden').some(function (it) { return it.m.reihe === 'voll'; });
    });
    var geoZeilen = [
      /* Hoehen mit einer Stelle nach dem Komma (83,3 cm), die Plattenstaerke so, wie der Katalog sie nennt (13 mm). */
      { k: 'Arbeitshöhe', v: mm(arbeitsHoehe(daten, z)) + ' cm' },
      { k: 'Arbeitsplatte', v: r0(platteTiefe()) + ' cm tief, ' + (platteVon(z, daten) && +platteVon(z, daten).dicke > 0
        ? platteVon(z, daten).dicke + ' mm dick' : r0(g.arbeitsplatte_dicke) + ' cm dick') },
      { k: 'Geplante Frontflucht', v: String(flucht()).replace('.', ',') + ' cm (0,5 cm Überstand)' },
      { k: 'Nische', v: mm(nischenHoehe(daten, z)) + ' cm' },
      { k: 'Hängeschrank-Unterkante', v: r0(g.haenge_unterkante) + ' cm' }
    ];
    /* Eine Bauhoehe, die im Plan nicht vorkommt, ist auf dem Beleg eine falsche Zusage. */
    if (hatVoll) geoZeilen.push({ k: 'Hochschrank', v: r0(g.hochschrank_hoehe) + ' cm' });

    return {
      stand: t.stand || '',
      serie: z.serie || '—', farbe: z.farbe || '—',
      zusatz: Object.keys(z.zusatz || {}).map(function (k) { return k + ': ' + z.zusatz[k]; }),
      form: t.form || z.form,
      raum: ws.map(function (w) { return { k: w.label, v: r0(w.len) + ' cm' }; })
        .concat([{ k: 'Raumhöhe', v: 'ca. ' + r0(z.hoehe) + ' cm – vom Kunden zu bestätigen' }]),
      geo: geoZeilen,
      plan: pl.inner, planVb: pl.vb, waende: waendeOut,
      merkmale: aktiveMerkmale(z).map(function (m) {
        return {
          kurz: MT[m.typ].kurz, label: MT[m.typ].label, wand: wandObj(z, m.wand).label,
          x: r0(m.x) + ' cm', hoehe: r0(m.hoehe) + ' cm',
          mass: MT[m.typ].breite ? r0(m.breite) + ' cm breit' : (MT[m.typ].geraet ? 'Gerät' : 'Punkt')
        };
      }),
      stueck: positionen(z, daten).map(function (x) {
        return {
          code: x.m.code, sku: (x.v && x.v.sku) || '', art: modellName(x.m),
          mass: mm(x.m.b) + ' × ' + mm(x.m.h) + ' × ' + mm(x.m.t) + ' cm',
          raster: nennMass(x.m) !== x.m.b
            ? 'Raster ' + r0(nennMass(x.m)) + ' × ' + r0(nennTiefe(x.m)) + ' cm' : '',
          menge: x.menge, einzel: eur(x.v.preis), zeile: eur(x.v.preis * x.menge),
          /* Frueher trug die FRONT den Hinweis des STELLPLATZES — und der sagt woertlich
             „ohne Moebelfront" auf genau der Zeile, die diese Moebelfront ist. Zwei
             verschiedene Dinge, zwei verschiedene Saetze. */
          notiz: x.m.funktion === 'geschirrspuelerfront' ? frontHinweis(x.m) : ''
        };
      }),
      zubehoer: zubehoerPos(z, daten).map(function (p) {
        return {
          code: p.code, sku: p.sku || '', art: p.art, mass: p.mass, menge: p.menge,
          einzel: eur(p.preis), zeile: eur(p.betrag),
          /* Frueher stand hier "800 cm von 600 cm Bodenreihe". Die 600 waren die Frontlaenge,
             nicht der Bedarf — seit der Bedarf die Seitenstuecke enthaelt, las sich das wie ein
             Widerspruch. Der Kunde braucht die Zahl hier gar nicht: der Sockelbedarf steht im
             Planer, und auf dem Papier zaehlt, was er bestellt. */
          info: ''
        };
      }),
      platten: arbeitsplattenPos(z, daten).map(function (p) {
        return {
          sku: p.sku || '', art: p.art, mass: p.mass, menge: 1,
          wand: p.label + ' ' + r0(p.von) + '–' + r0(p.bis) + ' cm',
          teil: p.teil,
          einzel: eur(p.preis), zeile: eur(p.betrag)
        };
      }),
      summe: eur(gesamt(z, daten)), anzahl: anzahl(z, daten),
      pruef: pruefung(z, daten).map(function (m) { return { art: m.art, text: m.text }; }),
      hinweis: t.hinweis || '', vorbehalt: t.vorbehalt || ''
    };
  }

  /* Je Stueck EINE Zeile mit Menge 1 — auch bei gleicher Variante: der Zuschnitt ist die
     Bestellung: Platte, Zuschnitt, Wand. */
  function plattenKorb(z, daten) {
    return arbeitsplattenPos(z, daten).filter(function (p) { return p.vid; }).map(function (p) {
      return {
        id: +p.vid, quantity: 1,
        properties: {
          'Arbeitsplatte': p.name + ' ' + p.dicke + ' mm',
          'Zuschnitt': p.laenge + ' × ' + r0(platteTiefe()) + ' cm' + (p.teil ? ' (Stück ' + p.teil + ')' : ''),
          /* `label` ist schon „Wand A" bzw. „Insel" — vorher stand „Wand Wand A" im Korb. */
          'Wand': p.label + ', ' + r0(p.von) + '–' + r0(p.bis) + ' cm'
        }
      };
    });
  }

  function korbNutzlast(z, daten) {
    var zub = zubehoerPos(z, daten).filter(function (p) { return p.vid; }).map(function (p) {
      return {
        id: +p.vid,
        quantity: p.menge,
        properties: { 'Serie': z.serie || '', 'Farbe': p.farbe || '', 'Zubehör': p.art }
      };
    });
    return {
      items: positionen(z, daten).map(function (p) {
        var eig = {
          'Serie': z.serie || '',
          'Farbe': z.farbe || '',
          'Reihe': p.m.reihe,
          'Position': stellen(z, daten, p.mi, p.wahl).join(' · ')
        };
        if (p.wahl) eig['Ausführung'] = p.wahl;
        return { id: p.v.vid, quantity: p.menge, properties: eig };
      }).concat(zub).concat(plattenKorb(z, daten))
    };
  }

  /* Der ganze Plan als Warenkorb-Attribut: der Service muss den Grundriss nachvollziehen
     können, ohne den Kunden erneut zu fragen. */
  function korbAttribut(z, daten) {
    var p = planSichern(z, daten);
    return JSON.stringify({
      v: 2, serie: z.serie, farbe: z.farbe, zusatz: z.zusatz, form: z.form,
      A: z.A, B: z.B, C: z.C, IL: z.IL, hoehe: z.hoehe,
      plan: p ? p.plan : {}, hoff: p ? p.hoff : {}, xpos: p ? p.xpos : {},
      merkmale: z.merkmale, platte: z.platte || null
    });
  }

  /* Der Satz über der Stückliste — er sagt, ob gekauft werden kann und warum nicht. */
  function pruefSatz(z, daten) {
    var f = pruefung(z, daten).filter(function (m) { return m.art === 'fehler'; });
    if (!anzahl(z, daten)) return 'Noch keine Schränke gesetzt.';
    if (f.length === 1) return 'Ein Punkt ist noch zu klären — er steht unter der Zeichnung in Schritt 4.';
    if (f.length > 1) return f.length + ' Punkte sind noch zu klären — sie stehen unter der Zeichnung in Schritt 4.';
    return 'Die Planung ist in sich stimmig: Maße, Anschlüsse und Reihen passen zusammen.';
  }

  w.HMKonfig = {
    r0: r0, ueber: ueber, eur: eur, istEck: istEck,
    setMoneyFormat: setMoneyFormat,
    laden: laden, variante: variante, optWerte: optWerte, optGruppen: optGruppen,
    optGlobal: optGlobal, PRO_SCHRANK: PRO_SCHRANK, zusatzUebernehmen: zusatzUebernehmen,
    gruppenName: gruppenName, istRegal: istRegal,
    SCHILD_GRUND: SCHILD_GRUND, SCHILD_DECKUNG: SCHILD_DECKUNG, SCHILD_SCHRIFT: SCHILD_SCHRIFT,
    frontTeile: frontTeile, griffe: griffe, griffStil: griffStil, istRahmen: istRahmen, istAst: istAst,
    optikSerie: optikSerie,
    GRIFF_SCHWARZ: GRIFF_SCHWARZ, GRIFF_MESSING: GRIFF_MESSING,
    zusatzMit: zusatzMit,
    sk: sk, ART: ART, aufbau: aufbau, gsLage: gsLage, frontFarbe: frontFarbe, korpusFarbe: korpusFarbe,
    istGlanz: istGlanz, istHolz: istHolz, hatGriff: hatGriff, ton: ton, front: front,
    frontZeichnung: frontZeichnung, planZeichnung: planZeichnung,
    geo: geo, platteTiefe: platteTiefe, flucht: flucht, inselFrei: inselFrei,
    arbeitsHoehe: arbeitsHoehe, nischenHoehe: nischenHoehe, plattenDicke: plattenDicke, zeile: zeile,
    waende: waende, wandObj: wandObj,
    raumGeometrie: raumGeometrie, VORLAGEN: VORLAGEN,
    wandLaenge: wandLaenge, wandTangente: wandTangente, wandNormaleInnen: wandNormaleInnen,
    wandPunkt: wandPunkt, wandProjektion: wandProjektion, wandNachbarn: wandNachbarn,
    wandTransform3D: wandTransform3D, weltPunkt3D: weltPunkt3D, raumBounds: raumBounds,
    geometrischeEcken: geometrischeEcken, schrankEcken: schrankEcken, offeneSeiten: offeneSeiten,
    schrankEckeAn: schrankEckeAn, wandAus: wandAus, eckPlaetze: eckPlaetze,
    eckBelegung: eckBelegung, nutzIntervall: nutzIntervall, EPS_ECKE: EPS_ECKE,
    wandVersatz: wandVersatz, versatzKarte: versatzKarte, versatzGrenze: versatzGrenze, VERSATZ_MAX: VERSATZ_MAX, ABSTAND_MAX: ABSTAND_MAX,
    EPS_KOINZIDENZ: EPS_KOINZIDENZ, EPS_FANG: EPS_FANG, ECK_TOLERANZ_GRAD: ECK_TOLERANZ_GRAD,
    nennMass: nennMass, nennTiefe: nennTiefe, schenkel: schenkel,
    stellTiefe: stellTiefe, eckL: eckL, grundPfad: grundPfad,
    eckNachbar: eckNachbar, eckOffset: eckOffset, eckVorher: eckVorher,
    nutzLaenge: nutzLaenge, items: items, reiheVonRechts: reiheVonRechts, belegt: belegt, belegtLaenge: belegtLaenge, bilanz: bilanz,
    MT: MT, HAUBE: HAUBE, EINMALIG: EINMALIG, MT_KURZLABEL: MT_KURZLABEL, mtGruppen: mtGruppen,
    wandDa: wandDa, wandAuswahl: wandAuswahl,
    aktiveMerkmale: aktiveMerkmale, ruhendeMerkmale: ruhendeMerkmale,
    ruhendeDaten: ruhendeDaten,
    mxMax: mxMax, merkmalNeu: merkmalNeu, merkmalSetzen: merkmalSetzen,
    elementIntervallAufWand: elementIntervallAufWand, elementAusserhalb: elementAusserhalb,
    ueberstandText: ueberstandText,
    inselOhnePlatte: inselOhnePlatte,
    inselSpiegeln: inselSpiegeln,
    INSEL_OHNE_PLATTE: INSEL_OHNE_PLATTE,
    fensterOeffnung: fensterOeffnung,
    SERIEN: SERIEN, umbau: umbau, farbliste: farbliste, katalog: katalog, deckung: deckung, codeKern: codeKern,
    REIHEN_TABS: REIHEN_TABS, sperrZonen: sperrZonen, freiSchieben: freiSchieben,
    raste: raste, rasteHoehe: rasteHoehe, rasteX: rasteX, offGrenze: offGrenze,
    offListe: offListe, xListe: xListe, wahlListe: wahlListe,
    eckSperre: eckSperre, setzen: setzen, ersetzen: ersetzen, entfernen: entfernen,
    stapeln: stapeln, stapelAngebot: stapelAngebot, schieben: schieben, kochstellen: kochstellen,
    stellplatzStatt: stellplatzStatt, ausStellplatz: ausStellplatz, planungsCheck: planungsCheck,
    bauZonen: bauZonen, schwebende: schwebende, sichtbareLuecken: sichtbareLuecken,
    obenNachziehen: obenNachziehen, startKueche: startKueche, hochSeiten: hochSeiten, hochInventar: hochInventar,
    raumHuelle: raumHuelle,
    fehlerTexte: fehlerTexte, positionen: positionen, summe: summe, anzahl: anzahl,
    pruefung: pruefung, raumPruefung: raumPruefung, kaufbar: kaufbar,
    stueckliste: stueckliste, geraeteListe: geraeteListe, stellen: stellen,
    korbNutzlast: korbNutzlast, korbAttribut: korbAttribut, pruefSatz: pruefSatz,
    SPEICHER: SPEICHER, SCHEMA: SCHEMA, schemaVon: schemaVon, migriere: migriere,
    fingerabdruck: fingerabdruck, planCodes: planCodes,
    planSichern: planSichern, planIndizes: planIndizes,
    modellName: modellName, sockelGruppe: sockelGruppe, zubehoerArten: zubehoerArten,
    sockelLaufmeter: sockelLaufmeter, sockelBedarf: sockelBedarf, seitenStueck: seitenStueck,
    inselUmfang: inselUmfang,
    sockelEnden: sockelEnden, sockelStrecken: sockelStrecken, SOCKEL_ZURUECK: SOCKEL_ZURUECK,
    zubehoerPos: zubehoerPos,
    zubehoerAufraeumen: zubehoerAufraeumen, zubehoerSumme: zubehoerSumme,
    PLATTE_MAX: PLATTE_MAX, plattenTabelle: plattenTabelle, platteVon: platteVon,
    plattenVariante: plattenVariante, plattenStuecke: plattenStuecke,
    arbeitsplattenPos: arbeitsplattenPos, plattenSumme: plattenSumme, plattenKorb: plattenKorb,
    gesamt: gesamt, korbSumme: korbSumme, posGesamtText: posGesamtText,
    beleg: beleg,
    planNutzlast: planNutzlast,
    sichern: sichern, gesichert: gesichert, verwerfen: verwerfen,
    umgebungSetzen: umgebungSetzen
  };
})(window);
